import { imgTest, imgTestLarge } from './files';

const UserType = {
	BUYER: 'BUYER',
	FRUITORE: 'FRUITORE',
	BUYER_FRUITORE: 'BUYER_FRUITORE'
};

const getClientToEnable = (userType) => {
	switch (userType) {
		case UserType.BUYER:
			return ['s4bweb'];
		case UserType.FRUITORE:
			return ['s4bwebuser'];
		case UserType.BUYER_FRUITORE:
		default:
			return ['s4bweb', 's4bwebuser'];
	}
};

const DomainType = {
	PRELIOS: 'PRELIOS',
	S4C: 'S4C',
}

const userType = getClientToEnable(UserType.BUYER_FRUITORE);
const domainType = DomainType.PRELIOS;

const IS_MULTI_DOMAIN = true;
const domainList = [
	{
		id: 47,
		title: 'Skills4Capital',
		url:
			'http://internal-sit-cms-s4b2-alb-internal-194819797.eu-west-1.elb.amazonaws.com',
		fruitionChannel: ['app', 'web'],
		cohortId: 17,
		brand: {
			name: 'Skills4Capital',
			color: '#F2284F',
			logo:
				'https://d22cxfqtum6m93.cloudfront.net/media/2021-04/logo-new-positivo-2.png?VersionId=kUDh6Z2LDMLxKZ.cV1MVGVCvIvc7FsIp',
		},
	},
	{
		id: 56,
		title: 'Dominio 2 ',
		url: '0',
		fruitionChannel: ['app', 'web'],
		cohortId: 18,
		brand: {
			name: 'Brand 2',
			color: '#fd8232',
			logo:
				'https://d22cxfqtum6m93.cloudfront.net/media/2021-03/winter.jpg?VersionId=uVmZ_kpdmd_hIgBRE8pTgpgg8lJazDjd',
		},
	},
];

const MOCK_PROFILE = {
	userName: '4c32eebd-2e84-4706-9647-bb895c76bd0a',
	email: 'a.rouissi@accenture.com',
	role: 'Admin',
	organizationId: 'd3be9862-9814-4c17-830c-59c5a6f7e9fe',
	token: 't o k e n',
	expiresIn: 3600,
	accessToken: 'a c c e s s t o k e n ',
	refreshToken: 'r e f r e s h t o k e n',
	domainList: IS_MULTI_DOMAIN ? domainList : domainList.at(0),
	clientEnabled: userType,
	userDomainAttributes: [{
		domainId: "301",
		englishPlatform: true,
		backOffice: true,
		backOfficeId: 'backofficeid'
	}],

	sendDataTreatment: false,
	givenName: 'Anouer',
	familyName: 'Rouissi',
	cf: 'QWERTY12Q12Q123Q',
	phoneNumber: '331234567',
};

export function shouldUseMock() {
	return (
		process.env.REACT_APP_DEPLOY_ENV === 'LOCAL'
		&& Number(process.env.REACT_APP_ENABLE_MOCK) === 1
	);
}

const lowecaseDataKeys = data =>
	// eslint-disable-next-line no-sequences
	Object.keys(data).reduce((c, k) => ((c[k.toLowerCase()] = data[k]), c), {});

const getBaseResponse = (data, status = 200, message) => ({
	status,
	data: lowecaseDataKeys(data),
	message,
});

const getRandomNumber = (min = 0, max = 20) =>
	Math.floor(Math.random() * (max - min) + min);

const mailName = ['Mario', 'Giovanna', 'Lucio', 'Federica', 'Simone'];
const mailSurname = ['Rossi', 'Verdi', 'Celeste', 'Bianchi', 'Romano'];
const mailDomain = [
	'gmail.com',
	'outlook.com',
	'libero.it',
	'yahoo.it',
	'icloud.com',
];
export const newActiveSubscription = (subscriptionId, type) => {
	const id = subscriptionId;
	const subscription_type = ['development', 'obbligatory'][
		getRandomNumber(0, 2)
	];
	// const is_deleted = [true, false][getRandomNumber(0, 2)];
	const is_deleted = subscriptionId >= 6;

	return {
		id,
		email: `${mailName[
			getRandomNumber(0, mailName.length)
		].toLocaleLowerCase()}.${mailSurname[
			getRandomNumber(0, mailSurname.length)
		].toLocaleLowerCase()}@${mailDomain[getRandomNumber(0, mailDomain.length)]
			}`,
		subscription_type,
		playlist_premium: [getRandomNumber(0, 9)],
		is_deleted,
		content_premium: [
			'content_premium 1',
			'content_premium 2',
			'content_premium 3',
		],
	};
};

export const newActiveSubscriptionEmpty = (subscriptionId, type) => {
	const id = subscriptionId;
	const subscription_type = ['FULL', 'SOLO FORMAZIONE OBBLIGATORIA'][
		type || getRandomNumber(0, 2)
	];
	return {
		id,
		email: '',
		subscription_type,
	};
};

// export const getActiveSubscriptionsMock = (length = getRandomNumber(5, 10), emptySubscription = false) => {

export const updateEmailSubscriptionMock = () =>
	getBaseResponse({
		appName: 'S4B',
		requestId: '7ee26e77-f5db-4aea-98f1-c1b4f7d7a1fb',
		success: true,
		prospects: [
			{
				prospect: {
					subscriptionId: '5743',
					variationId: '36',
					endDate: '2021-10-10',
					startDate: '2020-09-05',
					productPackage: {
						countSel: '1',
						countCol: '1',
						listSel: [],
						listCol: [],
					},
				},
			},
		],
		resultCode: 200,
	});

export const deleteEmailSubscriptionMock = () =>
	getBaseResponse({
		resultcode: 200,
		errorManagement: null,
	});

export const disableEmailSubscriptionMock = () =>
	getBaseResponse({
		appName: 'S4B',
		requestId: '25c8dbb0-2cb0-4a04-bc1a-f9ddf930f997',
		success: true,
		errorResponse: null,
		resultCode: 200,
		errorManagement: null,
	});

export const updateSubscriptionPlanMock = () => getBaseResponse();

export const createProspectMock = () => ({
	data: {
		requestId: 'ce660b8c-bfbb-422b-bbce-f91dce3b79ef',
		errorMessage: null,
		prospectResponse: [
			{
				prospectId: '8d661d84-60e9-4906-96b4-2c131fc264b7',
				email: 'test@test.com',
				status: 'not-registred',
				organizationId: '48235813-0664-40a8-9c1b-a89ef4f399fc',
				offerId: '43983ry',
				offerType: 'typeoffer',
				subscriptionId: 'subscriptionId',
				endDate: '2020-10-10T00:00:00.000+0000',
				startDate: '2020-09-05T00:00:00.000+0000',
				industry: 'ISP',
				productPackage: 'productPackage',
			},
			{
				prospectId: '883bbd8e-601a-4042-bae0-ceb3bf6c7536',
				email: 'bla@it.com',
				status: 'not-registred',
				organizationId: '48235813-0664-40a8-9c1b-a89ef4f399fc',
				offerId: '43983ry',
				offerType: 'typeoffer',
				subscriptionId: 'subscriptionId',
				endDate: '2020-10-10T00:00:00.000+0000',
				startDate: '2020-09-05T00:00:00.000+0000',
				industry: 'ISP',
				productPackage: 'productPackage',
			},
		],
		resultcode: 200,
	},
});

export const getProfileDataAccountMock = () => getBaseResponse(MOCK_PROFILE);

export const getProfileDataCompanyMock = () =>
	getBaseResponse(
		{
			organizationid: '7ee6f026-2d50-4219-a08b-867614aa04d4',
			title: 'title_org',
			vatNumber: '48505660257',
			orgFiscalCode: null, // null, //'DLFLFH86P02G170F', //
			sdinumber: '456787',
			street: 'via torrerossa',
			city: 'Rome',
			district: 'RM',
			zipcode: '00000',
			industryid: '31',
			atecoCode: '1234567',
			atecoDescription: 'descrizione ateco',
			zuoraAccountNumber: 'A00000014',
			zuoraAccountId: '8adc90277d5171bd017d56df2ba63040',
			// sourceType: 'BANK'
			sourceType: 'PORTAL'
		},
		200,
		'ok'
	);

export const newSubscriptionPlan = (
	subscriptionId,
	customList = [],
	imagesList = []
) => {
	const id = subscriptionId || getRandomNumber(1);
	return {
		id,
		name: customList[subscriptionId] || `Mock content ${id}`,
		cover_image: imagesList[subscriptionId] || 'https://picsum.photos/200/300',
		subscription_plan_type: 'monthly',
		price: 2.99,
		num_content: getRandomNumber(2, 10),
	};
};

export const getRecommendedPlansMock = () =>
	getBaseResponse({
		data: [
			{
				content_id: 289,
				title: 'Adipiscing Nulla Refoveo',
				body: 'Eros humo jumentum mauris nimis olim paulatim volutpat.',
				cover:
					'http://s4b.local/sites/default/files/2020-03/generateImage_ClanZR.png',
				creationDate: '2020-03-18T12:03:01+0100',
				duration: '465982',
				trailer: 'http://www.hufrapru.org',
				promoted: 'True',
				lo_count: 1,
			},
			{
				content_id: 270,
				title: 'Eros Fere Vindico',
				body:
					'Causa decet magna populus. Dolus eu jumentum macto ullamcorper vel virtus.',
				cover:
					'http://s4b.local/sites/default/files/2020-03/generateImage_ClanZR.png',
				creationDate: '2020-03-17T23:00:53+0100',
				duration: '598682',
				trailer: 'http://www.hufrapru.org',
				promoted: 'True',
				lo_count: 1,
			},
		],
		pager: {
			current_page: 0,
			total_items: '2',
			total_pages: 1,
			items_per_page: 10,
		},
		count_data_obj: '23',
	});

export const getTeamsInterestMock = () =>
	getBaseResponse(
		{
			appName: "S4B",
			content: {
				83: [
					{
						email: "acc-fruitore-08mar001@yopmail.com",
						firstName: "Giulio",
						lastName: " Verdi",
						pictureId: null,
						userId: "e49c6ca8-4521-4a5a-a5c9-b9e456ae60ba"
					}
				],
				97: [
					{
						email: "acc-fruitore-08mar001@yopmail.com",
						firstName: "Giulio",
						lastName: " Verdi",
						pictureId: null,
						userId: "e49c6ca8-4521-4a5a-a5c9-b9e456ae60ba"
					}
				]
			},
			errorManagement: null,
			errorResponse: null,
			requestId: "62fa4bac-4adf-4986-998a-f6a10beaf3f3",
			resultCode: 200,
			success: true
		}
	);

export const getTeamsInterestDetailsMock = type => {
	switch (type) {
		case 'collection':
			return getBaseResponse({
				data: [
					{
						content_id: 1080,
						title: 'Approfondimenti piattaforma circular 1 parte',
						body:
							'La collection descrive i principi di applicazione della Circular Economy nel contesto urbano, con esempi di citt\u00e0 circolari. Successivamente si descrivono le opportunit\u00e0 CE per il settore della finanza, con esempi di ambiti specifici in cui queste opportunit\u00e0 si manifestano e cenni al derisking. Si fornisce, inoltre, la descrizione del contesto strategico e normativo europeo per le imprese che intendono evolvere verso la CE: (normativa+policy), i fondi del Recovery Fund destinati ai progetti green. Infine, vengono descritti gli SDGs (Sustainable Development Goals\u201d, cio\u00e8 gli Obiettivi per lo Sviluppo Sostenibile) con l\u2019illustrazione di come SDGs aiutano le imprese a indirizzare il proprio sviluppo strategico 2/3 esempi, con illustrazione dei SDGs connessi (industry o modello).',
						cover:
							'https://d22cxfqtum6m93.cloudfront.net/media/2021-07/Collection%2047.PNG?VersionId=ibGJiTnPRTjlAtO1V7ooZ8bn1uSfXL9O',
						trailer: '',
						creationDate: '2021-07-26T22:27:08+0200',
						changed: '2021-07-26T22:28:59+0200',
						count_content: 5,
						total_duration: 1500,
						content: [
							{
								id: '1072',
								title: 'La circular economy nel sistema citt\u00e0',
							},
							{
								id: '1073',
								title: 'Il mondo della finanza per la circular economy',
							},
							{
								id: '1074',
								title:
									'Esempi di circular economy nel tessuto economico italiano',
							},
							{
								id: '1075',
								title: 'La strategia europea per la circular economy',
							},
							{
								id: '1076',
								title: 'Sdg, orientamento per uno sviluppo sostenibile',
							},
						],
						cohort: [{ id: '17', name: 'Cohort 1' }],
						needs: [{ id: '63', name: 'Economia circolare' }],
						survey: '',
					},
					{
						content_id: 1078,
						title:
							'Le opportunit\u00e0 dell\u2019economia circolare nel settore Agrifood - II parte',
						body:
							'Nella collection vengono presentate le linee guida dell\u2019Economia circolare nella fase di coltivazione, raccolta e stoccaggio; con la presentazione di best practice. Vengono inoltre, rappresentati i processi di fornitura e lavorazione che riducono l\u2019impatto ambientale, anche grazie all\u2019utilizzo di tecnologie digitali (precision farming \u2013 tracking \u2013 blockchain) con la presentazione di best practice.\r\nVengono descritte le diverse applicazioni del packaging nel settore agroalimentare, con focus sui recenti indirizzi normativi e con la presentazione di best practice.\u0026nbsp; Infine, si descrivono le logiche di sostenibilit\u00e0 e circolarit\u00e0 finalizzate a ottimizzare la logistica e la fase di commercializzazione, nonch\u00e9 le tecnologie abilitanti una migliore tracciabilit\u00e0 e distribuzione dei prodotti. Infine, si evidenziano i principi di circolarit\u00e0 implementabili nelle ultime fasi della value chain, con focus sulle evoluzioni del ruolo attivo del consumatore.',
						cover:
							'https://d22cxfqtum6m93.cloudfront.net/media/2021-07/Collection%2044.jpeg?VersionId=mjgV9iZDNbo0mrbKcxGVyiBjpyGlEkS1',
						trailer: '',
						creationDate: '2021-07-26T22:23:03+0200',
						changed: '2021-07-26T22:25:12+0200',
						count_content: 5,
						total_duration: 1500,
						content: [
							{
								id: '1062',
								title:
									'Agrifood: best practices circolari per la coltivazione e la raccolta',
							},
							{
								id: '1063',
								title:
									'Agrifood: best practices circolari per approvvigionamento e fornitura',
							},
							{
								id: '1064',
								title: 'Agrifood: best practices circolari per il packaging',
							},
							{
								id: '1065',
								title:
									'Agrifood: best practices circolari per la distribuzione e la vendita',
							},
							{
								id: '1066',
								title:
									'Agrifood: best practices circolari per il consumo e il fine vita',
							},
						],
						cohort: [{ id: '17', name: 'Cohort 1' }],
						needs: [{ id: '63', name: 'Economia circolare' }],
						survey: '',
					},
					{
						content_id: 499,
						title: 'Agriturismo',
						body: 'Promuovere l\u0027agriturismo e accogliere l\u0027ospite',
						cover:
							'https://d22cxfqtum6m93.cloudfront.net/media/2021-05/collection%2027.jpg?VersionId=oxHFD5g1XDY9GQg2k88T6izn5_kWwG6K',
						trailer: '',
						creationDate: '2021-05-07T16:41:03+0200',
						changed: '2021-05-18T18:27:59+0200',
						count_content: 10,
						total_duration: 2400,
						content: [
							{
								id: '487',
								title:
									'Il posizionamento commerciale giusto per il tuo agriturismo',
							},
							{
								id: '488',
								title:
									'Promuovi il tuo agriturismo in sinergia con il territorio',
							},
							{
								id: '489',
								title:
									'Scopri le caratteristiche dell\u2019agriturismo sostenibile e responsabile',
							},
							{
								id: '491',
								title: 'Come scegliere le attivit\u00e0 per il tuo agriturismo',
							},
							{
								id: '492',
								title:
									'Crea il tuo menu! Fattori di successo nel settore agrituristico',
							},
							{
								id: '493',
								title: 'L\u2019identikit del cliente per il tuo agriturismo',
							},
							{ id: '494', title: 'L\u2019accoglienza nel tuo agriturismo' },
							{
								id: '495',
								title:
									'Cura la crescita delle tue persone per valorizzare il tuo agriturismo',
							},
							{
								id: '496',
								title:
									'Digitalizza il business e vai online con il tuo agriturismo',
							},
							{ id: '498', title: 'Come presenti il tuo agriturismo' },
						],
						cohort: [{ id: '17', name: 'Cohort 1' }],
						needs: [{ id: '71', name: 'Agribusiness' }],
						survey: '',
					},
					{
						content_id: 490,
						title: 'Il business agricolo',
						body: 'Come realizzare il business plan della tua azienda agricola',
						cover:
							'https://d22cxfqtum6m93.cloudfront.net/media/2021-05/collection%2023.jpg?VersionId=poPXaQ7YNtcnCHCCsSyHPUTh3Eb4UIus',
						trailer: '',
						creationDate: '2021-05-07T16:31:02+0200',
						changed: '2021-05-18T18:29:54+0200',
						count_content: 10,
						total_duration: 2530,
						content: [
							{
								id: '476',
								title:
									'L\u2019equilibrio finanziario nell\u2019azienda agricola: cos\u2019\u00e8 e come gestirlo',
							},
							{
								id: '478',
								title:
									'Fabbisogno finanziario: quali risorse servono all\u2019azienda agricola?',
							},
							{
								id: '479',
								title: 'La tua azienda agricola vale... tu sai quanto?',
							},
							{
								id: '480',
								title:
									'IIl business plan dell\u2019azienda agricola: cos\u2019\u00e8 e a cosa ti serve',
							},
							{
								id: '481',
								title: 'Costruisci il business plan della tua azienda agricola!',
							},
							{
								id: '482',
								title:
									'L\u2019azienda agricola ha bisogno di un credito bancario: come ti prepari?',
							},
							{
								id: '483',
								title:
									'Programmi di sviluppo rurale: un aiuto per la tua azienda agricola',
							},
							{
								id: '484',
								title:
									'La tua azienda \u00e8 pronta per accedere al programma di sviluppo rurale?',
							},
							{
								id: '485',
								title:
									'L\u2019unione fa la forza! Organizzazioni di produttori per l\u2019agricoltura',
							},
							{
								id: '486',
								title:
									'Rischi agricoli: quali sono e come li gestisce la tua azienda',
							},
						],
						cohort: [{ id: '17', name: 'Cohort 1' }],
						needs: [{ id: '71', name: 'Agribusiness' }],
						survey: '',
					},
					{
						content_id: 20,
						title: 'Circular economy? Come svilupparla in azienda',
						body: 'Scopri le migliori practice sul mercato',
						cover:
							'https://d22cxfqtum6m93.cloudfront.net/media/2021-05/Collection%202.jpeg?VersionId=gtkHBMchyloa3WRHN5.OYw4_GkAKD7SM',
						trailer: '',
						creationDate: '2020-04-20T17:30:06+0200',
						changed: '2021-07-26T22:29:55+0200',
						count_content: 5,
						total_duration: 1260,
						content: [
							{
								id: '66',
								title:
									'Best Practice \u0022circolari\u0022: agricoltura e alimentazione',
							},
							{
								id: '69',
								title:
									'Best Practice \u0022circolari\u0022: chimica e materiali di base',
							},
							{
								id: '71',
								title: 'Best Practice \u0022circolari\u0022: tessile e moda',
							},
							{
								id: '72',
								title: 'Best Practice \u0022circolari\u0022: edilizia',
							},
							{
								id: '74',
								title: 'Best Practice \u0022circolari\u0022: automotive',
							},
						],
						cohort: [
							{ id: '17', name: 'Cohort 1' },
							{ id: '18', name: 'Cohort 2' },
						],
						needs: [{ id: '63', name: 'Economia circolare' }],
						survey: '',
					},
				],
				pager: {
					current_page: 0,
					total_items: '5',
					total_pages: 1,
					items_per_page: 10,
				},
				count_data_obj: '5',
			});
		case 'selection':
			return getBaseResponse({
				data: [
					{
						content_id: 48,
						title: 'Selection 1',
						body: 'test body',
						cover:
							'http://s4b2.local:8080/sites/default/files/2021-03/lemon_black.jpg',
						trailer: 'A8762G2189729',
						creationDate: '2021-03-16T09:26:17+0100',
						count_content: 2,
						content: [
							{ order: '0', id: '50', title: 'Training 1', final_test: 'True' },
							{ order: '1', id: '56', title: 'Training 2', final_test: 'True' },
						],
						cohort: [
							{ id: '17', name: 'Cohort 2' },
							{ id: '18', name: 'Cohort 3' },
						],
						needs: [{ id: '30', name: 'Esigenza 4' }],
						industries: [{ id: '31', name: 'Settore 2' }],
						changed: '2021-03-22T15:38:47+0100',
						valore_propedeuticita: 0,
						survey: 41,
					},
				],
				pager: {
					current_page: 0,
					total_items: '1',
					total_pages: 1,
					items_per_page: 10,
				},
				count_data_obj: '1',
			});

		case 'custom_pack':
			return getBaseResponse({
				data: [
					{
						id: 15,
						title: '1. Custom pack (8 collections)',
						content_type: 'Collection',
						limit: 8,
					},
				],
				pager: {
					current_page: 0,
					total_items: '1',
					total_pages: 1,
					items_per_page: 10,
				},
				count_data_obj: '1',
			});

		default:
			return getBaseResponse({});
	}
};

export const getCatalogMock = () =>
	getBaseResponse({
		appName: 'S4B',
		requestId: '212b0573-73b4-429a-93ad-70dahsbs6262',
		success: true,
		errorResponse: null,
		content: [
			{
				content_id: 'c1',
				count_content: 10,
				cover: null,
				title: 'Turismo: Pianificazione e Amministrazione',
				price: 80,
				industryId: 2,
			},
			{
				content_id: 'c2',
				count_content: 4,
				cover: null,
				title: 'Micro aziende: Pianificazione e Amministrazione',
				price: 60,
				industryId: 1,
			},
			{
				content_id: 'c3',
				count_content: 6,
				cover: null,
				title: 'Il Business migliora i processi aziendali',
				price: 80,
				industryId: 1,
			},
			{
				content_id: 'c4',
				count_content: 10,
				cover: null,
				title: 'Turismo: Business e Amministrazione',
				price: 50,
				industryId: 2,
			},
			{
				content_id: 'c5',
				count_content: 10,
				cover: null,
				title: 'Il Lean Management migliora i processi aziendali',
				price: 80,
				industryId: 1,
			},
		],
		resultcode: 200,
		errorManagement: null,
	});

const mockedTrainingList = [
	'Accesso al credito',
	'Trasformazione digitale',
	'Pagamenti e fatturazioni',
];

export const collaborator = subscriptionId => {
	const id = subscriptionId || getRandomNumber(1);
	const completed = getRandomNumber(1, 10);
	const total = completed + getRandomNumber(1, 10);
	const completed_obligatory = getRandomNumber(1, 10);
	const total_obligatory = completed_obligatory + getRandomNumber(1, 10);
	const percentage = (completed / total) * 100;
	const percentage_obligatory = (completed_obligatory / total_obligatory) * 100;
	return {
		id,
		name: `${mailName[getRandomNumber(0, mailName.length)]} ${mailSurname[getRandomNumber(0, mailSurname.length)]
			}`,
		profile_image: 'https://picsum.photos/200/300?grayscale',
		comments: getRandomNumber(1, 10),
		notes: getRandomNumber(1, 10),
		development_content: {
			completed,
			total,
			percentage,
		},
		mandatory_content: {
			completed_obligatory,
			total_obligatory,
			percentage_obligatory,
		},
		selected_training_needs: [
			mockedTrainingList[getRandomNumber(0, mockedTrainingList.length)],
			mockedTrainingList[getRandomNumber(0, mockedTrainingList.length)],
		],
	};
};

export const getCollaboratorsListMock = (length = 4) => {
	const collaborators = [];
	for (let i = 0; i < length; i += 1) {
		collaborators.push(collaborator(i));
	}
	return getBaseResponse({
		total_items: length,
		count: 5,
		from: 0,
		collaborators,
	});
};

export const userPasswordResetMock = () => ({
	status: 200,
});

export const updatePasswordMock = () => ({
	sdkResponseMetadata: null,
	sdkHttpMetadata: null,
});
export const setPasswordManagerMock = () => getBaseResponse({}, 204, 'ok');
export const setPasswordManagerFromBankMock = () => getBaseResponse({}, 204, 'ok');

const mockedMostPopularContentOverview = [
	'Progetto di investimento: è importante per te?',
	'Individua gli stakeholder del tuo progetto di investimento',
	'Valuta il tuo progetto di investimento con il business plan',
	'Le opportunità della circular economy nella mia azienda',
	'Come dare un feedback negativo al tuo collaboratore',
];
const mockedMostViewedContentOverview = [
	'Il lean management migliora i processi aziendali',
	'Microaziende: pianificazione e amministrazione',
	'I lucchetti da aprire per sbloccare i tuoi collaboratori',
	"Comunichiamo per creare valore nell'esperienza del cliente",
	"Il rating: cos'è?",
];

export const mostPopularContentOverview = subscriptionId => {
	const id = subscriptionId || getRandomNumber(1);
	const total_count = getRandomNumber(1, 100);
	return {
		id,
		name:
			mockedMostPopularContentOverview[subscriptionId]
			|| `Content overview mock ${id}`,
		total_count,
	};
};

export const getMostPopularContentOverViewMock = (length = 5) => {
	const contents = [];
	for (let i = 0; i < length; i += 1) {
		contents.push(mostPopularContentOverview(i));
	}
	return getBaseResponse({
		total_items: length,
		count: 5,
		from: 0,
		contents,
	});
};

export const mostViewedContentOverview = subscriptionId => {
	const id = subscriptionId || getRandomNumber(1);
	const total_count = getRandomNumber(1, 100);
	return {
		id,
		name:
			mockedMostViewedContentOverview[subscriptionId]
			|| `Content overview mock ${id}`,
		total_count,
	};
};

export const getMostViewedContentOverViewMock = (length = 5) => {
	const contents = [];
	for (let i = 0; i < length; i += 1) {
		contents.push(mostViewedContentOverview(i));
	}
	return getBaseResponse({
		total_items: length,
		count: 5,
		from: 0,
		contents,
	});
};

export const getLandingProductsMock = () =>
	getBaseResponse({
		data: [
			{
				title: "Un'esperienza unica su ogni canale",
				subtitle:
					'<p><strong>Scegli il piano su misura per te e per il tuo team.</strong></p>',
				products: {
					data: [
						{
							product_id: 30,
							product_type: 'Learning Subscription',
							title: 'Pacchetto Base - 10 collection',
							body:
								'<p><strong>10 collection</strong> di contenuti formativi personalizzabili per tema<br />\ne settore, in continuo aggiornamento</p>',
							domain: 47,
							variations: {
								data: [
									{
										variation_id: 35,
										title: 'BASE',
										question:
											'Necessiti di una formazione per lo sviluppo delle persone e di trasformazione digitale? ',
										information:
											'<p>Formazione per la gestione e sviluppo</p>\n\n<p>delle tue risorse e sui  temi del digitale</p>\n\n<p>sempre aggiornata. Hai la possibilità di</p>\n\n<p>accedere a 10 collection ad un prezzo</p>\n\n<p>competitivo, rinnovate annualmente</p>',
										sku: 'BASE_S4C',
										list_price_number: 0,
										price_number: '120,00',
										price_code: 'EUR',
										learning_contents: 303,
										cards: [
											{
												card_type: 'card_product_variation_relation',
												product_variation_ref: '36',
												quantity_ratio: 'At least one',
											},
											{
												card_type: 'card_payment_period',
												every_how_many_months: '12',
												number_of_payments: '1',
												product_price_logic: 'Full price',
											},
										],
										field_productid: '8adca41e7c6428eb017c762cd5964ee4',
										field_productrateplanchargesbill: '8adca41e7c6428eb017c762cd5964ee4',
										field_productrateplanchargesid: '8adca41e7c6428eb017c762d8cf14fa7',
										field_productrateplanchargestrig: 'Recurring',
										field_productrateplanchargestype: 'Annual',
										field_productrateplansid: 'ContractEffective',
									},
								],
							},
						},
						{
							product_id: 31,
							product_type: 'Learning',
							title: 'Formazione obbligatoria',
							body:
								'<p><strong>2 Selection </strong>di contenuti utili per ottenere le certificazioni<br />\ne adempiere agli obblighi formativi</p>',
							domain: 47,
							variations: {
								data: [
									{
										variation_id: 36,
										title: 'FORMAZIONE OBBLIGATORIA',
										question:
											'Hai bisogno di rinnovare la certificazione di sicurezza L.XXY/2018?',
										information:
											'<p>Vuoi ottenere le certificazioni di legge in</p>\n\n<p>modo efficace, veloce ed economico.</p>\n\n<p>Attiva la formazione obbligatoria ed</p>\n\n<p>otterrai i vantaggi di un corso</p>\n\n<p>completamente online con la</p>\n\n<p>certificazione finale</p>',
										sku: 'MANDATORY_S4C',
										list_price_number: 0,
										price_number: '0,00',
										price_code: 'EUR',
										learning_contents: 302,
										cards: 0,
										field_productid: '8adccb057ce8d8a7017cea1485a479fa',
										field_productrateplanchargesbill: '8adccb057ce8d8a7017cea1485a479fa',
										field_productrateplanchargesid: '8adccb057ce8d8a7017cea1485bc79fc',
										field_productrateplanchargestrig: 'OneTime',
										field_productrateplansid: 'ContractEffective',
									},
								],
							},
						},
					],
				},
			},
		],
		pager: {
			current_page: 0,
			total_items: '1',
			total_pages: 1,
			items_per_page: 10,
		},
		count_data_obj: '1',
	});

export const getProductDetailsMock = id =>
	getBaseResponse({
		data: [
			{
				id,
				type: 'standard_training_subscription',
				title: '1.standard training',
				variations: [
					{
						id: '2',
						product_id: '2',
						sku: 'codice sku',
						type: 'standard_training_subscription',
						title: '1.variation standard training',
						currency: 'EUR',
						list_price: '200.000000',
						price: '99.000000',
						calculated: {
							list_price_rounded: '200.00',
							price_rounded: '99.00',
						},
						description: 'variation desriotion',
						contents: [
							{
								nid: '1',
								type: 'selection',
							},
						],
					},
				],
				payment_card: {
					id: '6',
					title:
						'Pagamento mensile con durata annuale. Inizio pagamenti mese successivo attivazione.',
					field_postpone_payment: '1',
					field_duration: '12',
					field_periodicity: '1',
				},
				period_card: {
					id: '7',
					title: 'Durata annuale.',
					field_duration: '1',
				},
			},
		],
	});

export const getViewsMock = () =>
	getBaseResponse({
		appName: 'S4B',
		requestId: 'c4bd03fc-f2e3-44b1-9320-771c74a23d87',
		success: true,
		errorResponse: null,
		data: [
			{
				idCourseType: '14',
				views: 5,
				title: 'Cyber Crime: Cos’è E Perchè Devi Conoscerlo',
			},
			{
				idCourseType: '13',
				views: 3,
				title: 'Progetto Di Investimento: È Importante Per Te?',
			},
		],
		resultcode: 200,
		errorManagement: null,
	});

export const getPositiveMock = () =>
	getBaseResponse({
		appName: 'S4B',
		requestId: 'c4bd03fc-f2e3-44b1-9320-771c74a23d87',
		success: true,
		errorResponse: null,
		data: [
			{
				idCourseType: '14',
				positive: 5,
				title: 'Cyber Crime: Cos’è E Perchè Devi Conoscerlo',
			},
			{
				idCourseType: '13',
				positive: 3,
				title: 'Progetto Di Investimento: È Importante Per Te?',
			},
		],
		resultcode: 200,
		errorManagement: null,
	});

export const getPaymentGetwaysMock = () =>
	getBaseResponse([
		{
			id: 'stripe',
			type: 'commerce_payment_gateway',
			label: 'Stripe',
			plugin: 'stripe_gateway',
			mode: null,
			payment_method_types: ['stripe_credit_card', 'stripe_sepa'],
		},
	]);

export const setAgreementsMock = () => ({
	status: 200,
	errorMessage: null,
});

export const SubscriptionsList = subscriptionId => {
	const id = subscriptionId;
	const title = ['PACCHETTO FULL', 'FORMAZIONE OBBLIGATORIA'][
		getRandomNumber(0, 2)
	];
	const frequency = ['monthly', 'weekly', 'annualy'][getRandomNumber(0, 3)];
	const price = getRandomNumber(1, 100);
	const duration = getRandomNumber(1, 100);
	return {
		id,
		title,
		description: `Descrizione pacchetto mock ${id}`,
		price,
		frequency,
		duration,
	};
};

export const getCartProduct = index => ({
	nid: 54,
	sku: `[${index}] FULL TRAINING SUBSCRIPTION`,
	qty: 1.0,
	unit_price: '9.990000',
	price: '21.97',
});

export const signupCreateCartMock = () =>
	getBaseResponse({
		order_nid: '154',
		order_uuid: 'be950c58-7e93-4c5d-9687-144e53960944',
		products: [
			{
				nid: '384',
				uuid: '20ecd8a0-9129-4c34-a78e-86a8efe58f12',
				label: 'Corso sulla fattura elettronica',
				sku: 'corso_fattura_elettronica',
				qty: '3.00',
				unit_price: '60.000000',
				price_number: '180.000000',
			},
			{
				nid: '385',
				uuid: 'dc712ba2-03de-48b2-ac87-ce05a9b9e345',
				label: 'Economia Circolare',
				sku: 'prodotto_2',
				qty: '3.00',
				unit_price: '12.000000',
				price_number: '36.000000',
			},
			{
				nid: '386',
				uuid: 'f0f2f953-87a5-4084-bb2f-1afb21273415',
				label: 'BASE',
				sku: 'variation_base',
				qty: '3.00',
				unit_price: '120.000000',
				price_number: '360.000000',
			},
		],
		subtotal_price: '576',
		total_price: '576',
		valid: false,
	});

export const signupGetLatestCartMock = () =>
	getBaseResponse({
		data: {
			cart_nid: '109',
			cart_uuid: 'fb399f6a-6cf2-4340-b08c-ea6193d23034',
			products: [
				{
					nid: '33',
					sku: 'Default',
					qty: '1.00',
					unit_price: '10.000000',
					price: '10.000000',
				},
			],
			total_price: '10.000000',
		},
	});

export const paymentCartMock = () => {
	const status = ['succeeded', 'requires_action'][getRandomNumber(0, 2)];
	return getBaseResponse({
		status,
		payment_intent: 'pi_1GDCeICdk3StydeUkyuKO59p',
		payment_method: 'card_1FqgMPCdk3StydeUxyoSC2C7',
		redirect_url:
			status === 'succeeded'
				? null
				: 'https://hooks.stripe.com/redirect/authenticate/src_1GDSeZCdk3StydeUZvkRdBXO?client_secret=src_client_secret_Gkyb7spks7srk0IQIEMKqCbl',
	});
};

export const getConfigTextMock = () =>
	getBaseResponse({
		subscriptions_config_success: {
			title: 'I tuoi abbonamenti sono stati attivati!',
			description: 'A breve i tuoi collaboratori riceveranno una mail per:',
			list: [
				"Configurare l'account",
				"Scaricare l'App",
				'Creare un piano formativo personalizzato',
			],
			end: 'Da questo momento tutta la formazione  è a portata di App!',
		},
		delete_subscription: {
			title: 'Sei sicuro di voler eliminare il pacchetto?',
			description:
				"L'eliminazione del pacchetto verrà applicata entro le successive 24 ore.",
			cancel: 'Annulla',
			confirm: 'Conferma',
		},
		disable_subscription: {
			title: 'Sei sicuro di voler disabilitare un abbonamento?',
			description:
				'La disabilita anticipata decorrerà allo scadere dell’abbonamento annuale sottoscritto.',
			cancel: 'Annulla',
			confirm: 'Conferma',
		},
		welcome: {
			title: 'Benvenuto a bordo! Grazie per averci scelto!',
			description:
				'Puoi attivare quando vuoi i tuoi abbonamenti direttamente dalla home. Ti ricordiamo che se hai scelto l’addebito su conto corrente dovrai attendere pochi giorni per permettere l’addebito e l’effettiva attivazione del servizio.',
			call_to_action: 'Attiva gli abbonamenti',
		},
		confirm_password: {
			title: 'Procedura completata!',
			description:
				'Controlla la tua e-mail. Arriverà il codice otp per impostare la nuova password.',
			call_to_action: 'Reimposta la password',
		},
		payment_update: {
			title: 'La modifica del metodo di pagamento è avvenuta con successo!',
			description:
				'Dal prossimo mese il costo degli abbonamenti sarà addebitato sul nuovo metodo di pagamento selezionato!',
		},
		premium_purchase_confirm: {
			title: 'Confermi di acquistare le playlist per le utenze selezionate?',
		},
		premium_purchase: {
			title: 'La playlist è stata sbloccata!',
			description:
				'Da questo momento gli utenti che hai selezionato possono accedere alla playlist in app!',
		},
		load_list: {
			title: 'Carica elenco',
			description:
				"Per costruire il file puoi aiutarti con l'esempio che ti forniamo. ",
			description_two:
				', dopo che lo avrai compilato, ricaricalo in questa sezione.',
			cancel: 'Annulla',
			confirm: 'Conferma',
			success: {
				title: "L'elenco è stato caricato correttamente",
				subtitle: "Vedrai l'elenco dei collaboratori caricato sulla pagina.",
			},
		},
		welcome_from_bank: {
			title: 'Account creato',
			description:
				'Il Cliente riceverà a breve una email con le credenziali provvisorie per accedere alla piattaforma. ',
		},
		welcome_from_bank_link: {
			description:
				'Puoi attivare quando vuoi i tuoi abbonamenti direttamente dalla home. ',
		},
	});

export const getPaymentMethodsMock = () =>
	getBaseResponse({
		paymentMethodList: [
			{
				type: 'BankTransfer',
				bankTransferAccountName: 'Frasca',
				id: '8adc8ea17d7686e8017d7745696e14af',
				accountId: '8adcfc2f7d58673f017d6b9dc8af24ed',
				mandateId: 'VPZ5VSLKRS2L7X67',
				bankTransferAccountNumberMask: 'IT*********************3139',
				bankTransferType: 'SEPA',
				defaultPaymentMethod: false,
			},
			{
				type: 'BankTransfer',
				bankTransferAccountName: 'Frasca',
				id: '8adc8ea17d7686e8017d7745aa6014ed',
				accountId: '8adcfc2f7d58673f017d6b9dc8af24ed',
				mandateId: 'BPEZTEQDF8ZOPQFR',
				bankTransferAccountNumberMask: 'IT*********************3139',
				bankTransferType: 'SEPA',
				defaultPaymentMethod: false,
			},
			{
				type: 'CreditCard',
				id: '8adc94ed7d9330fe017d958444ab4d71',
				accountId: '8adcfc2f7d58673f017d6b9dc8af24ed',
				creditCardType: 'Visa',
				creditCardMaskNumber: '************1111',
				creditCardExpirationYear: 2028,
				creditCardExpirationMonth: 12,
				creditCardHolderName: 'Somebody',
				defaultPaymentMethod: true,
			},
		],
		success: true,
	});

export const signupManagerInfoMock = (responseType = 0) => {
	const possibleResponse = [
		getBaseResponse(
			{
				status: 300,
				bodyMessage: 'user successfully created, confirm your account',
			},
			300,
			'Error: Request failed with status code 300'
		),
		{
			status: 400,
			errorMessage: 'An account with the given email already exists.',
		},
		{
			status: 400,
			errorMessage:
				"1 validation error detected: Value at 'password' failed to satisfy constraint: Member must have length greater than or equal to 6",
		},
		{
			status: 400,
			errorMessage: 'cognito error message',
		},
	];

	return possibleResponse[responseType];
};

export const signupManagerPaymentInfoMock = () => {
	const possibleResponse = [
		{
			requestId: 'aafd77db-b2e2-4ede-89b2-1231d37ac1e2',
			userId: '3ef50ef0-cbbf-4fed-bc5c-39fd6f07f09a',
			organizationId: '6f9b0edd-1c54-4d19-8f3f-34a9f9c94fd2',
			paymentMethodId: '43f4064c-79cf-4a40-b30b-e50480ee30b7',
			status: 200,
			errorMessage: null,
		},
		{
			status: 400,
			errorMessage: 'Cannot be created',
		},
	];

	return getBaseResponse(possibleResponse[0], 200);
};

export const authenticationSigninMock = () => {
	const possibleResponse = [
		getBaseResponse(MOCK_PROFILE),
		getBaseResponse({
			status: 401,
			errorMessage: 'Unauthorized',
		}),
		getBaseResponse(
			{
				status: 300,
				errorMessage: 'Missing fields (phone number / fiscale code)',
				token: 't o k e n',
				accessToken: 'a c c e s s t o k e n ',
				refreshToken: 'r e f r e s h t o k e n',
				username: '919f591a-6884-4039-8d7a-56d074593798',
			},
			300,
			'Missing fields (phone number / fiscale code)'
		),
		getBaseResponse(
			{
				status: 400,
				errorMessage: 'User is not confirmed.',
			},
			400,
			'User is not confirmed.'
		),
	];

	return possibleResponse[0];
};

export const authenticationSignoutMock = () => {
	const possibleResponse = [
		{
			username: 'a6d43cba-0182-4b19-894b-27560aa54d74',
			firstname: 'nome_utente_1',
			lastname: 'cognome_utente_1',
			email: 'ispteampostman@gmail.com',
			role: 'Admin',
			pictureid: 'https://image.png',
			organizationid: '762c3f56-1823-4217-aa0e-a293a7498eda',
			prospectid: null,
			industry: 'Settore IT',
			token: 'token',
			expiresin: 3600,
			accesstoken: 'accesstoken',
		},
		{
			status: 401,
			errorMessage: 'Unauthorized',
		},
	];

	return possibleResponse[getRandomNumber(0, 2)];
};

export const getClientSecretMock = () =>
	getBaseResponse(
		{
			client_secret:
				'seti_1IxTcUCdk3StydeUucjPRHkG_secret_JaewGz7f3tv79GgWAo70Q9d5HkwBGHp',
		},
		201
	);

export const getZuoraSignatureMock = () => getBaseResponse({
	pageId: '8adc8ea17cfebeb8017d05186da06142',
	tenantId: '123',
	token: 'qJ52b1iCyPXyZTcuQbfZa2qmKhD4qBGz',
	signature: 'MjJmYjBmNTY3ZWI3ZjcyZTRmMjZlZWVhMTJhZDhiYWI1ZjUyMGRkNQ==',
	key: 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC59DglWlsd82ooSVYyXoniF5rln3edz+5tdPLVBXXPDVXDCI9w7sneaj+XQs5LFaHZby117XzE8CFmoskVd2tsGLvXr83gEQ7eCXUrY0NDBFlAs0t+ChkB18VXG2DBbeUCI2poZJpCbpQm4rSvqUeY+8H/+/Stf4hXFWVPEEWyjwIDQAB',
}, 200);

export const setDefaultPaymentMethodZuoraMock = () => getBaseResponse({}, 200);

export const checkDiscountCodeMock = code =>
	getBaseResponse({
		name: '50% off',
		display_name: null,
		description: null,
		compatibility: 'any',
		offer: {
			offer_type: 'order_item_percentage_off',
			percentage: '0.5',
		},
	});

export const getSectorMock = () => ({
	data: {
		0: {
			id: '2',
			name: 'Alimentare',
		},
		1: {
			id: '7',
			name: 'Agricolo',
		},
		2: {
			id: '8',
			name: 'Altre Industrie Manifatturiere',
		},
		3: {
			id: '9',
			name: 'Ambiente',
		},
		4: {
			id: '10',
			name: 'Arredamento',
		},
		5: {
			id: '11',
			name: 'Assicurativo',
		},
		6: {
			id: '12',
			name: 'Carta',
		},
		7: {
			id: '13',
			name: 'Chimico',
		},
		8: {
			id: '14',
			name: 'Distribuzione',
		},
		9: {
			id: '15',
			name: 'Edilizia',
		},
		10: {
			id: '16',
			name: 'Energia',
		},
		11: {
			id: '17',
			name: 'Estrattivo',
		},
		12: {
			id: '18',
			name: 'Farmaceutico',
		},
		13: {
			id: '19',
			name: 'Finanziario',
		},
		14: {
			id: '20',
			name: 'Gomma',
		},
		15: {
			id: '21',
			name: 'Installazioni',
		},
		16: {
			id: '22',
			name: 'Legno',
		},
		17: {
			id: '23',
			name: 'Materiale da Costruzione',
		},
		18: {
			id: '24',
			name: 'Metalmeccanico',
		},
		19: {
			id: '25',
			name: 'Moda e Accessori',
		},
		20: {
			id: '26',
			name: 'Plastica',
		},
		21: {
			id: '27',
			name: 'Sanità e salute',
		},
		22: {
			id: '28',
			name: 'Servizi innovativi e tecnologici',
		},
		23: {
			id: '29',
			name: 'Spettacolo',
		},
		24: {
			id: '30',
			name: 'Stampa-editoria',
		},
		25: {
			id: '31',
			name: 'Trasporto',
		},
		26: {
			id: '32',
			name: 'Turismo',
		},
		27: {
			id: '33',
			name: 'Vetro',
		},
		28: {
			id: '34',
			name: 'Altro',
		},
		29: {
			id: '35',
			name: 'Altri Servizi',
		},
	},
});

export const updateProfileCompanyMock = () => getBaseResponse({
	appName: 'S4B',
	requestId: 'f321f008-51ab-46ce-ab9b-23f0954d68be',
	success: true,
	errorResponse: null,
	response: {
		organizationId: '41648484-e0f5-4515-8cb7-63b81beebf86',
		title: 'Accenture SPA',
		vatNumber: '63934470590',
		street: 'Piazzale Industria',
		city: 'Roma',
		district: 'RM',
		zipCode: '00040',
		sdiNumber: '123edsw',
		atecoCode: '33',
		atecoDescription: 'RIPARAZIONE, MANUTENZIONE ED INSTALLAZIONE DI MACCHINE ED APPARECCHIATURE',
		organizationType: 'persona_giuridica',
		orgFiscalCode: '54298950764',
	},
	resultCode: 200,
	errorManagement: null,
});

export const createUserMock = () =>
	getBaseResponse({
		userName: '919f591a-6884-4039-8d7a-56d074593798',
		email: 'a.rouissi@accenture.com',
		token: 't o k e n',
		expiresIn: 3600,
		accessToken: 'a c c e s s t o k e n ',
		refreshToken: 'r e f r e s h t o k e n',
		domainList: IS_MULTI_DOMAIN ? domainList : domainList.at(0),
		clientEnabled: userType,
		sendDataTreatment: false,
		givenName: 'Anouer',
		familyName: 'Rouissi',
	});

export const getWalletStatusMock = () =>
	getBaseResponse({ last_updated: '2022-12-12T11:11:11' });

export const getTeamProgessMock = () =>
	getBaseResponse({
		appName: 'S4B',
		requestId: 'd142822a-6a5d-48cb-923f-39f19093dd5f',
		success: true,
		errorResponse: null,
		items: [
			{
				userName: 'b1a76447-7014-42ba-9776-ec4a24aeaa1e',
				firstname: 'MARTA RUTH',
				lastname: 'TORRE',
				counterNote: 0,
				counterReview: 0,
				profilepic:
					'https://los4b2sit.ispfdevelop.com/images/profile/a18f9a18-af09-4dd5-af0d-1163dfe39ad2_2021-06-30T13:17:14.096388Z.jpg',
				selectedCollection: [
					'Sales e marketing mix',
					"Esporta con l'e-commerce",
					'Additive manufacturing',
					"Come presentare un piano d'impresa",
					'Agriturismo',
					'Digitale per retailer',
					'Il business agricolo',
					'I pagamenti digitali per sviluppare il business',
					"Come l'azienda agricola diventa sostenibile",
					'Costruire un sito e-commerce',
					'Azienda agricola 2.0',
				],
				collectionProgress: { complete: 0, total: 76 },
				selectionProgress: { complete: 0, total: 0 },
			},
			{
				userName: 'oaIBgNth-WwqC-BuEf-eauE-HLQFCqarhjny',
				firstname: 'marta',
				lastname: 'della torre',
				counterNote: 0,
				counterReview: 1,
				profilepic: null,
				selectedCollection: [
					'Smart working',
					'Sviluppo del capitale umano',
					'Costruire un sito e-commerce',
					'Accesso al capitale di terzi',
					'Internet of things e 5g per l’industria 4.0',
					"Esporta con l'e-commerce",
					'Big data',
					'Come presentare un progetto di investimento',
					'Digitale per retailer',
					'Leadership sviluppo persone',
				],
				collectionProgress: { complete: 20, total: 72 },
				selectionProgress: { complete: 0, total: 75 },
			},
			{
				userName: 'HTDTZIeb-Jtjt-Mjtu-omsp-cHLgPKrnGLqK',
				firstname: 'test',
				lastname: 'errorModal',
				counterNote: 0,
				counterReview: 0,
				profilepic: null,
				selectedCollection: [
					'Come presentare un progetto di investimento',
					'Realtà virtuale e aumentata',
					'Relazione banca impresa',
					'Smart working',
					'Accesso al capitale di terzi',
					'La circular economy per la mia azienda',
					'Big data',
					'Circular economy? Come svilupparla in azienda',
					'Internet of things e 5g per l’industria 4.0',
					'Additive manufacturing',
				],
				collectionProgress: { complete: 0, total: 75 },
				selectionProgress: { complete: 0, total: 75 },
			},
			{
				userName: 'HIrIEtbz-rHuk-hpVC-xtlO-YhEQSFyyevgy',
				firstname: 'Anna',
				lastname: 'Oxa',
				counterNote: 0,
				counterReview: 0,
				profilepic: null,
				selectedCollection: [
					'I pagamenti digitali per sviluppare il business',
					"Come l'azienda agricola diventa sostenibile",
					'Sales e marketing mix',
					'Il business agricolo',
					'Digitale per retailer',
					"Come presentare un piano d'impresa",
					'Azienda agricola 2.0',
					'Costruire un sito e-commerce',
					'Agriturismo',
					"Esporta con l'e-commerce",
				],
				collectionProgress: { complete: 1, total: 72 },
				selectionProgress: { complete: 0, total: 0 },
			},
		],
		resultCode: 200,
		errorManagement: null,
	});

export const associatePaymentMethodMock = () => getBaseResponse({}, 200, 'ok');

export const deletePaymentMethodMock = () => getBaseResponse({}, 200, 'ok');

export const getNotificationsMock = () =>
	getBaseResponse(
		{
			appName: 'S4B',
			requestId: '2fdac8c2-1596-4c4b-815c-9ef190ae2d36',
			success: true,
			errorResponse: null,
			notifications: [
				{
					title: 'Ora tocca a te!',
					subtitle: null,
					body:
						'Il tuo manager  ha sbloccato la playlist premium che desideravi! Corri a guardarla!',
					section: 'S4B_UPDATE_PREMIUM_PL',
					sourceId: null,
					type: null,
					id: null,
					creationDate: '2021-06-09T13:33:33.970',
				},
				{
					title: 'Ora tocca a te!',
					subtitle: null,
					body:
						'Il tuo manager  ha sbloccato la playlist premium che desideravi! Corri a guardarla!',
					section: 'S4B_UPDATE_PREMIUM_PL',
					sourceId: null,
					type: null,
					id: null,
					creationDate: '2021-06-09T13:33:33.970',
				},
				{
					title: 'Ora tocca a te!',
					subtitle: null,
					body:
						'Il tuo manager  ha sbloccato la playlist premium che desideravi! Corri a guardarla!',
					section: 'S4B_UPDATE_PREMIUM_PL',
					sourceId: null,
					type: null,
					id: null,
					creationDate: '2021-06-09T13:33:33.970',
				},
				{
					title: 'Ora tocca a te!',
					subtitle: null,
					body:
						'Il tuo manager  ha sbloccato la playlist premium che desideravi! Corri a guardarla!',
					section: 'S4B_UPDATE_PREMIUM_PL',
					sourceId: null,
					type: null,
					id: null,
					creationDate: '2021-06-09T13:33:33.970',
				},
				{
					title: 'Ora tocca a te!',
					subtitle: null,
					body:
						'Il tuo manager  ha sbloccato la playlist premium che desideravi! Corri a guardarla!',
					section: 'S4B_UPDATE_PREMIUM_PL',
					sourceId: null,
					type: null,
					id: null,
					creationDate: '2021-06-09T13:33:33.970',
				},
			],
			resultCode: 200,
			errorManagement: null,
		},
		200,
		'ok'
	);
export const createAddonMock = () =>
	getBaseResponse({
		data: [
			{
				id: '1',
			},
		],
	});

export const associateAddonSubscriptionMock = () => getBaseResponse();

export const getLandingPageMock = () => {

	return getBaseResponse(
		{"data":[{"label":"","title":"Benvenuti umani!","subtitle":"","description":"\u003Cp\u003ESono \u003Cstrong\u003EApollo\u003C/strong\u003E, il Dio della conoscenza, della musica, del sole e dell\u0027arte e sono qui per presentarvi la nostra ultima avventura di apprendimento sulla \u003Cstrong\u003Enuova piattaforma di e-learning\u003C/strong\u003E.\u003Cbr /\u003E\nSono lieto di introdurvi in questo percorso di crescita professionale, in cui potrete accedere a una vasta gamma di corsi di formazione e materiali utili ad arricchire il vostro bagaglio di conoscenze e competenze di business.\u003Cbr /\u003E\nHo personalmente dedicato tempo ed energia per fornirvi un\u0027esperienza di apprendimento migliore, con contenuti sempre aggiornati e un\u0027interfaccia intuitiva e facile da utilizzare.\u003C/p\u003E\n\n\u003Ch5\u003E\u003Cbr /\u003E\u003Cstrong\u003ENon perdete tempo, iniziate da subito ad esplorare la piattaforma!\u003C/strong\u003E\u003C/h5\u003E\n\n\u003Ch5\u003E\u003Cstrong\u003EE che il mio fuoco di conoscenza vi illumini sempre...\u003C/strong\u003E\u003C/h5\u003E\n\n\u003Cp\u003E\u00a0\u003C/p\u003E\n\n\u003Ch2\u003E\u003Cstrong\u003EBUON APPRENDIMENTO!\u003C/strong\u003E\u003C/h2\u003E","description_trimmed":"\u003Cp\u003ESono \u003Cstrong\u003EApollo\u003C/strong\u003E, il Dio della conoscenza, della musica, del","brand":[{"name":"Prelios","color":"#33a7b2","color_2":"#c8d300","logo":"https://medias4b2sit.ispfdevelop.com/media/2023-02/Logo_Prelios_ottanio.png?VersionId=HN.rcukReCYe_GVxgoDhs4c9lKMz9tQt","logo_white":"https://medias4b2sit.ispfdevelop.com/media/2023-02/Logo_Prelios_bianco.png?VersionId=za9qEgkU7L_WcKLe.bYehWHCHwU2cPzp","logo_rgb":"https://medias4b2sit.ispfdevelop.com/media/2023-02/Logo_Prelios_ottanio.png?VersionId=HN.rcukReCYe_GVxgoDhs4c9lKMz9tQt"}],"cta_apple_store_title":"","cta_apple_store_url":"","cta_subscribe_title":"Accedi","cta_subscribe_url":"/access","image_app":"","image_background":"https://medias4b2sit.ispfdevelop.com/media/2023-03/homepage%20apollo.png?VersionId=dxblC2OcE87OCARutaF13sSOabKNQCK1","paragraphs":{"data":[]}}],"pager":{"current_page":0,"total_items":"1","total_pages":1,"items_per_page":10},"count_data_obj":"1"}
	);
};

export const getDomainMock = () => {
	switch (domainType) {
		case DomainType.PRELIOS:
			return getBaseResponse({
				count_data_obj: "1",
				data: [
					{
						brand: [
							{
								color: "#33a7b2",
								color_2: "#c8d300",
								logo: "https://medias4b2sit.ispfdevelop.com/media/2023-02/Logo_Prelios_ottanio.png?VersionId=HN.rcukReCYe_GVxgoDhs4c9lKMz9tQt",
								logo_rgb: "https://medias4b2sit.ispfdevelop.com/media/2023-02/Logo_Prelios_ottanio.png?VersionId=HN.rcukReCYe_GVxgoDhs4c9lKMz9tQt",
								logo_white: "https://medias4b2sit.ispfdevelop.com/media/2023-02/Logo_Prelios_bianco.png?VersionId=za9qEgkU7L_WcKLe.bYehWHCHwU2cPzp",
								name: "Prelios"
							}
						],
						cohort_id: 78,
						consents: {
							data: [
								{
									code: "Consenso_0010",
									consents: [
										{
											code: "Consenso_persona_Fisica_01",
											description: "<p>Dichiaro di aver preso visione dell'informativa per il <a href=\"https://formazione.digited.it/wp-content/uploads/2022/07/Informativa_Privacy_fruitori_DigitEd.pdf\" target=\"_blank\">trattamento dei dati personali</a>.</p>\n\n<p> </p>\n",
											id: "33",
											mandatory: "True",
											name: "Persona fisica_CONSENSO DELL’INTERESSATO AL TRATTAMENTO DEI DATI PERSONALI_1",
											type: "checkbox",
											user_type: ""
										},
										{
											code: "Consenso_PF1",
											description: "<p>CONSENSO DELL’INTERESSATO AL TRATTAMENTO DEI DATI PERSONALI</p>\n\n<p>con riferimento al trattamento per la finalità di marketing diretto ed indiretto, di cui alla lettera c) della Sezione 3 dell’Informativa, al trattamento dei dati personali a fini di informazione commerciale, offerte dirette, indagini di mercato o di <em>customer satisfaction </em>relative a prodotti e servizi della Società Digit'Ed;</p>",
											id: "25",
											mandatory: "False",
											name: "Persona fisica_1",
											type: "radio",
											user_type: ""
										},
										{
											code: "Consenso_PF2",
											description: "<p>al trattamento dei dati personali ai fini dell’offerta di prodotti e servizi specificamente individuati in base al profilo personale;</p>",
											id: "26",
											mandatory: "False",
											name: "Persona fisica_2",
											type: "radio",
											user_type: ""
										},
										{
											code: "Consenso_PF3",
											description: "<p>al trattamento dei dati personali a fini di informazione commerciale, offerte dirette, indagini di mercato o di <em>customer satisfaction </em>relative a prodotti e servizi di altre società;</p>",
											id: "27",
											mandatory: "False",
											name: "Persona fisica_3",
											type: "radio",
											user_type: ""
										}
									],
									id: 109,
									title: "Informativa della privacy persona fisica"
								}
							]
						},
						contract: {
							data: [
								{
									code: "Consenso_0020",
									consents: [
										{
											code: "Consenso_0017",
											description: "<p style=\"text-align:justify\"><img alt=\"logo\" data-entity-type=\"file\" data-entity-uuid=\"a520589d-4a28-4c49-b715-f518e48f742a\" height=\"66\" src=\"https://medias4b2sit.ispfdevelop.com/media/s3fs-public/inline-images/Digit%27Ed_logo%20for%20white%20bg.png?VersionId=O8l2lyqmYxDklZGBjU756RUoYn8b3Tzh\" width=\"231\" class=\"align-left\" loading=\"lazy\" /></p>\n\n<p style=\"text-align:justify\"> </p>\n\n<p style=\"text-align:justify\"> </p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\"><span style=\"font-size:20.0pt\">“Servizio SKILLS4CAPITAL” - Condizioni generali di Contratto</span></span></span></span></span></p>\n\n<p> </p>\n\n<p> </p>\n\n<p><span style=\"font-size:11pt\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\"><b>DEFINIZIONI</b></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">Nel presente Contratto deve intendersi per:</span></span></span></span></p>\n\n<p style=\"text-align:justify\"> </p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">“<b>CLIENTE IMPRESA</b>”: il soggetto diverso dal “consumatore”, dal libero professionista e dalle micro-imprese - secondo il significato attribuito a queste categorie dal decreto legislativo del 6 settembre 2005, n. 206 e successive modificazioni o integrazioni (c.d. Codice del Consumo) che sottoscrive il presente contratto;</span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">“<b>Contratto</b>”: indica il presente contratto, disciplinato dalle condizioni particolari illustrate nel procedimento di iscrizione di cui all’Art. 2 e dalle Condizioni Generali di Contratto, concluso con le modalità indicate all’Art. 2;</span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">“<b>DIGIT’ED</b>”: DIGIT’ED S.p.A., con sede legale in via Antonio Cechov n. 50/5; </span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">“<a name=\"_Hlk75945223\" id=\"_Hlk75945223\"><b>PACCHETTO FORMATIVO BASE</b></a>”: il pacchetto formativo caratterizzato da contenuti formativi trasversali; </span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">“<b>PACCHETTO FORMATIVO TEMATICO</b>”: il pacchetto formativo caratterizzato da contenuti formativi su specifiche aree tematiche;</span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">“<b>PACCHETTI FORMATIVI</b>”: indica l’insieme dei Pacchetti Formativi Base e i Pacchetti Formativi Tematici;</span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">“<b>PIATTAFORMA</b>”: la piattaforma telematica di proprietà di (e gestita da) Digit’Ed a cui il Cliente Impresa può accedere per fruire dei contenuti formativi; </span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">“<b>SITO</b>”: Il sito internet “www.skills4capital.com”, di proprietà di Digit’Ed; </span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">“<b>UTENTE</b>”: ciascuno dei soggetti indicati nel Contratto quali fruitori del Pacchetto Formativo Base o/e del Pacchetto Formativo Tematico e che si registrino in base ai profili indicati nella Piattaforma per lo specifico Pacchetto Formativo Base o/e Pacchetto Formativo Tematico ai sensi del presente Contratto.</span></span></span></span></p>\n\n<p style=\"text-align:justify\"> </p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\"><b>Art. 1 – OGGETTO DEL CONTRATTO</b></span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">1.1 Il presente Contratto disciplina i termini e le condizioni per l’erogazione dei contenuti informativi del Pacchetto Formativo Base e/o del Pacchetto Formativo Tematico, a seconda dei casi.</span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">1.2 Il Cliente Impresa sceglie al momento della conclusione del Contratto almeno un Pacchetto Formativo tra quelli offerti sulla Piattaforma. Nel corso del rapporto e fino all’eventuale comunicazione di disdetta ai sensi dell’articolo 4.1, il Cliente Impresa può acquistare ulteriori Pacchetti Formativi Base o/e Pacchetti Formativi Tematici tra quelli per tempo offerti da Digit’Ed nonché abilitare ulteriori utenze relativi agli stessi; anche per gli ulteriori Pacchetti Formativi e per le ulteriori utenze attivate resta ferma la data di scadenza originaria o prorogata del presente Contratto.  </span></span></span></span></p>\n\n<p style=\"text-align:justify\"> </p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\"><b>Art. 2 – CONCLUSIONE DEL CONTRATTO - ACQUISTO DI ULTERIORI CONTENUTI FORMATIVI E ATTIVAZIONE DI ULTERIORI UTENZE</b></span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">2.1 Il presente Contratto si conclude a distanza sul Sito con le seguenti modalità: il Cliente Impresa, seguendo le istruzioni, si registra, sceglie almeno un Pacchetto Formativo, indica il numero di utenze da abilitare, accetta le presenti condizioni contrattuali e autorizza i pagamenti secondo i tempi e le modalità di cui all’articolo 5. </span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">2.2 L’acquisto degli ulteriori contenuti formativi e l’attivazione di ulteriori utenze avviene sulla Piattaforma con le modalità del comma precedente in quanto compatibili. Il Cliente Impresa prende atto e accetta che agli acquisti successivi di ulteriori Pacchetti Formativi e alle attivazioni successive di nuove utenze si applicano le norme del presente Contratto. Salvo che il Cliente Impresa indichi diversamente, al momento dell’acquisto uno o più ulteriori Pacchetti Formativi, si intende richiesto il medesimo numero di utenze abilitate già in essere con i medesimi nominativi e dati. </span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">2.3 Le caratteristiche dei Pacchetti Formativi e i prezzi applicati al Cliente Impresa sono quelli indicati sul Sito al momento della conclusione del Contratto.  </span></span></span></span></p>\n\n<p style=\"text-align:justify\"> </p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\"><b>Art. 3 – ATTIVAZIONE  </b></span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">3.1 I Pacchetti Formativi acquistati al momento della conclusione del Contratto sono fruibili quando Digit’Ed abbia ricevuto conferma del valido rilascio delle autorizzazioni di addebito ai sensi dell’art. 5.2. </span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">3.2 Gli ulteriori Pacchetti Formativi acquistati successivamente alla conclusione del Contratto vengono resi disponibili agli Utenti abilitati entro 1 giorno lavorativo. </span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">3.3 Eventuali ulteriori utenze da abilitare sui Pacchetti Formativi già acquistati saranno disponibili entro 1 giorno lavorativo.</span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">3.4. Per la fruizione dei Pacchetti Formativi acquistati gli Utenti abilitati ricevono via e-mail il link alla pagina web che consente di impostare la password ed accedere alla Piattaforma.</span></span></span></span></p>\n\n<p style=\"text-align:justify\"> </p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\"><b>Art.4 – DURATA E CONDIZIONI DI RECESSO</b></span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">4.1 Il presente Contratto ha durata annuale decorrente dalla data di attivazione dei Pacchetti Formativi ai sensi dell’Articolo 3.1. Il Pacchetto Formativo Base si rinnova tacitamente di anno in anno ad ogni scadenza originaria o prorogata, salvo che (i) il Cliente Impresa non abbia effettuato il pagamento del corrispettivo entro quindici giorni lavorativi precedenti la data di scadenza, o (ii) una delle Parti abbia inviato disdetta tramite l’apposita procedura prevista sulla Piattaforma. Il Pacchetto Formativo Tematico ha invece durata annuale e non è suscettibile di automatico rinnovo a scadenza.</span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">4.2 Il Cliente Impresa può inoltre richiedere di disabilitare una o più utenze ad ogni scadenza originaria o prorogata mediante apposita procedura sulla Piattaforma. </span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">4.3 Per gli ulteriori contenuti formativi acquistati e per le ulteriori utenze abilitate dopo la sottoscrizione del presente Contratto si applica l’articolo 1.2. </span></span></span></span></p>\n\n<p style=\"text-align:justify\"> </p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\"><b>Art. 5 – PAGAMENTI</b></span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">5.1 Il corrispettivo per l’erogazione dei Pacchetti Formativi acquistati e del numero delle utenze abilitate è annuale; il pagamento avviene in un’unica soluzione in forma anticipata e, in caso di rinnovo, nel termine di cui al precedente punto 4.1.</span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">5.2 Per il pagamento degli importi dovuti, il Cliente Impresa deve autorizzare l’addebito mediante sistema di pagamento selezionato tra quelli disponibili nella Piattaforma.</span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">5.3 In occasione di ciascun addebito, Digit’Ed emette la relativa fattura.</span></span></span></span></p>\n\n<p style=\"text-align:justify\"> </p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\"><b>Art. 6 – UTILIZZO DEL SERVIZIO DA PARTE DEL CLIENTE</b></span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">6.1 Il Cliente Impresa dichiara di <i>(i) </i>essere a conoscenza e di accettare i prerequisiti hardware e software necessari per poter accedere alla Piattaforma e fruire dei contenuti formativi, e di <i>(ii) </i>prendere atto che sarà onere dell’Utente (e quindi del Cliente Impresa) dotarsi dei componenti hardware e software necessari. In particolare, il Cliente Impresa prende atto che i requisiti hardware e software richiesti sono minimi e sono generalmente soddisfatti su un normale sistema standard per uso domestico e che per poter usufruire al meglio dei contenuti multimediali presenti è necessario:</span></span></span></span></p>\n\n<ul><li style=\"text-align:justify; margin-left:8px\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">avere una connessione alla rete Internet. Per un utilizzo ottimale è consigliata una connessione ADSL;</span></span></span></span></li>\n\t<li style=\"text-align:justify; margin-left:8px\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">avere installato sulla propria macchina uno tra i principali browser disponibili regolarmente aggiornati;</span></span></span></span></li>\n\t<li style=\"text-align:justify; margin-left:8px\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">avere installato sulla propria macchina il software Adobe Acrobat Reader per visualizzare alcuni materiali in formato pdf.  </span></span></span></span></li>\n</ul><p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">È esclusiva responsabilità del Cliente Impresa assicurare l’interoperabilità tra la connettività, di cui si sia dotato, e la Piattaforma. </span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">6.2 Il Cliente Impresa si impegna, inoltre, ad adeguare l’hardware o software proprio e dei propri Utenti nel caso in cui fosse necessario a seguito di successivi aggiornamenti della Piattaforma.</span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">6.3 Il Cliente Impresa è, inoltre, consapevole che l’utilizzo dei contenuti formativi acquistati è consentito solo agli Utenti abilitati e che le stesse non potranno esser sostituite dopo l’attivazione. </span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">6.4 Il download e l’utilizzo dei contenuti formativi messi a disposizione è permesso solo alle Utenti abilitati. Il Cliente Impresa è responsabile, anche per conto delle utenze abilitate, della conservazione della segretezza delle credenziali assegnate ed è titolare, per effetto della conclusione del Contratto, di un diritto non cedibile di accesso all’area riservata, impegnandosi così a non far utilizzare o visionare i contenuti formativi a soggetti diversi dagli Utenti abilitati. Il Cliente Impresa si astiene dal compiere qualunque atto che possa ledere i diritti di esclusiva e di proprietà di Digit’Ed e si impegna altresì a manlevare e tenere indenne Digit’Ed da ogni e qualsiasi pretesa o rivendicazione derivante dall’uso o abuso di diritti di terzi.</span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">6.5 In caso di parziale o mancata fruizione da parte di uno o più Utenti abilitati dei contenuti formativi nel periodo di disponibilità degli stessi, non è prevista alcuna forma di rimborso a favore del Cliente Impresa, che resterà invece tenuto a corrispondere quanto ancora dovuto.</span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">6.6 Il Cliente Impresa infine non può cedere a terzi alcun obbligo o diritto originato dal presente Contratto in assenza di preventiva autorizzazione scritta di Digit’Ed. </span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">6.7 In caso di necessità di assistenza, il Cliente Impresa può contattare info@skills4capital.com<span class=\"MsoHyperlink\" style=\"color:blue\"><span style=\"text-decoration:underline\">.</span></span></span></span></span></span></p>\n\n<p style=\"text-align:justify\"> </p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\"><b>Art. 7 – FORNITURA DEL SERVIZIO</b></span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">7.1 Digit’Ed può avvalersi di soggetti terzi per l’esecuzione del Contratto; in particolare i contenuti formativi e le relative informazioni sono elaborati, rivisti ed aggiornati da Digit’Ed anche con la consulenza specialistica e il supporto di professionisti qualificati. </span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">7.2 Digit’Ed avrà la facoltà di sospendere parzialmente o totalmente le credenziali o di interrompere l’esecuzione del Contratto, dandone al Cliente Impresa immediata comunicazione tramite la Piattaforma o mediante e-mail qualora vi fossero fondati motivi per ritenere che si possano verificare problemi di sicurezza o di utilizzo non autorizzato.</span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">I suddetti oneri di comunicazione non possono considerarsi sussistenti in casi, alternativamente considerati, di forza maggiore, necessità o urgenza.</span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">7.3 Fermo quanto precede, Digit’Ed ha la facoltà di sospendere l’accesso e la fruibilità dei Pacchetti Formativi per periodi non superiori a 24 (ventiquattro) ore lavorative a causa di interventi di manutenzione e/o di aggiornamento dei contenuti formativi, e per periodi anche superiori a 24 (ventiquattro) ore lavorative per implementazioni tecnologiche della Piattaforma o in presenza di motivati problemi di sicurezza o garanzia di riservatezza, senza che ciò determini inadempimento al Contratto né dia diritto al Cliente Impresa a qualsivoglia risarcimento o indennità. Nel caso di interruzione per interventi di manutenzione programmabili, il Cliente Impresa sarà informato da Digit’Ed via e-mail (all’indirizzo di posta elettronica indicato nel processo di ordinazione) con il preavviso di 12 (dodici) ore; in tutti gli altri casi la comunicazione sarà effettuata non appena possibile con le modalità sopra indicate.</span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">7.4 Ai fini di cui al precedente comma 3, per ora lavorativa si intende un’ora compresa nell’intervallo tra le ore 8.30 e le ore 17.00 di una giornata non festiva compresa tra il lunedì e il venerdì.</span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">7.5 Nel caso di impedimento oggettivo che esuli dalla sfera del diretto ed immediato controllo di Digit’Ed o nel caso di forza maggiore:</span></span></span></span></p>\n\n<ul><li style=\"text-align:justify; margin-left:8px\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">Digit’Ed, se possibile, concorderà quanto prima con il Cliente Impresa le date e le modalità con cui recuperare l’erogazione dei Pacchetti Formativi e, qualora ciò non fosse possibile, Digit’Ed avrà diritto di risolvere in tutto o in parte il Contratto, dandone comunicazione al Cliente Impresa via e- mail e restituendogli la quota parte delle somme versate relativa alle prestazioni non godute;</span></span></span></span></li>\n\t<li style=\"text-align:justify; margin-left:8px\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">Digit’Ed non sarà responsabile per il ritardo o la mancata erogazione, e/o per danni o conseguenze negative derivanti da tale ritardo o dalla mancata erogazione del Corso di Formazione.</span></span></span></span></li>\n</ul><p style=\"text-align:justify\"> </p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\"><b>Art. 8 – SICUREZZA DEI DATI</b></span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">8.1 Il Cliente Impresa garantisce<i> (i) </i>di disporre legittimamente di tutte le informazioni fornite (o comunque messe a disposizione di Digit’Ed) ai fini della sottoscrizione del presente Contratto, assicurando altresì che le stesse non violino in alcun modo, direttamente o indirettamente, il diritto di terzi, e che <i>(ii) </i>i dati e le informazioni forniti (o comunque messi a disposizione di Digit’Ed) sono completi, veritieri e riferiti al Cliente Impresa o a ciascuno degli Utenti. Pertanto, il Cliente Impresa si obbliga a non immettere dati di cui non possa liberamente disporre.</span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">È fatto altresì divieto al Cliente Impresa di inserire dati falsi o di fantasia nella procedura di acquisto e in tutte le comunicazioni connesse all’esecuzione del Contratto.</span></span></span></span></p>\n\n<ul><li style=\"list-style-type:none\">\n\t<ol start=\"2\"><li style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">Il Cliente Impresa terrà Digit’Ed manlevata e indenne:</span></span></span></span></li>\n\t</ol></li>\n\t<li style=\"text-align:justify; margin-left:8px\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">da ogni responsabilità derivante dall’immissione di dati e documenti errati e/o non conformi a quanto previsto al paragrafo 8.1, essendo il Cliente Impresa stesso unico responsabile del corretto inserimento;</span></span></span></span></li>\n\t<li style=\"text-align:justify; margin-left:8px\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">da ogni obbligo o onere di accertamento e controllo diretto e indiretto al riguardo.</span></span></span></span></li>\n</ul><p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">8.3 Qualora venga accertata, in via autonoma da Digit’Ed o su segnalazione di terzi, la falsità dei dati forniti e/o la loro non conformità a quanto previsto dal paragrafo 8.1, Digit’Ed si riserva il diritto di impedire/sospendere la registrazione del Cliente Impresa e l’esecuzione del Contratto.</span></span></span></span></p>\n\n<p style=\"text-align:justify\"> </p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\"><b>ART. 9 – RESPONSABILITA’ E MANLEVA</b></span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">9.1 Salvi i casi di dolo o colpa grave, il Cliente Impresa esonera espressamente Digit’Ed da qualsiasi responsabilità per danni diretti e indiretti:</span></span></span></span></p>\n\n<ul><li style=\"text-align:justify; margin-left:8px\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">che il Cliente Impresa stesso, gli Utenti abilitati o i terzi possano subire in relazione o in dipendenza dell’interruzione del Contratto;</span></span></span></span></li>\n\t<li style=\"text-align:justify; margin-left:8px\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">che il Cliente Impresa stesso, le utenze abilitate o terzi possano in qualche modo lamentare per la mancata erogazione della connettività da parte del gestore della rete di telecomunicazione, o anche per il ricorso da parte del Cliente Impresa o delle utenze abilitate all’utilizzo di connettività tecnicamente incompatibile con il servizio offerto, nonché per la mancata fruizione del servizio a seguito di difetti riscontrati dal Cliente Impresa nella fruizione dello stesso, qualora tutto ciò sia dipeso dal mancato possesso dei requisiti minimi di sistema di cui all’articolo 6, la cui verifica è onere del Cliente Impresa;</span></span></span></span></li>\n\t<li style=\"text-align:justify; margin-left:8px\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">causati da terzi che illecitamente accedessero al servizio a causa della mancanza, da parte del Cliente Impresa o degli Utenti abilitati, di cautela nella custodia delle credenziali attribuite o per l’assenza di altre misure di sicurezza che il Cliente Impresa e gli Utenti abilitati sono tenute ad adottare.</span></span></span></span></li>\n</ul><p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">9.2 In nessun caso Digit’Ed sarà ritenuta responsabile:</span></span></span></span></p>\n\n<ul><li style=\"text-align:justify; margin-left:8px\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">del malfunzionamento del servizio derivante da guasti, sovraccarichi, interruzioni delle linee telefoniche, elettriche o riferite alla rete Internet;</span></span></span></span></li>\n\t<li style=\"text-align:justify; margin-left:8px\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">per inadempimenti di terzi che pregiudichino la fruizione dei contenuti formativi, compresi, in via esemplificativa, i rallentamenti di velocità o il mancato funzionamento delle linee telefoniche e degli elaboratori che gestiscono il traffico telematico fra il Cliente Impresa e la Piattaforma.</span></span></span></span></li>\n</ul><p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">9.3 Digit’Ed, inoltre, non potrà essere ritenuta responsabile per inadempimenti derivanti da impedimenti oggettivi che esulino dalla sfera del proprio diretto ed immediato controllo o da cause di forza maggiore. Al verificarsi di uno dei predetti eventi, Digit’Ed dovrà darne informazione al Cliente Impresa tramite il Sito, comunicando altresì le prospettive di riattivazione regolare del servizio.</span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">9.4 Digit’Ed non potrà essere ritenuta responsabile per i contenuti formativi acquistati dal Cliente Impresa a seguito del rilascio di informazioni non veritiere o acquistati per errore né per l’eventuale insoddisfazione circa i contenuti acquistati.</span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">9.5 Il Cliente Impresa si obbliga a tenere indenne Digit’Ed da tutte le perdite, i danni, le responsabilità, i costi, gli oneri e le spese (anche legali) che dovessero essere sostenute da Digit’Ed quale conseguenza delle informazioni fornite sul Sito, dell’uso illegale del Sito da parte del Cliente Impresa, delle utenze abilitate o di terzi e comunque di qualsiasi inadempimento degli obblighi assunti con il presente Contratto anche in ipotesi di richieste di risarcimento danni avanzate da terzi a qualunque titolo.</span></span></span></span></p>\n\n<p style=\"text-align:justify\"> </p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\"><b>Art. 10 – TUTELA DEL DIRITTO D’AUTORE</b></span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">10.1 In base alla legge sul diritto d’autore è vietato qualunque uso commerciale da parte di terzi, la riproduzione totale o parziale, la rielaborazione, la trasmissione sotto qualunque forma e con qualsiasi modalità senza preventiva autorizzazione scritta da parte di Digit’Ed di qualsiasi contenuto presente sul Sito.</span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">10.2 In caso di violazione degli obblighi previsti dal presente articolo e dall’art. 6.4, ferma la facoltà di sospensione di cui all’art. 7.2, il Contratto si intenderà risolto di diritto e Digit’Ed sarà libera di agire giudizialmente a tutela di ogni diritto disatteso, ivi compreso il risarcimento dei danni subiti.</span></span></span></span></p>\n\n<p style=\"text-align:justify\"> </p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\"><b>Art. 11 – CLAUSOLA RISOLUTIVA ESPRESSA</b></span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">11.1 L’esatto adempimento degli obblighi assunti dal Cliente Impresa:</span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">- in relazione al pagamento del corrispettivo come indicato nel presente Contratto;</span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">- all’art. 8 (<i>Sicurezza dei dati</i>);</span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">- all’art. 9 (<i>Responsabilità e manleva</i>);</span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">- all’art. 10 (<i>Tutela del diritto d’autore</i>);</span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">- all’art. 12 (<i>Tutela dei dati personali</i>);</span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">ha carattere essenziale cosicché l’inadempimento di una soltanto delle predette obbligazioni comporta che il Contratto è risolto con effetto immediato ai sensi e per gli effetti dell’art. 1456 ss. del codice civile, qualora Digit’Ed comunichi al Cliente Impresa di volersi avvalere della presente clausola risolutiva, salvo in ogni caso il diritto di Digit’Ed al risarcimento dei danni.</span></span></span></span></p>\n\n<p style=\"text-align:justify\"> </p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\"><b>Art. 12 – TUTELA DEI DATI PERSONALI</b></span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">1. Con riferimento ai dati personali trattati nell’ambito del Contratto, ciascuna delle Parti riveste il ruolo di autonomo titolare del trattamento e si obbliga a trattare i dati ricevuti dalle altre Parti esclusivamente per finalità strettamente connesse e strumentali all’esecuzione degli obblighi assunti con il Contratto e nel rispetto delle disposizioni previste dal Regolamento (UE) 2016/679 del Parlamento europeo e del Consiglio, del 27 aprile 2016 relativo alla protezione delle persone fisiche con riguardo al trattamento dei dati personali  e la normativa nazionale tempo per tempo vigente.</span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">2. Ciascuna Parte si impegna ad aggiornare ed integrare - per quanto di propria competenza – il proprio Registro dei trattamenti e la propria normativa interna in ambito <i>data protection</i> in funzione all’evoluzione normativa. Le Parti si impegnano altresì a comunicarsi tempestivamente eventuali irregolarità che dovessero verificarsi in qualunque fase del trattamento di dati personali connesso al Contratto. </span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">3. Il Cliente Impresa dichiara di aver preso visione dell’Informativa privacy relativamente al trattamento dei dati personali di persone fisiche derivanti dalla conclusione del Contratto. L’informativa privacy completa è allegata alle presenti Condizioni Generali di Contratto.</span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">4. Digit’Ed, per la parte relativa alla erogazione dei corsi di formazione di propria competenza, provvede all’esecuzione del Contratto in qualità di ‘Titolare del trattamento’ dei dati forniti dal Cliente Impresa, nei limiti di quanto previsto nell’informativa privacy di cui sopra.</span></span></span></span></p>\n\n<p style=\"text-align:justify\"> </p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\"><b>Art.13 – LEGGE APPLICABILE E FORO COMPETENTE</b></span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">13.1 Il presente Contratto è disciplinato dalla legge Italiana.</span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">13.2 Ogni controversia relativa all’applicazione, esecuzione, interpretazione e violazione del presente Contratto è sottoposta in via esclusiva al foro di Milano.</span></span></span></span></p>\n\n<p style=\"text-align:justify\"> </p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\"><b>Art. 14 – MISCELLANEA</b></span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">14.1 Il Cliente Impresa può comunicare con Digit’Ed all’indirizzo mail info@skills4capital.com<span class=\"MsoHyperlink\" style=\"color:blue\"><span style=\"text-decoration:underline\">.</span></span></span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">14.2 Sarà inoltre a disposizione del Clienti Impresa un servizio di assistenza digitale e telefonica (l’“<b><i>Helpdesk</i></b>”), anche tramite sistemi informatici e di chat (es. <i>chatbox</i>) per assistenza tecnica sull’utilizzo della Piattaforma e dei Pacchetti Formativi. Il servizio di Helpdesk sarà attivo dalle ore 9.30 alle ore 17.00 di ogni giorno lavorativo e raggiungibile al numero 01119118660.</span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:normal\"><span style=\"font-family:Calibri,sans-serif\">14.3 Il Cliente Impresa, nella sua qualità di soggetto non consumatore, accetta di derogare agli obblighi informativi di cui all’articolo 12 del D. Lgs. 70/2003.</span></span></span></span></p>\n\n<p align=\"center\" style=\"text-align:center\"><span style=\"font-size:11pt\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><a name=\"_Hlk108537708\" id=\"_Hlk108537708\"><b><span style=\"font-family:&quot;Arial&quot;,sans-serif\">INFORMATIVA CLIENTI IMPRESA</span></b></a></span></span></span></p>\n\n<p align=\"center\" style=\"text-align:center\"><span style=\"font-size:11pt\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><b><span style=\"font-family:&quot;Arial&quot;,sans-serif\">AI SENSI DEL REGOLAMENTO UE 2016/679 (GDPR) </span></b></span></span></span></p>\n\n<p align=\"center\" style=\"text-align:center\"> </p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><span style=\"font-family:&quot;Arial&quot;,sans-serif\">Il Regolamento 2016/679 sulla protezione delle persone fisiche con riguardo al trattamento dei dati personali, nonché alla libera circolazione di tali dati (di seguito il “Regolamento” o “GDPR”) contiene una serie di norme dirette a garantire che il trattamento dei dati personali si svolga nel rispetto dei diritti e delle libertà fondamentali delle persone fisiche. La presente Informativa ne recepisce le previsioni.</span></span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><span style=\"font-family:&quot;Arial&quot;,sans-serif\">Digit’Ed S.p.A., in qualità di Titolare del trattamento, informa il Cliente che il trattamento dei suoi dati personali avverrà nel rispetto dei principi di liceità, correttezza, trasparenza, adeguatezza e pertinenza.</span></span></span></span></span></p>\n\n<p style=\"text-align:justify\"> </p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><b><span style=\"font-family:&quot;Arial&quot;,sans-serif\">SEZIONE 1 – TITOLARE DEL TRATTAMENTO</span></b></span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><span style=\"font-family:&quot;Arial&quot;,sans-serif\">Digit’Ed S.p.A. (P.I. 07490560633) in persona del legale rappresentante <i>pro tempore</i>, con sede legale in Milano, Via Cechov Antonio n. 50/5, indirizzo di posta elettronica: </span><a href=\"mailto:privacy@digited.it\" style=\"color:blue; text-decoration:underline\"><span style=\"font-family:&quot;Arial&quot;,sans-serif\">privacy@digited.it</span></a><span style=\"font-family:&quot;Arial&quot;,sans-serif\">, in qualità di Titolare del trattamento (di seguito anche “Digit’Ed” o “Titolare”), tratterà i dati personali del Cliente per le finalità indicate nella Sezione 3 della presente informativa.</span></span></span></span></span></p>\n\n<p style=\"text-align:justify\"> </p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><b><span style=\"font-family:&quot;Arial&quot;,sans-serif\">SEZIONE 2 – RESPONSABILE DELLA PROTEZIONE DEI DATI (“RPD”)</span></b></span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><span style=\"font-family:&quot;Arial&quot;,sans-serif\">Digit’Ed ha nominato un Responsabile della Protezione dei Dati (“RPD”), che è raggiungibile attraverso i seguenti canali di contatto: </span></span></span></span></span></p>\n\n<ul><li style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:107%\"><span style=\"font-family:Calibri,sans-serif\"><span style=\"font-family:&quot;Arial&quot;,sans-serif\">Indirizzo di posta elettronica: </span><a href=\"mailto:dpo@digited.it\" style=\"color:blue; text-decoration:underline\"><span style=\"font-family:&quot;Arial&quot;,sans-serif\">dpo@digited.it</span></a><u><span style=\"font-family:&quot;Arial&quot;,sans-serif\">;</span></u></span></span></span></span></li>\n\t<li style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:107%\"><span style=\"font-family:Calibri,sans-serif\"><span style=\"font-family:&quot;Arial&quot;,sans-serif\">Posta ordinaria: Digit’Ed - Responsabile della Protezione dei Dati, Via Cechov Antonio, 50/5, 20151 Milano.</span></span></span></span></span></li>\n</ul><p style=\"margin-left:48px; text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"> </span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><b><span style=\"font-family:&quot;Arial&quot;,sans-serif\">SEZIONE 3 – TIPOLOGIA DEI DATI TRATTATI, FINALITA’ E BASE GIURIDICA DEL TRATTAMENTO</span></b></span></span></span></span></p>\n\n<p style=\"text-align:justify\"> </p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><b><span style=\"font-family:&quot;Arial&quot;,sans-serif\">Tipologia dei dati trattati. </span></b></span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><span style=\"font-family:&quot;Arial&quot;,sans-serif\">Per il perseguimento delle finalità indicate nella presente informativa Digit’Ed tratterà i dati personali comuni (a titolo esemplificativo dati anagrafici, dati di contatto, dati inseriti mediante compilazione di form on line, dati di pagamento ecc.). </span></span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><span style=\"font-family:&quot;Arial&quot;,sans-serif\">Per quanto concerne il trattamento dei dati raccolti mediante l‘utilizzo della Piattaforma e dell’App aziendali (inclusi i dati di geolocalizzazione, quelli derivanti dai servizi web, etc.) si rinvia a quanto previsto nelle relative Privacy Policy. </span></span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><span style=\"font-family:&quot;Arial&quot;,sans-serif\">Con riferimento ai dati di soggetti terzi eventualmente comunicati (es: dati dei dipendenti del Cliente), Digit’Ed informa che il Cliente si pone quale autonomo Titolare del trattamento, garantendo di essere legittimato alla comunicazione di tali dati e conferendo la più ampia manleva rispetto ad ogni contestazione, pretesa e/o richiesta di risarcimento del danno che dovesse pervenire al Titolare da tali terzi soggetti i cui dati personali siano stati trattati attraverso le sue richieste in violazione della normativa applicabile.</span></span></span></span></span></p>\n\n<p style=\"text-align:justify\"> </p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><b><span style=\"font-family:&quot;Arial&quot;,sans-serif\">Finalità e base giuridica del trattamento</span></b></span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><span style=\"font-family:&quot;Arial&quot;,sans-serif\">I dati personali del Cliente sono trattati da Digit’Ed nell'ambito della propria attività per le seguenti finalità:</span></span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><span style=\"font-family:&quot;Arial&quot;,sans-serif\">a)<b> Prestazione dei servizi ed esecuzione dei contratti</b>. In questo caso la base giuridica del trattamento risiede nell’art. 6 par. 1 lett. b) GDPR; il conferimento dei dati personali necessari per prestare i servizi richiesti ed eseguire i contratti (ivi compresi gli atti in fase precontrattuale) non è obbligatorio, ma il rifiuto a fornire tali dati personali comporta l’impossibilità per Digit’Ed di adempiere a quanto richiesto.</span></span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><span style=\"font-family:&quot;Arial&quot;,sans-serif\">b)<b> Adempimento a prescrizioni normative nazionali e comunitarie.</b> In questo caso la base giuridica risiede nell’art. 6 par. 1 lett. c) GDPR; il trattamento dei dati personali per adempiere a prescrizioni normative (es: normativa contabile e fiscale) è obbligatorio e non è richiesto il consenso. </span></span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><span style=\"font-family:&quot;Arial&quot;,sans-serif\">c)<b> Marketing diretto e indiretto</b> (per svolgere attività funzionali alla promozione e vendita di prodotti e servizi Digit’Ed ed effettuare analisi di mercato e di <i>customer satisfaction</i> attraverso lettere, telefono, Internet, SMS, MMS ed altri sistemi di comunicazione). Il trattamento dei dati per questa finalità non è obbligatorio ma facoltativo ed è richiesta la manifestazione del consenso <span style=\"border:none windowtext 1.0pt; color:black; padding:0cm\">ai sensi dell’art. 6 par. 1 lett. a) del GDPR. Il consenso manifestato potrà essere revocato in ogni momento scrivendo al Titolare del trattamento agli indirizzi indicati sopra alla Sezione 1 della presente informativa. La revoca del consenso inizialmente prestato non pregiudica la liceità del trattamento effettuato prima della revoca.</span></span></span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><span style=\"font-family:&quot;Arial&quot;,sans-serif\">d)<b> Nei casi previsti dalla legge, dalla normativa comunitaria, dai regolamenti per far valere o difendere un diritto, anche da parte di un terzo, in sede giudiziaria o nelle procedure di arbitrato e di conciliazione.</b> In questo caso la base giuridica del trattamento risiede nel legittimo interesse del Titolare ai sensi dell’art. 6 par. 1 lett. f) del GDPR; il trattamento è obbligatorio e non è richiesto il consenso. </span></span></span></span></span></p>\n\n<p style=\"text-align:justify\"> </p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><b><span style=\"font-family:&quot;Arial&quot;,sans-serif\">SEZIONE 4 – DESTINATARI DEI DATI PERSONALI.</span></b></span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><span style=\"font-family:&quot;Arial&quot;,sans-serif\">I dati del Cliente verranno trattati da dipendenti e/o collaboratori del Titolare, appositamente autorizzati e vincolati alla riservatezza.</span></span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><span style=\"font-family:&quot;Arial&quot;,sans-serif\">Nei limiti del perseguimento delle finalità sopra indicate potrebbe essere necessario che la Società comunichi i dati personali del Cliente a Soggetti terzi (società, liberi professionisti, ecc.), operanti sia all’interno che all’esterno dell’Unione Europea, che in qualità di Responsabili esterni tratteranno i Suoi dati personali a titolo esemplificativo e non esaustivo per le seguenti attività di:</span></span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><span style=\"font-family:&quot;Arial&quot;,sans-serif\">- attività di sviluppo di percorsi formativi;</span></span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><span style=\"font-family:&quot;Arial&quot;,sans-serif\">- servizi di pagamento;</span></span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><span style=\"font-family:&quot;Arial&quot;,sans-serif\">- recupero crediti e attività correlate;</span></span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><span style=\"font-family:&quot;Arial&quot;,sans-serif\">- fondi interprofessionali;</span></span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><span style=\"font-family:&quot;Arial&quot;,sans-serif\">- fornitura e gestione di procedure e sistemi informatici;</span></span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><span style=\"font-family:&quot;Arial&quot;,sans-serif\">- attività di revisione contabile e di consulenza in genere;</span></span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><span style=\"font-family:&quot;Arial&quot;,sans-serif\">- gestione della comunicazione alla clientela, nonché archiviazione di dati e documenti sia in forma cartacea che elettronica;</span></span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><span style=\"font-family:&quot;Arial&quot;,sans-serif\">- servizi di formazione;</span></span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><span style=\"font-family:&quot;Arial&quot;,sans-serif\">- servizi di consulenza sui fondi interprofessionali;</span></span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><span style=\"font-family:&quot;Arial&quot;,sans-serif\">- rilevazione della qualità dei servizi, ricerche di mercato, informazione e promozione commerciale di prodotti e/o servizi.</span></span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><span style=\"font-family:&quot;Arial&quot;,sans-serif\">Per maggiori informazioni in merito ai destinatari dei suoi dati il Cliente può contattare il Titolare o il RPD agli indirizzi indicati sopra rispettivamente alle Sezioni 1 e 2 della presente informativa.</span></span></span></span></span></p>\n\n<p style=\"text-align:justify\"> </p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><b><span style=\"font-family:&quot;Arial&quot;,sans-serif\">SEZIONE 5 – TRASFERIMENTO DEI DATI PERSONALI AD UN PAESE TERZO O A UN’ORGANIZZAZIONE INTERNAZIONALE FUORI DALL’UNIONE EUROPEA</span></b></span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><span style=\"font-family:&quot;Arial&quot;,sans-serif\">I dati personali verranno trattati all’interno del territorio dell’Unione Europea e non verranno diffusi. Se necessario, per ragioni di natura tecnica od operativa, Digit’Ed si riserva, nel rispetto delle disposizioni di legge applicabili, di trasferire i dati personali in Paesi al di fuori dell’Unione Europea per i quali esistono decisioni di “adeguatezza” della Commissione Europea, ovvero sulla base delle adeguate garanzie oppure delle specifiche deroghe previste dal Regolamento.</span></span></span></span></span></p>\n\n<p style=\"text-align:justify\"> </p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><b><span style=\"font-family:&quot;Arial&quot;,sans-serif\">SEZIONE 6 – MODALITA’ DI TRATTAMENTO E PERIODO DI CONSERVAZIONE DEI DATI</span></b></span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><span style=\"font-family:&quot;Arial&quot;,sans-serif\">Il trattamento dei dati personali avviene mediante strumenti manuali, informatici e telematici e in modo da garantire la sicurezza e la riservatezza dei dati stessi. I dati personali sono trattati nel pieno rispetto del principio di proporzionalità del trattamento, in base al quale i medesimi dati e le relative modalità del loro trattamento sono pertinenti e non eccedenti rispetto alle finalità perseguite.</span></span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><span style=\"font-family:&quot;Arial&quot;,sans-serif\">I dati personali sono conservati, per un periodo di tempo non superiore a quello necessario al conseguimento delle finalità per le quali essi sono trattati, fatti salvi i termini di conservazione previsti dalla legge. A titolo esemplificativo i dati personali sono conservati per un periodo temporale di 10 anni a decorrere dalla conclusione del rapporto contrattuale; i dati trattati per finalità di marketing potranno essere conservati per 24 mesi o fino alla revoca del consenso, laddove anteriore.</span></span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><span style=\"font-family:&quot;Arial&quot;,sans-serif\">Al termine di tali periodi i dati verranno cancellati, salvo il loro ulteriore trattamento sia necessario per consentire al Titolare di esercitare o difendere un diritto in sede giudiziale, nonché dare seguito a specifiche richieste delle Autorità italiane e/o estere, sempreché tali circostanze siano intervenute prima della scadenza di tale termine di conservazione.</span></span></span></span></span></p>\n\n<p style=\"text-align:justify\"> </p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><b><span style=\"font-family:&quot;Arial&quot;,sans-serif\">SEZIONE 7 – DIRITTI DELL'INTERESSATO </span></b></span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><span style=\"font-family:&quot;Arial&quot;,sans-serif\">Il Cliente potrà esercitare, in qualsiasi momento, nei confronti del Titolare i seguenti diritti previsti dagli artt. 15, 16, 17, 18, 20 e 21 del Regolamento:<br />\n- il diritto di accesso, che consente di ottenere dal Titolare la conferma che sia o meno in corso un trattamento dei propri dati personali e, in tal caso, di ottenere l'accesso a tali dati;     <br />\n- il diritto di rettifica, che consente di ottenere dal Titolare la rettifica e/o l’integrazione dei propri dati personali che risultino inesatti e/o incompleti;     <br />\n- il diritto alla cancellazione, che consente, in specifici casi previsti dall’art. 17 del Regolamento, di ottenere dal Titolare la cancellazione dei propri dati personali;       <br />\n- il diritto di limitazione di trattamento, che consente, nelle specifiche ipotesi previste dall’art. 18 del Regolamento, di limitare il trattamento dei propri dati personali da parte del Titolare;         <br />\n- il diritto di opposizione, che consente di opporsi al trattamento dei propri dati personali al ricorrere di particolari condizioni;    <br />\n- il diritto alla portabilità dei dati, che consente, in determinati casi e rispetto ai soli dati dallo stesso forniti, di poter chiedere la ricezione dei propri dati personali in un formato strutturato, di uso comune e leggibile da dispositivo automatico. </span></span></span></span></span></p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><span style=\"font-family:&quot;Arial&quot;,sans-serif\">Per l’esercizio dei diritti di cui alla presente Sezione il Cliente potrà, in qualsiasi momento, indirizzare le sue richieste al Responsabile della Protezione dei Dati (RPD) all’indirizzo di posta elettronica </span><a href=\"mailto:dpo@digited.it\" style=\"color:blue; text-decoration:underline\"><span style=\"font-family:&quot;Arial&quot;,sans-serif\">dpo@digited.it</span></a><span style=\"font-family:&quot;Arial&quot;,sans-serif\">. <br />\nNel caso in cui ritenga che i suoi dati personali siano stati trattati in modo non conforme alla normativa, il Cliente ha diritto di proporre reclamo all’Autorità di controllo dello Strato membro dell’Unione Europea dove risiede abitualmente o lavora, ovvero del luogo dove si è verificata la presunta violazione. In Italia l’autorità di controllo è il Garante per la protezione dei dati personali (</span><a href=\"http://www.garanteprivacy.it/\" style=\"color:blue; text-decoration:underline\"><span style=\"font-family:&quot;Arial&quot;,sans-serif\">www.garanteprivacy.it</span></a><span style=\"font-family:&quot;Arial&quot;,sans-serif\">) con sede in Roma, Piazza Venezia n. 11, Centralino telefonico (+39)06696771, e-mail: </span><a href=\"mailto:garante@gpdp.it\" style=\"color:blue; text-decoration:underline\"><span style=\"font-family:&quot;Arial&quot;,sans-serif\">garante@gpdp.it</span></a><span style=\"font-family:&quot;Arial&quot;,sans-serif\">.                           </span></span></span></span></span><br />\n </p>\n\n<p align=\"right\" style=\"text-align:right\"><span style=\"font-size:11pt\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><i><span style=\"font-family:&quot;Arial&quot;,sans-serif\">                                                                                              Ultimo aggiornamento: 18 luglio 2022</span></i></span></span></span></p>\n\n<p align=\"right\" style=\"margin-bottom:13px; text-align:right\"> </p>\n\n<p align=\"center\" style=\"text-align:center; margin-left:48px\"><span style=\"font-size:11pt\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><span style=\"font-family:&quot;Arial&quot;,sans-serif\">* * * * * *</span></span></span></span></p>\n\n<p style=\"text-align:justify; margin-bottom:13px\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><span style=\"font-family:&quot;Arial&quot;,sans-serif\">Tenuto conto dell’Informativa resami ai sensi dell’art. 13 del Regolamento, il Cliente prende atto del trattamento dei dati personali effettuato da Digit’Ed per le finalità descritte in Informativa, nella Sezione 3 “Tipologia di dati trattati, finalità e base giuridica del trattamento dei dati personali”.</span></span></span></span></span></p>\n\n<p style=\"text-align:justify; margin-bottom:13px\"> </p>\n\n<p align=\"center\" style=\"text-align:center\"><span style=\"font-size:11pt\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><b><span style=\"font-family:&quot;Arial&quot;,sans-serif\">CONSENSO AL TRATTAMENTO DEI DATI PERSONALI</span></b></span></span></span></p>\n\n<p align=\"center\" style=\"text-align:center\"> </p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><span style=\"font-family:&quot;Arial&quot;,sans-serif\">Con riferimento al trattamento DEI DATI per la finalità di marketing, di cui alla lettera c) della Sezione 3 della presente Informativa, il Cliente</span></span></span></span></span></p>\n\n<p style=\"text-align:justify\"> </p>\n\n<p align=\"center\" style=\"text-align:center\"><span style=\"font-size:11pt\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><b><span style=\"font-family:&quot;Arial&quot;,sans-serif\"> □ presta il consenso           □ nega il consenso</span></b></span></span></span></p>\n\n<p style=\"text-align:justify\"> </p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><span style=\"font-family:&quot;Arial&quot;,sans-serif\">al trattamento dei dati personali a fini di informazione commerciale, offerte dirette, indagini di mercato o di <i>customer satisfaction</i> relative a prodotti e servizi Digit’Ed.</span></span></span></span></span></p>\n\n<p style=\"text-align:justify\"> </p>\n\n<p style=\"text-align:justify\"><span style=\"font-size:11pt\"><span style=\"text-justify:inter-ideograph\"><span style=\"line-height:115%\"><span style=\"font-family:Calibri,sans-serif\"><span style=\"font-family:&quot;Arial&quot;,sans-serif\">Data e firma    __________________________ </span></span></span></span></span></p>\n\n<p style=\"text-align:justify\"> </p>\n\n<p style=\"margin-bottom:13px\"> </p>\n",
											id: "24",
											mandatory: "True",
											name: "Presa visione del contratto",
											type: "checkbox",
											user_type: ""
										}
									],
									id: 108,
									title: "Presa visione del contratto"
								}
							]
						},
						cookies_description: "",
						email: "info@prelios.com",
						id: 301,
						image_login: "https://medias4b2sit.ispfdevelop.com/media/2023-02/Login_margini_1440v23.png?VersionId=hNkj7XIRn0m94xvnt3Avqu2Y0EIYkVfp",
						multi_channel: "web",
						needs: null,
						policy: {
							data: [
								{
									code: "03",
									consents: [
										{
											code: "Consenso_0010",
											description: "<p>Autorizzo all'invio di mail per finalità pubblicitarie</p>",
											id: "6",
											mandatory: "True",
											name: "Autorizzazione mail pubblicitarie",
											type: "checkbox",
											user_type: ""
										}
									],
									id: 22,
									title: "Consensi Piattaforma"
								}
							]
						},
						title: "Prelios",
						url: "prelios.sit.digitedacademy.net"
					}
				],
				pager: {
					current_page: 0,
					items_per_page: 10,
					total_items: "1",
					total_pages: 1
				}
			});
		default:
			return getBaseResponse({
				data: [
					{
						id: 47,
						title: 'Skills4Capital',
						url: 's4b2sit.ispfdevelop.com',
						cohort_id: 17,
						email: 'info@skills4capital.it',
						image_login:
							'https://medias4b2sit.ispfdevelop.com/media/2022-11/homepage_PROD_v2.png?VersionId=91w_I9_a_0p5ig7kIjzZLTn3FTzy8BVK',
						brand: [
							{
								name: 'Skills4Capital',
								color: '#33a7b2',
								logo:
									'https://prelios.com/sites/prelioscorp/themes/prelioscorporate/logo-white.svg',
								logo_white:
									'https://prelios.com/sites/prelioscorp/themes/prelioscorporate/logo-white.svg',
								logo_rgb:
									'https://prelios.com/sites/prelioscorp/themes/prelioscorporate/logo-white.svg',
							},
						],
						multi_channel: 'web_app',
						contract: {
							data: [
								{
									id: 76,
									title: 'Presa visione del contratto',
									code: 'Consenso_0020',
									consents: [
										{
											id: '61',
											name: 'Presa visione del contratto',
											description:
												'\u003Cimg alt=\u0022logo\u0022 data-entity-type=\u0022file\u0022 data-entity-uuid=\u00220239368f-4a44-42b7-afeb-c7b33561482f\u0022 src=\u0022https://d22cxfqtum6m93.cloudfront.net/media/s3fs-public/inline-images/Screenshot%202021-07-08%20at%2019.01.18_0.png?VersionId=or083knbsVmqlptUqYshaIyFF8rdZn2G\u0022 class=\u0022align-center\u0022 width=\u00221648\u0022 height=\u0022164\u0022 loading=\u0022lazy\u0022 /\u003E\u003Cp\u003E\u00a0\u003C/p\u003E\n\n\u003Cp\u003E\u003Cstrong\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan lang=\u0022IT\u0022 xml:lang=\u0022IT\u0022 xml:lang=\u0022IT\u0022\u003E\u201cServizio SKILLS4CAPITAL\u201d - Condizioni generali \u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/strong\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u00a0\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cstrong\u003EDEFINIZIONI\u003C/strong\u003E\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003ENel presente contratto deve intendersi per:\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E\u201c\u003Cstrong\u003ECLIENTE\u003C/strong\u003E\u201d: il soggetto (professionista o azienda) che sottoscrive il presente contratto;\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E\u201c\u003Cstrong\u003EISF\u003C/strong\u003E\u201d: Intesa Sanpaolo Formazione S. p.a., con sede in Via A. Cechov, 50/5 \u2013 20151 Milano;\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E\u201c\u003Cstrong\u003EINTESA SANPAOLO\u003C/strong\u003E\u201d: Intesa Sanpaolo S.p.A., con sede in Piazza San Carlo, 156 \u2013 10121 Torino;\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E\u201c\u003Cstrong\u003EPIATTAFORMA\u003C/strong\u003E\u201d: l\u2019area riservata del Sito dove \u00e8 possibile accedere ai contenuti formativi ;\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E\u201c\u003Cstrong\u003ESITO\u003C/strong\u003E\u201d: Il sito internet \u201cwww.skills4capital.com\u201d, di propriet\u00e0 di ISF. \u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E\u201cPACCHETTO FORMATIVO BASE\u201d: caratterizzato da contenuti formativi trasversali \u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E\u201cPACCHETTO FORMATIVO TEMATICO\u201d: caratterizzato da contenuti formativi su specifiche aree tematiche\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u00a0\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003EArt. 1 - OGGETTO DEL CONTRATTO\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E1.1 Il presente contratto comprende: \u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cul\u003E\u003Cli\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003El\u2019abbonamento che consente al Cliente di fruire attraverso la Piattaforma dei contenuti formativi offerti da ISF,\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/li\u003E\n\t\u003Cli\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003Ela consulenza di INTESA SANPAOLO per accompagnare la crescita del Cliente sviluppando le competenze necessarie attraverso la formazione (\u201cConsulenza in merito ai bisogni formativi del Cliente\u201d).\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/li\u003E\n\u003C/ul\u003E\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E1.2 Il Cliente sceglie al momento della conclusione del contratto almeno un pacchetto formativo tra quelli disponibili sulla Piattaforma. Nel corso del rapporto e fino all\u2019eventuale comunicazione di disdetta ai sensi dell\u2019articolo 4.1, il Cliente pu\u00f2 acquistare ulteriori contenuti formativi tra quelli tempo per tempo offerti da ISF nonch\u00e9 abilitare ulteriori utenze; anche per gli ulteriori contenuti formativi e per le ulteriori utenze attivate resta ferma la data di scadenza del contratto relativo al \u00a0rispettivo pacchetto formativo acquistato originaria o prorogata.\u00a0 \u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E1.3 Il Cliente pu\u00f2 fruire della consulenza di INTESA SANPAOLO prendendo contatto con una filiale della Banca; se il Cliente \u00e8 cliente di INTESA SANPAOLO la richiesta della consulenza pu\u00f2 essere fatta anche prima della conclusione del contratto rivolgendosi alla propria filiale di riferimento. Nel corso del rapporto, INTESA SANPAOLO pu\u00f2 inoltre di propria iniziativa contattare il Cliente per fornire la consulenza.\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u00a0\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003EArt. 2 - CONCLUSIONE DEL CONTRATTO - ACQUISTO DI ULTERIORI CONTENUTI FORMATIVI E ATTIVAZIONE DI ULTERIORI UTENZE\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E2.1 Il presente contratto si conclude a distanza sul Sito con le seguenti modalit\u00e0: il Cliente, seguendo le istruzioni, si registra, sceglie almeno un pacchetto formativo, indica il numero di utenze da abilitare, accetta le presenti condizioni contrattuali e autorizza i pagamenti secondo i tempi e le modalit\u00e0 di cui all\u2019articolo 5. \u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E2.2 L\u2019acquisto degli ulteriori contenuti formativi e l\u2019attivazione di ulteriori utenze avviene sulla Piattaforma con le modalit\u00e0 del comma precedente in quanto compatibili. Il Cliente prende atto e accetta che agli acquisti successivi e alle attivazioni successive si applicano le norme del presente contratto. Salvo che il Cliente indichi diversamente al momento dell\u2019acquisto di ulteriori contenuti formativi, si intende richiesto il medesimo numero di utenze abilitate gi\u00e0 in essere. \u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E2.3 Le caratteristiche dei contenuti formativi e i prezzi applicati al Cliente sono quelli indicati sul Sito al momento della conclusione del contratto.\u00a0 \u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u00a0\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003EArt. 3 \u2013 ATTIVAZIONE\u00a0 \u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E3.1 I contenuti formativi acquistati al momento della conclusione del contratto sono fruibili sulla Piattaforma quando ISF abbia ricevuto conferma del valido rilascio delle autorizzazioni di addebito ai sensi dell\u2019art. 5.2. \u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E3.2 Gli ulteriori contenuti formativi acquistati successivamente alla conclusione del contratto vengono resi disponibili alle utenze abilitate entro 1 giorno lavorativo. \u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E3.3 Eventuali ulteriori utenze da abilitare sui contenuti formativi gi\u00e0 acquistati saranno disponibili entro 1 giorno lavorativo.\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E3.4. Per la fruizione dei contenuti formativi acquistati le utenze abilitate ricevono via e-mail il link alla pagina web che consente di impostare la password ed accedere alla Piattaforma.\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u00a0\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003EArt.4 - DURATA E CONDIZIONI DI RECESSO\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E4.1 Il presente contratto ha durata annuale decorrente dalla data di attivazione dei contenuti formativi ai sensi dell\u2019articolo 3.1. Il Pacchetto Formativo \u2018BASE\u2019 si rinnova tacitamente di anno in anno ad ogni scadenza originaria o prorogata, salvo mancato pagamento entro quindici giorni lavorativi dalla scadenza, o disdetta che ciascuna Parte comunica tramite apposita procedura in Piattaforma. Il Pacchetto Formativo tematico ha durata annuale.\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E4.2 Il Cliente pu\u00f2 inoltre richiedere di disabilitare una o pi\u00f9 utenze ad ogni scadenza originaria o prorogata mediante apposita procedura in Piattaforma. \u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E4.3 Per gli ulteriori contenuti formativi acquistati e per le ulteriori utenze abilitate dopo la sottoscrizione del presente contratto si applica l\u2019articolo 1.2. \u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u00a0\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003EArt. 5 - PAGAMENTI \u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E5.1 Il prezzo dei contenuti formativi acquistati e del numero delle utenze abilitate \u00e8 annuale; il pagamento avviene in un\u2019unica soluzione in forma anticipata.\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E5.2 Per il pagamento degli importi dovuti, il Cliente deve autorizzare l\u2019addebito mediante sistema di pagamento selezionato tra quelli disponibili in Piattaforma.\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E5.3 In occasione di ciascun addebito, ISF emette la relativa fattura.\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u00a0\u003C/p\u003E\n\n\u003Cp\u003E\u00a0\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003EArt. 6 - UTILIZZO DEL SERVIZIO DA PARTE DEL CLIENTE\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E6.1 Il Cliente dichiara di essere a conoscenza e di accettare i prerequisiti hardware e software necessari per poter accedere alla Piattaforma e fruire dei contenuti formativi. In particolare, il Cliente prende atto che i requisiti hardware e software richiesti sono minimi e sono generalmente soddisfatti su un normale sistema standard per uso domestico e che per poter usufruire al meglio dei contenuti multimediali presenti \u00e8 necessario:\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cul\u003E\u003Cli\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003Eavere una connessione alla rete Internet. Per un utilizzo ottimale \u00e8 consigliata una connessione ADSL;\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/li\u003E\n\t\u003Cli\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003Eavere installato sulla propria macchina uno tra i principali browser disponibili regolarmente aggiornati;\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/li\u003E\n\t\u003Cli\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003Eavere installato sulla propria macchina il software Adobe Acrobat Reader per visualizzare alcuni materiali in formato pdf.\u00a0 \u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/li\u003E\n\u003C/ul\u003E\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E\u00c8 esclusiva responsabilit\u00e0 del Cliente assicurare l\u2019interoperabilit\u00e0 tra la connettivit\u00e0, di cui si sia dotato, e la Piattaforma. \u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E6.2 Il Cliente si impegna, inoltre, ad adeguare il proprio hardware o software nel caso in cui fosse necessario a seguito di successivi aggiornamenti della Piattaforma.\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E6.3 Il Cliente \u00e8, inoltre, consapevole che l\u2019utilizzo dei contenuti formativi acquistati \u00e8 consentito solo alle utenze abilitate e che le stesse non potranno esser sostituite dopo l\u2019attivazione. \u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E6.4 Il download e l\u2019utilizzo dei contenuti formativi messi a disposizione \u00e8 permesso solo alle utenze abilitate. Il Cliente \u00e8 responsabile, insieme alle utenze abilitate, della conservazione della segretezza delle credenziali assegnate ed \u00e8 titolare, per effetto della conclusione del contratto, di un diritto non cedibile di accesso all\u2019area riservata, impegnandosi cos\u00ec a non far utilizzare o visionare i contenuti formativi a soggetti diversi dalle utenze abilitate. Il Cliente si astiene dal compiere qualunque atto che possa ledere i diritti di esclusiva e di propriet\u00e0 di ISF e di INTESA SANPAOLO e si impegna altres\u00ec a manlevare e tenere indenni ISF e INTESA SANPAOLO da ogni e qualsiasi pretesa o rivendicazione derivante dall\u2019uso o abuso di diritti di terzi.\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E6.5 In caso di parziale o mancata fruizione da parte di una o pi\u00f9 utenze abilitate dei contenuti formativi nel periodo di disponibilit\u00e0 degli stessi, non \u00e8 prevista alcuna forma di rimborso a favore del Cliente, che sar\u00e0 invece tenuto a corrispondere quanto ancora dovuto.\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E6.6 Il Cliente infine non pu\u00f2 cedere a terzi alcun obbligo o diritto originato dal presente contratto in assenza di preventiva autorizzazione scritta di ISF e INTESA SANPAOLO. \u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E6.7 In caso di necessit\u00e0 di assistenza, il Cliente pu\u00f2 contattare \u003Ca href=\u0022mailto:info@skills4capital.com\u0022\u003Einfo@skills4capital.com\u003C/a\u003E\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u00a0\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003EArt. 7 \u2013 FORNITURA DEL SERVIZIO\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E7.1 ISF e INTESA SANPAOLO possono avvalersi di soggetti terzi per l\u2019esecuzione del contratto; in particolare i contenuti formativi e le relative informazioni sono elaborati, rivisti ed aggiornati da ISF e INTESA SANPAOLO anche con la consulenza specialistica e il supporto di professionisti qualificati. \u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E7.2 ISF e INTESA SANPAOLO avranno la facolt\u00e0 di sospendere parzialmente o totalmente le credenziali o di interrompere l\u2019esecuzione del contratto, dandone al Cliente immediata comunicazione tramite la Piattaforma o mediante e-mail qualora vi fossero fondati motivi per ritenere che si possano verificare problemi di sicurezza o di utilizzo non autorizzato.\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003EI suddetti oneri di comunicazione non possono considerarsi sussistenti in casi, alternativamente considerati, di forza maggiore, necessit\u00e0 o urgenza.\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E7.3 Inoltre ISF e INTESA SANPAOLO avranno facolt\u00e0 di sospendere parzialmente o totalmente il servizio per aggiornamento dei contenuti formativi ovvero implementazioni tecnologiche della Piattaforma dandone al Cliente immediata comunicazione tramite la Piattaforma o mediante e-mail.\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u00a0\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003EArt. 8 - SICUREZZA DEI DATI\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E8.1 Il Cliente garantisce di disporre legittimamente di tutte le informazioni fornite ai fini della sottoscrizione del presente contratto, assicurando altres\u00ec che le stesse non violino in alcun modo, direttamente o indirettamente, il diritto di terzi. Pertanto, il Cliente si obbliga a non immettere dati di cui non possa liberamente disporre.\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E\u00c8 fatto altres\u00ec divieto al Cliente di inserire dati falsi o di fantasia nella procedura di acquisto e in tutte le comunicazioni connesse all\u2019esecuzione del contratto.\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cul\u003E\u003Cli\u003E\n\t\u003Col start=\u00222\u0022\u003E\u003Cli\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003EIl Cliente manleva ISF e INTESA SANPAOLO:\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/li\u003E\n\t\u003C/ol\u003E\u003C/li\u003E\n\t\u003Cli\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003Eda ogni responsabilit\u00e0 derivante dall\u2019immissione di dati e documenti errati, essendo il Cliente stesso unico responsabile del corretto inserimento;\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/li\u003E\n\t\u003Cli\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003Eda ogni obbligo o onere di accertamento e controllo diretto e indiretto al riguardo.\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/li\u003E\n\u003C/ul\u003E\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E8.3 Qualora venga accertata, in via autonoma da ISF o da INTESA SANPAOLO o su segnalazione di terzi, la falsit\u00e0 dei dati forniti, ISF e INTESA SANPAOLO si riservano il diritto di impedire/sospendere la registrazione del Cliente.\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u00a0\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003EART. 9 - RESPONSABILITA\u2019 E MANLEVA\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E9.1 Salvi i casi di dolo o colpa grave, il Cliente esonera espressamente ISF e INTESA SANPAOLO da qualsiasi responsabilit\u00e0 per danni diretti e indiretti:\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cul\u003E\u003Cli\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003Eche il Cliente stesso, le utenze abilitate o terzi possano subire in relazione o in dipendenza dell\u2019interruzione del contratto;\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/li\u003E\n\t\u003Cli\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003Eche il Cliente stesso, le utenze abilitate o terzi possano in qualche modo lamentare per la mancata erogazione della connettivit\u00e0 da parte del gestore della rete di telecomunicazione, o anche per il ricorso da parte del Cliente o delle utenze abilitate all\u2019utilizzo di connettivit\u00e0 tecnicamente incompatibile con il servizio offerto, nonch\u00e9 per la mancata fruizione del servizio a seguito di difetti riscontrati dal Cliente nella fruizione dello stesso, qualora tutto ci\u00f2 sia dipeso dal mancato possesso dei requisiti minimi di sistema di cui all\u2019articolo 6, la cui verifica \u00e8 onere del Cliente;\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/li\u003E\n\t\u003Cli\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003Ecausati da terzi che illecitamente accedessero al servizio a causa della mancanza, da parte del Cliente o delle utenze abilitate, di cautela nella custodia delle credenziali attribuite o per l\u2019assenza di altre misure di sicurezza che il Cliente e le utenze abilitate sono tenute ad adottare.\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/li\u003E\n\u003C/ul\u003E\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E9.2 In nessun caso ISF e INTESA SANPAOLO saranno ritenute responsabili:\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cul\u003E\u003Cli\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003Edel malfunzionamento del servizio derivante da guasti, sovraccarichi, interruzioni delle linee telefoniche, elettriche o riferite alla rete Internet;\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/li\u003E\n\t\u003Cli\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003Eper inadempimenti di terzi che pregiudichino la fruizione dei contenuti formativi, compresi, in via esemplificativa, i rallentamenti di velocit\u00e0 o il mancato funzionamento delle linee telefoniche e degli elaboratori che gestiscono il traffico telematico fra il Cliente e la Piattaforma didattica da cui \u00e8 erogato il servizio.\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/li\u003E\n\u003C/ul\u003E\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E9.3 ISF e INTESA SANPAOLO, inoltre, non potranno essere ritenute responsabili per inadempimenti derivanti da impedimenti oggettivi che esulino dalla sfera del proprio diretto ed immediato controllo o da cause di forza maggiore. Al verificarsi di uno dei predetti eventi, ISF e INTESA SANPAOLO dovranno darne informazione al Cliente tramite il Sito, comunicando altres\u00ec le prospettive di riattivazione regolare del servizio.\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E9.4 Nell\u2019ambito della consulenza prestata da INTESA SANPAOLO, ogni responsabilit\u00e0 in ordine alla veridicit\u00e0 delle esigenze manifestate dal Cliente a INTESA SANPAOLO \u00e8 totalmente a carico del Cliente stesso. Per tale ragione, ISF e INTESA SANPAOLO non potranno essere ritenute responsabili per i contenuti formativi acquistati dal Cliente a seguito del rilascio di informazioni non veritiere o acquistati per errore n\u00e9 per l\u2019eventuale insoddisfazione circa i contenuti acquistati.\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E9.5 Il Cliente si obbliga a tenere indenne ISF e INTESA SANPAOLO da tutte le perdite, i danni, le responsabilit\u00e0, i costi, gli oneri e le spese (anche legali) che dovessero essere sostenute da ISF e INTESA SANPAOLO quale conseguenza delle informazioni fornite sul Sito, dell\u2019uso illegale del Sito da parte del Cliente, delle utenze abilitate o di terzi e comunque di qualsiasi inadempimento degli obblighi assunti con il presente contratto anche in ipotesi di richieste di risarcimento danni avanzate da terzi a qualunque titolo.\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u00a0\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003EArt.10 - TUTELA DEL DIRITTO D\u2019AUTORE\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E10.1 In base alla legge sul diritto d\u2019autore \u00e8 vietato qualunque uso commerciale da parte di terzi, la riproduzione totale o parziale, la rielaborazione, la trasmissione sotto qualunque forma e con qualsiasi modalit\u00e0 senza preventiva autorizzazione scritta da parte di ISF e INTESA SANPAOLO di qualsiasi contenuto presente sul Sito.\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E10.2 In caso di violazione degli obblighi previsti dal presente articolo e dall\u2019art. 6.4, ferma la facolt\u00e0 di sospensione di cui all\u2019art. 7.2, il contratto si intender\u00e0 risolto di diritto e ISF e INTESA SANPAOLO saranno libere di agire giudizialmente a tutela di ogni diritto disatteso, ivi compreso il risarcimento dei danni subiti.\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u00a0\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003EArt. 11 - TUTELA DEI DATI PERSONALI\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E11.1\u00a0\u00a0\u00a0\u00a0Con riferimento ai dati personali trattati nell\u2019ambito del presente contratto ciascuna delle parti contraenti si obbliga a trattare i dati ricevuti dall\u0027altra esclusivamente per finalit\u00e0 strettamente connesse e strumentali all\u2019esecuzione degli obblighi assunti con il presente contratto stesso e nel rispetto delle disposizioni previste dal Regolamento (UE) 2016/679 del Parlamento europeo e del Consiglio, del 27 aprile 2016 relativo alla protezione delle persone fisiche con riguardo al trattamento dei dati personali\u00a0 e la normativa nazionale tempo per tempo vigente.\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E\u00a0\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E11.2.\u00a0 INTESA SANPAOLO, per la parte di competenza del presente contratto , provvede ad operare in qualit\u00e0 di \u2018Titolare\u2019 autonomo del trattamento. \u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E11.3 \u00a0\u00a0ISF, per la parte di competenza del presente contratto , provvede all\u2019esecuzione del presente contratto in qualit\u00e0 di \u2018Titolare\u2019 autonomo del trattamento salvo l\u2019assunzione del ruolo di \u2018Responsabile del trattamento\u2019 dei dati forniti dal Cliente, relativamente alla formazione obbligatoria. Ove ISF agisce in tale veste opera nel rispetto di quanto previsto dall\u2019articolo 28 del Regolamento (UE) 2016/679 del Parlamento europeo e del Consiglio, del 27 aprile 2016 sulla protezione dei dati personali (di seguito \u201cGDPR\u201d) che disciplina gli obblighi a carico del Responsabile del trattamento. .\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E11.4 In relazione al comma precedente, iI Cliente fornisce a ISF, limitatamente allo svolgimento del ruolo di Responsabile, le istruzioni di cui al citato articolo 28 GDPR.\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E.\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E11.5 \u00a0Il Cliente dichiara di aver \u00a0ricevuto da Intesa Sanpaolo Formazionel\u2019Informativa privacy\u00a0 sul trattamento dei dati e derivanti dalla sottoscrizione del presente contratto. Clicca qui per vedere l\u2019informativa privacy completa.\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u00a0\u003C/p\u003E\n\n\u003Cp\u003E\u00a0\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003EArt.12 - LEGGE APPLICABILE E FORO COMPETENTE\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E12.1 Il presente contratto \u00e8 disciplinato dalla legge Italiana.\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E12.2 Ogni controversia relativa all\u2019applicazione, esecuzione, interpretazione e violazione del presente contratto \u00e8 sottoposta in via esclusiva al foro di Milano.\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u00a0\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003EArt. 13 \u2013 MISCELLANEA\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E13.1 Il Cliente pu\u00f2 comunicare con ISF e con INTESA SANPAOLO all\u2019indirizzo mail \u003Ca href=\u0022mailto:info@skills4capital.com\u0022\u003Einfo@skills4capital.com\u003C/a\u003E\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E13.2 Il Cliente, nella sua qualit\u00e0 di soggetto non consumatore, accetta di derogare agli obblighi informativi di cui agli articoli 12 del D. Lgs. 70/2003.\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u00a0\u003C/p\u003E\n\n\u003Cp\u003E\u00a0\u003C/p\u003E\n\n\u003Cp\u003E\u00a0\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Ca\u003E\u003Cstrong\u003E\u003Cspan lang=\u0022IT\u0022 xml:lang=\u0022IT\u0022 xml:lang=\u0022IT\u0022\u003E\u003Cspan\u003EISTRUZIONI PER IL TRATTAMENTO DEI DATI\u003C/span\u003E\u003C/span\u003E\u003C/strong\u003E\u003C/a\u003E\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003EIl Cliente, in qualit\u00e0 di Titolare, in relazione a quanto previsto all\u2019articolo11, comma 6 fornisce al Responsabile le seguenti ISTRUZIONI per il trattamento dei Dati:\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Col\u003E\u003Cli\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003Eil trattamento dei Dati sar\u00e0 effettuato dal Responsabile esclusivamente per l\u2019esecuzione del presente contratto\u00a0 in modo lecito e secondo correttezza, attenendosi alle prescrizioni della normativa sulla protezione dei dati personali, alle previsioni del presente contratto e del presente Atto di Nomina, nonch\u00e9 alle eventuali successive istruzioni impartite per iscritto (di seguito, nel complesso le \u201cIstruzioni\u201d); \u00e8 fatto esplicito divieto di diffondere o comunicare i Dati a soggetti che siano estranei al trattamento;\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/li\u003E\n\t\u003Cli\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003Ein relazione al presente Atto di Nomina, il Responsabile in particolare dovr\u00e0:\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\n\t\u003Col\u003E\u003Cli\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003Eincaricare per iscritto ai sensi dell\u0027art. 29 GDPR il personale cui spetta, sul piano esecutivo, effettuare le operazioni connesse all\u0027esecuzione del presente contratto, fornendo loro istruzioni dettagliate per lo svolgimento delle relative mansioni in applicazione delle previsioni del presente contratto e del presente Atto di Nomina, definendo regole e modelli di comportamento vincolanti che assicurino la riservatezza ed il rispetto del divieto di comunicazione e diffusione dei Dati ai quali gli incaricati hanno accesso e vigilando sul loro operato;\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/li\u003E\n\t\t\u003Cli\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003Eincaricare per iscritto ai sensi dell\u2019art.29 GDPR i soggetti che abbiano le caratteristiche di Amministratori di Sistema, ai sensi del Provvedimento del Garante per la Protezione dei Dati Personali (il \u201cGarante\u201d) del 27 novembre 2008 e successive modifiche, tenendone l\u2019elenco aggiornato a disposizione del Titolare;\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/li\u003E\n\t\t\u003Cli\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003Enominare per iscritto, ai sensi degli artt.37-39 GDPR, ricorrendone i presupposti, un Responsabile della protezione dei dati \u201cData Protection Officer\u201d \u2013 \u201c\u003Cstrong\u003EDPO\u201d \u003C/strong\u003E\u2013 fornendo i recapiti di contatto in calce al presente atto;\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/li\u003E\n\t\t\u003Cli\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003Ein caso intenda affidare - previa acquisizione di specifica autorizzazione scritta del Titolare - in tutto o in parte, le attivit\u00e0 in premessa ad eventuali subaffidatari, appartenenti o meno al suo gruppo societario, \u003Cspan\u003Estipulare\u003C/span\u003E con essi un accordo scritto che imponga il rispetto delle Istruzioni, fornendo al Titolare un elenco di tali subaffidatari, delle modalit\u00e0 di esecuzione dei servizi resi dai medesimi e dei trattamenti di dati personali a tali servizi correlati. Il Responsabile limiter\u00e0 l\u0027accesso ai Dati da parte dei subaffidatari nella misura in cui ci\u00f2 risulter\u00e0 necessario per l\u0027espletamento dei servizi concordati contrattualmente;\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/li\u003E\n\t\t\u003Cli\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003Etrattare i Dati (\u003Cspan\u003Edirettamente o per il tramite di subaffidatari secondo\u003C/span\u003E quanto sopra precisato) solo all\u2019interno dell\u2019Unione Europea, a meno che il Paese Terzo in cui si intendano trasferire i Dati sia fra quelli che hanno conseguito formale valutazione di c.d. \u201cadequacy\u201d dalla Commissione Europea (art. 45 GDPR). Qualora, in assenza di un parere di adeguatezza da parte della Commissione Europea, il Responsabile intenda trasferire i Dati in un Paese Terzo, facendo ricorso a uno degli strumenti di garanzia di cui all\u2019art. 46 del GDPR o basandosi su una delle deroghe previste dall\u2019art. 49 del GDPR, dovr\u00e0 preventivamente comunicarlo al Titolare ed ottenere da quest\u2019ultimo l\u2019autorizzazione al trasferimento dei Dati. Anche nelle ipotesi di trasferimento dei Dati in un Paese Terzo, il Responsabile deve trattare i Dati attenendosi alle Istruzioni del Titolare. Nel caso in cui il trasferimento verso un Paese Terzo o verso un\u2019organizzazione internazionale sia imposto da un obbligo normativo cui \u00e8 soggetto il Responsabile, questi deve informare il Titolare circa tale obbligo prima del trasferimento, a meno che il diritto vieti tale informazione per rilevanti motivi di interesse pubblico.\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/li\u003E\n\t\t\u003Cli\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003Eadottare un \u003Cstrong\u003ERegistro dei Trattamenti\u003C/strong\u003E in cui siano tracciate tutte le categorie di attivit\u00e0 e le applicazioni informatiche utilizzate, relative ai trattamenti dei Dati svolti per conto del Titolare, nel pieno rispetto di quanto disposto dall\u2019art. 30 GDPR;\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/li\u003E\n\t\t\u003Cli\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003Eassistere il Titolare nelle \u003Cstrong\u003Evalutazioni di impatto\u003C/strong\u003E sulla protezione dei dati personali \u201cData Protection Impact Assesment\u201d \u2013 \u201c\u003Cstrong\u003EDPIA\u201d\u003C/strong\u003E \u2013 ai sensi dell\u2019art. 35 del GDPR e nel consultare l\u2019Autorit\u00e0 di controllo nei casi in cui la DPIA indichi che il trattamento presenterebbe un rischio elevato in assenza di misure per attenuare il rischio ai sensi dell\u2019art. 36 GDPR;\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/li\u003E\n\t\t\u003Cli\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003Eassistere il Titolare nell\u2019assicurare protezione ai Dati attraverso misure tecniche ed organizzative adeguate ai sensi dell\u2019art. 32 del GDPR;\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/li\u003E\n\t\t\u003Cli\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003Efermo restando quanto contrattualmente previsto, mettere in atto misure tecniche ed organizzative adeguate per garantire un livello di sicurezza adeguato al rischio del trattamento dei Dati, attenendosi a quanto previsto dall\u2019art. 32 GDPR. A tal riguardo, il Responsabile, anche in relazione alle conoscenze acquisite in base al progresso tecnico e tecnologico, alla natura dei Dati e alle caratteristiche delle operazioni di trattamento, deve tenere conto in special modo dei rischi che derivano dalla distruzione, dalla perdita, dalla modifica, dalla divulgazione non autorizzata dei Dati o dall\u2019accesso non autorizzato, anche accidentale, ai Dati. Le misure tecniche e organizzative comprendono, se del caso, tecniche di pseudonimizzazione, oscuramento e minimizzazione, nonch\u00e9 di protezione dei canali di comunicazione web (ad es. https);\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/li\u003E\n\t\t\u003Cli\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003Ecustodire i Dati separatamente rispetto a quelli trattati per conto di altre terze parti, sulla base di un criterio di sicurezza di tipo logico;\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/li\u003E\n\t\t\u003Cli\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Ca\u003E collaborare col Titolare - con misure tecniche e organizzative adeguate - affinch\u00e9 possa fornire il dovuto riscontro alle richieste degli Interessati aventi ad oggetto l\u2019esercizio dei diritti di cui agli artt.15-22 del GDPR; a tale fine, il Responsabile dovr\u00e0, entro tre (3) giorni lavorativi, informare il Titolare delle richieste che dovessero pervenire da parte degli Interessati, tese ad esercitare i diritti di cui ai citati articoli, e\u00a0 fornire al Titolare tutto quanto necessario per le relative risposte ed i provvedimenti da adottare eventualmente al riguardo;\u003C/a\u003E\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/li\u003E\n\t\t\u003Cli\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003Ecomunicare al Titolare qualsiasi accadimento che possa compromettere il corretto trattamento dei Dati, in particolare garantire, in virt\u00f9 dell\u2019art. 33 del GDPR, in caso di violazione dei Dati \u2013 \u201c\u003Cstrong\u003EData Breach\u201d\u003C/strong\u003E (da intendersi quale la violazione di sicurezza che comporta accidentalmente o in modo illecito la distruzione, la perdita, la modifica, la divulgazione non autorizzata o l\u2019accesso ai Dati) di informare il Titolare senza ingiustificato ritardo entro le 24h dall\u2019avvenuta conoscenza della violazione, fornendo ogni opportuno contributo e l\u2019assistenza necessaria per gli adempimenti prescritti dagli artt. 33 e 34 del GDPR;\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/li\u003E\n\t\t\u003Cli\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003Einformare immediatamente il Titolare, ove consentito, di qualsiasi richiesta o comunicazione da parte del Garante e/o Giudiziaria, per dare adeguato seguito alle stesse;\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/li\u003E\n\t\t\u003Cli\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003Ecollaborare con il Titolare per l\u2019attuazione delle prescrizioni eventualmente impartite dal Garante;\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/li\u003E\n\t\t\u003Cli\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003Eadottare idonee procedure interne finalizzate alla verifica periodica della corretta applicazione degli adempimenti posti in essere ai sensi del GDPR;\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/li\u003E\n\t\t\u003Cli\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003Einformare immediatamente il Titolare qualora, a suo parere, una o pi\u00f9 delle Istruzioni violi il GDPR o altre disposizioni applicabili, nazionali o dell\u2019Unione Europea;\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/li\u003E\n\t\t\u003Cli\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003Esalvo diversa istruzione del Titolare, nel caso di cessazione del presente contratto per qualsiasi causa (ad es. risoluzione, recesso, mancato rinnovo alla scadenza), provvedere all\u2019immediata restituzione al Titolare stesso dei Dati e dei documenti trattati. Nel caso in cui fosse necessaria la conservazione dei Dati per ottemperare a un obbligo di legge, i Dati saranno custoditi dal Responsabile esclusivamente per le finalit\u00e0 imposte dalla legge e solo per il periodo strettamente necessario a tale scopo.\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/li\u003E\n\t\u003C/ol\u003E\u003C/li\u003E\n\t\u003Cli\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003Eil trattamento dei Dati deve intendersi effettuato ai sensi dell\u0027art.29 GDPR, sotto l\u2019autorit\u00e0 del Titolare, il quale, in ogni momento e con congruo preavviso - preavviso non dovuto in caso di Data Breach o altra emergenza o necessit\u00e0 di riscontro ad un\u2019Autorit\u00e0 -\u00a0 potr\u00e0 operare controlli presso il Fornitore, e presso eventuali subaffidatari, e impartire eventuali ulteriori specifiche istruzioni per il suo svolgimento; il Titolare potr\u00e0 altres\u00ec chiedere la messa a disposizione di tutte le informazioni necessarie per dimostrare il rispetto degli obblighi in capo al Responsabile. Il Responsabile, anche con riguardo ai propri subaffidatari, dovr\u00e0 fornire la pi\u00f9 ampia collaborazione per le attivit\u00e0 di revisione del Titolare, comprese le ispezioni. Il Titolare potr\u00e0 altres\u00ec chiedere la cessazione del Trattamento se imposta dalla necessit\u00e0 di adempiere a divieti od obblighi di legge, ovvero a provvedimenti del Garante e/o dell\u2019autorit\u00e0 Giudiziaria;\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/li\u003E\n\t\u003Cli\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003Eil Titolare si riserva comunque, in caso di inosservanza da parte del Responsabile di quanto previsto agli artt. 1, 2 e 3 del presente Atto di Nomina, la facolt\u00e0 di risolvere il presente contratto ai sensi dell\u2019art.1456 Cod. Civ., con conseguente revoca immediata dell\u2019Atto di Nomina.\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/li\u003E\n\u003C/ol\u003E\u003Cp\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan\u003E\u003Cspan lang=\u0022IT\u0022 xml:lang=\u0022IT\u0022 xml:lang=\u0022IT\u0022\u003EIl Cliente, in relazione a quanto previsto all\u2019articolo 7 comma 1 prende atto che, ISF, al momento della stipula del presente contratto, si avvale nell\u2019erogazione dello stesso della societ\u00e0 Amazon Web Services\u003C/span\u003E.\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/span\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u00a0\u003C/p\u003E\n\n\u003Cp\u003E\u00a0\u003C/p\u003E\n\n\u003Cp\u003E\u00a0\u003C/p\u003E\n',
											code: 'Consenso_0017',
											type: 'checkbox',
											mandatory: 'True',
											user_type: '',
										},
									],
								},
							],
						},
						policy: {
							data: [
								{
									id: 22,
									title: 'Consensi della piattaforma Skills4Capital',
									code: 'Consenso_001',
									consents: [
										{
											id: '6',
											name:
												'CONSENSO DELL\u2019INTERESSATO AL TRATTAMENTO DEI DATI PERSONALI',
											description:
												'\u003Cp\u003E\u00a0\u003C/p\u003E\n\n\u003Cp\u003E\u003Cstrong\u003EArt. 1 - OGGETTO DEL CONTRATTO\u003C/strong\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u00a0\u003C/p\u003E\n\n\u003Cp\u003E1.1 Il presente contratto ha per oggetto l\u2019abbonamento che consente al Cliente di fruire attraverso la Piattaforma dei contenuti formativi prodotti da ISF.\u003C/p\u003E\n\n\u003Cp\u003E1.2 Il Cliente sceglie, al momento della conclusione del contratto, almeno un pacchetto formativo tra quelli disponibili sulla Piattaforma. Nel corso del rapporto e fino all\u2019eventuale comunicazione di disdetta ai sensi dell\u2019articolo 4.1, il Cliente pu\u00f2 acquistare ulteriori contenuti formativi tra quelli tempo per tempo offerti da ISF, nonch\u00e9 abilitare ulteriori utenze.\u00a0\u003C/p\u003E\n\n\u003Cp\u003E\u00a0\u003C/p\u003E\n\n\u003Cp\u003E\u00a0\u003C/p\u003E\n\n\u003Cp\u003E\u003Cstrong\u003EArt. 2 - CONCLUSIONE DEL CONTRATTO - ACQUISTO DI ULTERIORI CONTENUTI FORMATIVI E ATTIVAZIONE DI ULTERIORI UTENZE\u003C/strong\u003E\u003C/p\u003E\n\n\u003Cp\u003E2.1 Il presente contratto si conclude a distanza sul Sito con le seguenti modalit\u00e0: il Cliente, seguendo le istruzioni, si registra, sceglie almeno un pacchetto formativo, indica il numero di utenze da abilitare, accetta le presenti condizioni contrattuali e autorizza i pagamenti secondo i tempi e le modalit\u00e0 di cui all\u2019articolo 5.\u003C/p\u003E\n\n\u003Cp\u003E2.2 L\u2019acquisto degli ulteriori contenuti formativi e l\u2019attivazione di ulteriori utenze avviene sulla Piattaforma con le modalit\u00e0 del comma precedente in quanto compatibili. Il Cliente prende atto e accetta che agli acquisti successivi e alle attivazioni successive si applicano le norme del presente contratto. Salvo che il Cliente indichi diversamente, al momento dell\u2019acquisto di ulteriori contenuti formativi, si intendono richieste il medesimo numero di utenze abilitate gi\u00e0 in essere.\u003C/p\u003E\n\n\u003Cp\u003E2.3 Le caratteristiche dei contenuti formativi e i prezzi applicati al Cliente sono quelli indicati sul Sito al momento della conclusione dell\u2019acquisto.\u00a0\u003C/p\u003E\n\n\u003Cp\u003E\u00a0\u003C/p\u003E\n\n\u003Cp\u003E\u003Cstrong\u003EArt. 3 \u2013 ATTIVAZIONE\u00a0\u003C/strong\u003E\u003C/p\u003E\n\n\u003Cp\u003E3.1 I contenuti formativi acquistati al momento della conclusione del contratto sono fruibili sulla Piattaforma quando ISF abbia ricevuto conferma del valido rilascio delle autorizzazioni di addebito ai sensi dell\u2019art. 5.2.\u003C/p\u003E\n\n\u003Cp\u003E3.2 Gli ulteriori contenuti formativi acquistati successivamente alla conclusione del contratto vengono resi disponibili alle utenze abilitate entro 1 giorno lavorativo.\u003C/p\u003E\n\n\u003Cp\u003E3.3 Per le eventuali ulteriori utenze da abilitare sui contenuti formativi gi\u00e0 acquistati, le stesse vengono abilitate entro 1 giorno lavorativo.\u003C/p\u003E\n\n\u003Cp\u003E3.4. Per la fruizione dei contenuti formativi acquistati, le utenze abilitate ricevono via e-mail il link alla pagina web che consente di impostare la password e accedere alla Piattaforma.\u003C/p\u003E\n\n\u003Cp\u003E\u00a0\u003C/p\u003E\n\n\u003Cp\u003E\u003Cstrong\u003EArt.4 - DURATA E CONDIZIONI DI RECESSO\u003C/strong\u003E\u003C/p\u003E\n\n\u003Cp\u003E4.1 Il presente contratto ha durata annuale decorrente dalla data di attivazione dei contenuti formativi ai sensi dell\u2019articolo 3.1 e si rinnova tacitamente di anno in anno ad ogni scadenza originaria o rinnovata, salvo disdetta che ciascuna Parte comunica per iscritto all\u2019altra entro 30 giorni dalla data di scadenza originaria o rinnovata.\u003C/p\u003E\n\n\u003Cp\u003E4.2 Il Cliente pu\u00f2 inoltre richiedere di disabilitare una o pi\u00f9 utenze ad ogni scadenza originaria o rinnovata, mediante comunicazione scritta con preavviso di almeno 30 giorni, fermo restando il pagamento delle rate residue, come previsto al successivo art. 5.5.\u003C/p\u003E\n\n\u003Cp\u003E4.3 Per gli ulteriori contenuti formativi acquistati e per le ulteriori utenze abilitate dopo la sottoscrizione del presente contratto resta ferma la data di scadenza del contratto originaria o rinnovata.\u003C/p\u003E\n\n\u003Cp\u003E\u00a0\u003C/p\u003E\n\n\u003Cp\u003E\u00a0\u003C/p\u003E\n\n\u003Cp\u003E\u003Cstrong\u003EArt. 5 - PAGAMENTI\u003C/strong\u003E\u003C/p\u003E\n\n\u003Cp\u003E5.1 I prezzi indicati sul sito dei singoli contenuti formativi acquistati e delle utenze abilitate sono annuali e prevedono una rateizzazione in n. 12 mensilit\u00e0.\u003C/p\u003E\n\n\u003Cp\u003EIl pagamento di ciascuna mensilit\u00e0 riferita ai contenuti formativi e alle utenze di cui sopra viene effettuato, mediante addebito al Cliente stesso, il giorno 1 di ciascun mese. Il pagamento della prima mensilit\u00e0 viene effettuato alla prima data utile di addebito, tenuto conto dei tempi tecnici necessari\u003Cem\u003E.\u003C/em\u003E\u003C/p\u003E\n\n\u003Cp\u003E5.2 Per il pagamento degli importi dovuti, il Cliente deve autorizzare l\u2019addebito su carta di credito oppure l\u2019addebito SEPA.\u003C/p\u003E\n\n\u003Cp\u003E5.3 In occasione di ciascuna data di addebito, ISF emette la relativa fattura.\u003C/p\u003E\n\n\u003Cp\u003E5.4 In caso di mancato pagamento di una o pi\u00f9 rate, ISF si riserva la facolt\u00e0 di sospendere l\u2019esecuzione del contratto, fermo restando il diritto di ottenere il pagamento integrale della somma ancora non corrisposta.\u003C/p\u003E\n\n\u003Cp\u003E5.5 In caso di disdetta del contratto, per i contenuti formativi acquistati successivamente e per le ulteriori utenze abilitate nel corso del rapporto restano dovute le rate residue, che sono addebitate con l\u2019ultima rata.\u003C/p\u003E\n\n\u003Cp\u003E\u00a0\u003C/p\u003E\n\n\u003Cp\u003E\u00a0\u003C/p\u003E\n\n\u003Cp\u003E\u003Cstrong\u003EArt. 6 - UTILIZZO DEL SERVIZIO DA PARTE DEL CLIENTE\u003C/strong\u003E\u003C/p\u003E\n\n\u003Cp\u003E6.1 Il Cliente dichiara di essere a conoscenza e di accettare i prerequisiti hardware e software necessari per poter accedere alla Piattaforma e fruire dei contenuti formativi. In particolare, il Cliente prende atto che i requisiti hardware e software richiesti sono minimi e sono generalmente soddisfatti su un normale sistema standard per uso domestico e che per poter usufruire al meglio dei contenuti multimediali presenti \u00e8 necessario:\u003C/p\u003E\n\n\u003Cul\u003E\u003Cli\u003Eavere una connessione alla rete Internet. Per un utilizzo ottimale \u00e8 consigliata una connessione ADSL;\u003C/li\u003E\n\t\u003Cli\u003Eavere installato sulla propria macchina uno tra i principali browser disponibili regolarmente aggiornati;\u003C/li\u003E\n\t\u003Cli\u003Eavere installato sulla propria macchina il software Adobe Acrobat Reader per visualizzare alcuni materiali in formato pdf.\u00a0\u003C/li\u003E\n\u003C/ul\u003E\u003Cp\u003E\u00c8 esclusiva responsabilit\u00e0 del Cliente assicurare l\u2019interoperabilit\u00e0 tra la connettivit\u00e0, di cui si sia dotato, e la Piattaforma.\u003C/p\u003E\n\n\u003Cp\u003E6.2 Il Cliente si impegna, inoltre, ad adeguare il proprio hardware o software nel caso in cui fosse necessario a seguito di successivi aggiornamenti della Piattaforma.\u003C/p\u003E\n\n\u003Cp\u003E6.3 Il Cliente \u00e8, inoltre, consapevole che l\u2019utilizzo dei contenuti formativi acquistati \u00e8 consentito solo alle utenze abilitate e che le stesse non potranno esser sostituite dopo l\u2019attivazione, salvo la facolt\u00e0 di disabilitare le utenze stesse riconosciuta al Cliente all\u2019art. 4.2.\u003C/p\u003E\n\n\u003Cp\u003E6.4 Il download e l\u2019utilizzo dei contenuti formativi messi a disposizione \u00e8 permesso solo alle utenze abilitate. Il Cliente \u00e8 responsabile, insieme alle utenze abilitate, della conservazione della segretezza delle credenziali assegnate ed \u00e8 titolare, per effetto della conclusione del contratto, di un diritto non cedibile di accesso all\u2019area riservata, impegnandosi cos\u00ec a non far utilizzare o visionare i contenuti formativi a soggetti diversi dalle utenze abilitate. Il Cliente si astiene dal compiere qualunque atto che possa ledere i diritti di esclusiva e di propriet\u00e0 di ISF e si impegna altres\u00ec a manlevare e tenere indenne ISF da ogni e qualsiasi pretesa o rivendicazione derivante dall\u2019uso o abuso di terzi.\u003C/p\u003E\n\n\u003Cp\u003E6.5 In caso di parziale o mancata fruizione da parte di una o pi\u00f9 utenze abilitate dei contenuti formativi nel periodo di disponibilit\u00e0 degli stessi, non \u00e8 prevista alcuna forma di rimborso a favore del Cliente, che sar\u00e0 invece tenuto a corrispondere quanto ancora dovuto.\u003C/p\u003E\n\n\u003Cp\u003E6.6 Il Cliente infine non pu\u00f2 cedere a terzi alcun obbligo o diritto originato dal presente contratto in assenza di preventiva autorizzazione scritta di ISF.\u003C/p\u003E\n\n\u003Cp\u003E6.7 In caso di necessit\u00e0 di assistenza, il Cliente pu\u00f2 contattare info@skills4business.it.\u003C/p\u003E\n\n\u003Cp\u003E\u00a0\u003C/p\u003E\n\n\u003Cp\u003E\u003Cstrong\u003EArt. 7 \u2013 FORNITURA DEL SERVIZIO\u003C/strong\u003E\u003C/p\u003E\n\n\u003Cp\u003E7.1 ISF pu\u00f2 avvalersi di soggetti terzi per l\u2019esecuzione del contratto; in particolare i contenuti formativi e le relative informazioni sono elaborati, rivisti ed aggiornati da ISF anche con la consulenza specialistica e il supporto di professionisti qualificati.\u003C/p\u003E\n\n\u003Cp\u003E7.2 ISF avr\u00e0 la facolt\u00e0 di sospendere parzialmente o totalmente le credenziali o di interrompere l\u2019esecuzione del contratto, dandone al Cliente immediata comunicazione tramite la Piattaforma o mediante e-mail qualora vi fossero fondati motivi per ritenere che si possano verificare problemi di sicurezza, di utilizzo non autorizzato o di violazione del diritto di riservatezza.\u003C/p\u003E\n\n\u003Cp\u003EI suddetti oneri di comunicazione non possono considerarsi sussistenti in casi, alternativamente considerati, di forza maggiore, necessit\u00e0 o urgenza.\u003C/p\u003E\n\n\u003Cp\u003E7.3 Inoltre ISF avr\u00e0 facolt\u00e0 di sospendere parzialmente o totalmente il servizio per aggiornamento dei contenuti formativi ovvero implementazioni tecnologiche della Piattaforma dandone al Cliente immediata comunicazione tramite la Piattaforma o mediante e-mail.\u003C/p\u003E\n\n\u003Cp\u003E\u00a0\u003C/p\u003E\n\n\u003Cp\u003E\u003Cstrong\u003EArt. 8 - SICUREZZA E RISERVATEZZA DEI DATI\u003C/strong\u003E\u003C/p\u003E\n\n\u003Cp\u003E8.1 Il Cliente garantisce di disporre legittimamente di tutte le informazioni fornite ai fini della sottoscrizione del presente contratto, assicurando altres\u00ec che le stesse non violino in alcun modo, direttamente o indirettamente, il diritto di terzi. Pertanto, il Cliente si obbliga a non immettere dati di cui non possa liberamente disporre.\u003C/p\u003E\n\n\u003Cp\u003E\u00c8 fatto altres\u00ec divieto al Cliente di inserire dati falsi o di fantasia nella procedura di acquisto e in tutte le comunicazioni connesse all\u2019esecuzione del contratto.\u003C/p\u003E\n\n\u003Cul\u003E\u003Cli\u003E\n\t\u003Col start=\u00222\u0022\u003E\u003Cli\u003EIl Cliente manleva ISF:\u003C/li\u003E\n\t\u003C/ol\u003E\u003C/li\u003E\n\t\u003Cli\u003Eda ogni responsabilit\u00e0 derivante dall\u2019immissione di dati e documenti errati, essendo il Cliente stesso unico responsabile del corretto inserimento;\u003C/li\u003E\n\t\u003Cli\u003Eda ogni obbligo o onere di accertamento e controllo diretto e indiretto al riguardo.\u003C/li\u003E\n\u003C/ul\u003E\u003Cp\u003E8.3 Qualora venga accertata, in via autonoma da ISF o su segnalazione di terzi, la falsit\u00e0 dei dati forniti, ISF si riserva il diritto di impedire/sospendere la registrazione del Cliente.\u003C/p\u003E\n\n\u003Cp\u003E\u00a0\u003C/p\u003E\n\n\u003Cp\u003E\u003Cstrong\u003EART. 9 - RESPONSABILITA\u2019 E MANLEVA\u003C/strong\u003E\u003C/p\u003E\n\n\u003Cp\u003E9.1 Salvi i casi di dolo o colpa grave, il Cliente esonera espressamente ISF da qualsiasi responsabilit\u00e0 per danni diretti e indiretti:\u003C/p\u003E\n\n\u003Cul\u003E\u003Cli\u003Eche il Cliente stesso, le utenze abilitate o terzi possano subire in relazione o in dipendenza dell\u2019esecuzione del contratto o per effetto della sua interruzione;\u003C/li\u003E\n\t\u003Cli\u003Eche il Cliente stesso, le utenze abilitate o terzi possano in qualche modo lamentare per la mancata erogazione della connettivit\u00e0 da parte del gestore della rete di telecomunicazione, o anche per il ricorso da parte del Cliente o delle utenze abilitate all\u2019utilizzo di connettivit\u00e0 tecnicamente incompatibile con il servizio offerto, nonch\u00e9 per la mancata fruizione del servizio a seguito di difetti riscontrati dal Cliente nella fruizione dello stesso, qualora tutto ci\u00f2 sia dipeso dal mancato possesso dei requisiti minimi di sistema di cui all\u2019articolo 6, la cui verifica \u00e8 onere del Cliente;\u003C/li\u003E\n\t\u003Cli\u003Ecausati da terzi che illecitamente accedessero al servizio a causa della mancanza, da parte del Cliente o delle utenze abilitate, di cautela nella custodia delle credenziali attribuite o per l\u2019assenza di altre misure di sicurezza che il Cliente e le utenze abilitate sono tenute ad adottare.\u003C/li\u003E\n\u003C/ul\u003E\u003Cp\u003E9.2 In nessun caso ISF sar\u00e0 ritenuta responsabile:\u003C/p\u003E\n\n\u003Cul\u003E\u003Cli\u003Edel malfunzionamento del servizio derivante da guasti, sovraccarichi, interruzioni delle linee telefoniche, elettriche o riferite alla rete Internet;\u003C/li\u003E\n\t\u003Cli\u003Eper inadempimenti di terzi che pregiudichino la fruizione dei contenuti formativi, compresi, in via esemplificativa, i rallentamenti di velocit\u00e0 o il mancato funzionamento delle linee telefoniche e degli elaboratori che gestiscono il traffico telematico fra il Cliente e la Piattaforma didattica da cui \u00e8 erogato il servizio.\u003C/li\u003E\n\u003C/ul\u003E\u003Cp\u003E9.3 ISF, inoltre, non potr\u00e0 essere ritenuta responsabile per inadempimenti derivanti da impedimenti oggettivi che esulino dalla sfera del proprio diretto ed immediato controllo o da cause di forza maggiore. Al verificarsi di uno dei predetti eventi, ISF dovr\u00e0 darne informazione al Cliente tramite il Sito, comunicando altres\u00ec le prospettive di riattivazione regolare del servizio.\u003C/p\u003E\n\n\u003Cp\u003E9.4 In relazione alla scelta dei pacchetti formativi, ogni responsabilit\u00e0 \u00e8 totalmente a carico del Cliente stesso. Per tale ragione, ISF non potr\u00e0 essere ritenuta responsabile per i contenuti formativi acquistati dal Cliente per errore, n\u00e9 per l\u2019eventuale insoddisfazione circa i contenuti acquistati.\u003C/p\u003E\n\n\u003Cp\u003E9.5 Il Cliente si obbliga a tenere indenne ISF da tutte le perdite, i danni, le responsabilit\u00e0, i costi, gli oneri e le spese (anche legali) che dovessero essere sostenute da ISF quale conseguenza delle informazioni fornite sul Sito, dell\u2019uso illegale del Sito da parte del Cliente, delle utenze abilitate o di terzi e comunque di qualsiasi inadempimento degli obblighi assunti con il presente contratto anche in ipotesi di richieste di risarcimento danni avanzate da terzi a qualunque titolo.\u003C/p\u003E\n\n\u003Cp\u003E\u00a0\u003C/p\u003E\n\n\u003Cp\u003E\u003Cstrong\u003EArt.10 - TUTELA DEL DIRITTO D\u2019AUTORE\u003C/strong\u003E\u003C/p\u003E\n\n\u003Cp\u003E10.1 In base alla legge sul diritto d\u2019autore \u00e8 vietato qualunque uso commerciale da parte di terzi, la riproduzione totale o parziale, la rielaborazione, la trasmissione sotto qualunque forma e con qualsiasi modalit\u00e0 senza preventiva autorizzazione scritta da parte di ISF di qualsiasi contenuto presente sul Sito.\u003C/p\u003E\n\n\u003Cp\u003E10.2 In caso di violazione degli obblighi previsti dal presente articolo e dall\u2019art. 6.4, ferma la facolt\u00e0 di sospensione di cui all\u2019art. 7.2, il contratto si intender\u00e0 risolto di diritto e ISF sar\u00e0 libera di agire giudizialmente a tutela di ogni diritto disatteso, ivi compreso il risarcimento dei danni subiti.\u003C/p\u003E\n\n\u003Cp\u003E\u00a0\u003C/p\u003E\n\n\u003Cp\u003E\u003Cstrong\u003EArt. 11 - TUTELA DEI DATI PERSONALI\u003C/strong\u003E\u003C/p\u003E\n\n\u003Cp\u003E11.1\u00a0\u00a0\u00a0\u00a0Con riferimento ai dati personali trattati nell\u2019ambito del presente contratto ciascuna delle parti contraenti si obbliga a trattare i dati ricevuti dall\u0027altra esclusivamente per finalit\u00e0 strettamente connesse e strumentali all\u2019esecuzione degli obblighi assunti con il presente contratto stesso e nel rispetto delle disposizioni previste dal Regolamento (UE) 2016/679 del Parlamento europeo e del Consiglio, del 27 aprile 2016 relativo alla protezione delle persone fisiche con riguardo al trattamento dei dati personali\u00a0 e la normativa nazionale tempo per tempo vigente.\u003C/p\u003E\n\n\u003Cp\u003E11.2.\u00a0\u00a0\u00a0Ciascuna parte si impegna ad aggiornare ed integrare - per quanto di propria competenza - le proprie procedure di protezione dei dati personali in relazione all\u2019evoluzione normativa. Le parti si impegnano altres\u00ec a comunicarsi tempestivamente eventuali irregolarit\u00e0 che dovessero verificarsi in qualunque fase del trattamento di dati personali connesso al presente contratto.\u003C/p\u003E\n\n\u003Cp\u003E11.3.\u00a0\u00a0\u003Ca\u003EISF per il trattamento dei dati personali\u00a0\u003C/a\u003Edi persone fisiche derivanti dalla sottoscrizione del presente contratto, provvede ad operare in qualit\u00e0 di \u2018Titolare\u2019 del trattamento.\u003C/p\u003E\n\n\u003Cp\u003E11.4 Il Cliente dichiara di aver preso visione dell\u2019Informativa privacy relativamente al trattamento dei dati personali di persone fisiche derivanti dalla sottoscrizione del presente contratto. Clicca qui per vedere l\u2019informativa privacy completa.\u003C/p\u003E\n\n\u003Cp\u003E11.5 \u00a0\u00a0ISF per il trattamento dei dati personali di persone fisiche derivanti dalla fruizione dei contenuti formativi, provvede all\u2019esecuzione del presente contratto in qualit\u00e0 di \u2018Responsabile del trattamento\u2019 dei dati forniti dal Cliente. ISF agisce in tale veste nel rispetto di quanto previsto dall\u2019articolo 28 del Regolamento (UE) 2016/679 del Parlamento europeo e del Consiglio, del 27 aprile 2016 sulla protezione dei dati personali (di seguito \u201cGDPR\u201d) che disciplina gli obblighi a carico del Responsabile del trattamento. In particolare, a titolo meramente esemplificativo, ISF:\u003C/p\u003E\n\n\u003Cp\u003Ea. tratta i dati personali acquisiti nell\u2019ambito dell\u2019attivit\u00e0 solo su istruzioni del Cliente quale Titolare;\u003C/p\u003E\n\n\u003Cp\u003Eb. garantisce il rispetto degli obblighi di riservatezza da parte dei propri dipendenti;\u003C/p\u003E\n\n\u003Cp\u003Ec. adotta le misure tecniche ed organizzative adeguate.\u003C/p\u003E\n\n\u003Cp\u003E11.6 In relazione al comma precedente, iI Cliente fornisce a ISF, limitatamente allo svolgimento di detto ruolo, le istruzioni di cui al citato articolo 28 GDPR.\u003C/p\u003E\n\n\u003Cp\u003E\u00a0\u003C/p\u003E\n\n\u003Cp\u003E\u003Cstrong\u003EArt.12 - LEGGE APPLICABILE E FORO COMPETENTE\u003C/strong\u003E\u003C/p\u003E\n\n\u003Cp\u003E12.1 Il presente contratto \u00e8 disciplinato dalla legge Italiana.\u003C/p\u003E\n\n\u003Cp\u003E12.2 Ogni controversia relativa all\u2019applicazione, esecuzione, interpretazione e violazione del presente contratto \u00e8 sottoposta in via esclusiva al foro di Milano.\u003C/p\u003E\n\n\u003Cp\u003E\u00a0\u003C/p\u003E\n\n\u003Cp\u003E\u003Cstrong\u003EArt. 13 \u2013 MISCELLANEA\u003C/strong\u003E\u003C/p\u003E\n\n\u003Cp\u003E13.1 Il Cliente pu\u00f2 comunicare con ISF all\u2019indirizzo mail info@skills4business.it.\u003C/p\u003E\n\n\u003Cp\u003E13.2 Il Cliente, nella sua qualit\u00e0 di soggetto non consumatore, accetta di derogare agli obblighi informativi di cui agli articoli 12 del D. Lgs. 70/2003.\u003C/p\u003E\n\n\u003Cp\u003E\u00a0\u003C/p\u003E\n\n\u003Cp\u003E\u00a0\u003C/p\u003E\n\n\u003Cp\u003E\u003Cstrong\u003EATTO DI NOMINA - ISTRUZIONI PER IL TRATTAMENTO DEI DATI\u003C/strong\u003E\u003C/p\u003E\n\n\u003Cp\u003EIl Cliente, in qualit\u00e0 di Titolare, in relazione a quanto previsto all\u2019articolo11, comma 6 fornisce al Responsabile le seguenti ISTRUZIONI per il trattamento dei Dati:\u003C/p\u003E\n\n\u003Col\u003E\u003Cli\u003Eil trattamento dei Dati sar\u00e0 effettuato dal Responsabile esclusivamente per l\u2019esecuzione del presente contratto\u00a0 in modo lecito e secondo correttezza, attenendosi alle prescrizioni della normativa sulla protezione dei dati personali, alle previsioni del presente contratto e del presente Atto di Nomina, nonch\u00e9 alle eventuali successive istruzioni impartite per iscritto (di seguito, nel complesso le \u201cIstruzioni\u201d); \u00e8 fatto esplicito divieto di diffondere o comunicare i Dati a soggetti che siano estranei al trattamento;\u003C/li\u003E\n\t\u003Cli\u003Ein relazione al presente Atto di Nomina, il Responsabile in particolare dovr\u00e0:\n\t\u003Col\u003E\u003Cli\u003Eincaricare per iscritto il personale cui spetta, sul piano esecutivo, effettuare le operazioni connesse all\u0027esecuzione del presente contratto, fornendo loro istruzioni dettagliate per lo svolgimento delle relative mansioni in applicazione delle previsioni del presente contratto e del presente Atto di Nomina, definendo regole e modelli di comportamento vincolanti che assicurino la riservatezza ed il rispetto del divieto di comunicazione e diffusione dei Dati ai quali gli incaricati hanno accesso e vigilando sul loro operato;\u003C/li\u003E\n\t\t\u003Cli\u003Eincaricare per iscritto i soggetti che abbiano le caratteristiche di Amministratori di Sistema, ai sensi del Provvedimento del Garante per la Protezione dei Dati Personali (il \u201cGarante\u201d) del 27 novembre 2008 e successive modifiche, tenendone l\u2019elenco aggiornato a disposizione del Titolare;\u003C/li\u003E\n\t\t\u003Cli\u003Enominare per iscritto, ai sensi degli artt.37-39 GDPR, ricorrendone i presupposti, un Responsabile della protezione dei dati \u201cData Protection Officer\u201d \u2013 \u201c\u003Cstrong\u003EDPO\u201d\u00a0\u003C/strong\u003E\u2013 fornendo i recapiti di contatto in calce al presente atto;\u003C/li\u003E\n\t\t\u003Cli\u003Ein caso intenda affidare - previa acquisizione di specifica autorizzazione scritta del Titolare - in tutto o in parte, le attivit\u00e0 in premessa ad eventuali subaffidatari, appartenenti o meno al suo gruppo societario,\u00a0stipulare\u00a0con essi un accordo scritto che imponga il rispetto delle Istruzioni, fornendo al Titolare un elenco di tali subaffidatari, delle modalit\u00e0 di esecuzione dei servizi resi dai medesimi e dei trattamenti di dati personali a tali servizi correlati. Il Responsabile limiter\u00e0 l\u0027accesso ai Dati da parte dei subaffidatari nella misura in cui ci\u00f2 risulter\u00e0 necessario per l\u0027espletamento dei servizi concordati contrattualmente;\u003C/li\u003E\n\t\t\u003Cli\u003Etrattare i Dati (direttamente o per il tramite di subaffidatari secondo\u00a0quanto sopra precisato) solo all\u2019interno dell\u2019Unione Europea, a meno che il Paese Terzo in cui si intendano trasferire i Dati sia fra quelli che hanno conseguito formale valutazione di c.d. \u201cadequacy\u201d dalla Commissione Europea (art. 45 GDPR). Qualora, in assenza di un parere di adeguatezza da parte della Commissione Europea, il Responsabile intenda trasferire i Dati in un Paese Terzo, facendo ricorso a uno degli strumenti di garanzia di cui all\u2019art. 46 del GDPR o basandosi su una delle deroghe previste dall\u2019art. 49 del GDPR, dovr\u00e0 preventivamente comunicarlo al Titolare ed ottenere da quest\u2019ultimo l\u2019autorizzazione al trasferimento dei Dati. Anche nelle ipotesi di trasferimento dei Dati in un Paese Terzo, il Responsabile deve trattare i Dati attenendosi alle Istruzioni del Titolare. Nel caso in cui il trasferimento verso un Paese Terzo o verso un\u2019organizzazione internazionale sia imposto da un obbligo normativo cui \u00e8 soggetto il Responsabile, questi deve informare il Titolare circa tale obbligo prima del trasferimento, a meno che il diritto vieti tale informazione per rilevanti motivi di interesse pubblico.\u003C/li\u003E\n\t\t\u003Cli\u003Eadottare un\u00a0\u003Cstrong\u003ERegistro dei Trattamenti\u003C/strong\u003E\u00a0in cui siano tracciate tutte le categorie di attivit\u00e0 e le applicazioni informatiche utilizzate, relative ai trattamenti dei Dati svolti per conto del Titolare, nel pieno rispetto di quanto disposto dall\u2019art. 30 GDPR;\u003C/li\u003E\n\t\t\u003Cli\u003Eassistere il Titolare nelle\u00a0\u003Cstrong\u003Evalutazioni di impatto\u003C/strong\u003E\u00a0sulla protezione dei dati personali \u201cData Protection Impact Assessment\u201d \u2013 \u201c\u003Cstrong\u003EDPIA\u201d\u003C/strong\u003E\u00a0\u2013 ai sensi dell\u2019art. 35 del GDPR e nel consultare l\u2019Autorit\u00e0 di controllo nei casi in cui la DPIA indichi che il trattamento presenterebbe un rischio elevato in assenza di misure per attenuare il rischio ai sensi dell\u2019art. 36 GDPR;\u003C/li\u003E\n\t\t\u003Cli\u003Eassistere il Titolare nell\u2019assicurare protezione ai Dati attraverso misure tecniche ed organizzative adeguate ai sensi dell\u2019art. 32 del GDPR;\u003C/li\u003E\n\t\t\u003Cli\u003Efermo restando quanto contrattualmente previsto, mettere in atto misure tecniche ed organizzative adeguate per garantire un livello di sicurezza adeguato al rischio del trattamento dei Dati, attenendosi a quanto previsto dall\u2019art. 32 GDPR. A tal riguardo, il Responsabile, anche in relazione alle conoscenze acquisite in base al progresso tecnico e tecnologico, alla natura dei Dati e alle caratteristiche delle operazioni di trattamento, deve tenere conto in special modo dei rischi che derivano dalla distruzione, dalla perdita, dalla modifica, dalla divulgazione non autorizzata dei Dati o dall\u2019accesso non autorizzato, anche accidentale, ai Dati. Le misure tecniche e organizzative comprendono, se del caso, tecniche di pseudonimizzazione, oscuramento e minimizzazione, nonch\u00e9 di protezione dei canali di comunicazione web (ad es. https);\u003C/li\u003E\n\t\t\u003Cli\u003Ecustodire i Dati separatamente rispetto a quelli trattati per conto di altre terze parti, sulla base di un criterio di sicurezza di tipo logico;\u003C/li\u003E\n\t\t\u003Cli\u003E\u003Ca\u003Ecollaborare col Titolare - con misure tecniche e organizzative adeguate - affinch\u00e9 possa fornire il dovuto riscontro alle richieste degli Interessati aventi ad oggetto l\u2019esercizio dei diritti di cui agli artt.15-22 del GDPR; a tale fine, il Responsabile dovr\u00e0, entro tre (3) giorni lavorativi, informare il Titolare delle richieste che dovessero pervenire da parte degli Interessati, tese ad esercitare i diritti di cui ai citati articoli, e\u00a0 fornire al Titolare tutto quanto necessario per le relative risposte ed i provvedimenti da adottare eventualmente al riguardo;\u003C/a\u003E\u003C/li\u003E\n\t\t\u003Cli\u003Ecomunicare al Titolare qualsiasi accadimento che possa compromettere il corretto trattamento dei Dati, in particolare garantire, in virt\u00f9 dell\u2019art. 33 del GDPR, in caso di violazione dei Dati \u2013 \u201c\u003Cstrong\u003EData Breach\u201d\u003C/strong\u003E\u00a0(da intendersi quale la violazione di sicurezza che comporta accidentalmente o in modo illecito la distruzione, la perdita, la modifica, la divulgazione non autorizzata o l\u2019accesso ai Dati) di informare il Titolare senza ingiustificato ritardo entro le 24h dall\u2019avvenuta conoscenza della violazione, fornendo ogni opportuno contributo e l\u2019assistenza necessaria per gli adempimenti prescritti dagli artt. 33 e 34 del GDPR;\u003C/li\u003E\n\t\t\u003Cli\u003Einformare immediatamente il Titolare, ove consentito, di qualsiasi richiesta o comunicazione da parte del Garante e/o Giudiziaria, per dare adeguato seguito alle stesse;\u003C/li\u003E\n\t\t\u003Cli\u003Ecollaborare con il Titolare per l\u2019attuazione delle prescrizioni eventualmente impartite dal Garante;\u003C/li\u003E\n\t\t\u003Cli\u003Eadottare idonee procedure interne finalizzate alla verifica periodica della corretta applicazione degli adempimenti posti in essere ai sensi del GDPR;\u003C/li\u003E\n\t\t\u003Cli\u003Einformare immediatamente il Titolare qualora, a suo parere, una o pi\u00f9 delle Istruzioni violi il GDPR o altre disposizioni applicabili, nazionali o dell\u2019Unione Europea;\u003C/li\u003E\n\t\t\u003Cli\u003Esalvo diversa istruzione del Titolare, nel caso di cessazione del presente contratto per qualsiasi causa (ad es. risoluzione, recesso, mancato rinnovo alla scadenza), provvedere all\u2019immediata restituzione al Titolare stesso dei Dati e dei documenti trattati. Nel caso in cui fosse necessaria la conservazione dei Dati per ottemperare a un obbligo di legge, i Dati saranno custoditi dal Responsabile esclusivamente per le finalit\u00e0 imposte dalla legge e solo per il periodo strettamente necessario a tale scopo.\u003C/li\u003E\n\t\u003C/ol\u003E\u003C/li\u003E\n\t\u003Cli\u003Eil trattamento dei Dati deve intendersi effettuato ai sensi dell\u0027art.29 GDPR, sotto l\u2019autorit\u00e0 del Titolare, il quale, in ogni momento e con congruo preavviso - preavviso non dovuto in caso di Data Breach o altra emergenza o necessit\u00e0 di riscontro ad un\u2019Autorit\u00e0 -\u00a0 potr\u00e0 operare controlli presso il Fornitore, e presso eventuali subaffidatari, e impartire eventuali ulteriori specifiche istruzioni per il suo svolgimento; il Titolare potr\u00e0 altres\u00ec chiedere la messa a disposizione di tutte le informazioni necessarie per dimostrare il rispetto degli obblighi in capo al Responsabile. Il Responsabile, anche con riguardo ai propri subaffidatari, dovr\u00e0 fornire la pi\u00f9 ampia collaborazione per le attivit\u00e0 di revisione del Titolare, comprese le ispezioni. Il Titolare potr\u00e0 altres\u00ec chiedere la cessazione del Trattamento se imposta dalla necessit\u00e0 di adempiere a divieti od obblighi di legge, ovvero a provvedimenti del Garante e/o dell\u2019autorit\u00e0 Giudiziaria;\u003C/li\u003E\n\t\u003Cli\u003Eil Titolare si riserva comunque, in caso di inosservanza da parte del Responsabile di quanto previsto agli artt. 1, 2 e 3 del presente Atto di Nomina, la facolt\u00e0 di risolvere il presente contratto ai sensi dell\u2019art.1456 Cod. Civ., con conseguente revoca immediata dell\u2019Atto di Nomina.\u003C/li\u003E\n\u003C/ol\u003E\u003Cp\u003EIl Cliente, in relazione a quanto previsto all\u2019articolo 7 comma 1 prende atto che, ISF, al momento della stipula del presente contratto, si avvale nell\u2019erogazione dello stesso della societ\u00e0 Amazon Web Services\u003C/p\u003E',
											code: 'Consenso_0010',
											type: 'checkbox',
											mandatory: 'True',
											user_type: '',
										},
										{
											id: '83',
											name: 'Consenso_ditta1',
											description:
												'\u003Cp\u003E\u003Cstrong\u003ELorem Ipsum 11\u003C/strong\u003E\u00a0is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\u0027s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.\u003C/p\u003E',
											code: 'Consenso_0011',
											type: 'radio',
											mandatory: 'False',
											user_type: 'ditta_individuale',
										},
										{
											id: '84',
											name: 'Consenso_ditta2',
											description:
												'\u003Cp\u003E\u003Cstrong\u003ELorem Ipsum 12\u003C/strong\u003E\u00a0is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\u0027s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.\u003C/p\u003E',
											code: 'Consenso_0012',
											type: 'radio',
											mandatory: 'False',
											user_type: 'ditta_individuale',
										},
										{
											id: '85',
											name: 'Consenso_personaG1',
											description:
												'\u003Cp\u003E\u003Cstrong\u003ELorem Ipsum\u003C/strong\u003E\u00a0is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\u0027s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.\u003C/p\u003E',
											code: 'Consenso_0013',
											type: 'radio',
											mandatory: 'False',
											user_type: 'persona_giuridica',
										},
										{
											id: '86',
											name: 'Consenso_personaG2',
											description:
												'\u003Cp\u003E\u003Cstrong\u003ELorem Ipsum\u003C/strong\u003E\u00a0is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\u0027s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.\u003C/p\u003E',
											code: 'Consenso_0014',
											type: 'radio',
											mandatory: 'False',
											user_type: 'persona_giuridica',
										},
									],
								},
							],
						},
						consents: {
							data: [
								{
									id: 854,
									title: 'Consensi cliente',
									code: '01',
									consents: [
										{
											id: '82',
											name: 'Cliente',
											description:
												'\u003Cp\u003E\u003Cstrong\u003EPresa visione delle condizioni contrattuali da parte del cliente\u003C/strong\u003E\u003C/p\u003E\n\n\u003Cp\u003E\u00a0\u003C/p\u003E\n\n\u003Cp\u003E\u00a0\u003C/p\u003E\n\n\u003Cp\u003E\u003Cstrong\u003ELorem Ipsum\u003C/strong\u003E\u00a0is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\u0027s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum\u003C/p\u003E\n\n\u003Cp\u003EIt is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using \u0027Content here, content here\u0027, making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for \u0027lorem ipsum\u0027 will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).\u003C/p\u003E',
											code: 'Consenso_0011',
											type: 'radio',
											mandatory: 'False',
											user_type: '',
										},
									],
								},
							],
						},
						cookies_description: '',
						middleware_configs: {
							client_id: '20j7prm58bg05o00vifd9o6d60',
							redirect_uri: 'https://prelios.sit.digitedacademy.net',
							base_url_cognito: 'https://sitpooldigitedacademy.auth.eu-west-1.amazoncognito.com/',
							identity_pool_name: 'prelios-sit'
						}
					},
				],
				pager: {
					current_page: 0,
					total_items: '1',
					total_pages: 1,
					items_per_page: 10,
				},
				count_data_obj: '1',

			})
	}
}

export const getBankLandingPageMock = () =>
	getBaseResponse({
		data: [
			{
				label: 'La formazione, un passo avanti',
				title: 'Coltiva il talento della tua azienda.',
				subtitle: '<p>Dove e quando vuoi.</p>',
				description:
					'<p>Un ampio catalogo di contenuti formativi digitali per te<br />\ne il tuo team</p>',
				brand: [
					{
						name: 'Brand 1',
						color: '#F2284F',
						logo:
							'http://s4b2.local:8080/sites/default/files/2021-03/lemon_black.jpg',
					},
				],
				cta_apple_store_title: 0,
				cta_apple_store_url: 0,
				cta_subscribe_title: 'Iscrivi il manager',
				cta_subscribe_url: 'http://www.google.com',
				image_app:
					'https://d22cxfqtum6m93.cloudfront.net/media/2021-03/iphone.png?VersionId=R0WAxfMRJACbn_jiAUSPfxVr4DRgyCEg',
				image_background: 0,
				paragraphs: [
					{
						type: 'File Article',
						title:
							'Innovazione tecnologica al tuo servizio, per una formazione continua ',
						subtitle: '',
						body: '',
						body_2: '',
						description:
							'\u003Cp\u003EScegli tu il momento della giornata e il luogo che preferisci: puoi connetterti e fruire dei contenuti sia da portale web sia da app. \u003C/p\u003E',
						textbox_position: 'left',
						image:
							'https://d22cxfqtum6m93.cloudfront.net/media/2021-03/iphone.png?VersionId=R0WAxfMRJACbn_jiAUSPfxVr4DRgyCEg',
						image_position: 'background',
						video_id: '',
						video_position: '',
						cta_1_title: 'link interno ',
						cta_1_url: '/it/node/22',
						cta_2_title: '',
						cta_2_url: '',
						color: '#f1f1f1',
						content_ids: '',
					},
					{
						type: 'File Article',
						title: 'Il mercato cambia, noi lo anticipiamo.',
						body: '',
						body_2: '',
						description:
							'<p>Per accelerare il tuo business, scegliere corsi formativi da un ampio catalogo, accedere a contenuti online "dove, come e quando vuoi" e mettere così la tua impresa nella condizioni di poter cogliere con successo le diverse opportunità attualmente disponibili</p>\n\n<ul><li>\n\t<p>Contenuti formativi personalizzabili per tema e settore, in continuo aggiornamento</p>\n\t</li>\n\t<li>\n\t<p>Contenuti utili  per ottenere le certificazioni e adempiere agli obblighi formativi</p>\n\t</li>\n</ul>',
						image:
							'https://d22cxfqtum6m93.cloudfront.net/media/2021-03/group-6%403x.png?VersionId=sPc95RdDgjPfsukKAMLfdvTSehDtNCBS',
						image_position: 'left',
						video: '',
						cta_1_title: '',
						cta_1_url: '',
						cta_2_title: '',
						cta_2_url: '',
						color: '#ccc',
						content_ids: '',
					},
					{
						type: 'File Article',
						title: 'Una nuova idea di formazione  su misura per te.',
						body: '',
						body_2: '',
						description:
							'<p>Un’esperienza formativa comoda e immediata con contenuti personalizzati per tema</p>\n\n<ul><li>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </li>\n\t<li>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </li>\n\t<li>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </li>\n</ul>',
						image:
							'https://d22cxfqtum6m93.cloudfront.net/media/2021-03/group-19%403x.jpg?VersionId=E8dhFdXbHgX62XbhP_9AOGPbvOpf2a7g',
						image_position: 'right',
						video: '',
						cta_1_title: '',
						cta_1_url: '',
						cta_2_title: '',
						cta_2_url: '',
					},

					{
						type: 'Contents Carousel',
						title: 'Di quali percorsi hai bisogno?',
						body: '',
						body_2: '',
						description:
							'<p>Per accelerare il tuo business, scegliere corsi formativi da un ampio , accedere a contenuti online "dove, come e quando vuoi"</p>',
						image: '',
						image_position: '',
						video_id: '',
						cta_1_title: '',
						cta_1_url: '',
						cta_2_title: '',
						cta_2_url: '',
						color: '',
						content_ids: '57, 34,    22, 18   , 27',
					},

					{
						type: 'File Article',
						title: 'La tua formazione sempre con te',
						body: '',
						body_2: '',
						description:
							'<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation </p>',
						image:
							'https://d22cxfqtum6m93.cloudfront.net/media/2021-03/iphone.png?VersionId=R0WAxfMRJACbn_jiAUSPfxVr4DRgyCEg',
						image_position: 'left',
						video: '',
						cta_1_title: '',
						cta_1_url: '',
						cta_2_title: '',
						cta_2_url: '',
					},
				],
			},
		],
		pager: {
			current_page: 0,
			total_items: '1',
			total_pages: 1,
			items_per_page: 10,
		},
		count_data_obj: '1',
	});

export const getContentsCarouselMock = () =>
	getBaseResponse({
		data: [
			{
				id: 198,
				title: 'Relazione Banca Impresa',
				body:
					"<p><span><span><span><span><span><span>Rating e business idea per l'erogazione del credito</span></span></span></span></span></span></p>",
				image:
					'https://d22cxfqtum6m93.cloudfront.net/media/2021-05/Collection%2017.jpg?VersionId=Ns1N5pD2HYd9sHxM9g5bjk2eyWbPz5pO',
				courses: [
					{
						title: ' Il Rating: Cos&#039;è? ',
						video_duration: ' 240 ',
					},
					{
						title:
							' Il Rating Quantitativo: Quali Dati &quot;Legge&quot; La Banca? ',
						video_duration: ' 300 ',
					},
					{
						title:
							' Conosci Il Valore Dei Tuoi &quot;Intangibles&quot; Aziendali? ',
						video_duration: ' 240 ',
					},
					{
						title: ' Analizza Il Tuo Business Con Il Rating Qualitativo ',
						video_duration: ' 240 ',
					},
					{
						title: ' Monitora Il Tuo Rating Andamentale… ',
						video_duration: ' 240 ',
					},
					{
						title: ' Il Rating: Cos&#039;è? ',
						video_duration: ' 240 ',
					},
				],
			},
			{
				id: 163,
				title: 'I pagamenti digitali per sviluppare il business',
				body:
					'<p><span><span><span><span><span><span>Nuovi canali di vendita e customer care</span></span></span></span></span></span></p>',
				image:
					'https://d22cxfqtum6m93.cloudfront.net/media/2021-05/Collection%2010.PNG?VersionId=gax_d3s0YeZ9vmTDz6ocYNePCsbTZrNK',
				courses: [
					{
						title:
							' Evoluzione e-commerce B2C: un business che cresce a doppia cifra ',
						video_duration: ' 180 ',
					},
					{
						title: ' Omnicanalità: cos’è e come funziona ',
						video_duration: ' 180 ',
					},
					{
						title: ' I servizi di pagamento digitale che fanno per noi ',
						video_duration: ' 180 ',
					},
					{
						title: ' Evoluzione dei pagamenti digitali in italia ',
						video_duration: ' 240 ',
					},
				],
			},
			{
				id: 153,
				title: 'Micro Aziende: Pianificazione e Amministrazione',
				body:
					"<p><span><span><span><span><span><span>Valuta l'equilibrio economico-finanziario della tua azienda</span></span></span></span></span></span></p>",
				image:
					'https://d22cxfqtum6m93.cloudfront.net/media/2021-05/collection%2033.jpg?VersionId=mr_wLGtAv6IkDg7Y44yVWrLIoIM3Vuwq',
				courses: [
					{
						title:
							' L&#039;Analisi Dei Dati Aziendali: Conoscere Per Decidere ',
						video_duration: '',
					},
					{
						title:
							' Siamo In Grado Di Far Fronte Agli Impegni Finanziari? Valutiamo I Dati ',
						video_duration: '',
					},
					{
						title: ' Stiamo Guadagnando? Leggiamo I Dati Dal Conto Economico ',
						video_duration: '',
					},
					{
						title:
							' Equilibrio Economico Ed Equilibrio Finanziario, Come Li Valutiamo? ',
						video_duration: '',
					},
					{
						title: ' Flusso Di Cassa: Che Cos&#039;È E Perchè È Importante? ',
						video_duration: '',
					},
				],
			},
			{
				id: 147,
				title: 'Realtà virtuale e aumentata',
				body:
					'<p><span><span><span><span><span><span>Cosa cambia con la realtà virtuale e aumentata</span></span></span></span></span></span></p>',
				image:
					'https://d22cxfqtum6m93.cloudfront.net/media/2021-05/Collection%2039.jpeg?VersionId=DVdkd6QCz9gx4_dNsSOOxzL3bB2bIiKG',
				courses: [
					{
						title:
							' Realtà virtuale e aumentata, caratteristiche e differenze ',
						video_duration: ' 100 ',
					},
					{
						title: ' Impatto di realtà virtuale e aumentata sul lavoro ',
						video_duration: ' 180 ',
					},
					{
						title:
							' Realtà virtuale e aumentata per ideazione e progettazione ',
						video_duration: ' 180 ',
					},
					{
						title:
							' Realtà virtuale e aumentata per produzione, servizi e training ',
						video_duration: ' 180 ',
					},
					{
						title: ' Realtà virtuale e aumentata per sales e marketing ',
						video_duration: ' 180 ',
					},
				],
			},
			{
				id: 20,
				title: 'Circular Economy? Come svilupparla in azienda',
				body:
					'<p><span><span><span><span><span><span>Scopri le migliori practice sul mercato</span></span></span></span></span></span></p>',
				image:
					'https://d22cxfqtum6m93.cloudfront.net/media/2021-05/Collection%202.jpeg?VersionId=gtkHBMchyloa3WRHN5.OYw4_GkAKD7SM',
				courses: [
					{
						title:
							' Best Practice &quot;circolari&quot;: agricoltura e alimentazione ',
						video_duration: ' 300 ',
					},
					{
						title:
							' Best Practice &quot;circolari&quot;: chimica e materiali di base ',
						video_duration: ' 240 ',
					},
					{
						title: ' Best Practice &quot;circolari&quot;: tessile e moda ',
						video_duration: ' 240 ',
					},
					{
						title: ' Best Practice &quot;circolari&quot;: edilizia ',
						video_duration: ' 240 ',
					},
					{
						title: ' Best Practice &quot;circolari&quot;: automotive ',
						video_duration: ' 240 ',
					},
				],
			},
			{
				id: 19,
				title: 'Il Lean Management ',
				body:
					'<p><span><span><span><span><span><span>Come il lean management può cambiare il tuo business</span></span></span></span></span></span></p>',
				image:
					'https://d22cxfqtum6m93.cloudfront.net/media/2021-05/Collection%201.jpg?VersionId=zSL9.WDdTVd.akWyqQPSv_txYwfz8yxi',
				courses: [
					{
						title:
							' Visual Management e 5S: I Primi Passi Nel Lean Management ',
						video_duration: ' 300 ',
					},
					{
						title:
							' Mappatura Del Flusso Di Valore, Rappresentazione Grafica Del Lean ',
						video_duration: ' 240 ',
					},
					{
						title: ' Lean Management e Persone ',
						video_duration: ' 240 ',
					},
					{
						title: ' Lean Management e Digitale 4.0: Quali Le Connessioni ',
						video_duration: ' 240 ',
					},
					{
						title: ' Lean Management: Cosa e Perchè ',
						video_duration: ' 300 ',
					},
				],
			},
			{
				id: 157,
				title: 'BIG DATA',
				body:
					'<p><span><span><span><span><span><span>I big data nella tua strategia aziendale</span></span></span></span></span></span></p>',
				image:
					'https://d22cxfqtum6m93.cloudfront.net/media/2021-05/Collection%203.jpeg?VersionId=GEBsvmvfmRCW.LDse.xWoysUNgOqS5LQ',
				courses: [
					{
						title: ' Big Data: cosa sono ',
						video_duration: ' 180 ',
					},
					{
						title:
							' Big Data: come essere responsabili della qualità dei dati ',
						video_duration: ' 120 ',
					},
					{
						title: ' Big Data: Quali sono le opportunità per le PMI ',
						video_duration: ' 120 ',
					},
					{
						title: ' Big Data: perchè è importante automatizzare i processi ',
						video_duration: ' 240 ',
					},
					{
						title:
							' Big Data: come utilizzarli per personalizzare l&#039;offerta turistica ',
						video_duration: ' 180 ',
					},
				],
			},
		],
	});

export const getProfilePictureMock = () =>
	getBaseResponse(
		'/9j/4AAQSkZJRgABAQAAAQABAAD//gAfQ29tcHJlc3NlZCBieSBqcGVnLXJlY29tcHJlc3P/2wCEABQUFBQVFBcZGRcfIh4iHy4rJycrLkYyNjI2MkZqQk5CQk5Cal5yXVZdcl6phXZ2hanDpJukw+zT0+z///////8BFBQUFBUUFxkZFx8iHiIfLisnJysuRjI2MjYyRmpCTkJCTkJqXnJdVl1yXqmFdnaFqcOkm6TD7NPT7P/////////CABEIBDgHgAMBIgACEQEDEQH/xAAaAAEBAQEBAQEAAAAAAAAAAAAAAQIDBAUG/9oACAEBAAAAAPIAKBEQgShAAAEAAQAEAIAAAAQKAEAAAAQAIAAACAAIAgECAIPpgKAREQQAAAAIAEAFRAEAAAAgAAABAAAAQAIAACAAAgEECAEPqgAQEhAAIAAACACAtpIIggAAAEAAABAAAgBAAAAQAEAEAIEIAPqgCKIRBAAAACKgQAAKqjMkARQIACAAAgBAAAEAAAAgCAAQQBAgED6wAgIEEAAAAQAQAQKKtMoiABAAIABAEqAABAAAQAAIAIAQIBBABD64EAgQIAAAAEBBAAAXVSIRIABAEAAEAAQAAACAAgAIAQAggEEAIPsAQCCAgAAQAAgQAiwCtUygiEABAQAAQAQAAAEAABAAQCAICBAQAg+zABAEECAABAAQIACAWqkCIQAgEAAEBAAAAABAgAABAIAhAIQACD7UAQCAQQCBAAAQIBCwBaEEEQBAIIAAIsAAAAAEEAACACAIIIEAQAT7iCCAgBCEAQACAgBAIBdCCQEAQgQCCpUABAAAACAAEAAgCAggEEABD7hBAgQCCECEAAgCAAggqqCQEAghAgAAEAAEAAAEAACABAQICBAAgPuIgEIBARCBBAAgCAAgAFKSQABCBCAUQCAAAAAIAgAAQAIEEBABAQPuEQCCAQRCCACAgQAAQAACYhulgCEQgKAIABAAACAAAEAEAgIBAEAhD7gggQQEEEQIAgIEAACABBE5Q11oACSBAUBAAEAAAAIAAQqAEEAgCAgIQ+4IEEECBBICAEAgEAAgAFnHlyyu+nbRQJRIiAUAIAAIKgAACAACAEBABBAgEI+4EEEEEBBIBAEAQEAAQA3Jx4Y5ZL13vV1uggIiCgACAAAIAAAQAAQBABAIIIBA+2SiIhUiCAhACAgBAQACAa3jn5uXPBKvS6326UCEIgqgIAQAAQAAAEAAEACARFgggCD7YBCQIiAQQAIAgIBAAyFtY4eTGLXOXox1667buqEQiC0pAgEAAEAAABAAAEACIICCAIPuIBERBAEIEAEAgAQQBM806dGZx8fDndacDR13da69upUIQiqVAIAQAAIAACAAAAEBCIBAQCPuxAkIiAARAQBAIAEAgZxyZ9CZx5fPxz1453LUt1vetejvvSAhApUAQBAAAgACAAAAACEEICAQI+4gkIRABYQQEBAEAECAY4SZ65xny8cpjMutmZ26TG99fR23QEIFAAIEAACABAIUAAABAQhAIBA+0CIQgABCECAgEAEEWCZ485JnhPNLvnxHXdzz9W+OJrfTp27ddUBEKAAQEAACAQIABQAACAIQgCAg+3ARUJAIAgRAgQAgEEAxzefjrhOWuJ0x52um2ee+rfCTtcdeno79NKCAAIAQAAECBAACggKAICAggCBD7aACCBAgEQEgCAgEBBcebn5+XKnbjjDXPVnPfZxvW4nXTGN6319PbVoEBAAQAACCIAAUAgFACAQEIpAhD7aACBAggEQEgICACAJM8vNxx5zp6/LxmdrM8++84zvD0XhjXTM1rp379OmqCBAAgAACIQAFBSAQoAQAIICAIPsgAhAEEBECICCAAQC458uHHeeLfp8vn1jpuTfLbGpzne448r2vK63279evTYCAEAIAASBAUUBUAgqFEAIECAgCPsFAEQAREEEEAggACAvPlw54x09ca4eTj6PVjhdYnPWcTrrGODpq+ddb79+3XpoBAAIAAQRACigAAIACAEEAQBA+uqkCEAEiQQIAgAhYCA6Y8PHHDXo9/SXzeHj9a+PUmOOMbu2OWN9944cE3vff0d+mwAQAIAAEQCigARQgIAQCBAEAQPsCkECAhERAQEAAhUAI6Z5c+Mno9mGfL4tfT5cMaxy57xxut3HTe+XDnzzN736e3XtuhAIAEFAIEApQIAEAEAQAhAAIQPsgQgIEREICAQABAADTlzx169rnHm8/D09ubhHPnTpc3Wjm5453jnr6PT167KAgBAFAEIAUAIAIAEAIAggAhBPtAIgQQhEICAEKEAgANzly16vTjPn4+bi9O3LnmcZo3tWmJu45cfO16PT6OuqAEAAAoCAACAIAQAIAQCAIEII+3AiECCEEIBAAAgBADfXn5u3puHn5eXz+r0YY4zfk51vPXbZJJOXLOHT0ejt11SACCkChQEAgAQEAEACAEEAgIERPtwIIEEQEIAQAAQAQDfWY6dszjwng5+zS+bHPXnjnrtnru1c8sRUxOnfv26UAIkUoCgAgBABABBAAEBAhCAISI+4iCBAhAQAhAqABABBddczunLhOflx7N8HinXfDjnOHfp2kLpm6W8c67duuqgBMwKFpQAIBAAgARAAEBCAhAhIhPukQgQIQCAIIUQAgAAvSb3xxvnx35uXffkx576eeOHOZd+5zurqzK66TDp177ogkkkgAultUgAgACAEEAACCECIIiIE+6SEBAhAIAgAIAAEA10nSebz+/wA29+bl05+Dz9u058+OLm79G6xLJWtTpqxvv0tImZnMIigDS70g0AAAgCBAAAQQgkQhCBPupEAEIIAgEAACAAQXqdOHj8/p+jynj68vN4fp4+RrWenXHmdOmu2NTHJHXeptZeu7VSSSEAQBbbVW6tKAQqAQAAQAhCEiEIQD7aIAEIEAIAAIAACBd7OGPL6Pf5d+Xp5fHy+v8Xx+rt67nx+WXtPVOdYjGuupazrr1qAQhAgAVbVrVq2gAAIAqAEBEIiIghAPtoQAIIEAIAAIAAEF6auceTr3584z5PL05+Dt7t41z8fJK6+zljWWczp0qYb69tiAkCCIoAqqtt1baAAAAAQIERCJCCBA+2hAAQQEAACAAACBel3zcPNz7sY9XHyeXxPR69ufm86xHT1eZus4utGWu3btUIIggiABSlVqrbatAAAAEECEQiQggEPtoAQCAgAgAABCggQ73WOXPn57jnn088eDx69PsufJyzSWZ3rHTprOFwmd77d+vQREIRCEABaChWltoW0UAAQgIQiIiIAD7QICAgBAAIAAACAj05nXz45+Xnw315ebHLhp6vRw4Zmkus4mnXW85axxxenTv6d9NBJEMkhCABVRQUoLVttWigBCBBERCIgAPtABEAEAlAgAACAQF9HOenhz8nHjy25eXneXROrlNLZrGI6dOhyac+c1v0+nvdUEkkSSEQIChFkhrQrM1u0tUWqABCCEhEQgCo+2gAQIBAAACAAQEB31jPonPx8uHFnHDlnHRmaS6dubld4nTe+WJXONa9Xq9FugRJJJJCIIBhMDjDXbpnDWcuvfVUtUKAAIQiIiEKAj7YEBAQAAAIAIBBAL3mHbXPzc/Lxzzxwwl1nCx11XLL1Y4O2+XGOnKavXt6/Vq0gREkmZIgkzJGcSHMo1ZM5a7X072VaUAACCEQiCKAj7iAgEAQKAIEBACCBF3u5m0zw8nDHLnz542VJLd65LN75c+vo5cedzvGtdO3r9W9AQkRIiTMkmOXLF1mXrzmG6km+eTOrddtunTXVaCACEkIiAAomMj9CgAQAAAhAgECAQEXbry1NY4+Vy4+bjjj3i2uZVhudHm9G9+PGLo6vR6fZvVEERIgSZmOHPnlUUyupM5GM7XDVq69XqvYCCCERIiCSNEy1jGOUmpP1wCkIQABBARABAIALn1cTn0x+c7Z5+XlfZ6vLizTEyTcdGt+Xfp58/PDrjpvv6PX20pCESQIzy4Z485aETOem8TObpznTLBQ329vp2mWqzm6CJCRM4W8pLcXmZwzlqP2SiAhCCAIBAgAgEACT158Hsjfn+P5ceX3+rpx82s4xuzllNNW3v5+X0fJnhmulu+vq9Hp1QIIkjOZnl5cYZ0okYa3nmgXCb5SrUa6de+46ysce2zZz23cOXLPOXTObEbZzMzVy/ahBEBCBAAgIAIAIAl73F5Tpw5/K8Xs9/Hnz5c+eeu8vPIrWmu+fL7vNyxC98769/Z26UAIiTl58Y5zOZLHTMSzN1jG8awdLOdzmRtJpdbjpazm6ppNW3lnMlpZIjeryzZnVuf2ghAIICABAIAQAIAO/VzM8b8/5P2Ljz8s8tTHPtPNlN5um+uePacMJb01rp29/bdBSCZY83n55zM5NR0k0Zxupzz6PNXTThLnKUXSaNajK9LNAyIhSZmjpvFjGNXWf2JAgCAIAEAQAgAIBrr155ctcunn+F9TevL5ufLku+nLiuW823eca6cuUVrpvp393fdACZ4zy8uWWZGU1ZrebnMJreWcmufXiuc2LFK1bZK3pLSTGmkSBm7suN3BLcz9mgQAgQAAQAgAQAQt6awrrnl8z4nr91vLh55yXpjzXbNNWzndXnib1Hffq93bQAM8fFjlljBqSVZu82I0m9bcsNJOfWTC5zZoS7tGrF1FZxvSSMxprSsTVRZJj9oIAECAABAAgAgAit7lSPl/G115X0dePHGNzXnzbuFupOVGG9L0e339qoJiPFx8+d87nFZ1oLeWesnNtvt585TVxN7zMY6+jz8ikaqrtNNSNZaZZMpbvOtzK3KEzz/cIACAgAQogAEAQAC60M/O+TykzHSueJ37eJW7ddLvjy5tpyu+mlnu9/a0RjPk49+PHljryz0zcXokyTPo9nDl5536zlnn0vnWNJrPL0ezz+bIsNXZsTSWyxphEhXSZSI1lZj9ugAIAgASiAAIAgAF2rDfk8nmznp5uDHK+nHGaadu3aZ4+bndb3wl1vW8+v6Xagx5PNz5Ok4Ztx0057YsgnT0Y57xnXLF7cPVfLjuxmc1dGMqF1vS1mTW9Z50szAGm5mZdEc9bxn9qgAEAQAAAQAIAIBdZu517+Lx+fh1vLyJ5cawVrfo7d88ceLk1rvxGre3T6ffQMfO8zGdTjG9azMbvP1ceG5pe3LEanE9e/P058u1xJzmiAl3daNIS9HJZiRFFbXKR1zTTlP2iAAQAEAAAQAgAQDWNbt9Pm8vHkvk8lvLlylXXT099615seDkt7YGrN9/perQOXycZy59ueddNyYz0ubzz0vXHPrwwRNdu3PjOc6LjeuN3xnS84N26NMxLtm4km9cbWV1UaRc7jMT9sgAAgAgAQFEAQAIC5u9Tty8zz4xy8vLWOOJV16PT13NY83i4K2mprWXb6ns2I8HzLq8+/Tlvn2c+TN785jOt4zmrmb7bxiY54a7Tpwz05Sx1Ywt2KEkuqziVdY6VjOtMluYi2Sz9sBAAQAQAAQUgBAEBhet1jjeWPHx54vmxka36fTei44+HzGqst1l2+n7umeeMPmef0TGe+NPO1czrz9PLHONIx3Yem+XeTnm9N46cca5TpbrXLE1vUNMWsa3dZ55ys7756zjN2moxN3KiP2gAgACAgAAAIAgCBz5u/QxeXLy+fz8OnFkm+/qvWmc/N88atuV1m+j6Xs6cfDyxOXRjnek9Hl55zeumfb5eK6uMR3mOqc5qcmjc1nOZNWt5Zbtq5gy7aznCLv1XyOVTU3szKWRjM/bgAgAIABAAAIAgBHPzXr3xvDXDhjxYcpkxr3d5esxnHj8di73jndan0Po9pw8XmZ1vHPO83r57x09N8++2WJ068eU136cOnDpjM68cFpqTDczOutamWmbvPNl0zztaNdOvnmcZaXpqI1M5XKT9sABAAgAABAAgCAEcvFHXpbdzhnhx1hzwdPVpnprlw5+fyhel4nS/W9vPl4+czm3G+Tn19HmOvn79PP0zq85rtOF6Z7YvIZ3z4VrQmM9enOTtswm1jGbm3GNa3Um3PUmMtdNpJazilX9kAAQAQAABAAQAgDPDxePU7dXq63Xnzxk3nPPW97vLWufh58uUE3vGG9+36Xz+Gc6zc4dOc311xz6XDaZxnfe3fmunP1Y4Fx0vHz9efoms83Ob1i9PRmTNaZc5SmN9Gckdc4kzm9to3kkzjsX9iIACAEAAABAEAEAnk8Hj1x9HSez1uvLhrn0OU566dN+Xj6s+Pwa5o0zplu69PHCeucufPteWnbl03y687hzxrvrLkrXWs8JrHVzxO+ekxxSGuu9c5qS7zizMdl1nOkmTeszkmNdrdW3GRz1Y/ZgIAQAQAAAIAIACJ4/n+Xm3rXf6eGvP1zel5TlN9t+Ty+zly8XKQbyS7K3Ne/wA3Lhv0Y304a8/T1eRvOc3pklwc+mrvHPHbU5TN30knJlvWuuc5y6Y1YkNbS43cWZmwxzueu71jSYMZlr9kAgAQBAAAAgAIAEnj+Zw53c11+jefJvpn02cXB6Ovk4d+HledmRpGrqS71z32nTi6awnT52+22cS9cZxtZiYdb054q5xTXVdeLfPW9b3mXWZjaalgjVYzc1WbdTnM9vdNc158sLCP2YIABAEAAACAJQgAnn+R5sa3jXX0+vh5+evTv06zyvHj6t8fP183lxExjUpvaS66c+rtnlvrOWcdfF09nKZzu6xjPV04SdManL0dvPJnfLVl6aeXvjGuutY11ccXeIkpLN7587qZtY6b1MTn6+11zzrnnGNWSP2QCVAEAACAACAgAAcfjeXF3jXbfv448/Lt6unoZ5OHoZ818mMYrnz01nW9XC3ouu/i16EwdPneuZ6M0mZrtz5+nnLeXD0duHPTpmb5bzvlnrza1uxrPPWspmHW8md754bN6zevPOhqyFZZrDWv1wCUgAgABAABAAQFJy+V4cFz6delPPwvo9HXo54zrV8/lzzZzzc2qdNb5jTXR5ul7efpNZ8nbttymuXXvnE6Th6Y8XXF754tLvjt6Od8mthrTNsucIzrXTtjlbnm103zkz11hq4uGGkk1NM3e/1oQAIoQABAAAEAABz+d8/lnOp27b6cdeXPb6WKYxrPTHgwh5ozrVutb5lue/Ty59PXlefD0cuHb0t8cM7784zUdPN21iZ562mud1OfRbEm7iXVzMpC76Mdryl2xhbqZbLyZWWXcaWv1oEFEAQABAAAAAQqGPL83hzxqXv068WeHs9XGyzB0eLlnWbwxJrdt1vmVv18fF7p1vPz9N+e60kJpz1NdMcXS3GZA74znWW7pkqYaqYjRnVmu2sJjpMRtiUqy4mik21E/XAQFBAgABAAAABCoTl4PJyxJjp26Z5dMd+mJTjb2vk54uN+fEN6re+dF7eefVxOfPHu4+bUajV88mu+8PNN2smL6Pfrvy8Xnw1LqZtk556945820kHTpJGt5znPTnKzd4xvUsFa0Mz9eBAKCCAAEAABAAATHDxcMc8TPXu4TXfUY1rjw7bs8pi8uUutaau8AT355zXDfq48J116OXfPj5y9nXPPOVZlvXt9HPk9ePL5ea4u6jMy7+jHKZz2xlMr2tzl23ylw5tWSufS5Ki7omf2AEAAgAAAIABAAASc+HDhz5Yzrp087Wtunnu88bvXfw4Zc+Uu9Vq9MSVY9+OUZ7YnGa7d56uXm8m/TvzdJy6c+vPDW76umt8ufPjyucwu0k037OOOUnSJjOumjGderOJklzmNKxq5szre7mST9kACAIAAAAAQQAIzjOc51M+fhHKS9uNaa6+Zeedaerj4s43jnNa1ovTIzqdPXrnxxj045YvXfTXq8+/L03x4654746Lz3Ldd+3m5c+U1zkHTUkXWol1vPOaNZkzdevlzktTGOjNLZMs9N1nBr9kACAAgAAAAIBMZ53XLz8c5gsQMZdcM3Wee+euM9GuPr6fLmIxLtrUdJCam/ZrhwmtYmem89PTcdPNj0eTF5b6uic7nOb19XlzjCXXOXWmbM71h2mO9xgazzG965is5k6TM3qqcru5zJK/aAIpABAAAhQAhx8jPPlBmECyWyWs2uXOax2xxPS83r9Hy5zJnVa1G2alX0S74duUTpmO7j0uZwdM57wmMzJ6ZyMLvGarLcsuevbjcnTOczWLN6m83JMLLq2WUpnMt65xj9oBAABAACAACHj+dEmoRBUqKuKNXnymp0efN6Xj37eLHMKXWqZsUb6dOeuHo6cucxrWuM3n0+ZqzriJyaRvG8b5lk1Ml61rMqObtWc5XLUejlcpMWzrtz0MoC95jGf2YIAAEACAAASZ4eDiCJBStpunPnvnRJM9cZwOe+vHGIFprbM1JpmtejlOudvNltnn6XXp5M7ludOeKSpu5jOVjLfbSRlUnt9OOKY5TMR1XGcqrtlJLrOV1cHbHOT9qBAABAAgAAjnz8fHESCEauTU1d3L078UnPXKsprOYTFMZLqSpd65zoxpm56ejnjefRPNJtm+vWLxxrGO/Rx55smdI3EwwaZ9W+cC6zv2dmudrHVm4zyufNwqdJdJY0kKk25D9oEVAEAACAAIx5PJjOSSiFIVJdOmff7fH43Cb5swwCc4zI3rOS29OLozrXO5neZ6O+Ovllzy79dcs40y+jz4csVlcXUamJrnbZfZjnCX13rZPRgbahhjHXPDHDM1osSnTrEcOdqP2QRUhRAAAgAE5eXh55lvU3nnkSoLazFa+n7OHl4Xy56YzE5iS4txg0mV0vTljszemExq3oZ9WeHRw7enhhlU+jz8mMpJuW50YhlHT088E6fR1p507R0xh25Mq5ejOefmzZZ0mEb9W5jOtedyzrE/aBACAAACAJjz+TliS6u8zGYyClqJGmvqenl5vNq8eNwmcYSjVxjF1mKtus8t9cXphMumjPbWMelyejz3HO01hYklQ1qTnEjXpnG2+r0b6Tjlz7y9NeJ6MTnpx6+jHO+SWXUxk79vNeu+OKznnZn9sEACAAAIROfn5cOeUW5lSJEKoIsL0+r6fP5/Lz9M8+HIzzxmdJ01MY5664ZpW5x10zdsQ11RqSeicOmubnd6zi5dM3OcltqMZReu8516fV2541nLWPR5u2Nee9c8uXea0V5+d1OaZz6emOF7780ObO839mAAIAAIMY48OWeeRIiogyoqpCVF16Pqb8/P5/n+j08nK8uF3eXHOuluufPO/bjGMLG3De83UzLd2S6L05Z665ns8PbkkipMyatzGplDV6+zt2PLz7ZnLtdcZictTCerpnXH1ThytkwzOvq4uHqk489ZjKb/ZggAmKwb0TPPni45uGcIS3MIgWCUpCiB7vo58/Lweb7F8nO8eOLuY43puaxzev6GOeOGM5b1592aTBrWrnWkXHWpn078HbmkzJrczzupLFkgdfpdemTyzs5c+/XlxxhnOaxv1s4HW5xnnk9Ucp6MzmjLnlv8AaIKzznLHHVx5TK762Z55kBLlYSBFpkJRBaSB7vp44+f53P7HPxY6TyMa1OWOxZjf3enLnz4+fnlbgNYzd76a1iXMRvJ29/Hy5mFjGt3ni3GdG7nnKv1PTbm8vB6Uy7b83POIzNTnOvWNWmWMTPbpq4zcPTjlnlm5b/ZgcvnebMCQaKMqllXebnCWwk0iCwC5sy0NM+37HDj5PBr6nHw8+k5YTrjHLopn0/es5efy+WYNTKW8p16buqTFmFj1e3Hk53ONjMyTKXYznLXT2+jed4zfN0yjUxy5WTAZ69K2xi63y5Nb65nTljOt9HPyYvXo/YDPHz+DlAWJ0JJUjet2w5zIBEpBclmuupnMgkse/wCry4ePw9ffw8kmZhntz58+tJj6P22ePk8vDBLMyWc+nXWtWLIxjN6ev2zzeXLLSxzzdYw3vtjOOUu/Z60s3i8/P2xVnHXPmrm6Yu99dMc8Zu3NqzTEjGtb3w4unTtx/XsY+Z5plLBbUzFq3WtMmM5tISwEFSUW9dLpJxymb9L6XLz+TxdfoeLhvz43hnq48uurM4+t9bfPz+bhw5GLnCM66a1V0SdOOXT2dpxz55E0uZiW85d76Zxjm6+31Y49qc9OHTPPG8Y6Y5p343pzvZ0mMc43rjvpmYJM7xjpvvw1crj9d8/y555CFBUurjesrGcxpESaJFRQZq2OnTTLWeeMXX0vpcOHl8fb3eFnxZ2l1rnw3dJn7f0ry8vn83PimNZwmXTeqLuMa1vHo9meXDjFYXlqYWSrdzm36tdssernc4t56kmcdeXLLesrGlyzmXV69OHPKB258esb3jMr7fkzJKQNaYLnZmoVktSEzpCwqFijNnWduedYkV9L6fLh5fD6PV5b5/I7csvbjnxhpn7308cPJ5uWOMznXKMzpvVqNTdxWt/R3x4cMVc5Z56TNzLeuZc+z14xod+fWHPcxOHJMyaQXSZzBd9e3LlxIa3c87buZyx19iShELZM6TWZrUis26SIkbkKETUAKmoy0Hr+zjz+Txejvzz4/Prty5dPT15efnBr7P2Ofl8vDnx5a55c5Jem9VJNL0mNb+hq48mWbecYl24LlO2cd+/Xrjrzmd9dk8vL18uTlmVnV45b1pGM3PRN9tY58crk6ZN71eeJjXX0EIGaqKSNEmrlbUSBc2kliwokrQM2s2+r7M8nDx9et8nk576Tl6e++vLycsK+p93l5PHz5Yw5criZb3rWpJLa1J6vUxjlmRMudSdMTbN6Y6+nHVpp0uN4804Y3q85J05Z3ea7sZi6MTVazzyupi9M732nJzxnW/SkAFBKgFSqZu7qZzLcRG8NQKy2BFzqnp+1ny8fG9OPF589bib+z6M44+XhxX1fpOXi8nLleTzpiZvu550ZhobnTdzeeNXMnPO7Mxdy77ehidJpNdN5xx4ZxHW5xFmdGs5A7zEZ0xZI69Jg1rXo4efXMuutAii7zkIKWCp6OuouIzjOdXG8TIAaEXM1qS+n7fPjw8vD2+fycLqJ0+l77y8/l5uWfR+m4+Px8uVxngmJnv8Apfh8dSSTRbVtuEsmLzb255utNX1Z3JvHVOrr5nHjjLW5M5W8923OJmzpvrjOZJmh01dZY68+rlktN1aIQXciAtIqTq9Gpnp0xwVzlxiWBCTW0zaoYer7eOPPwc/V5vHjdXW9fT35OWGY1+l4eXyeVMc+bOWPqfa+JwMSNIt6ZlSsuudxy1NM6TPbefV5+u+NrXVl5+PK7lmcpqamrZjM1fRMZYkzNTWr6OGsJrfPOpJvVzntLqyAC2KFpIQ3mtt7xrryvDMqZolKjQmY0zl6/u548fFjp5vK210mZ9P1+LzOmTX3+Hh8/GYzjm5j7/s+X4UmYag3uc9WZnquLOXLeyGb1z09PLblnEvrycJxjWsyST0WXKZcuvq3w42RmXWb0z154nqYzzJLuF6WkkFXSNIGhBRINM66XjZUEkm6krVYxLrU5437Puc8cfH598PPd3eSfc+l8/y55bxOn1+Hj8+Jz55zMnT73bxfMkmCXWTfRhk69c5xM3TTncXpz59fRz9Kc5d757vLlwdmcI9DK5MovrccYzrecXu4m5zno3jPJMruZ3va5qSFrREC7oBJm2yN51lUZ0yUK0TnnN7Gcten7bly8ni1x5b776cMW/Z9zy+W4zzfY83m4Y5444siej9C4/FzJmC5L01Y3jbOcTXXEtWDgez1cs5NTCcJienWcYdfZnljAkmtddTHHGu/ThvtjzOfp6889OfJjUGjrjqkazJaqZtQau6hILKM6ICImrJbomZmN2TTLPt+szx8/gxjPs9nTHn4p9b6MebydOEn0vP5eWMY5c1Men7nXj8nhlmRUGum89Jz0xmTrJ6M4Ys3njnPo9uM1m5Ywc9ehuTp6S+blMTedZXi6+i6uOXe8/Hnfv15Y45tY0E3OrNlAZWKG7pIhaRUSaQCUVoxkLWJ0rOL9H26nPh4OfKen074znJ7/tRjy43yevy+fhzzOOG2c37vo5+L5+UmRFrXZZyi6k1Nctdcwxnll19VlXM1zxGvT11rGt2WTGeXPXTgZ4327utYrjjM9He+TOMZssqZreeqOtzjDVkbwC70iM3TeZTKypFGklBM5taCLgfU9Wczl4XmdNdHMz6P0cY5+fuPN5M8py5Zd8ZmPt+mcvlcUmakarXXTnnF6ambz9HP0Z4N3nzYz26N7xiaYy6+xvVs5TesE5cr154cp6u2Jrpzzvhnn6t9c+PnEZdMmbqzpDr058s3SRcitbVu84WJqCpCKaklGc243sUxz1mH3O2OEebzc9bkXRP0u2eXkvrY83DHHGePPfaTln6vuzz8fixlJWZu13ucSXbOde1rHPhemUznWs30Y5YaZvb3oXORVmeHPWam99+Wc9HNrPPj7Z1nl4XUwu8ymrnaTepzm95krIa3vPSddY5TeMKXSSFS2WZJKajSXUzMZZutffnPnz15/DnpTXWc84/Q+yzh5fP6fTjzcccM54Z7eiZ82Pb9XOOfzeOchmb1XbXPMm6mde7pj53RnGfRnV1iXpjidTv69TObOR0xejOfNmZi+npOWNuNvdwxrfVnnlzzoi1K65z17csYapEgt3vPbrjGGUlXSWLmWKucVJW1zNpbjOcxNXf38cJzvDy891dXpnjPo/dZ5+TzY+lz4cufCY5T1ejnnzcu31k58vnYyJJvR16c4Usvfv5vF078eN6NdJjWumOW89tdfRrnlznPn33vjrpynPkxmOne3ONcM9Onpx58TerrMc8UqVk7ydennmHWQiBrp0xdVzhldbzAJnNqoZq6zJrUrEmcw29P3OXnzjE8nLfXWWKy6/pbnPn82Pfx8+OXNz5T36cvPxfW3OeeHizCSa0dOmFudXWGvVwxi5yzXbEmunHXT067LwzzvJeWu3Tz+gnPPLnLrfbtzzm8c76+vPz7NtTPTGJvJMyxPQz6bx526ImaRrepXTr5WmbNIkzKhWbbJu2Qus5hJiLpfR9vly58uLzY9F1OZir9n6Gc8fLPdw8+OXDfHGPb3nHhyx9H0TGJ5fNmGWqu+2IN2YT1p5+bcydeVrbTeu3OcpnWWJrWr2ms5588rPTvpnnmZejXWfM3vrJiM5byxJartienXHF0WM50FtOi41ZlcZ1WJFKM2OlWUTEzWZGrT0fc48M8ufHhnvNTn6OGrh6P0uMcfPPXw5c+HLXHGPd1zjlynq67xJy8fPJlqnTrI1Emcuvq5ebm66mdZl2mzN9HJlneZm0mt7mmOc1e+bc4tvS8s+Tr6OnLmclpnMVTtL1vOXQrMpJqN5lzdyJLGsyXNy3alSzdljLOJplQ1Pd9bHm554cOU6rjPSb688a+/wCnlz4a6+ecfPHDGPpdOc5c3L2dcSc+HnzGLdG+oZMpd+ieThvvrOMmjc6Yurc5w1czomI63N9N5ZzuY64W7s1w4Xp01jk1yauJrJNo6rYFlslgpmxuLJUrKGWsuwVI1KzKuMyxd74zd+l788OWPP5ubq6cevp8/ZnnPV9/jy5b3wzw868OM+tHLm5eb0eyZxnHn5Rz1bW+kLcypvXXHm43pqc5tbjrpczVmGsp0qZxdo9fTn04dOfEz13ct8eO+iZzLI1nNtytjWqQy1QljWqlzJAsqaSZautSZvRWcaYy6GGsY0TVa+xvM82vM8bXpcvXMTOWd/c7+bn2cJ5szHHz9PppMcfPjP0rzmeXDnJi6ta6M6tluLd6k359c+eLqrnfS3nOu+OSS9UYlsdPTvGZeec5nTrjnvpPJ6dYwZsy1Mr052ltIBoyXdEMNZglt0RFqa0qXMzGs56y255c7eusZz6Pt8uW/PnHHi+hfPx+hz5cVL6ft8/O6cOfLlvzvPv6d1z5+XlMen0ZcuXLOeUuquukulXMmp01rv5Oc5ZWk1vW889+rPDnmW7CEu/UxjFjGZ03hq3z9UhkkIdJqjG7mF1FKuhM41mrDOjbmTZvLd1OZGU2u5Sc8Z3rTnnp9b2Y8uvJ6vL4+fTsa6znxXVl+r6eHg9Os+fHThicvq1z5eflF+hnHLnzw45uq1ek1bWMZvfl06Tpw83r54573jM1tvXOdvTPJzi3XTOcLdN3mMpmddqkwJNZzUBu3UzNEyrVF1NZmWpCyqAxJes2xvUYw0mdnSRUc5N0dOn12eGPH9bweLjtvbTXBpI9X2OfDh0zxx15cO/l+mxnnw5prt6XLzyc+GLsu+mellznGO3Rpy63yevn53q6ebGNVrpia9PKevzcp09eeHnLvPbOAiYzvp0uM6wkjUyQ1dS3WczYmdaCbZQXRIpKZTN3uzSZmmQm7zvXEuc25pe/rebnvpvp4eH2/L4OPbHTHb07nDHOC/c7+byzy4y7TPD6fTGOPGZdcYt5zN3jkNdOxjdxcTtWcZejHXnyezlwxlo1F78539E8+DPFZrW8qjLOc9Ova8eW8wiwNNWYzdTLVLqqkmmVyl3hdoGTK73Zno5pRJq9M0vJmaJe3p68vPwe7jxzzn03zsdXvZ9nl8umMJL6/R4978/PG/Xy5cev0+fHniZ3eHLprExrdcstd9MTqlRvnJN9vK73Hq8vGLQzvWW+msc1xxxvpek0zZnIz079XmwZVINbpM5yV0y1tmyo0zkRrWLdIWZlu6oyZUka7Z0zhEM7ns6V5eXH6E8eMrfT5Om/d08fqxw4ct61MV68cvZ08XDl6fZx48n0d+XkTV82ds3jvetcpntuZTdXeJM3tznTnw79uk8fNWt5hd829IxM5lu+zpjFzMy1rrrPKEzakt0hZjNdNXnraQS6ZxNZl1qwsVnNt1GhmtZGaa6M5m5mGs739PyevyeThv6fh4YLmb9Hr9/i8nbp5uXONa6Ovfx8Ppd/F5OHs+h5nk5evvz54HTx9NTl28u+nPty3jomdZb23zznetYnTfk9e9eXhIu985V3kq5mci9enbOc6xyx02LvGFZzGqumBbjN1quet5VUWYksvSyRRChbdXMR25M3Ua0wbmM26av2eDHk8mvpeXjxlzh39H0fT4vne7p8/nzvfpjnfTweX605ebyfS+j4O3zuHfPtvLGOVl7PJ383T6/lvnvDVuGM9umdSNkz07Yd+XkzgbvObt1lNVMzNp1nonKbzjG+thefPWt8s5a1qySJqZdBNgJFZjWlzZFSKtZurWZodecnWzPW87e/Dl0nLO5qfT62efzcfpPPww1y6ezrpx5d8Tl24XNzr0ef0eb6HPl5fP7/AHeHSeXe/Ry5FuZrl6enTOc3XnTPTjHfHP0Oa55s9evLnc8rrM667eLF1bE0hmdO/HNnTWDXPO9a1mXnncyk1dWaxIsk6bzczYZhaqZ3TKwJKlNaRL0zK3z30zPRZz65c+dmXG+jnz319HHfb1MbZno7Z4eYz3z6tfOevj5fZx3z6O+M8dYxjWODNVvdk26zpPX5t8uHK9pnnMdtc99fVrhGePXlMcsszpvtxrzlLJIs11iznv0cs42x06N4w5rkLdTOpiXWbrRnOeqJLaVMzVRcy3Iot0znppc1OmOm+fbrzXhvPTn1Xyu6y+jnxz69cc511errjjx5r7Pn8voeX2d8c88nf04nPzef2dcee45+fLLpvpyYb7483t9euO/JznX0cs8+GOmOnX3a6OfXPirm3z5dOphM6Y5Te/PwXXTpmxnHbvxw1rOuhMXnEku0SVhpnetZmcN2lAM56GZrMtFF0SW3eZdc+ue+N9tcmJ28nbrNXlya765aa10x4url7vRJ5Menox4PL6/Xjv1rPLj3zmNefz9fV5uO88uXPfXLS5zvNb116dePPh3751GMejPn59PP07+kzeErlqzpzx0jFx2yxnllelZxHTaqzrbNmM3OZnVJSLcm9TOJOtAgVaxFlkDWwk1WHZO3HpfVm56Xzt64a49vXOGWuU6dfR5ezp873ebrvv5Mt9M9Oc+Z9Dti73rzsb5459+vknHPpvh59Pb4J6eXPfaOvnx293n82etva51mOfPp15unn4tbx19PPTlpwzlvfW64850bxdHIEzGtzEu+l5rz0xCM2zRUyu7jMl6MxRRNkEjJpdUmWd3pm9ZNNz3a4t8eO8dtThn1cc9enDeNdO/HfbOvLy7cfVnHDq9lxy5dPQ0Yxy5y9uXTyd+GfP7u3k8/O43315ta756cefS67a4c/RzupxM9N4685wdHCT1Ot4sYzOtnXnOeWtL06t115Sefk16YvNzuueY1qVMYas0byWVzzDSg1YqyUEiihmXR01OmLvpr08sHLj212nOMbdpjh27jrrk48NXprPD1dtYed3zi8PXrj5HfWZjnz5a9PXny82avTuZ3OPs1LxvPlfTOczc4m9Zw0kzM69Osy3lGWsplur159Xr88ntmOTh26Yxn3b5cOWmuObq4zWNYNM7UjExpjS0WhUQBFMrYt0XV3i77dbyzi+d3675wxx7eic/HvvXr6Th18mNzj6XD1eznjzzpvhrr1k8/nx27Z5M64ztv0+Xh5ZZ278+vDt6fHPR07+ThvPTs4eXOF1Mbzd9M4x1479XTiswmIXnvt11xnTe875em87wY58da6ent0k6cPN6Lw5+i3xelzuPN29LzZ3qXkTmpolEW1mC2orMzLtVob3V6erlnDPlz7m7zs1rW/HZz9Xab49tTjebvjz+Tt9Ph04ef0dfLrt253zb3nlPLn6Pbh0OuPnScMde3LWfbnz9s9u/jxrG64Rx79ubPbmz0y5bxru46snTTnw53fT0cuuPPp09FufPjprHbz6ze+eWvdek5Z1z6a4435eddMuiYu8zK3TOMWSWhqpmW6oiJGrYtQXt0xe3bjOdnn7WehvlG+bz9+szvp058O05bx11w3x311OXPp6OONunTmzjjw3N+zPPfi9XT5t9Plx6OU01HTlv0eT0Z15t65c3bt08ub6ufLPX1ejzXy8rxa21N3HMdO/PFxvp6GefORneZ2vluZv1dnS5hh5+vj7cLvo897ZvOZ1boTiZKW0gtBItpKWA69su3blOblrD38N3GOl83bne/LvjU83fTPGdunFO956x0576yc7p05+ffn7eWfU8nfn4c9HTfC4xveFvHt5vXj2zjOfLp0nnbnTp7MeT0dM+vHnzt4cyb1nfXjXTrmc3V248prpecx0TpqcLM9b18s9HLXoctTM8y95nn6uXFrV9N8s63PHmSLFq0BAKC0ZtnTfXDd1nNrnrfTfmhVljtnfBvDrxa3jlrpqa1rx9+3XljF3cZ4uvn4enm3wx3nOc46dJiOuLnqN9c8efq6eL38e2d4xvG9PN3O/HlMN6x23ymmIazoExvBjpq3m64Tnm7ms4tb43LrdThMdvTvlvObnl28ajK1aIAABoyXbptz7ujOr5q305TMY7dOnj7Z1DEs64z6I57mOnXM5erc5tZ1eeees6zw53euNznt55vuk5a1rl0tzNdt71i15td2/O8/f154ery8vXma5Zw6Ovmx15r0zc8S9tZ4a6uknK9bzzNbxxva5yedZ11nTMxvOuu8c+nRz8/TjKFqwgUCgEBd6bs7rK4rnTGFxvtpmbzczDnrtjos6TlN9cJq3d5y75OfThvWM+fUzx337csdu95cuWs7z2426m2OmZ1Z2rXHPVveJx7uXDfc1m1jFzZyxelxLtdybxntrNvn3vnJnvXV5MTJqa1rWuXOsul1zxn/8QAGAEBAQEBAQAAAAAAAAAAAAAAAAECAwT/2gAIAQIQAAAAAAoAAFAAAAAAAogKBFQAAADIAUACgAECgALABQAAABACwCwMgBQAKAAIiqLFAABYAAAAAAADAAKAqFAAEhVBQCooEAUAAQUAAg5lAFAoAABAKFAAUAAAAAgKAgOYoAUKAAAIAoCgFAAAAAQCgIDmCgFCgAACMyN1QFAKAAAAJYAAAOYFAUKAAAThiautbqgLBSgAABAKQAADlQKAUKAADHHjd2rreqAAooACAAACUADkoUAKCgAMceeL2Lare4ABQAFQQBQAQoQrkUUAFBQATjxzemrZLLtrQBYFABUEqAqAohRBeRQBQKFADHDKzd1JLNalutWWACgACAAAABYOYUBQFCgE8eLdc+m5LLo00t1QQKAIFgLAAAADmBQUBQKBPFE43rc26p0N03VBFgCwCwAAAAA5gUFAoAoZ8nOYa3nVtJW+lN2gAAAAAAAAA5UFBQCgATycobuN6usSLd70u6AAAAAAAAADlRQFACgBPJyzWmd9Ju55rd2271QAAAAAAAAA5UUBQAFATyccrqty9dTlRqr03QAAAAAAAAA5UUAoAAUZ8nG7zb0nXnjuxLbFu96AAAAAAAAADlRQAUAAE8fPG9Lvtz4b9FmZVlt3qgAAAAAACUAOVAoABQAcvLMXpbrty59thmWtNWigAAAAABFSgOQoBQABQefzpd3fSs6RqZzq2tUFKAkkLUapKBCkWLCxeQUAFABQeXlGtXe6EXNl0TWgChMsyWhatUsAUAIjnQUAFAUCebkdHTcKCJdpnWwAJmQWKtmgtAAhCIIKBQFAFCcuEjp14umtLUmbdXE1tQhM5VBZVLaQSKlEIM20hQKAUAKJnzZi7jrqtESqmdbUQxkpIqLpNUAJIqCoktBQKAUAATz4k6dMzW60QsqS7AzmKIKmdaWNFISIWKJLC2FAUAoAA58MzrqtalsYa1DLegzMVc2Ucelm2embbnVlSZWSlCKllhQFRQKAAnDk0t6zWmeWd9NzNi7GcFmdRNRNq5b3jTQGYqFKQQWBQBQCgAnPhNGujdmODfbbKLqxjLLUrG9SxJdambqosiKk1WVsKRcgUAoAUAZ8+Yt3rVcMt9OiSrWGVk3cXG03mLVsWxEJaipz6aSAtyAoAoAKBnjM5g3rMOnTRnYwi2Ss25udzG6bktsYUUsgasyKgAUAFAFBnDOMIoutdiWmWG8LrFW5WuetTVw1pMKFkKGriZl3UAAUAUABMGMGVLre6KTOZrFdedubZaktpjVuImlDOliTU4y73SUAAUBQAOdmcTUxab1q6BJIh05qzSa1jaDUSUpM6mpDNVRUBQAKAoAMRMZ1edWb3bqwhy3i6XnazopbFhLLCrMxc6sI1SIKKABQACjOYznUzWo3q7RBOV1jVxL0mdUrHOdtENcmypmzG7ZQqZthQKACgABnOUqLZN61pIVnjvXPo5871xvUlTGenS1IYtjTNvJtaRTLTIKFAAAAInMNRqHS1BU42rHO6buJq2S6LkMpaXMtUiUsXIKACgAAgmJCrVaqhUnMz0sszuS2gomVHOtkWmVLLhvBQFAKAAIScLaq1WrLSoYTGtXOdW8t7Ui05aMznmWi66akVCqwCgFAAjQIJ5WrbdUastNSDMmdM6q892gq5zZywZaSk6dDVxMaurcAFAKAUAis+W7xu7bZm7z3a1AzIlmoUtQtZzjlrGodFYZ6abuc6xu05ilVFAUAAiufnvbh0vVOmV5+bfbpaCSSxOfS2s6VGmfPh0xrG97q8qTW2FTWjkXVAixC0AIUMeXXXl0urOkry876OtoQkXPK71Fqsat58M510hvdpiNxqS1mdc5zdUBEFVKAEyNXHlvXGupnoXx5126bUkEk5Xdposzuc+TFbat3mkauWiyzKlABFAAAgrHmvTOuycum08uNdum1SLDPHO9rpNVm45Ejeb0ppFpjHWrkzdSgAAIoAAM+W9M9ts8G+jz43030WQsXPK23VlRjMyy1veZuWaFzRWbGNXUoAAM4s1aUADPmu53tnDGtXnje99F8nfVIZlUVGMyMzfaxRLqYatMS2LYpQQARE1QACeW9L1RnlUzjpvptPD6etBIzNVLY551rMdLLcxaxnpqXGpZndEpQsIAAACwnmdd3nOmeFJnrvrZnxd/RQTBdZWlzypd2Z1jnrdJUxc9s41uhnQopIAAAAMcHXpeV1POrN3vtI8d9eio56uaKamczTeOUJL0m7ecjd5XraEtzpKplidAAAEU58XTsSPPFl1vtym/Nnv3oTNQlWmefRMcasZ6dNXONEuubo0EqbkqpljWgAAItueXK67xF48xd668J15c76egSIlmlExc4xq61ys100xjWry1vMa0CyahRGS0AECqTjzuu+c2p5xrd68G88bv00MktzaBM89aaSYa05zVmejGrqWoqWFEAFIEUpDjh06xlnXHJrW+vna1wmu/SokDO9RAZWWW5cbq1k6YbAKLJUFCAAEupDzxvti8d6Z4mtb6edveOWuvWokgi6qBLWZScdatuLNS0ENSiAUJUEogthz5LvrmZ1TgNb3wdNTi7dNIzDWZLpM9BMb1nnrSSquJbRUSaoQFQKgCQ0M4oOuJjejni71jrxz0s21QxYZtHLfSoyxtq5yq28W6CLqShFBCkAMLac8XpjrUzx1OtMzn2vHvOO66Z2EJM6S3HP0WpELWec1qy41QBrM0gUAIEsQmqmOc7cuu2ecN3Os3HS8t9MY3qmc3VljNVM3pYCKjMtuTQRQAFCUQQjMprO8plizGem4y1bmdJtvTMrM53tJbJwXd01ktTRhpy6GV0QokuoBQEBJGMzc1M6mWZvUx0md9eUmqNzerLBm5WSy3eMS26mVq1m1mVmrQipNKIFCFSSSctNRcJc4Xpc7xNpWmG94vdIhJuLWK0vPN3ZLUmGbrUuNVUohK0BABUGczGd7nPS4vTlJNnXnN51m6rXLWM+nbDGszdxvUssW8qt1ZzbzJWemueMTqs1ZrluNjQQAIExMLrWJZpi51NxCg1q4mmpqyGM71bjWK563bJNMzSRpZdOTK1tLmpo0EAAhMTK25UI1YlmVzbNabuNFxrUuXOrIt57Y3pJaCahKaktGbpxq3YikACZmZVNS4LdXEluSNS2t24xcddSWCAy1NSC1qWSCLbmN0mdVmb/8QAGAEBAQEBAQAAAAAAAAAAAAAAAAECAwT/2gAIAQMQAAAAoAgAAQAAAAAAAAgAAAACgDQAgAAQAAARQgAAAAAAAAAA2AEAAEAAKQRSAAAAAARQAAADoQAgAAQACiEAAAAAQKEKQUAADoBACABAACiEFQAAAAIAFQBZQAOghYCAAQAAoEAgAAAgAAKgFlAA6BFQIABAACtXTnkAgAACAAAWKgUADoAgCABAAF77smeeZAEAAAgAAChAoAOgAgIAAQCt9erMmZjOQCKQAAIUEAFAAA6AEWCAACA6demnJGZGcwCFQAAAAAAAADrAEWCAABC3v01MZkayZzmSiAAAAAAAAAA6wAEAQAlDfbYznNtlzhmSIAAAAAAAAAA6wAAgQASj17Sb5y3G85OaZSIAAAAAAAAADrAEUQEAELfXW6xLEhzMZMyAAAAAAAAABeggAIEAAa9W7ZM2SS0meeTOYAAKEAAAAAAXoIACAgAF9e7JGsZZ3akzzkmYEUAAEAAFRSAFOhAAIBAAX17IXGWLrZnOUzjIAAAAIAoAgCjoQACAIAGvT1RDFcpesJEzzzAAAAAgKACBQOsIAAIBFIa9W2RhjeuU6WSLM4xAAAAAAAAJQDoEAAgAAa9WkhjlvtnhLsQznOQAAAAAAAJQDoCAAQAAdfQ1MyZ5dOvHCmrJJMwEAAAAAAAADrAQAAAIsejqMzGI3ksXWYjOQEAFpZFkAAAAA6iAQAAELHq2SZziBbNZ3nJcZABFq2smpEhAAAAK6AgCAAQVL6dVhnlUA0s526zzAAtURYEiyFgAUWg0AgEACCh160zz6MYSJbuTDdzzAFoUSkqSAUAUWNsw0AgEAAQpr0UmdTGcpC6jLW+eADVsS2yS6YusSAKoAKpE0AgEAAQLe+rM43cZkkKljdxgC61JSUi6zkJZAWgA0zVk0BACAAAOvWzCM5szXRjNN3ngLdLLLJb1xmxeepJvOSlLYSF0ypNAQAQAAC99saTlcReu8cstLc4hq3WbqLcVeZemMbkhAtikIUaRNACAEAAC9OtzU5sR07Mccq0mIutXcxqXXKazo1M5u5iWsqqNXBpkELNgAQAgABrvajOcR30xz5rZZlqaudaxOjWDGySRbhVirI1IvTGSiWNAAQCAABe7VUzGjnjFa52S6LnVSxqXOtYHO2ZtmkEAakLYStQABAIWABrpNa0pCMciyQu7jVk1mFSa3iWZ3cZXUKkoFZN61iZNCAAgEVABejV3FRZMYREW7s1m8umZY1JNWSLrMmrbi5CwTVxe1kxk0EAAIAgBei3dy1BnEmBUu5avPSK1GZrDSsWWwkb1lmpbEsWRdBAACAQAXel1ZNwZxJgC9efRi42iywkVKVCzJdazNYDVxBTaBAABAAC9KtzqpKxnOZQb2lznprPO7mCXfVy52pHViJKa3iQELTSAgABAABd7WKktxnOQF7Zlw67zjWJqZa6azymZabS5kptglINQ2IEAACFEFL1pCSmM5AXqzGp0ymGpE1cxJarUsyLZEWUCzYQAlIAigiqdashBiJkDW41zmpq5IktSJbpEu5IakzVIGrjYIACACWKSlvawkGUlzJAbmt5zN3MbxkipF6Zjd3pAkxIRohOkAQAEBTIKL6BIyGImSULq6i5ybwyWyF1m9tC5ahcZzMt71JjF2IBACCFgBS+i51lmZmrjPTEklCq1Lm3MWQqGrvpN5MyR1lzjMzvpneM5OiBAIAQAArXomNyYXluZ6ds8+eQFpTrzkEhUa7auN51jGZHaQzm9ZGs85eiSQAW1JAAtQNd2N5kXlZO/ScuWQFWNdJiCQ3Mt9rUJjnB0uIubYnW8Lu5kChbcyAAGtDE36JjUwt5mfTXPniApbekwiSF1jW+lpliMWFkauYbzdTNkBUoQAACiN92NTk1vniu+pjHNJaC9tcoyXMab2qzOs4kuSyW73yxbvLWYgAAFCACoNehm8+c32Yw7amMc0oC7kZktla3pazjGmNS5LNQuWi6kxrIAig10lzIkAA16GLxydtyTW85xys9PHMLFohFdbVrHKVFEu5iF0CSoQKigLqaxCKAL6WJyhrsLrOefPT18OUBTbMCulzLZki2Q3rnLncS6xBYQAoAAhRFL6XPE2xe0q3GeWda9PPhkDVuFhKvSIzNWa3nEs0rU1yu85kVcrIAoABCkVDfoc+c3mXvYqY43T0TzZA0llIRqpJvqVZzRnqrM3OcQqNZlgaauIAgAWDr2Y5ZLe9Ss549LnveXADUDUiGtZXXVFXHKN1GpncwxVJq81QbbzgqCAFIO/SZ4i57dAznl2vPpuefAKVLEF21q5kbSYy6azl0zm1MBLplZBpqIhBYUCF7dJnkpnXajE5dmb0Z88BSNSAXW8RF1Ul1cW3DWZkFzUqAAAoAhrN7dJjlNarHXYxnl6JJ0s48wCrM0BQRb1TBs56mQFyAAAFALWGo9Gpnjt0xhrsSZ4+hnOuk5cgKspIBqRVzb1zGWmsMoNLMgAAsUJTVM5V06pnlus5O9JjHZiXo58oFrOqg1zF68464yuskdEwgW6mYAAqFANUzDWxK5a1rGY6dGJrj23zlwzAqmpC7nINXWUzdESdpzIKSoCwACgXSSG+s575RXazGU3d8p14Xtk5XIC3WQ104QDUia6JM1qZIoS3IAsAKqWjWZLvo59OWV6aTCzU3zz2541vOBd5kS2xDcxKgDU2ialyRYJoyKQAFUtu4ZuNLpuW6zizSSac9YYyu8tXpOLUlvZMzMmiZXJtJ0zVTKVAtkiiAAWrbrbKXWbbWZbm3HPrbmDFxklGlTSVnG9ajObpIkWGrGomQVLcoFIAFt1b0iE0q6jE1jdyS5aZxpwmtSlvPaRqJM9rMypFu2pnNz0zJKQtEiAsAFU3d6zi7iamOmiSY3c2VmJ0zq8MOjWdsN4xZZpmdZZMR1Y1oXnnprbCXMuemazEgAAqxel0ZmrLJslxVIDMzu4S5ltm9YzJvO5dTEzq2S6zVZEk6XSRzamouTIAAUXpbZJpFipKS0sMxnO8w3nNV0gqNSaxFslQuaWGbrMKZdSTAAAC7tpCJtDM1azoJZIxJvc3yzpKsqis3N0iJjcWpokmqxFWRq8//EACUQAQADAAMBAAMAAgMBAQAAAAEAAhEDEBIgBBMwYHAUQFAFkP/aAAgBAQABAgD/AHPs36zMzMzMmZ/fMzMzMzMzMzMzMzMz4zMzMmZnWd5mZmZmZmZmZmfGZ3mZmZnWZmZmZmZmdZmZmZmZn8MzJmf+NneZmfyzP/DzMzMzPrMzrMmfOZmZmZmZmZmZmZ1mdZneZ3mTMzMzM7zMzPPnzmZ1mZnxmZmZmZmZmZmZ3n98zM+8zMzMzM6zM+szMmZMzMzMzvM/62f+BmTMzrJmfWdZmZmZmZmZmZmZmZmZ9ZmZn1mZMzMzPjMzMzMzMzMzMzvO8zMzMzM6zMz/AKWdZ/0szP8AC8zMz/pZmZ1mfOZMz+WZ8Z/LP+nmZnWZ/guZmZ/g2Zmfed5n/QzP45mfGZ/LMzM+M/tn+qsz4zP5Z/tvJneZn+18zPnM6zrP5ZM/9Q/1BneTP/w23d/3Pu7F3dg/7nemzb160T/cuRu8luRt69ehqju/7gB6vdbWbb0NYJf16LH+3gjLN31Z+B/YWH0Ilh/2ru7vWEtbb3tf1N6RrULt/VbFi9b+vW/7StN3SEbel5L2tazeqo3Xk9+hbVsO+vZetqv+0WKq+qxd1vyclrWajG5f3MFtPRf0WERpYT/aDLMQlbXv+xvfkbKCtpkPhZWhx2PRYatbFh/2bu3rraF+S3q17WGcc5et0hUJZCtHltytoWLCXryV5C3+y2MtC3JPRyWu3W8QGcL+QdBWgt/TKRTpqwhVt6OSvJXlrctv+yEvFtLWVRJjWwxd5UoceL6rMSbUtPUrQuzx5H9hyVvXkLbv+xBtaWrZl49bxypeL56Ks8tWtKNZZDYFOO7ZbnJ6ZpYtW9b1uWLf7DxstrWfOW4niOPj4w5TJ5/VWlipYKkbNDjRPNKWZfolJc6GrW1URH/YL0jLW21vVOStP1VrbjvS9JThOK1bVrxtGqEG19yvHZJa1mtCpW5sHS1Ll62E/wDVz/RgXL8f6rDataU4asK2Ll5QpS7ewWIyzM8ANrLa/mvFXjare3ZCVKysrD/YVYxlo1Px/PFx+bVoXeS1p+PxraNSyy8K5YDCC1/WUKMWxYzog1awlYf7CIxjAleDCWW172unDVioxgsYRfBRPGFfOeGnh4n8X9P6mEq0lYFf/Lz/AEsRrYTjK0IjLS7LzjqFZaXclhTsgzMnr9jy6DzPIt4srKNUSH/mZn+Gbv8AgtZ5sNa0oWmsWxyTeEskyxY41nJUd62tps8+MxsLe1mfqSUa2rYT/YNQEClQY1vAuXgVFLL65JxTkWaxa2ehPglljM85jRphKtWqf7AqdMrVat7crVta1K1KtF9Wt74q2jVPTNL1apG3r1oYmHWAy0Kkq1T+z1u7u7u7v+piDtarYpyWLS0pTmrxxL2vevJzvEWt6u2ir1xoxmF9Le/bye/fsuKMISqQ/hu+vXrd3d9bu7u+vXrd3frf9MBgZaciFZynHxznnCWbnJcs8VHkNbWhM6qiQctQfXr1sJkHc8kGti27s3V3V3fW7u7u7u769evXv2XL+vXrd3f9L1GVja1/yir/APN5Oeo3nIUre173Px/x+fkry35btJ+qvDejCV6okZ6ZYt2J169Ft1SxYt69e/fv363d/lu7v1u+vW7u+t3d3/SVZYoLYrZ4vxrXJa1jb2vahW35VyUt446W65b2ZpatiWnrpriZVJqzVg1T/wAjd3d3/SBKSzSIy9OPn5p+zfRLN6cteKfkcxK1rPbPVr8lpkFeO5L0ry6sY22tizC9nfQ1R/8AE2bu7u7v+kKxKjMu2q31W/FyWbt5e1rDxVOEplm97P1TlJyBYtGZkH0wiwatUf8Ayt3169evW7v+iCUHq9ato9NvdnijyvLe3M9cN20b3szOnrHqtrXIJEjCJ69ttElYSvzn/k7u7vr169evXrd3f8/rFFJaWdsty5LtuQ5bswnHyWvFWZ2Sx2QqdPZa1GkElWkrAO8zMzMmf+Nu7u7Nm7u7u7u/5vStpaUhLVa8sZaWpUbXlunqsQhaJnRMmMeyVtmows19WsgEq0lJgTMzMzMzMzP+tu7PXr169D1uzd9D/oSgxlZWzGXLUtVNjLLFIdMJ66JsCwRlTx5IQiNm0re83olZRrD+WdZmZmfxz63W3r2Xtdt69ei1b+2/v3+x5G5aiP8AoIIrArLSx5vLdKtmzmYdJnZACWZYJS1i8rYWWiCpawdEzjlITJn8MzJmZmZn2vr379NvfojMXZmdbsbb69CXOSvKW3f8+rLIMpNrLJXlrevm1UZY9bNmzOsIWXWXgV6sErKtxjFGYTKtZxwh/wBLMzEzOmLZXSasOlGwfLKxdfnRLV5P2nKchyCHWZ/093d3d3d3d3+LZv8As9/s/Z/gxNnJKyr63n5z8m3I8l+S13k/ba3HRMCAx+FLPW0Dq0ZxpL1Y9igkITjlYf8AWxMRlrNm3zk3rSParusX0TJo769evRycV7ctH/wd3vW3otbkOa/L7b+vTb13mfOf+3ok5oysSlvy+C/Fxc9r2bXWvHw/jXLzc8ke2auxScbYr1c4XkC/Kb0IZXqrWUf7Z/D1a7yvNay6fSxVlTd1fhA3YvW7u7W/vh5DkLemxf0O629j/XIrf2X9Wt69/s/Y8ntuXb+ljNJu/wCDsCkucl618lJzcPNwXW2cX4pxZevnGL6qRbOvQsIxlWclaN5aa/FGxXonG0g/2ztfXtbWvfP57sCKvwOoxRj3vyWL15ac7zfury+/2fseS3J+yvL+45f2nIcluU5zl9+teR5LcryvI39Fvett31vo6Sauw6X/AAgKtivFcWnLbk/by8fLTz+L+O1td5XkvyN9leL9TPVmb1pF0nE8kYWZrHur0QnFKlf+hmS8tZs3WLu9LtRYwjXwwmMyL5YdB5txecTOibvxpYs2LF/Xts230W316LNoPv8AZ+xt6Vd+N35IFmMBIRhWx/g5KTFbIFpas/I4wqR4Xj5OK3HatbNmDXktL1idId1aPIs41GPzVYQnE1lf+gvq17clrNours34zoFbQW0RSvq6Rlb2tazYX+J3o9Du+t0h0fO7u7H43emaowhPbMnq3y/4QSkW0LWWyNPPJOWVcl42b2u3HapW89ZEFCHRBuyttsPyInXFWsr/AGsnJe9uW3J63023tYPRZ7Xdm6NZata2AStWlisSZnTNjB+d+Qwmw+t/lsZjUrmKtZZmYVyL/hBKu2gVG/7LNnn5ubk/H/IrznN6tMqXo2AlXlWEOsGHR1bstLHQZhCE4ZUP6ryXtye7OsZsw6ZmAzK1XdXR7JVs6vwvuVqx78tfp6O97Ot+N6ZgRd63d3YTYdMw+Mj0xf8ACKvdY0pW/J+R+Vflp+O8bc5Tk0ryVlT1s9dHeBkBlujt7O8IPDKQ/ixsclr25bXslousyLp9qpLcZxNVlS0468nHPT3sYlZrMsbWHHen8B3eiEf4sKx6zZkzojNOt6H0vpsK6v8AhJNOiWV528aYiYNeWnJyche1xpVbQh8hWjTzYt0dBYhBHO+BrD+Da3JfmOQvcZZq2swtMyxWpV7UisTgLq5ycdaBWnIF98I8Sbve+i1mcNv3XvY+X5BA7YPWB1u959DCEWau9Zm6Rif4UTRl5Tj/AONzcV+G3G8ZxV4eTheE4rcdq0m+36qVp5vWk5S3Y1lhM6JpE4JWH3Z5OS3Iy0LelYRZ5KkXRbaDFGPVbDaxb9luTbWeQtx25Kkpy3rahPIZyAKdC2i/GzMDMzI9MwgZZXvV9bu78Bh09PVa2BVK1tWJ/hRBEljilpzVaWocYeeSLWXpaoNt+StaVrUuM5S8e6uvWQjKo8Uon3cuJqytrO9VCs16rMlDk6wcytZZZrKy0YlUb8dq7ezOF9UnIg16zrM+DsOyLvWiTWZNXd63vdhN3e8IpVnmssv+HVhGcTZvOVvWxQ3ki0bPmw/B1WtKFcpLHJW0v8DWzD5JVo8UPvktyc3pQvKxo8TUKUyp4tXCYUWxUAoV5JWLaMIzYDx0rUtfjW97VOOMxlI1sUja0EmJ2QmH3u6IqRd3oEYTOt+NhMwjbfW629Rf8LtKsYS1rRLCS6vIEZ6s/BCccCvVYS5Y5D4HoYfFLcLX53fyr2SZLSlWfseO0472reemzcSMXdLl/bcsWyxlY8ZxVosJ5rErBpW885K2XSIAI/AB8EUelhCZF3RgzKjXEzrEO9bd7sZkf8MZRLHW3lKsSwN26S0t09nVSlSHZGchyx6Ojph0fFZwSvSvI8ryvNy3KgqjWMy123uvJ+3YUlZayvZHteOMWlWWsXbjqvVROCXSys1ZSWlGsZbsh84xh2geCkapmBNrV4IRYw+MzGBmefIMP8PtBq1tBisa8gV5S5t1SICSsrWhKxGVly85q9kYRJp2ShwVr1y2b/ueT9sIxVqFha2slm15RT1g3jMrXz5YzYR6rNusGMU63aWXQTrKy0JV20C1SoYHkIzO2ELF7XbKRhPPHx1L2Yq7A6r1mJmZnWY/4daNhrYVGz63khL1uPG1aeczylK0qCV6ScivNGZ1tYFw6HCcFOIC1rXvEegixM2rfmHdtWrxFkm1uzzaUbPi1Ua1SeHhIzM8Qib0dkIzGFTiyyQnkPL2RYGMemEyzsOszM45ZbEYkHYAR6U7XRXf8OvLLyV5ac/7PXsYlqJegWr4/Xbi8FP114qmJlery9q25Fh8Eq2EhBn4pjy8nNbk9MYTfWyz7tKBw7WcdLdUtata+YI2PJXllJcD9VVv+1t5tN2VnL0wiTAYrbavtswKkIuqRSb6bL2RV6DydbtbWv0kYwSHwvWxWEXMzz/hfK2tyX9fspf9hyUZuMS9KHjzehS1AJhEIQnKLW94/Ok1GEOvxeS/Jy8jfd06VtVtFrVhThl+PCtzyTY2USVqBHkbFqzkvx0KFLVLM1laM5eq1wQa2npXodUla4uvYdLF63rMwA1e1Aqzdj0NetYBRMmeE0/w/mnI3jbaWLluK8GrzlbMI1CwS4QhKli0OQbvJTV+CIdsO6rzNt2U4k2zK0v1WWnv3xnPTitzNOtVWVmFvTbeiw1s3rLKlvOVbWsVKtq06b8kDp6wK0qK9CzRiwj2QMzEzrE6ANZjNSVAmBMxOiMakX/DGcrdYsO+G1HfbZSyUQC1cQRpLy8ISyPJU+d+T4GeQrKt7WqzjreVClqXo0IXpflqHTGVq0zd1mdMEtYrW0Ws9ei/JCwWOOywrep1sCVHpdYdId4zAah3sqPa9HW9WMIlIylGvnKkRmYj2Sz/AIUzml20eqxScbw2tLQ5LPHdRrGWBsEHjby8yXnvkcjHogr0AdkIxaBZqRrK1Tffqy2tOEYxisCsW02s5CkYwlgCFi9rSprYiUlovCstCWmzAIlB6StLcZVjKj851uwmRsTfom41xqPGFa1a2KktZd9anb/hnNXlj3SMrKzivc29W3Hf1WVbQbBLVs8Ms36W7Z06R7I9EIfBKrMhbjbWL5R5Zr0DKBG3qMDCWFlIxlkqni1KVvSlacH67VKWqAWhDjxfVXmaibleiMwCWsrKkfjR6OtorZ6rLdgwhUqFpiNOE9Fy1po2r5TyEe/P+F8s5h7qsokGlrS4g+6PutpaPVzgnKy0W7id2+joj2dbBOPxdrKJOWwIUuyhaxULdEbCzzhK15YQPLCy2d4rN72baWJaloXY8dQOS3GWmMCDsUtbo6XWbsylLUaxlIrCLRsFCsWlbKneYOtv2e/Xtv8AsbDr2Tf8Luc1bHWsIQnE8iWsXR47lavotaayryJOYL3hGYisYMOiEI/I6Qs8qgUbWtVvycbz2I34a2Ae2UjULhVZZ4rE5qjGVpUusCIMBcostZlIzMmjN0dhFYTehGtiXLFa+bdFfFOOwurOOLBIzY29bB3V3vWEJn+F2nPW9cejqjONYNy5WcZWu76Vm6Wq8hc0loNi016PghGP1x1a3a8fHGtpehGvBOdygALaM2UrZHWyjapal+W9SX69NlrGaoru6ooGd4EU63rfnZWe/SULRPIRuqzMI22E0lnMyITMDrM85/hrOal6okIyqJK2tKX5a1nFW1vXpR2ypKy8tHphFtHs+CE35rN5bM4K8nHR5ILY4ytzzUUsswpZpy2sLAKhZe6F5q6TIdfr/WgJMwI950rCAmPx5CxUeyVPT09VEzzCM3rd6WC9ZnyGdr/hbLHLS1fLWJtbFqzk6LeeJt1u1WWsXGlrW5A7Jcfgh8HT0dkbXvx8fGc0Fb24qBysIxnlqGZYJe3FLE3L2h0K7EweLgp+EUKXreiMDIdMzp6WVKiEsQhVg9PRCbN2Yma9CsPjV9Ezrd+T5f8ADGJyVvXy1tXMOqvKRnHbhnoloI7cJW3XJWqzLHq0eyHeHSQ+LQ46Jy3tSbY4rW5Lq7x29UGHHelr+oUKPTLXKXrnT1gFKfj8c5bjW1rXsrN1g+t63dQKFaWjGPVSxMj0B2zdpLWULdMYAfDMDeszsO92P+HXni3HatiwmEq2mZStL2jMYOrYr0NJzVFdYr0dHYkI/RKtatbnEciT9TGPVStbW4hby/E1rxV4bdrZockq3JlTzWtARapfkeS15jN60tMzojOO9b3WL0PT0ysDrV2spW1U16YCxd7BYdbq6JDpd3f8F3Xk/c8//Ifyf+T/AMl/I/ffmbTESaRhCXpul7IM9DSWlXjn5FIzdY9EOiZBG0PqtaNjzOW1H2qwqQuHGss3qQvvI9WdJlJlqwGD7OSnI8lr2WzN9MzeiH2G+vTKzyCPQNSk3d6qNm7YikzpYDNFYEzIzKmCq7v/AL6vJ+5/Irz/ALr89vyHmeT1u73vapnlONsBG1FfTUnthOI5AeC3OJGHT0dnwSyfLK245a1rsrUrbpCAhC9K+pd8kZe26wrCVmrNXVLccYrFZkDEhA7I9HWs46XlIT0uZ1tnewJZ7wmr1nTUAK70nlCob2nW/wDs8nI/lP5T+TbneQd9evWzZve72xmj1WPVhlVh2xScTyu/jvNa0Yw6fk7wl4fLCcPJy2rXwLW08ta1FYQ5PTyfu9tvSkxB61SNvT8Ulr7r2dPXnrdhEzoCmsIunT0zfg6HPjVXrYEwJnYzWy9FfJWxn/s/ku7u/wBjre3qs1R6YylLFS3STBtbOJ5Wwxh8Z0QSZLQ+MYTRtcuP7FpGqK29DGy7W1Zbi6Og1tN20PktoM1gMLLNXdYQEDzm+t1VJ56envevQz1NXWILCVIzZuxd3ZiQgT1b/wBhXkvz8l/5bvezCrX9Zx+PHi1ZasyyWFCWayyL0dWSC31WZMz4OiMU6e2ESrPOZx1telrrGZFWcXHyU4eO0tXAZr15y3zu7BTtd9evWsEK1et9evhhXg/HeO3A8X6D8d4Hi8tMejoriLBYUZUjNzo6e8IxmysvaLv/AKluS3PfneTf55keibvssLZsX4pycN6UlqxGpaWYTY954yCx+AxPk6vK9JCPbKWbL6pE46WpahGBGcULVjY5r2YO2eOeNsqdPZ2O9L8gkpVWb9ZXipxaOvVG9QrW1a8TR4Xgtwfq/Vy16QhZTsizDrPPw9C2XIV/9K1r/kX5fS7/AE3d0+EJo7PxxOTjtUL1q4n3k3WMPo6X5GWle2ViPTBFZSEtanJepTIxeMBsWV6QGv4/FyS1mIdMqs0nnCZGAkJkZQqMfmpXgeKvCrfSMZlZpGevXss2s+xsPG8aJgZAz52vH+n9bU43itSHef8AoLblt+TfnXWwlf1/r86vxvzh8PyThi2nJUnJW1K3YxenvetWBjHo61ejslZeCdnTCPVVKmjdJurxVvxvHSlqXCrHrGEpe1rvb0dZ2GxOsfjjrtntnHx14cy0tCLVUYF705dsiw6s0rk3ljMybAZu9U4q09+rO1tazPNjNX/zdtyX/Ivz2vNhXxWN/wBntt3v2fO9b0TiGWnJGC1vxgxBTHrdLQcI9PR9HwS/VXsj09nwlBtuUbRnE2ta+qvYt/Q/DDreyZ0k17CotodFePgOMYtreGuAoEZecRqa2Jd9cUtNZYuVjMK+dXvj47XtetqqWnpvrZs2JaH/AJOtr8z+S/k35WbuzSyn1v8ADP5EoUiWeSM91liwdWgxiRgjDrWPRK185mfBL9HwRm71V3onp6CrezbibWjZQrVq/B2zWbvZN9bH5JWNola1/Hpwlb2H0oN9qWlrVf2Xve/FZ5HktdvSJKPtlTeSEwFbax64qWtZWsrLWs9avbA/8Ldb25rflW/KfyHmbTZr97uzd+czrf4nXBXjlrXbTktZ4Jcv3ZYW9Sw9VTr0Sz1U4KeLUapmdExlYvVVV6IRm6PZ1ZyomZ4rxPJq52W2PT8bF2DZ+R2lacRxwW3JbTqz1xS9rRSNmVbcntV47kYyvXq92Zkemazi41y8JWrLSxHvGbp/bdi/tOT28xzftL7u+nked/J/5T+U/lH5NvyXlb9bF+N73dmZn8Nm/GZ87+LKS5eXnJN4S7d2XlllbLthlYTenqpTi4aVpalqWp5Ywg7YI9aS0Xog7nkrnfplIuxnFTkhx2I9Y9bVzyxh0wU7ap88dK8Na5CrL3oTLwhAlrbaw7GEeqNbtrX31oFZbu3ZUdloFVdTwmRs9n8VeV5n8m35P7z8n/l3/Kb/ALP2+/XuvKfkf8n/AJDzN/W7u7N2bCPezPnM6X+p8b3k/Eay0ZyW5GlalmyI2lwiVWssHyrOCtOKlCtqWEuo9kuHzZhCpU6xr8sOl9Tj4615VYikxr5a1CKxMj0RhAlvmpxUK9M3ktKRSyk45yWta1ZY1d6Yu1d6CC29MzVm0gArCbpKHIy0XeiH2t+Xk/JeT9nrd3d3Zve7u7vznkp48eVXrPh+N+D7wp58zWw9ZAevwuricryP4wzklu9vKy0rHq3Vfln4daGebFjkVt82+CKpAAD5e9UfShxcJWze2iuHzvrYzdgePPmavQUpxfjk9e/VnbVwi7icbe1Zeyr0u+tZleslRi+tIyzpLVp0pb1Zm7SzCvJLdbWv62vxa7+Ry/k25F/jgTd3etUmFCvnGa39+l+93+9QTpGn6/1eMx63Z+EMW7yy5+P1zNpUs69WhCJbqvyz8ACwy8u3rlpnb09EsyoIlu97xmzzWnFw435LvT0dMI9MYdPYVrj0x6JWnH+LXj9RQRR5Lk9KPrbLYjLdbiFbcYStCn6/GemywgN98lEJrN3d3ao2tZQ4ziKy1uvd+Xl5m2/xJm7uj2HgphN3fTZd+t+d/gvejBq/JLVRAe/wYy0tORvPxzORBLI9ISsS3RM6Yz8ErES8sWljCW6Jb41ahDsdF6YO2njyV4eNW8W38NYsGWgEIIqxjCv6fx+O1mxbMUYSxAZYmtgIx6CMIxAJvr2216EipXj9elYTWPRW9RJVVK0Vd2Wty/kvLbkbf00M84VBJWevWlhYuwmfL/0Mm95NOSrloWGK2WHX4MsMtOQ5D8YlwreW7tBrMq3Mm9MT8CtS0tLy8ssIFmVlvhQOj4HSz1kJmcXGCWll6zzjBX1GPe/I2dleGnHaV6tKkbeUCNP1nH+q3F+tnkrZWZUZnTM61dj1nXGWbTde9gSxgM2kY97OT8lt0/LM7J5TfRZtpN9KPyvxvyuj/Le2B3ve+62ulnk9dYE/AuywnK3n40UjORtCNdlW1WiNe9Yz/wCaktLNrXthVidEXpYEPhh2OL0zipUlpZszJizHo6Tp7EGDvni4SqZ1aUrjSpanmeyKra1vTZtr1530s0+FXfXZCjRlx+iZFtKxgVLnTBDfnd340d7OxXoV3r1p/MI95/Fen6O9jGH1+I6y7yS84JySpZuspFsb447Vtelh+v8A5jLy8u2VLLHt7YBCHwzeiCmiHHTR5G0DrImavkmtWuJ5QHunF4oeoRrlq0qM3bNrl+O3LatrWVIVSVbRdgFfhhLBTzkrLXry2tZt3nRb1swnitEt09UO9/qp0/J8n3u9PwTd72bF+A+F9fwwOzr8SYlpctOEZaXtdlemWPx2nAcLS3FfhePM85/820tORs2jAvULMfggdHw9HwKE40u2/be8Wbvr0qk3SzdR6YGeKcM1lRhbJWuQl33bkXa8mourWLq0LM8hNXWbAm+nod3VeyebVa1Ilaea1stpaLlZuzf65n/UK+P1/qaYnn9bV+MxAi6fLA/ivz+IMVOSJ6pLt1TrV3jnDbLV88lEtRqdfg2ZacpZZyoXb9EemMJxfj8lD4ZvT1g9CX9M21tGLrG3oek3fgla1pLQJpLQsNLq3eS12L0Qi49E9MUWB1vrdjCFUTsm76XplKhaoZnkSUeX5DyA7/Le3/p7KUInWeGnm0xp58frSt1X63rdOt+UqRdn4qrLS5dpCXeRYRI9VOBrLReRtMlqz8aMs8jaKR6Xp7ZwU4+L8qHw/WwjCaO6gbs3WFPJRE8h5zyAVjaoo7oWKlJt1hW9WLsEdVe9+WPwJKGrFm+tm9CUg2aq7W+1s2tYdmBNm7s3foYP/R3oqXq7PQ7azGEYz37sv2vxgdJvZHrYzfxXJeJywi3bMJo4VlL8f5F7X5b23vOKqs5Il4y3SvT8f/P4yflnb2fG7p0wfR2tJ+s4vH6o29QEOt9euOKQbSlbRa3eQ5Kclbcl6ra9lh8a9MHSeYTeljKzxWjNixj2dE81rjNgIdWR1mwm7vWwO93d+d7zOz534I2jYf2Fyzb3RiNrW+X+GZu4EQGbo9Lq/inVy7yFJZ5V6wCsWL+FwX/FtxWrWZmeaV2zyOsCxaWj8lfx6E/PqdvwfVYxhMi6SlVnq120IdLNegLN6Q6G6sYlGstKloyw9aOxhHupZ8zOslpxQrLdPeJ15SopNY9UmJYet3ojN3oJvT8j3k2bu7p8PwHeszsWy0t7btpvW/Gw+N34Vs29QIrBz8Xq0YnJKtpyLDohF6z/AOdLPPwFrcPkq0H2N1jLEJZs58cEyr+ZX4fp7E6BdwrWkXVevOPXlYpCWVo25C9IzwzPJRdLtm1+Rg4UxmrK8bWyKkXYwslCnVhrFpLHlgUpeuzaxOqRm3foj0VzM63+W787BP4bsej4UEJu6RNXveg63calcjZVhUmx6Kr+JCbeWnIba12UDirwvE8fnA/Aj1z8HHa1WuIBLt20yJc7zr8SpUOcsdv8hmWKUtKvrV3dJqk0QVgY1T374a4y15mlm0FurFCs9S1fJx0460tRo0ztmecJV97YapWlaYhStOSPS8ZjXyxvrAfkjDrfrZmTOl2b8kDvetXo+8PrdmTZgTesDpt6XrAjbSPWz8ILLdtLjNt1wUKBa1r5u/8Azm0Oubh1GZjGWbRZZudZkZ+FevOrOevb/KqPVZaE1des9NS1bttYQ6re18Vfx7/ssnSvW6xYq16OMEleOtLJVralqghLVDetsl6wqU8+bytCu3l5vHU42tnFTISwQmQjD4et6z5XoH+B0u72fD8qR+N+c85vWd6vrrJkYwnnOrQr+KD0zknJEeqc/HzW5G0bTfwLvSTm46N6tK1tOQWzCMV6CMSjSVsz8mj1sfgij3X4W0FsTygXhy2mhikO9tbZxzWwvS7GL1hx04vIFCn6w9MIto1aolVpmSzacdK1za9JWWm2tevFStSWLz0r0dbnTN+VhCiYx6OnvX+BHvGbh/HPnPk7zphF1Wb95nrVIvr8SiNm22nIWGVPNZ69KD1+NZhLMvKpVrx0vORS1cYxGBj09cCS0vOSvb8sIdkOmKxAILNl+KlP11pYtCVqiZ4tWpWsZQZtkm6zJx8daMrMJiqWLa9erCLSrbz5RSnHxxWcbOR420G83KMta9t2KK1+CIdvzS1iyrCZ8v0B8Vq18eWZNX/oHb8bGaRgAGQM6s9L6g/jjLLNnMFrSk9evkB4Vj1eXnFy7VZdxLRlpYlOvLVjPxbd8/Hkfq0IdkrGa9KPSrRtTx59cisLtszLVpxpCVVbbsY9cfFSjMmz0rK1QXoLFrT0tVSFahL39bWzfkaRfPJOMbiN5eqBEmHzkI/C5UVXqsbfyIHmBlIxWAxj0TcPjUJvZ8L1u95kybp0q+l3WHVTjjGWmznj0Rh0Soy09lv/AJ97d3l+uLlrLN0lmyxlpnFUqlhGfh2GMtOSsfq0IfFOnrYHTMD8ds8l78vsLyyXrydBusCWLQAyFePhrWMJZq3tW0tKNrVcg2tabF9eqspLWtDpv7s0mbyzjlrUt69KjMfjYQ7e0jOOthidHb/KsUlEGNvX1ta4wjCZMybN2LvedBNUZmE1Y/fEJeKo7aWIdnRb1ZYT8HlQ6vLiRlm0ZZerD1+PW1fNxGfj2rb0q8lbDH5tCHxRfjOiIdcLdsWpVJySyUwRGzpYdVIFa/qpxBG1rlm3vktVrGVLtRsuttZu9ccYQl5WWLQCUmJySraVnrSLiP8ADZqlljOOWtFhA+d+SVnnIX3H4ew7Is3rVh1pFDPgI9ZWrNIq9vedfi1tLdWj1aXZWvh4/CTYwlHiuS7aXLTiLSwxiMy0ycEtcORtEq0s92OSiPywh8UluzrQCbKrErLQbStX4rLPQq3ClClYTfV+T9rb0uvIXL1u8spFJaJll6JlKhmXSWXqoVoXnJeoysxN0bMPnemEYGatCWOgmec+M7IT1opSXJhVMzJvwu7vZHoelgZm7MDpfW9MWZmTfxWWmWlki3hB9e21rUq9BN/+dyy0Vlz8csXmMYrG1mcEYuWiJwO69Jy0fm0IfFY/R0s31W0Tkmjr2TVIRggovLxXVv7XSM1WVEpbRrZTplo95KQiheAuFa0ykuXKwr4tNsE9awm9avxnTCDLdBkIsxO8z69C27Wbq7vT879HZ2zznavxqxmHz+L1YsyxG1oJ8aWj8ficnTLFjgLNpbq6kywzggWloiFaOz1GWL1fhh8kOkDOljGEperytuRuXrMSE2E3tCzKPu0IzRXHoj1ulh9ehjVqhMJulrugU8kYXvyyspFZusXZnb0dBneARtM+DtnnMjAinS+tbFvW7N3vV3d62HxmYDNIu9asVe2EYPR3+EBaJLRl1TvW0LSg0tRKn4fMjGWn45cbJYe7iziHpLTJe9bDFlpaqPbCHwQ73re8AOOcsuZUH0qr0RgzCJo7sbbNVZWtjEYIrpYr5Tkp5BfRbVhBX3+y1rJKjC1rKW9WmEYox+Drd3rd9bu+oTd63d7yEtKkQ6Xd2bN3vRWEO9+MD11q7CI9brAZQtFIM/BoNmPV5bomktx+eOnjwGsZv4vLOQlpwSyicj1YssJQYVtbJZtPxrnTFZaWj/EhHsidZ0QJcvEHRVTsj0LKy3Q7FgdbAmx6Ot642yRUIid0Xq1q1Ym0MjbXtIMyDM+c0+90e92E2HbDpm7une/GZEQMKh09EyZGeSaxg9KzyUsT11gdE/Hrra8erjxWIFeO1mcFeSVG5Zeifh81olpwFz02v1Us3GcZCWPDLS8SlqLHplm0SPZ8EPgiwGbNJsvU42oXXo+NhNISxtJbjet3eqx7ZgdEqYkWauMWUi2VoxGUj0/BH4XoiPWdnzvWYHb1gZnW+tVhMRPnMm/JCPRM8lXrV1dGWlTrAZZXogeUbbwVy0bbZ1bc1kOKvJdWcU5BWVOiM/E5WXEOe9otosu5c4mAxi3j0nBZ6Yy0VmWh0fBCMDJmSzBmkyBywveuIfR1VJaoVlW3Hbja50TfndmUnpsq62IstCVjGZN3B34Zsfh6JuZidnW70feZ5+Xrd634DyEZu76IwAUnkIrb0vWvQb5rxszol49YBGy+Sn4XDaXrabe1OLlL9ErZhLVpa91ZsCMJ+PzM5Jy04Lp5usHmOG3JWkJtrNrNnvjsGMSwmZbs+CEYdkYq+qxGVY2rbkMsWHor+tOjsYk4rMZfrMCAcTRj2HQ+m2/LCCp29Z1q9MYfYYfD1nWd58nW761d6zPOdZ1nexOgCEzzUUVV+GYDB8t/QLq6rDo7KnFx8VWtuTkJyXLWnJOXom0sWtccatSs9NtX8bkJcvTiG7yNmVeSUGJTq0ZctHupxX9NeQVVZYh8kzA6IssZSqFIrOF5KtaFxScNLtjvYIsZVFuH6bcDTKcdZ+3ksvQjCavw9s2rAxm/wfjeg850TVWbvT0fZ/DZu7M+l6WYVK97q6RZh8VqxArL1CLNmB0SnBX8dl+X95+Sc9eR5OS5el+Q5JoQEpwV4TitVGM2EZV4uRL3LLaxLXrYjZs3/GtaKxX4pGzetmzbfQxonZKmgukYmWCpCM1VLFqsW1ArWzZ+hZpK2tBpyFmXN9RV3dHvDvd+KEqJaDsfrYwPJVqHTN0V+NgBnb8rsZunT0dvy9swqHTAmZ1vW9BWszzNV6e9h1xcJWrflvda1KW5Hk9rPxOXll2nVK14FracnI8pyI1zpR4OTl5rW4a3bvpeI82orOK4sXXvJZWkXWKJCXq16JU6YQi9BYJq6mTiLteUUpN5LbvZ8k3SELe2030tnTqsyZu4/BMytQBbv1k3sIRd1V62YV6AGbs3dO12b2fB9avwHezd9P2wlU63VYRe3vODivbipe1m1mcFOXktZd6rd57Na5wcPJe1uNte1bhC/wCws9ZnDS9vXENbMtb8e2WGtirw2tLfB1bpKHJKliEEteEtUK13W2kLdHWruhjCUeWufjlpSl7Xt3p3uwj2M3V3V7HSeQseetWETJvps/RNiHWEXd2YnQB2Qm950HSr0zSZnW79nZF+xBPupsZpAsZ0KYFTzynAcksWnAWbidZHqhn43Fd5YTkjVtdmFcEtOPiu3i/iS8vSxafh1tW7yU5ZW3FbbkUm+q9WOI5CjYZWWlJeaw617Z6Em6xmlSLkrOSuUrx03ku97Dpm/O6OxX7Ba9WRYy00PKY9MZuzHrYdhF+degw7yp0fWxV62FQ+93ZszPg7YR6Fr0tTo6IvR0q9YM2rx15uPgGnJx2r+PL0tx8lMyM2cQV4KNOatpz15JevlmUo8dqRrwNb3rafgn5FwvW0/BLV4acs5IyiWpzW4XizkrC0ZxTllGzacZXi/wCLycD+M8RUhV42bZCtYOzAJmLsrDjvbjl7WPPZCMUYdHwfDM6zrityWpZtZG1mMISjaViVLRWBG0ez+b0fKv3q7NiZgZ0pE+M+DrdITJqyvxSz1la+cCtGnh46cfJVmCq+izYC/B+byfk/jXuXl+Os/Jc5KfoeE4f+I/h8X4teCvHW37eV/UtuTGvi9LU9F2tXgrfhtxvDxFy1ctw/iF+WtrvjkrWlq04/dmhyV/QcH6a8dqfqOA4D8bC/tqF7w47NS/H+n9VOLlq0eOn49uA4TgvW1U8WOKktePP+xtW+NCn6a0aWrkP4b0spRqmeQqWmeYiQCuVErLx7e3rMmR+cjAqZnT9bveZkYQ+Hrf4PbAwN9dBUtDobkAi2ePjTkgqXbR46luksVq1xCvGXSpKcVeNrTlOQ5a/lX5eCtqMvxW4hpx5xUvStGteTjbuVp4TzaeOLh8Xu81eL9JPBxi0se1OT9nt5K83qlLleb99uWjtuSj4a1rzWtyqclbNnkeavK8lOf/kPIcvGFGluB4mluN4KcfJT9TwvC0/W8RxU4gGzS/IZnRM8tc1g9FKxcCyziiMUNagHQWJfoj8ZgQi7sZp0wPJCLF+N6zM+Wad73ozf4nT0GYL0TOqjF46etBva/msvx8fH+siWlKS1Ti/T+itLW5GtOKv7nl4ubm/Jpz8b+viEtTy24+O16XryW/Or+ScjXzmNG3M1OOjWzZeO/GctOe5bipf37vSwwlumtL5W1+atmUg8pZ4OUsFm9OWiErUb8VeF/G5OKtXh/V+nj5KfkVuXlhPHi1bS1+ONN91ng47UQ4yjxHA15IcbWtb3uzeqS3WTYziEVgFWYQMJaYnzo71syPQdMq6RjNWb3mdb8oAYxh09Z/DPkISqxhGpKwK15JTj0L1WxTiXUpAaHFbhtWtS1eX28tU4LUrXOSWhwfo/QFKUb35m1PXG2p+j8tpSvHxjct+1vavi845x0b05f2/ttS/ClOevPzVKF+S9rWNqtN2rGYzj5L8hZRZSFW6XDirT0XWxLUqbycZTbchynJXneT1yQmclaz0ytLXry25f22tW7Qil/JKnh4/NqePHgr1veVt+2eWtJeEIdCwLQI9PR1v1mZ0QCKvfnJu797A6es7Wb2TM63rMRSJmVlq0M4uK/BgFWMD3c/Ta3HycdKy/LflWt41tK14yIcrCVLyvL7468ox56WtXz+usrfl43i4Zav6q8fgLXCfjy1/d25xS973TlOPkELxlLWlgKy9cJrx1P034s4qX4r15Lcd62hB/VVVXkLcnJ7rVjdf18tvU8/ueTg57cpy+c2trWLt/RAhK3veyWbnIW9ltKlHjaFGnlqcduPx5ypqrujVvF0V7zMi/B2HWYdPxs3V+d+Trfp7zMD4Zs0YLUlZbqrYpGcFr2ettfSB51rcpdvYDirajW60pSlKvrCet/IleH8WralinJTjluTjajGnoqH7C0t1YpZs8pCVLcXut3ktzFuTi/GpexW8T0IkuIVqcY09Wc0hxnMW5At5X9s5ImeEK/trLXbt70rwvD45OPSoVlZvJCWQQrVsFvQ3s2UmllrElWpYpP1X4P+Nbit+P4I04OI4P0f8AG/47xpW6NELeh2HasIR6IkOnoMBi9r/APjP67vy94ECq1qvdWg1T1e9LWtZ9CFS6LUoWUKFrNjkq8csD4xK2s87Z47cnLxc9Lct+OUoUYkbUq0K8oo+rcicsUhW3J7s0rdharRuckvDo6qEtAs1nJxluOtS1K05J6RtSpwtN9WtW3Jy/v/bS1riwjc5HkrznJeErajaWSBbp6QFevTCpXM8tGtakKWi8KX935vX7bclU/I/5L+RTl4i05THhKlmrxHA8P6f024w8vF+v9LTMO6RMzOmJCWA/7y7vwfJaxWaysrOM5GWalpyX47NaVtZlYN3jbzjlFJbi4+r8nFyVn7btK24uQJU5KFeOX5Kc1PyfUZyNmrV5b0nEeEtTmt4rwBGtktWXOS9ePzSv63i5eNqp1SD6rbkt+POWIX47EtUF44LaimvK8pcEKJ7jKzcavG1rx+s46y0IxixV3fTaCUK/qtSFq1Spa9LEtSssNvayyJPFC3NxvMcRY5DyJyX42lOSl7lWtmuMb/u442S1KjMC3wxh8Zk342Hwu71mfGR6WHefdUlyE44y1pZGxcqVsKWKULy1TjJezestQ4qRrjOS3Ee3kvGVPNZy2vS9eEHk5iNm/H00LcULl7W5Cg1uF/3clqSstS9bAe/bfmZfiScUsylvHHW8KNKtW9+Xkscdb10LTxxcfMhxnFRqRrxW8XqBFVaxqTjb2s1bIkYRlxjPIVOQhfkffouWrUI8tuT3RtC3ulrGVtblOW/NxcpaFmXrWrVUaeS13plbev1BaxyNm1Fnpt2H62nlJuru7u9Hw94Hzu7swrn8hrEhONsRer2TjG+6vrkKpZv+y1vNahaVpa/HbzeUMy9W405G5bWnHWtkW0txV5Dk8JapenIxK0U5eat5+vxw2y9GDyX4eW5yXrOOch5pRtA9Nq2bXv7Lty3jGW5SzbltW2cfF5LvKclUrarFpx8f4n/F/Rb8e34yPI29l/Qxa9FiZs4y8xlmnC8NOIjfzY8+PHHS88qtKcnG1Z580K8xyfsOSWlZ4irdra1isqVhYve9aFum26d7sx+z5P5bu/BMm79b3tEWM4pd1XpgXOIa1EslJSXSpa0GjyHGcnDVryWatbJ+xOS/FBal6TSW6a2bW4oXa3Iz0dIUvZ6tbjt6ravNe7yFqcnJXhtyXb+rcinS6thnIDR80tfmsVpdhWnHycZytqpSv436CXvy3px2lOQ5GWvbkqcnE0/U8ZTI8XFTw8RxeK0JaMYVrK2S1INUYxTkUWULEtUXpsVOO5Szy++PkLX5y4/qK8nFWaI48f66Nqp6Kfrrx1rarUmFWWPjM+N/6W7/ADZWtOmbxz1usQqtbDtG97Qs2G9+OIUVvSzcs2Ur7si2LStiXK8cKiyoy0bBSoPLyUKtay1q2tLQA5OOtXkOSlyX42tK8sFtuwoDZmwmizjbJeqwCl62nCc0oU4WtFCUL3y1iyBfl4q3tx2Tk4qjTZSqeqW23IJVBL4Vs770t0UseiWoVtQlbnLW6ZWWsGR5PZzPOWtbzUU5q8llrjCF/Y8kFtKQK1eT3LVJdX19LAmdb1u7/c73ehgzWMqFYkqNhCVVvat9Ft6YI2NrGqjokXiuy0JWt7+/2N5pBSrU45vpGNvdbQmaF77YsDWVbPJDktepStyplatDivx6QmLWhV6915q2LawtjUOScA2ra1q0tz3tWpOW1eI4+fj4b25ffiMaNKC1bNrWvS0Ctaz17tZdF5K8ryXdrYtC1ZY8lSylXiDRtRlZ+s4ruhemT3691lqttjPP6yo1u8irSyl7M9ZmTMzMzMzvMzMzMzMzMzMzOszMyjatXIETUxZ5yVlrKwZacfHKxlpWYW06ZlpUG0rN8frKJda8cBpWjyr70taWsBCXVDbJZ6vQhLS8SqcdBhWtQSxaeCwefNq/r/V+s4v1bC3uyWKtQwtpNeJrStrViF78kKoWbUuKFVsExretRS3plqrUxmYTfODYEtaUEAF9PFgXmW4i9ea1aApbjKvE08BMIytizdhVp5YIM82q9f/EAC8QAAICAgEDBAEEAgMBAQEBAAABAhEQISASMDEDQEFRIlBgYXATIzJCcVIEYrD/2gAIAQEAAz8A5v2LwxjH2WMYxj4sYxjGPuMYxj5MYxjGPDGMYxjGMYxjGMYxjGMYxjGMYxjGMYxjGMYxjHhjGMeGMYxjwxjGMeGMYx5Yx5eGMYx4YxjGMYxjGMYxjGMYxjGMYxjGMYxjGMYxjGMYxjGMYxjGMYxjGMYxjGMYxjH/AP5zkV8i/uxJYf8AdtDZXNZX9yXzSKG+D/t+srnJj+xfJFeEfwb4IQv7dpcpMlEkMbHyY/7ZtFZSLzbFFFsd+R15Lx/AvrCQ/wC2d8KwjWHizpL5PNjYzpKeaf8AaSxWVmuFs3wseUWxR2xLwtkvkvjWb/s+0VhFMtDtcdsprNlKxCzRYou2KSKKLYyuKF/ZrQxjNbxZaRQ0MaOqEWNjKGMtiI0VhyEvDxZ0qxEZYaeP4JD+xC/sehvLE3wZbNVnWE0omxjxvFFMTGPFi8svDGdSGsPDGP8AsbWFixi+RSGhtDjLhotjKKLEbHhsQllHwuNF8V/Y+jQl5Ei3lMUkUO80O6G3ihvRWnhI6VlIchs+ylUcUWN4bZS/szWJt6ZJeRpDG/IhpYTKRrFzKSxbpCKZYkWP4RKxfLEiK8IkxLDZ8vCQka/tBMQvCG3tFDKxSxc7KRZuzYmsN4WGNlF/AnhYUVhtn2LL/siuGxiexRVLCEhFlnTEbQ0UhHSstsSxGXyJET6whDxfwIcvCJpeCXzpEUrb/slNYYyxFKuDPydl+BskkPDYyTGU+LxWUV4RP4RN+T7EtRJFj/slCENvFLFioTKfkStl8UdMW7OpH2b0+LTLKymIeUvgX1hskNP+x1hYQkdWhIpFsVGzYkk8WawnGkUMeKGSsTWKEx8pDGfxiyiv7JpC+y5D66Q5OjoiOSw7E0kKKEaopipjqxUL7FhDHY2U9kcss/kQsIREj9EfoX0IS/sZGhebOn1KPzsVljcSh2Si00OuHXR0qkO+bE0NYa2niY+K4JlD+v7F3lvwiSnbOpDUi9scfApIp7Q1I+Vht6JS8kYairZLySS2jXJ2LFCe0fwSWUIRERTymL7Kwhf2Evotnqwj1KWiEYdc05/xY3OWmovwmRZWh0NlRvDLZDo6vkhBNEusk51FNI9SKTs9WXwT+VRFIWVi9CemOLGXhLg/skvA/lZeF/YtDcWxerFwn5J+k66eqIuuuhxEfkKi2VETKOpij6YpSdMaYvmJL1PjRCB1MSL4WinsUlrD8DL5P7JIsf8AY+mJlIfVZvpmRUVJEpodl4dDbGheWapMt28QSPiJLNvhQ2NEZoaK0xZovDE8L+x1RvDQ/JN1FlKkyvLEfmREJnSdTw5DXllDxWr5scWdatSHF8bw1lP+xdGykWrHnZWNHTKyIhNFo3imWNISN4T4srDi7R1dmhYf9h0sWz8cqMcuyxJCHneGj7LRb2dMi+9ay/gTExx/sS5cLRssfgos/kSRYxjs1wpmsPuJlCZ0vFFMT2hCf6ihC5rjf9C1wQmITk+C+F31hNbRWmjWLHWNljTE0NFllFfqTGMeELgl/RGyljeVipFZXFdpCfkcC8bKE1TEs3i8bKYmqZTzT/REIQst41i+T4MedFMRYv6A3lR2Nu3h3ixjXKi33LN4uJrPnKaKeKZfOv0Fj5KsP2TRWUIv9QQhCwv2Rs1io4Tfk/I/wypnV82JoihYaw26HVvvaNFxN4saZaOlia0Vp87RTL/S0L2jxbIpHV+l0MY8PL/ZH5Fo2qGobY2hrYmL1YHqejK42Oap+SVjaGhslId2xJUsMY1wXYqQlIvGzZR0n/ZcbRuveorNv3NLttFioiIQuCEIRfsEIQhdlsaL/aOhXY5Sol0Lwh15L+RpUyM1dHQ7iOjQ5SNXIURIk/DGKhLgv/k/hDQ/ovjvG89Mi/TTNFxrl88Ne6bfuXhrvMeL7DFySwnlESIuDw+ykX+00/J6d20JjifwyNETrQlaY03E/wCzEiN0RToUX5E3iVXQ5EH/ANya8UySwm/I12bTWNnV6RrlTLWde4Yxvs64XmhsfDY64N4r2bHhj5MY8VxY8Puuyllsr9oRQ29IjWyNCEzQpJleoosSiksRbshe1sjdka6kJo6URl40SWJVvZB+NMafa2bxqsb7W/ZoSE+7rNiQspCFm2RSLZQhIVWXH9WSOpiQhIv9o7L0kST2iTR6hSE0xR9VP+RSimWhxQ6bob+Cmb0MY/svyfQ0MWaLXGs12bxov2FI2LDY+5XcTEhsriz8M2h/pyF+2GylipEcLpYqdM6mR6FFi8G6IkWmiO0RTaaIx2toS8F4r3FP2SEjZfYS52ULtKyLElrnSG3iuFjX9DLbZ0+SMSkyU2RkrckRiqUkNMticf5RFx6kyM352UzTiJCQmx0fDK/87L7++9FiSHY3w3yfabZJIkxC4WxKPerLkvA4v+htE0r3RKb8Ohr4H9Eh4lEdFMt5cihUbL5XlCvtp99JY2JoWEzeaFWaL7STtkZlWKXgcXoknsVECMNobTbEW7I1aG42iS41wsoQkhT9+vYsZS/avXpnp/8AyeknSiempaRFsghEXEoZfyJFY0Wud4rG6ZT477Ca7dLF5Y3y3inmsvnWsqIns6i2NIvTKtGzVoZ0rpYmimUxSVos6pUUKuFMv3FD9vZWLxZX7N1zSVlpsSVl7Yqo6TWLzRrnZoaRaxRq+Vx7CaKZrsa7bGsPLY8Lpw7GMbGsOudsodjaQlG1h0uHS2U7LfFv4y/ZLhfuKysJF/s3XH8sWUqRpFKjQs6Ndm80Uy1i4G+Ou1rsKMS3llIdjaJ/Q0tlodm2Ldm9DEUh1itF4cihCWFXJs2NkIrZGrG7LtsVlmii5YsTEJiT2KuNe7VfumnZaKR1PFtjijRemUyjXctZsqzfe2a5LFaN5RbIkUiXhHWlbojB1Ej00yPwJoaHdsVmzQ08oSQqGhvDG3jRbLZ0ogUxM1R5GrWdlsqRaN0Uz7KeLxft65P9z+eOhq2zYrPxkWzYmhMSKfYafCvZ/jmhYQukc2xtlLNvDbKGx2NbJCoco2WLyfkNLtNGs/kKImhxkWVhYZQuk0z8jRbNlLjRb9o+dFscikV3Gi+0v2bTeL5bPxzoaZcUx8r5axTE0NPsVybHWdDKzbEuVs/Cyzeb2i1QilRsSiW8Mviy2awi9lvF5Y+PThNdilyfdZQuwmxIVG+F80LsL9obxRazvCaymiizVc2MWK43Es3yvnorFCaxvixtjsaWfxoZaZsdWNKilsirG3i0bzTLkJxsrMV5LFRs6Y1RsVY+cKSwua4NkhrN9l4QlxXaSZQ3xr9wbOl0zZ8CY0JrNlO806Z8osXCxo0uF4oTXavlcSkdImsXytiWNVi0RlHyU6ZbaFexVVG9DFRsRTExGxkm0SjFUJ+T8ixJWxdRQi1pjbsaLwmU81iuxRrC9u8VllF/uWljeykipGx4TWVJHS6LLRaplPhUhdjRplp899jplQolvhobxTxvNiLiNNpn+wcJCatHTHZ8irLwxioQosi1hUItUhydirZBlPRJl+SOaz1I6WdURtjKRfFcK95fdvjeGv2ncj8cay3XD5LxstY1i1x0Ux9RotUNRKfNdimNx4/jYksWW+DWKghjk7HSHGVCkjXFlvFG+SFHxjYrw/DHRIZsckIcZClG0OIjYq5MeKftF3a4WVxfYr9naxbfLWLjijqWymWsbxZWKzvP5GsWminztdqzWF1C6RWOsWzp8DYrItYqFjZ/jF6i2OPqWht2+DLYhR4WPghDH5xo2MVCboV6HVDw2i0aLdlLisrN9p9hvvPKw5PhYxi7C/ZejRTN8qeNms3h2aKLiUXimbzs1hwFNWvZ0PyN6LPxy35EhrCbF0sfUWhot8dFI3mzpRrixCYqxaKFltm6ZRo28fgaQlB2UzQ+d/oKzQ5MUVot4ri8X+0dG+O81ItYadjNiN8N42NFo3jZovD577VvGyhIvYky3mmXluDNluhRjhj41mkdUhJViXnFxscS0dKG/kT3YqN0UNDGbOob8Di8KSx+BbEl7mu0x4eFxUViixXlPL/aWjfYpicSpGrRZ0yxootZotZploqQmtDL7OuzTyizpiPqERop2hOuChAti6UxzdId4WVwrCz+KF1UP0xTWxItFMY0WxjaKLFYl4OmPgstWjdDixyZvFvuVhcrGNdl5SEKTK127/bO3yplrFYtUVLFo+BsrOyiymdRaxRftrGMuRaH9ijGh2avHWarH40ilYh50XhUJmyni0dImi5mrGmSZItiiXiysUXEfUPCoSkIdsaL9oiixXiyuS40XyfaeXh/s/fatFMUo3m2VE3m8UUs6KY+O/YO8paRJ7FHTEtotC6LRao3RRcsWyi2LjJs1wY7LOkqRcTZ0tCK4oWNDseXZZft6GWNsaxeF2K7F9xYX7PtdrRTN1jZspc9ZuOXZru65LqI0KsSa/g6ZWNkUKipUhy2OLLkI6R5vFCR8YtlDYxcLVFPGub+huOkTXlDG2Pv3365WhIbHhsrnQn+3r5u7LzWE1TN2i2N4p58lFrCFR8llPFSNdzfJUWOb8HTHpQiMY2jqQjqdlDwsNIbQ0PGjZTxci5FIY0jZeXxZRL1PCIQVyPSTpIjWkL6EV4H3rQlhcF3bw0sU80v3brG83ndM/KRt86fC4lFsoZa9k5IoUY6Qxy8loUUNsqWLykKxNWdchJCqxovFnSbLRWFLYojEVxsTdsjBUsOyoirvvDYyu4+aFRZsXB9iv29osRT5aLjnZXqDUrXyUy4lM3i+NoqXt3dDpISeNm6OpiXF2OTKioo2aLQqsl8ImyUds/E3lY/KxM3xsSzaEsOiy+8hpiot8XXd3mv3GhEV8kPsiREIiRIljfP8TeKYvKNLC6TZZWbfNotez1Y6LQqKkJm+F4ooZ+VUaHdFwLXSVpnUuNlRLeLYsJcUKhyfN9yisWPKrisUuWzRfbr9pJEV8kPsiiLIkRk38kn8jH3maN50RZVlilC/lDW0JqnwrFmin7Zlo6Vhssp8WUsM1ZstlI6XY3ISjedDeaEhJ9h2JRN8n7C1bKGyhe7Y8rKEP8AYnQhkiRJkmPL+x+w1w2b4U8bH8DSNl4p52fib9vWmW6E0JJn5nzizWEi80jQ0z7OoijWVQqxfGuWhsftkoliQ8W+7a95bFQhIv8AWk17m1msJPHniuop2KSN43i0bKZoY+9rsUOTOmhtCsocno6UJorloWKHKQ1ASxeN9ykNvOvZJcm2NdzZUS37d8NFCLK/V0iP2RR1P2t4Qs0y46zReaxvs0y17mjqZSxYkIsXJ1ixxKVslLWa4tle3b4vm2JbkRZHLY0SRL6JL4H9D+nl1zsftNcL/VUiI2x/feXYvLwpHyhnw8bFQ147d++Qms9RsSVl7Q86whXtCQntjb0OLpichCoRR1IRXuNFdlkpMUebwvoT1RFeURfwQ+iH0JMsaGs0sUX7JYY/1WlhyH7isoQuk/ETKZaKZ8P9LVCLKRchRRuj8RvNYXSOj8cXm8WKMCvHCuV95Nmubbofl4RGA2NMVcKLN4Swq4JMTIy1RFfAo7LYu7KQhIQnihrCf6mkRisORebGPEUiPbvuVFGsIpiY0OImr99vuNlZsa8Da2UsWJjHpGsMri7Eo0Rr2lcaQuLkyMVhYQsaymhplM3WGPgqLYqwjWL7cpEICrXBZT/U1ESJMk+FiRFMjhjft9mlyTQii+D437au1fY2Us/kbN86GN+4SXFy0j7Es0WWUWx1iyjRstjGUbxRJjbKxstFcUuXyxRWht4vNcr/AExIjEQ7JSfJYfvLkh6xvNMtcLK4Vmu1a7Wu412Niz8j4WWyuwvaay2SYoYrNmymWi5FIdiSF1CoQkUJ50WxUdJ1MaLKYm8oobfG9s3wo1+nxXyRQkMkTY35f6Pc8N4RQy4LG+Di8WJlcLK56Lk+zpm/bWVh46mRhE6ZsuNl+8ciJG9ISWXYzWbZo2W8MobGUMeVWfxH1CoUSyx4rl1MSVI2Ki2JI2X7hZoj9kfsj9kF8kPsj9iYhYRFfJEjhDJDZJ/I/wBM8vDQx9ONpFRWN8qLL4UXxuQy4sVs/Ls/l3H2bxvhqx9JcrfavuNjXKU3o6VillIVnU7wsbwlHjrnTEJmsS+xjYhc22KMaWWxmstviu6kRRH7IoTQ/saw5Il9kl8kvsbH9kvsmvkmSJkn8kvsfcf6RtorCz1TSOmOHbymimWUx8b5dU6FR0p43n8qN8d32bELCoQ+25CSF722KMdDKLEhUJIbZS5Ui/ZVm+WsLmstYXcjFeRt6G35H7ljGPEV7pjYx9z/AGcdn+zFRZrsWuGuVzNGmKsbNls33niu2st7YktFG8Lv325TdIUXbFZSG2UsNirZESQhUWUUWLs3zfNcKxWI8XYnhVwvFcVHyQFWhy7qF2GMYhCEhYYx+6Wbwxldi52aHw2bLrlTzop9nZ44OxuzZvt3l91jkU7YqF7xyeiT8kYLmkNodixrNLGuLeGylm8IQiudjZXc2OhjY3ijXCJGKHJj7i7N4QlwfB/oKw0fYhj47ly3j8mi2UuOs3jfP8eVnyeeO+N91NYY0NlK3jWF7lt0iSOlFY2PCNZVYQs6xbxWW2JI3iysUjZorsNsa2xLF82VnYqLEhLOhWdKsd0iTd2SfeYx5QuC/SkxWfR9l4XLcuejqkJCo3n5xY1nfP8A1XxfnOni879haKeELKrFdlG/YSkRiNspDbxspYbQ0hjJMkSRvbxFZilhvD9mltoQud40WU8yylwoci33kJdm/wBMpDsVCzfJKTXCs6Zb4/iap4poUoplIT7F+k+DsZ5LTeNcN8L7u+DkxJYa7r7dlsXyJISG3xsdjLexCWWI1wfBlFldl8nfdWHweKeGX+ybfZ/2rhobeKRrhvOx1Z+FCemfQ09866lw0xnlj2bNe1RTw2xRjyXCyuKLXOli2NigPGxVlspYsoTFimJm83m8q+DfcrGyhCb7FMseLKOoZX7HrvvH+1Y0bxs22dTKNm+Sf4s2xp+MJ6o6WNZvC/yNcN5TPotY37ZLCEWu7vsWhsrbEkWylhLgmVlGx5aOplcNj+Bjxru1yQuzRfCkVhMWaL/R2MeKwxsZXJj7V+xv1VnbNYp9KPx4b47FJJiwiLRBaIvh0+vE1lWW9m0lh2kKtdhzVnRNrvtDRfafdsikKzqZWHihsY+F+0fK2Kua564VhZVZ1xr9FbYqtkbELCY7whob5JLYvavl/tRrh0o/KzVmn2VoeUXhYYl60DQjzii2Oj5LTXPrnGJGET/dL2d8HxY8seHxSiWMSzsvDxs/HFor9ItFZQsUqNirF+3ftaVjboikReKYhCw2VxXdeEi8Pt/7Vxt4qJrleKGpIi1TeHZYlwRXqRf8n4Lg+o8FKs75W3JlFeq+8muy5PCsQhRWNYQs1n5eNmjeawhIsV4RXesrs3hUV3VYlHCrDHhVh/pzay0PFlLFsRTFRfsF7C/Vjw12kuC9VS6iUI/i7R1bQ08IvDfgkpIX+OJSHsrDZcsa5OUkjogi2fnF96sazWbFFZrN9qlnRseLKGxlPFjGNs1222Vlc7KNY3m+LHw1wVCE2V+rUN4aGWh37Fewr1Yjo+TQqPJTN9v8Hh31wexS1NbK3EYqGvDGtY/CN/QqaxcjZRtmy0a4/wC6C/nNwUu/rNFjGyu8+MrNaGOi+FiTzQmJMvCItH43hoQrG2KtiWF2EUKS2UPhchXoeLLOni86wky+0/05Zfvb436qxemViypFvN4bEkSGPH4SypK4+Rp9MiLeih42j8Im8IrHjsdXrxxR1QaKfsbwkbw+LFWGPCEJixop7H8D+SEleEmXmi+N4Y2UjVYYxkrHiyh8Wx8EJ4YyWEkJsrKxs0IQrOlYt4d9heyf6gvZP/LY7eNY+T8mzebWEULwuHnhe4+R3vydSvOz8ELbZtnjGhqux0esj7FJWsdM337NcKfOkkPyintEaIl485SQ2XlxeNcLKQ+KzobEsUdQorMaHY8bxaKE80hjJSNCQstsrCZvHVLFIdjLXBca/Y77DzXHzjRrGilRWXBUdSKGxIvNerXHzJYTwnJLGjRY0XbN9ipx/wDROhVWLV9/fCysXxqKwpK0UOXKuNPGhjxRfNvgjYhLlYkIosTiLj1PhZQhcExfIk8NlPN5ovjRfZSX7FrnXpuXG2xuQpQxbw4liLKz0+rEtLhoSYsK22vGNFlGjWKxs1x6ooSxaaOlv2d8+rRTOmJchIrGhsWVi2U8vNjXJtlFF8Xm1wsrFOxCyxyKRSy+O8W6HFeBYa9tb5P2bK4r3zvvXivRWFWGbK2ir7dSR1+jGXL4YqNPjo0UuLKzcEaNY+fdbQpJSWEhIbQ7woivg2UisWJIXYbFFYQkXlCLEnnRbK5LCaEJYWKyiymUNyNZvD9nY0PjffsZrCxvjXYfs69irQl6cVnedLsIsaGkWX6fTjRrOzqVMqONFZtcLZWNZ8rgqHGXur0UJQdtCdUy0hlGhEekXC+TYzWLPllYovNIRbGsbFmuVFls1wsoSNljzorF5v2llL2qEyhtDvtVwXbfZXKu31epFfyaiOs+S0WU+whPPT6iWUnwfUqPxSFx0uGspRz0+pxU07Kfs65VLCnaZJOqNIRsukhiSpcK4aEJsSRKTPhjbEsUspI3hjxZSI3lldjeHXB0Pha4Wyl7S80a4rv1ijqKXcr2l8H7C/ViXjedliw2xj7HTJNC9T0os2bNGsdXqLC8myh41wXQbpDFdZ6ZJlpZ3hMp17K+VMtYdlMosp8t8NYY2xJYVCEbEWKh4XTVYos0O74XhJctmzRvOiyi8KhUbxvG8UPDxvsvkun2j4qvfr2r/wA0SmXYsfjY8bNiijfBsWaxacCmWaPOP9qPJo1edn4cLiJHTEVNvhcFlrK7trhZXPqjihtjHypF53ZYkxDQ6Lwx53zaLEKhdnZo2aL4piSwqFTPyLLZQl7bXt1XbfuF7N/5oi3isqq7Gz8TeNZfp+qmKST4v/IUPN41w/Afkt8Nii6N4+zeLKfc13OlljGsPjXBYpiebHFjYzWaZa7TGhmhMWKLwqxYuNPDoaHQ3l17euaFlCF2F+sf7Vo84soTxvsaw5FlYo/yen0/K4v/ACM2bFw0NM1ioLCedlFNFpPG+F9zXdoVieULFF8rGmJop9y+3ay9FcFWEXwSYixt5pGvfXwfZY+K9k77a9giK4+ZDxWad8W3SGliyMFTLkdKK4P0/URatcPyb/g2bxQ2y2VnaKiiytvDbKLWLj043h8989dysdSGiQ1h4vlvhfevs6NYtCbEkLhs2bKxYsUxsf6m/ZLvs3ljHiuDHx6fS4OxJFsaWynhydIcNjeFVlsoRfCj/J6dfKxRo02VbzvG7LzcorFEpeBRXHolZaxb94sIj0CxXdp4Tez6K9im8WuFFvjTL4WaPyK9hr9LfsEhdrfBYotcqFhzmkUlH6wkWjYzo38k3tstlkIojh2JRNmufR6n8MTVotYhBdIpL+MW28U8UzqRTPzjlllG2+Hxw372KiJCfevFFosaGPvUxd28UjRo3+wr4332ysVw3xoY2WIS/wBjLYkjYlE/IqKbN8HjYkIs1zo6oJWWUi1Z1emsfifBvGjWKkjxhoovZb4dM7E9o3Qx5YzfsrZrDy5RLRTLjEXB532N4RTLXFkmiv2Kx9xd+u4sfJQ3ldpyJfRJyoj6celCWxMtkUX6iv7Eo1jeaGxJlmhmspcemVZ/FnSpZjeEWOLE4lMv00xrNrjY4yp+CF+SL8NCSERFh37JosQs7wy4U8PCb2JeO48JtWQa0NMa+MWQgvAi+aoXcbzRZr9QQv0NvL7k5bekQitkIeEbJJ3ZNkiyKWKkmL1PTUhKxXikWykNs9R7YxLyIXOmmJxTEQV7IpaZSG3holJjEaGxOFXwu+KXk3h+b5Iixp9hd5o6oWRemJLh0x8Cst95oTQmL3Fe5f6Ux+zovKRa5I1mU/4R6fp+NstdTG2XhzeiMI+BIY8pw6PlHnFvDchVciEPESfqSpEYIRJEZF83dDqrG0btlm8vFY2OEjqjfOjWdYWN8F59hXNJSPydDWmKRotjaOllvt1wfYfYXYt40a92/wBIXFL2KLGi3zYq6pFLR1flLKLZ0Rt85QdoU478llIb0iqlJDLYvShfySkNjRQ0MTw80uo84uIkhW1m8NvFPCcBNFPjZ+A7p52kjynjeKEzWKeEu1rjbEkJYo3jyy1SEhLRb42Vy136edZa7Oh9P6qvZ2UhITRT7Fd/8kJxSNifojbaw0dXqJMSVdm3hOdsXhCZspxbY0uLGho+0RYnJFLWeuDYlEWyniylYkoSju3s3axWijq8MfGhOLG/U3i4j8jc22aKkbK38FyNYuJT5ULneKZeKxcRnRAbtjRvu67/AFFKhOPd8e+f6ZvFM1wv2e0WoS/g2fhNIVfzimV6qPljZ08/kbKFeKkRlH05I/H+RobH9ElTG/I6s+cqmX6vqW9JeB1Y0yvRscV41Q+hNiTZvGmf75fSEtLFM0TjLR6clU9MT3Fpod6RKUukfp6fkeN4SFR+RaNmyEv/AM3T8sj6cbsUkuhk1KiUYbQ/OGyVDjmx1ht4vCXLVlxFdsRUEXaNj7mu+lIuYunGzfNZVm+Kr9j2ullOsXnVlssot4t7IpaRo+2en8EcMQhtCTPTjCpHoTWpnpNuPUdEhMs6Jof+KDieNfA5fB6krqDPVX/Rnqy8QZ68lfTSPX/+bPUv8oiukh7o/wAd7VnrXutko7lNOzqXV8FwVfBJ/BPz0pnry/6aPTjC7Tf0PrqrPVaumifTTNU0dXhOx1XQ7EpPr1or1upeDrRCTofpQ6Iq0SmnBVTJxg4yW0WiTekf476iHTplTsUmehZCUX4GmQck0R8tWQiqotWnTJRmpE/Unbo1tqiDWmRiv5G3uNjukqF07E2elSu7PTjTjE9OP/KkQ2kx000N00ySZJvdCkqaPT+EfCHexSQyNC6kpCi0orWGRcbb2V4ZJ2P5IQaRQx2UxyOlUy/BY6oZZRGWG2NC+SPSU/YWRSy1lpF4TdFLg1w3jX7Lpl0+LdIXTsXwUi/EWUtqjWhtFkn4FHVbJX4F9MWHey15o+KGNopp2yTVWTXlsd0em7lJ3R101pI6U22aurKhv5PTSFKbShQm+mUqITbaaojBkfgV2nQuq2RlG5S18Hp07WxptNaE/TuhuqdC6aZFQ6fgipSUoq14HF9Uj8fBHpf4j67I9JNuojTtsU2SjGkKtp2SXnwQX5fRCaZ1dVDW5JUJ2np3oUtWSSZpKmxqLdHzbsdJMaHVWSj8jkNH2iEltl/8ZE4vZJHV5SoUlSVEat+RddfAoHp+rJJnoxWltEW2RWkyMFvyRmqYr/EmhyX/ABQvHSxoryhXdG9iT3tEE3aIS2iT1FI6ns+htUhXciLRFLwKVfA78ij8lyo0OvI0Ml9EydaPUbJRlVGrZsYnEvsNcmNG82UWxNFY3ZeN8vyRtmvaX+pPjZ+OaNl7EJM3Z0nU/IlEbY0nR6l3sfnFRb0iUmSTt+EWy8NspeSMY7IUUtOycla+Remq8slFukTkpNDumaryRnCq2hNNNbFOe0dKqNaH6lpukTgnUrQpr/kerBOlaJTfU1oabG5Rpuxx8pKhqbqJ6kpeSbVMfWiLSTKVvaOtWtokpN1SFJE4uo+PsfTU7bYk10ivZT0OXyJpkUSg2jqqyHqRSWkhKNwuynUiEJVDaHFyX2R+HvDxTGzVoVU0JxtxQ4O0TZeLdHQ6asvaJp0VS6TzbQukcPUTFLbRFJNI/wAbtEJ+XscfEikdS/ETT6xfDJx/km3VHqeaJ/R6iJQ04kHGvDJJXYvkTJXVaEopUJpnqRlRJUzwdKoU/JFeEU9o2PwibVI+JMf3Z0eUtiYrpsiJbs9P6FKKSiMaLeyC8ItcVm+Ly3iykfPLw/bVnf6fZTzqymaZs2bLqTK0hVsV6KR1CQox8FuhvSbZJRocXt2OT0NKmyUdon0/+kktjQvoQmxzJ/8AZkIOl5J0KMd+bPmK8koy/wDRv8qFJ3F2SjKmhpJRWxUnKSRFOS9N20StRkepGaW+lnqKaF/xl8/JB/hFrRFyacfyrR01J02TUtnURjtxbHVkEqSttiUer6IyS0Rg1Y5rTojFVqz8JJK5DnH/APolHzVokxfItpeUxtxE9kLT3slF1E3U1R0patP5FVrw/k1cWKJBvTLVDGheGhKqQyyVUmNPYrxR0Ssk3dNDZvY6JpbJNXbofV5tC1EexySiyPVpledijG0ateTqYrWzp81QpO1onfnRDqWzq3FjvZLqpElCj1LrqJp31MnKkpbPXktpaHRJqky4ipWQvyJMt+RMV3R8JDiPqsiKfyOGpIhJdUZEn4VmtirwKS0x3TNbIP5PrYvoT+MsawhcLZ0jOoooSE0Ks6wma9tfBeyv3VYZazaNlGzqNlIZeNjsQq8nUf41ryT3ZLcpSPoSR11WhNWJiY0x0KEbaIfDGPq8WxwdNDnVCXpsbnexqF21ZGKcUzq9K4q2LrVyfgU0oxdJC9KTuXkdUl1MlJ0/CXg2mrojJVI6IP8Ax6bGl/P2TTkmRnCpOzoeh0lIbVNUiNJNNNHhtkvAtdSKVUSfVIcfFbQ0nfkUfHwN/SQ7r4LaaaTobnHqW6FdEmxtp4/KvgXjyhu+lUSUmhiRBwE2UyT0inrKmtj6bE0osuL2OGhy+SpK0elNadMj6NO0z1Jv8U6PUVrZ6lUibGnssVOSGnRWmRWxUVsXhHqPSPUjUpHzZ6jdImmk/kjE+MKQ47TPUqusl/8ATPyqbdEIp15JTixSt3imbOmy8tjRYkrSEmJuxFYZsaxssTZEaeGITF9oS8DQxj5t6IxVXs0KjX7EYxNU+VFmimVEvKSzcWVoXSin5ISX8kYrfklJ7NaLEIjWkOMtMSQn4dEpVGyMJVR8sXW2KXlaIxI21RCFOlslOpXq/AncmKpX4PUj/wDopeDy0L1JS+RenDxTF1Jop9KQ+oTIiq0Rq38EJuUr8lsh4ERvbG9odJas0eb8CT6r0KPg6jdCaOqSOi/kc/UZ6a+BdRb38jUriPzJFN9NJiblJCcmUNLFs2nYpM6WWONn4uy31Lwj8NEpKxoZL4E2lIh6eqPSmvAopdLG2J7HB2kTb+kJjjoclsa8lklqhqnQ7qS0KU7vRBK0K7T2OUaJNjZGCLR0vyKtje0dSiylKIup2xGyh5+WIRvCsV5saw8XJVh3QurZW0RkJo0ul7JRVtWLxVHq+Uz1kerdUet8wZKXpTZ6lDx/JQ0U/AvUlfglfkaH7Lf6mxlY2Ws/GE2KMFjpQmss0ipb8C8IrVaHQ2h9A4uvIqLWJJEWrIt7OrSKE3eN2OSpC6aFZGT2KlFEnFUxRi7bINX/AMX8sgodKQ7/ABJyVWfXlEpJS1ZatDUV07HFWyPRt0JSbfgUna8CbienF7exSf8AyaNJLyep6c6VuxyVyeyMVRLf0f8AFXpEGaPk6XSHGSY3YlbGmPqPyKLH1pjuomy+C0yNoQtfZ0u2L1GiUFcXobasgkyEurRGkL5VUPqVeBPUilcWMkTorziXwSfkSLJtUSa2SvyyQjeGn4GaPvZLqJN3eOl4uaZTYi3i+Vjw3hCxWKZWy5EUuo65aJJUVJ2JIUdtbHIZI2Q6fKshFV5GvCJs9TqG22yPhC6brwf5ESPUUfB/4N7USX0N+WhoY/glHyXljrwSTHxtm+NF/qFHyi0VLKN28Mv4Ghs+jqdGhCSHLbEyalrwNpip9SK9S4k35Q/A2hdPgdnRpPZ6qfUnf8EqtqhPEfSfgUovp8sqST8iY+tUdLIik6SHB0kOBCBFTdoVV0pM6kkl5KtGi2okKo/16Q0lYo+Ksn0qTqheVTbEmRc6IPchf42o/AnBfbG27Y1GnodLY2j8l4ojWxdbSKKiqQ+nqZ4rYxNbG3sjF0OLLyqNOj86YnbP5GxdIkzfku7LZ+F/JKOpCd35E1fwLq/hlIT8yFfkirTY/sYyUmXpIldNE4+CZ6jjdaJOI0rY7wihkultlMsdEUK2zRWfsWK4NvHiz0yLHFjQ35HexeDpdlryJM634IoV0xra2hYeHZZsl5oWqOkjJWKhVh0KL2NJdIm6aJN2rR6kSo00JeD/ACJkoNqhSH9qiLZ0ryxqN0Sb8EWKOkhOPgoaZb/WfktYdijnYi0USTUkdcSiy4UhxiKxs3QhWJIuXk2NsalbOn5ISWz04JdO2KLTZ1yUaPThduyLbenZFPpI9S2RSdRLjpbJ9SVbN7SYpWq2dUSvApSTZo/JRRq2LqZHraSKiWi2x9HSJRTbosp+PLHtVs1/LHOo1VH5V8CdfXwJNtlIcmfLISakiLIXFKvIo1fhkYzTXgXWWROttoUnE3oaeNjWl4Y222fixyoUI1Z1WrJN78EEimeNjSockdUCoJDT0W4nmyLRFpkXMXVSxSY6k0iUrHHyRbOlSi0Kx/GElhjHJedELPocRJeRcNiIJeCKfgj9ZeFaPBsaH5G8NPySbHL/AJMjEj5pWV8kr8kmN/JH5Qk/BBppod18CZEUXaItbIxjSOrQ/TOuN4vCkhpaE1fySqmyVRItFeBpkZLwN2TfyxrbY38nwtotihKqEOhvFrFcUyJChC/QV3LLRWsUx+Xis0MVEVpYuKGJVZHrtC6i/UY1Ykv5G0ScrG15x8m+ol4+BHUxLzJD9Ry6VSFGKpiu2xJ9QunTJLaGrvbx5bNCdoUENi6rZb/gWkiUX1PwdKtrTFKOhn+OVNicfI0tkdEZbZFJWXJzT0OClbFKKi/I14HPZ0x6lh30k00v+opbUqZ6v/zaHF38D6+qIpKpMg/DKeh+ReWPrGnTKg3mhjKdsbfkikeH8CsVNv6OvQug9RJa0RrZT0PyR0bHFjbFIj6S/N+SKho6WzqbEdcbQxoaHNCkrbPSivtkZSoglSdE0/I4vaNeCz+BCfjFYvwWflT8C6nwfUmy3h9SY53RLEPkhEi/kTWmOKOpWyLH8MkpD69n42lslVsk92WV5RT0SzTElTRCStCiQktYSJOyyXhjiUfJFwdDF0WmOWFZ0s9PbcdibpEquyNUyIoIby2NYr9ReLZQpS5NsdDh4GpJ0Qav5JXRJIi41ipMXk0dTElRb0NDaw3FdSN3FigtocbbHOfWx9PStCiW7sk0+qqF1aGNxTQk3GXyVJloti8FIbKWh9d/Ba6RdKjXgioCF6m2jSdUUKvGLY1F0dSQuu3o0hbr5K/8olGdM/2Wxf43Q36t/AnpYq1QyTdG1a2JumRSZcY/aFaY7q9cloXTaGyMPTSQzrR0yFRXgc4ifleC1pD8nVHZG0Si2SjdEpj6Sc/EWTveiXUmvAvTj4JdPUvgbduNHpuEWf4lS2TfmVHi2KMm3WxeFsrTI+otoXTqIrpoWP5Ehsl8M9ZP4JtkuokhnppXI9OtIiWhjk9nQmqN7LPmyrvZY/gfy8NvEkyLRRflCaqh/BNo3vTE1sV6QvNEOlEJeSFE0SvS2epFbiepPdHqdVNkk/4OleLFPZ16ZFCWkJQKGh3ZGS/nCY7IdNNEGjpOoZIV7Ix8IU0UbIkRPROP6YmjYkU8PbKeHl1oSX8knfUixpWNUxVobY0Wxn4GqN0SsTJR0dTHXkf2UhysZGJsbIqBETKeiTdstuj1Bp0iTdobw2VRGjqlR8Ij4Z020/Iv+NPyLp0N1bw0xpDeom6KjT8lo+/I5ocZ7HVIdUh7G3s2U0RSs611EUrRe87xWbx+IhPzsiRXjEuk+yTWh9FPyao14HSSPtDrQuraPTSbIxfgT0iTkdUZJbonTcvgekmtiepH+NpROt70R8MXpxuycpb8CWxVpDmOz5ENbSspbiQ+dCe1I9StE4+UOSOnyi2NeT035sS8CT2flsbekSTtifk1fg15EkR+rF9bG0a/Irw9CQmi2UMn9mti3Fi8JllPwLqIPWiG/B0rwSux3SHF+CSlZ9RJL8qJSVnUtiT2V4H4Lltkn4Yr4V5EiLEkLL+zWhUOLpmtPO9lFmqf6XaKPkvL6ULFCLIrSKk2bNjbwy1vG8dRVUNs0NSLiJPxhobeHYrFTNUhy8ijsk6a+SlsV0hRVjfzsbRryfWKGo22KtsSe0UkNDHKVjbpiLGWdMn/ACOzqH5Q1/6T6fBbv5H8DQ2nR+Sb+CzYlQ5Oli4tDTqizeiTXgkNvTHHDeFhPyRT0x/QkJERCIvemRr/AIkREWtojHaHKV/JJOmNTpUynrQnF15FfUyMNJDlIWnehOIunaTOrbdIUUS+BxdMQqIvwyMV5INnpi+BrwyXyxJj8oad0MUojurGU7Y7sd+SDFVYkiSdok/JouhSWj7Gi/KEaLu4kWtFeTdokzRbNsivLOpUNKhNaPhkbIsa3Y4jXwNvaGld5a+TYmiL0UyLQitpjkh34G1aGnspnTjq+c2Lw8NM0P6Y/pj+mP6Y/of0P6Y/of0x/Q/pj+mP6H9D+mP6Y/of0P6Y/pj+mP6H9Mf0P6H9D+mP6H9D+h/TH9Mf0x/TH9Mf0x/TH9Mf0x/Q/o/gaL2kPw0NDrxmS+B14GyhxXgawx34GMbGOvAxkntjXwP6Nja8DkvBrCfwOvGGfwyU3Sujp8Y6hpUkTfkUhl+YjVD6rSJJaRZ/BOQo/wDJsipJRi2N0SJMaFVmkqESY/pkr8Dq0O7SGl4G34J0tFbo3tDq6GP6HY38DH1LQ7salbR1Tlolfg3dFO6LXgcXaJtbQ38EoquklZNfBO7aJUTvweoxL/lZ6co2rIFKliUZ1EkMkvgbiNfLJ9SJole1sl8oXmy/Bu2X8ElE9XxFHqOhxW0S8bHdOI1LwR+UVG1EdNk7+Sa+GzqRJLwyXwiv+rOpeB+BeGmQ8NCitIkdJJvwO/BfwSi/BJ+UMf08Nj+mSPpHzQ/o/ge3QmqdknonvTJN7HY/ocpDg/8AiWtIm5bsSHW0SukfcWatE0qpkqpoc14PhnxRaqir0SfwSvwMl9D+mMf0S+UL6Gl4H8IkvESfyiTZIlXkkP6Ghjfkki/gf0z/xAAoEQACAgEEAgIDAAMBAQAAAAAAAQIREBIgITEwQUBQAzJgIlFxYZD/2gAIAQIBAT8A/wDn3ZqRqQ5CYv7Fsf5Bze1Mv+usc0S/JihbUxP+skxyHJ4SsSGjSJbbE/6lsmx4oSwsMvFizZf9NKaQ/wAll2JWUNpMTwuiymzouxqiJdF4ssv+knK5PFikkakTfJF8FjkWKRdiaLsutiyn/Ry/Z4odItlsjZOTQrY2xCxYrEaixbF/RS7eLGyhIjwS5ZErDEyyy2WWJovK/oWT7wysIYyIxUyh7kLK/oWT7HhMsTJPERvgTxQ1Q1lFllliYv6Bn5OxvYsJWJJMlyxIWJdbKK2pi/n2T7GR7GVhEeEQWqQ0lzQ5UujW2R6GittbEL+fZJ2xiE9naoitKPySGyMRcLFDiJbK2L+f/I6WGMQljTZFNPE43yKIluexVlfz/wCXNCQsR2ad1jwsLK+FZqNRqNRbEyzUaixP+C/K+diwkLw+ti2rztmo1F4sXgRZZfybLNS+jZJW9kUmiiMSkhzRfgYh9i2x8tmovdQ9iH8W0WizUajUajUW/p2h97FI1KKHJsV4S8MhZeI+Ns1DYsvZe3oteTnFlllmovwMWF9MyW2XrCsQl4KGhZYyPhsct7QsVhoR3mvK/JeGryvpmTWyMbHpao0YQsLwrYvA5eKi1mz9hLNDy2l8qvp5IarKmazWKSfo4FQxZbHIsWGJjyttlljEIZe6XQkLUh2xJ2ULlCk0+catjjYvirNiL+mZLdHKy3RKRYiO9bXl8MtDdFlobExFjkXaI5XA5cCu+DsRXLF2XT8rFivE1mvpmSRLvaizvZN5RHxWXsq2P/w02jS0UcC5YkUaVhqhDfIk2JCw2c6iI8sXhbRey0hi+wZLvZYpCkKQmWNjd5RHZe1svDYsUJCxfJQlTEz2KV4kxNC5YnWE81i9tl7FnSVlvgUbf2TKtmka22KTNQ5PZES2rLw1irGsNoXbG6IsfZy2UdGoXRfB65FQl/rD4Fy1hlnZWKw/E9nQsv66QsNDWKK3LC8c2xHSLvkch00hrjgi7TizpUI6NWKWENDSREZdiWOuChZsu/htlotFia+qex4Q0VvS8SHye6x7KGujpHbbyxDPWLobKTQ2kWIWKGQ6LGMQ2K/NaLLJPgdisaItCf1L2MawhrchZW+hoindjViRTsq5USTLp0LFcGosV2Ss9pMcRcD5Ylmhuui2z0LZW5ikWdvDaFLD6FsopFGkr6p5Y8Ie6OV4bbZJ6US9NCfCLSF+1jZQlRY7oSxdC5GldjdsRWU1sva3svNIbF4UL657Hih7awsLw1RJuZX+IkfkTsh0McqQ50J6sNqqzfrZZKZbZbIt5a2zYhDFl5fAreH4n9he9i6F4mXTE7TF0ctiQx80S7IuqHJibbGhI92XTExsdsaEmJCFl7JRsSrDey7KxOyKK8b+hvyPbWFliF4mjTyJpDeL4O3hocXwckVj1ihIooaEitl7mz0V5r8Cl9VY9t4WxCxfhaGUh88CtOhIaKs6RaqyL89DeOdjaRrRqRrRaLWJLc/BIS+rcqYnexb1leFoo9s57Iy4GxEuxISWb5F5O3s1Ich8jeEsWy2amOTRH8nApJ+DUjUhOxr5/PlfYsJ7Eiti8rw+BIl0RbJXZyLOh2LgvaxbJMSw5JEpNllixZHkkIoSJCRB5sWHIp4oSoV/Vy6eEJWj2IRRdC5GsrGvll+J7GRVI4vDaQ7WyvE0XQ5jdlcYirK7Io0EIDhbFCiS4xVnPRGNbW8N0UVx5q+fP9cx6PeFisesVj8kqLYpkXYvKyh8F3IuxbV4JOiTx2yXCKYuEMSEtlDhyJViihYeeyixPfRXksstnPmsvdP9XhD/AFEIo9YQtn5v3wiHC8jxQ3Q3ZFFHW9l4rEppEpNl4XLJY5FG2JbLsuhyReKGJZoorDRHstDaE28UV56+BWxPM/1eEP8AUWEtieUT/Z4RHC8TRY5DkLkSxeK3UIckiU3WJ4QkMTRaZdCQhvC4GNCiVhl7Wxc4qs0V9G1isz6wh/riKyzoTWyf7PCFhdeNkneFuva6HLHZQ8pHujSJHCxfNFeB3ZzYtlCw2LDfxbL+HLp4R6xFZkrRYmKbFK8T/bCwtkpKKE73yNJpFEooSKxRWXKi2xjaRfBqwhRKGkLDXOK5LxRWLzRRWGxPFjYhYfw2WWWxN5588unldCXItk44WLJ94jhbPzSuVEP1XgrYmjUhNvFl4ZViGNWaXQ40IiLKW5Ys1FbpPFFCHEXx6KKGhJiXwJdPK6EtsnwWXiyWEIWW6TG7bZ+J3HxydiRpFxt7GuBRZ7wmSplCIl1s1YWyZHNlmrDESEL66XTzESw5ikyyfWLvLEIQsy/SWPxPmhb2O6F0VnvdVklwUVihISoRI4LJTosUi1iyxigdDmXbGxdiROSE8LcvqZ9ZiIY48lYfW1iEIRJ5fbIumLnwMWHhb2UNlFCw5JDkajVh45Ij74y3ReEVyLsdpDIooXhfYvE2KT+V+R8Zj3seZcPchCJvkUhE1Unj8UvXleK3MWyc66LbEVyNYa4wkxIookMSKs0j7F2SVjQuCxeCREQ/AyqF8r8nayj0WWtk1uQhEv2YuxH5VzeFwyErXmu9zRpw2amU2xRFE00SiymNUhITFmTwuiIyRDl7KEvAxeGsMiq+V+TvKF0UUPMla2oRFCJfsxCJ8rMXQtz3MSK30OPAkJbLGhxsooTLLO2ULrDKsgqGLyV9NPvMcMQ2kxvgV4kqe6OH2LCRNU8Ig9z3exeKisVtoofZbTLEUPFER9YS87+Ze5jdvMbeG8X/AJCVlYkrWxYQ+sWLnE1avCI7nsQxiYn4W6E7xQ9rOSiisMSHh9CXhv6B5oWy0TeWQxRyaVYs0TVMQ+xLC6Iu1Q+8Ry00xCE/AsMZWHiTpEZXtZ7NVFpjHJi2VtaH9W2WMW1ySNTErHSKsUCa4shhscixbJxsSwh0kJ2JE40xCykNci2vFZsYlh5myC3UNWUxdFISKw9z6GR8SKK+fW6bpFiOkLlixQopDY3bwiPWLxJiQ+yJNVEiJk1aEq2+8PfWFhiwiUqEtTEqXlY3QixYssaEvHfym6wyxvFo1WXWyatFOuhF2mXSIyVdmpf7NUf9olNF2UNi4LSGaZLHtkWdysiT/UjfJGVIUrRISZ0y0WjgckhzFqLYpOuiyyxyxqRqR3h4lHURjWLLE/A2KVj5RJcEawvgX8tDY3Ry+ccHCY2jUJ0hyNcR/kVCJUjS2aHdGlK7JVXDFz7I8eyvSZK0P8cyK7sd2JtCTbOixMS44NVPkTvrCplFIaT9FOuBLjk0pGm2ONLHKaFQxNey4lJo0r0xx44KYnI1tClqLLoUrxZ3iyxlsRQ+C7FiX6kcvPvyr5KZZqVjbbE3i+eR0+hqjUamORSY6QpNnJB9mqT6G77EotCjXI2uDj0yDpqybFRxhIfbFQ0qsiziRWli/wAiqE7GdjE+C1JUdI12ejTZ0XZRQkxqzlLsi1I0olC+kjRXIkX6KFyaUVQ2WIZbLLRwyiscMpFM0lZXjYvkPLYihLDEhtUaWi2cnKHJt1sj0VyymrF+vI6KIofJQo37wlY1RyWztlEp2iL6xwMTouz2fqa0XYkJccnBpKKZRSNKFGh2cjGafeFhocTSVjgY+MStMUpCkxv/AMP8muj/ACNbFM47RZwcFrN7LL+U8yxZEmq6wusJ0Ps6LTRavlDp9FcDQjlMbsjGLVEopPCWPWELhF2aTQqH2auENCbE+EJpkhJiVMfMi0SXJGxvgfJpd9i4QuUOVFjpFjYmOyxptnKQiy8vhGqxNlDiUhijaNJTQsO2jQ6OaoRdi46HIr2h8ii/9lDopixRXymM95XBV8jSZWPZSHyhLk4bdjjzwVSwkvY0aRJoeLodUXj/AIWKmJidk1yPj0Qpj/Grs6RGzvFFFWVYlVibdiaOy6R64HE4JMiNj1Cv/ZbXZFplI0lHN4sc74oSKocmVfspltY5sssTLGyUYj/GaGU0UxcC7FasZwPoSKrss14v5D2pFoZTWKwuTtGkpmkpUUNCLO8vNvYuDsoqnwO6F0KjosWFmhpoTaG7QnSFZzbOUf8ABqkWNoq4i1I1mpYfKENFY5KKGnii6LOGVRYv+4Q6L5WOGaR2WVjgY0zTZ1hr4z7HvoWH1hYoW+h94a6xW5C6zIXbHhYZexLkoazR0PKVYSVkkj1ldnsYtlZYuh4XA8LkaSY0Itl7KFs9lH//xAAqEQACAgEEAgIDAQACAwEAAAAAARARAhIgITEwQUBQAzJgUSJCYXGBkP/aAAgBAwEBPwD/APIev7OijQzSxYDQ1/YpWLAWCW1or+toSFgLDa4cV/WYoWKFiUMbEWXsoor+pSMFNjcNwuSooctf0+OLYsKK2NQ02xYlpHLKo7MirGpr+lwSWKmimYrgyKKKHiJUNHRVjlzX9GulKuWYob20MZpKMv6VGPS2WWMXCHK2VDGipf8AQox62sUOGJi3Mcsf9AjHraxQxLkcWJ3Fy0UUUND/AKBGG+y7EMcY9+Bwx/z+JjD62MZk6Qnfs0ts0pGXYnRfgYx/z+PYuhRWzpmTswUNj7ixZD2XDh/z/wCNbHNjdqMMhsycqExf034+pQ3OWxZDmooUOG5fw6KNJRQyiiiv4PBcbHLONyLPex7X8CiiooexLbRRXyqK+jRj1sdpw3Q8mxYMord7EMXQ9uXmrdcLal46K8NFRRRRpNJX0yExbGh46qFikOG96Z6MRyoy8dFbUrK3VCKfnqaK8CHsr6RC2qGMb8F8CY5UZeKt622NHShF/Jooutt/SIxex5UK1yaixjh+JFCMvAl49LKijlDc3sWLfyLLL+mRixOGaTSaTS0cjsQ5QsShwhoQoe6ijFHsbsRUXLMKsbHTFSHkjVY+GaU0UaSpWVD+K4SKGV9NiKHscUOUrMcShmUuFD52qKF0UxI0lGkeI0qEhYnCY5YseR0dRbpD6Ksrkar4FeBMssv6ZCYtrKGOcJZlue+i0XGqjUmhuM3Q2xNmpwhiXA2kNjcJcH/VGXQmWehDXhSGhzpbKH9gmY7aHiPEaKEhKcjLY0XtqEOExscehMf/ACGqElQ8SjFDxZ0hooam3usrwaqLldjY39iuxOkWXuaNIlsyHs9RexFQoSH0JWZifELKj9ikN8ns4sdjf+lo7H0ISNLOoQ2V4q29j3VFfU49jcJifjy3PbghxQsBJpsT5GuU0N27moUplmQuSq9lx3yWzLua+IkLFlFDX1WPcoXjY/Ahi4n0WxPs9j4SW1dwyrEi2maWyhnQ0J0hGfZUKEh153GPYmhtFjQ19Stilie5jl77EzJiY3SLVF0mzFnauUyiqcI6TYsh8sTaQ2yxO0WLkqj2Pfc4jxKKpQkOENxU2Wahv6pShQxbnLHvRwkJamL/AAoqx8YiUNlRfMUPgTdUdIvZTUrckUOKlMsbj0Pe/rk91i3OX4bsxrEvkbMGqMhcixNI+CxLm5p7KMcP9NKRwZJRYmNlzj0MYt6GMW2/sU972sY/CuWUimmhvkdDEhUY9DVixRVCY2PqiioTMWNjyLHK2J0XZRQ92I39bRXiQt72McV4EauBlRR6ExMWSOBubLHFmJkxuXvSPZq3rfW+rNJX09FFC8jihrwJxYuOR8ouLFyxYuzJCh7U9tylFoblJtmlmlmllMpxiUxxXixG/qLE4XXkcvw3PHQ8ShmI2PITiuB+TpDnSLASrbRRpKHhY8KKaK2pGlmhlMT+dSOC/IuprYy5ocvyIbMTJIVUOhzrl7XsxQ3CxbMcaKlQxQmNijKXKxFShjY6+rx7Ut7LGPgTixiHjwhoryp0N2z1CxbFQ9j8KZViwEqluGah5Gs1mL5GXDc3GOIxcljY5XhsssuLL+Vh+0uXFx7ixmGNw8Rqh+VFi5OlD8uONiUrl7GyxuUxZWiy2WWOMVzDLosqxouFssvx0UaSkceaiiitmH7KGe5vY9mH6zkPzJCRk/CitmOAlUsU6hvbQkMbmyhcMeRZcYsyKEhpRfiooqbG38BMuOBpTh+0MXct7MlLMf1UuH34kUmLESHFDW9SsWzHFJwpYhjOxwofIjVRezSPYsbMlTFwN2dF+Syyy/jJxbnD9p9wxsxcvZj0oY/KjFVDc2XGmyipVsWOxRZqixuaL8CODKUWN2UUOF8WmUUV8HH9ltyYyxMooeJVRj1Dh7Em2NU96ZrNRe62jVNWJVCVlFQ2NliY3CcXxuqLLNQ3cJDUJFDY38VFRU0cefHtbGMc4ZWocUYw4cs/FjWNmf7PxrkeLNJUUVC2LItF3GQ4Q/BRp3pFlljZqL+PbLZqExsb+Bj+ylj2497VDGNzVtCPyLnxpUNlj29CZaPUULgsYxKyqnTD2YGU6SuTTCGYjof12H7KWNwsB4oZh3vYx9zj+yj8i48KHDjremXssu4RyULGGjS4ooRqOzRCR6jFDhxW+ivpfx9zkONRqjHvexjMVKGrQ1XxEWVLjHEWJRUVLQnxDErez1C5cZF+JPgfgoQkPFfK/GpY3K5KhdbmMZguCoxfEfkXvyry44FVFllidjMmMbLFNli6H0LhCY+Roa2LZj2ZDFvXQuCxv5X45YyimKcHuYxmK4QxmHUPkyxrxXKK3JmoQkUWkPI1FiyRYnyMaGMoxUsQjLqUWPwYj8apGTs4HF/G/H1LGWWY8sajHh7mMyMf1UMwnJWNeRDfgsWXI2NzcWxZFljRRRZY4SLozdmIzs68KdDc38x7KnDqWOKZimJDSjF3uYz0pYnahma8VFQ/FfiRRQyxSxcs6LL+qoa2oSpS6GLEbP8AqN0XGLp7mLuXGMMy8zRXgSseLXgRY2WXCHYrhOmN3vRRX0CVlKLG9lMwUoyhZFqjU6HsxdocXHsyVOxQ5TGMfhYluSsyxSW1cM9GlspiViwRlxKL2piLL8b+ckULgZexYtixSGJMuh5GGRnCTFgaR7MHTG4YuxjZg7UOWy/HW/BGb3ahOi7ixuUPcjLx385FlnZU0YY24Z2xjl5NiViVKGMoqMUNnaMjD9hjXJi6ZdqX1HrzOcVY+EN299l7VDRQxclFCfA39GoShIaEimUzS0VY1QowdFoZXJVmWLvop/4acv8ABYMWNDYhlWItOckf9TIw/YZljbHjRiOi+CsimcixbNA9JSGlfBRRQsX3FMpjTUKMctJllcUaRqvBRVC4YnyNw4vzV8toQlZwhx2imaWNWxYjwZjgMSZaRrVF2K7GZF/6hULPGxiGkOkjsoY/VjVrgaruHaLLYm0+zUr5G+eGLJl0LK2UjimOxDT9FZF5Jmp/4LLnkTRSNKNKxGirNMLGdI1FIcI6nHsy3Pxr5bUaXQlRUrgTsooWJbEPFI4MlyjShKuhtobFxZ/7RkrXBgh3LF0oTdjSOUfshrSN2x40JWMSsd2c4tM7Zoa9i7NR2VRZqG0JnDY08S3/AKY512zWm6G0VD4NTG7EihiopFFMprYhMtGouW/GvkriUoscKEi7KjhiWxl8Iux/tLYixuG6E7ikdFmOPNmSPZyIasqh9H7GhlUhsvng5/w1HY2i+S2ax5XwxUOoRcOEah5FypVNDxxHiiv/ACf8V2z/AImhDxOemLGzk5KcUU5RRXzVFGVmD2NWI7KaZX+MVlzw0VRk8kzFtqG49ijtlUahZ8xXIhoyVsaaMWNofKFwqKMXwOj2Lhl8D7G+RY2UJFCQ0hQqSO2MoodzpoaRYsjkQ8jWJpjhaUa1Z7sZVMasWMLg1ITtCs4Gpb+ShbXzHKLmxcDfEai7hsT5osdM6irE3eyhumNDSRhyjsytGP5C+TIpKLo1DdF6WN3RSGmN0VbtHCfIskc2JGXAl/otI0jSn0ZJoto1Fi6ihYexsuzQjr0ajgZxRRRkihIxeRrNSE7LR2PodMRyLlll30UaDor46Qtrc3Fw+IsssssQyti39nRZdoVD7HZ2VQ57LLFT9jSYlQ8bdjpHqU+SjFMush0zSaWJQxMtxwWahNRqK9lHKLso/wDh2MVnqG2hZCaKnkQmizuE/jLoXiXcPxqE/Axl8HsxH0JQ4Wzob4E2KbO0KXzDZg3sZ6Ex7Lj0IfcvkR7Hx0JsTHyikVChMexrgs//2Q=='
	);

export const confirmUserMock = () => getBaseResponse({ status: 200 });
export const resendConfimCodeMock = () => getBaseResponse({ status: 200 });

export const getLandingMock = () =>
	getBaseResponse({
		data: [
			{
				id: '30',
				title: 'Coltiva il talento della tua azienda',
				subtitle: "Con un'App. Dove e quando vuoi",
				description:
					'Un ampio catalogo di contenuti formativi digitali per te e il tuo team',
				brand: [
					{
						name: 'Brand 1',
						color: '#F2284F',
						logo:
							'http://s4b2.local:8080/sites/default/files/2021-03/lemon_black.jpg',
					},
				],
				cta_apple_store: [
					{
						uri: 'http://www.google.it',
						title: 'Link Apple Store',
						options: [],
					},
				],
				cta_subscribe: [
					{ uri: 'http://www.google.it', title: 'Iscriviti ora', options: [] },
				],
				background_image: '',
				app_image: '',
			},
		],
	});

export const getFiveMinutesMock = () =>
	getBaseResponse({
		appName: 's4b',
		requestId: '1c5f6d07-cc38-4c64-99cb-8eec6c251678',
		success: true,
		errorResponse: null,
		relatedLo: [
			{
				title: "Big Data: Cos'è la data monetization",
				type: 'learning_object',
				finalTest: false,
				format: 'video',
				duration: '180',
				cover: null,
				creationDate: '2021-04-26T16:54:01+0200',
				creationDateTS: 1619448841000,
				completed: false,
				itemId: '82',
			},
			{
				title:
					'Big Data: perchè è importante utilizzare informazioni da fonti terze',
				type: 'learning_object',
				finalTest: false,
				format: 'video',
				duration: '180',
				cover:
					'https://d22cxfqtum6m93.cloudfront.net/media/2021-03/sample200x200_1.png?VersionId=vIPtJvN5pq6H2A5VYIzCJac6I6JBchIX',
				creationDate: '2021-04-26T16:53:59+0200',
				creationDateTS: 1619448839000,
				completed: false,
				itemId: '81',
			},
			{
				title:
					"Big Data: come utilizzarli per personalizzare l'offerta turistica",
				type: 'learning_object',
				finalTest: false,
				format: 'video',
				duration: '180',
				cover:
					'https://d22cxfqtum6m93.cloudfront.net/media/2021-03/lemon_black.jpg?VersionId=Xaw5C5oL4cSgJMoaK60RdZXiUEBwvuhL',
				creationDate: '2021-04-26T16:51:22+0200',
				creationDateTS: 1619448682000,
				completed: false,
				itemId: '80',
			},
			{
				title: 'Big Data: perchè è importante automatizzare i processi',
				type: 'learning_object',
				finalTest: false,
				format: 'video',
				duration: '180',
				cover:
					'https://d22cxfqtum6m93.cloudfront.net/media/2021-03/sample200x200_0.png?VersionId=p7G.h12I0df.WhH0YrFm4ZeI2n5JNFRE',
				creationDate: '2021-04-26T16:51:20+0200',
				creationDateTS: 1619448680000,
				completed: false,
				itemId: '79',
			},
			{
				title: 'Big Data: Quali sono le opportunità per le PMI',
				type: 'learning_object',
				finalTest: false,
				format: 'video',
				duration: '180',
				cover:
					'https://d22cxfqtum6m93.cloudfront.net/media/2021-03/sample200x200_0.png?VersionId=p7G.h12I0df.WhH0YrFm4ZeI2n5JNFRE',
				creationDate: '2021-04-26T16:51:18+0200',
				creationDateTS: 1619448678000,
				completed: false,
				itemId: '78',
			},
		],
		news: [
			{
				itemId: '83',
				title:
					'Circular economy, al via quarta edizione contest nazionale di SeedUp',
				body:
					'Al via la call per la quarta edizione del contest nazionale di SeedUp "Dall’idea all’impresa green" rivolto alle start up che operano nella green e circular economy, in particolare nei settori agrifood, mobilità sostenibile, energie rinnovabili, waste management ed economia circolare.\r\n\r\n"Il nostro obiettivo è quello di essere al fianco ai giovani innovatori italiani per cercare di accompagnare e aiutare tutte le neo imprese che si stanno cimentando nella transizione ecologica", dice Angelo Bruscino, consigliere d’amministrazione della Green Energy Holding, nel corso della presentazione dell’iniziativa, sottolineando che "il futuro del mondo è legato al cambiamento epocale che dovremo realizzare nei prossimi anni. Compito non semplice ma alla portata delle menti geniali dei nostri ragazzi". La pandemia - prosegue - "ha falcidiato in particolar modo le imprese condotte dai giovani, ma noi andiamo controcorrente e li esortiamo a crederci ancora".\r\n\r\n"Ospitiamo con piacere la quarta edizione del contest di SeedUp nel nostro quartier generale. Nel mese di giugno procederemo con la premiazione del progetto non solo per celebrarne l’idea - conclude - ma anche per affiancarla nella realizzazione in concreto del progetto".\r\n\r\n"SeedUp è un acceleratore di start up innovative nato nel 2015 per favorire la nascita e lo sviluppo di startup innovative”, sottolinea Alberto Celentano, ceo dell’incubatore. "Abbiamo lanciato una nuova call, la quarta, per giovani realtà che operano nel settore della green e circular economy. Entro i primi giorni di giugno saranno individuati i 5 finalisti che si confronteranno in una elevator competition pitch di fronte a una giuria composta da docenti universitari e partner imprenditoriali del contest che ci aiuteranno a selezionare il miglior progetto imprenditoriale".\r\n\r\n“Nel 2019 - ricorda Celentano - data dell’ultima edizione del contest, la startup vincitrice, River Cleaning, è riuscita ad estendere il proprio brevetto relativo ai mulini galleggianti a livello europeo e successivamente a venderlo. Un’ impresa realizzata anche grazie al nostro supporto, dopo soli 8 mesi dalla vittoria del contest”.\r\n\r\n\r\nAl progetto vincitore, diecimila euro per sostenere la propria attività. Per inviare le proposte basta cliccare sul sito e andare nell’apposita sezione "Contest 2021". C\'è tempo fino al 15 maggio 2021',
				creationDate: '2021-04-26T17:04:36+0200',
				changed: '2021-04-26T17:25:25+0200',
				duration: '120',
				format: 'text',
				cover:
					'https://medias4b2sit.ispfdevelop.com/media/2022-11/webinar.jpg?VersionId=NhaGhZ4cFXe3aa.ZmDjRckhqNVYr0Faw',
				type: 'news',
				needs: [
					{
						id: null,
						name: null,
					},
				],
				cohorts: [
					{
						id: '17',
						name: 'Cohort 1',
					},
				],
			},
			{
				itemId: '67',
				title:
					'Tutto quello che sappiamo (per ora) di iOS 15, il prossimo sistema operativo di Apple',
				body:
					'Riformatore ma non rivoluzionario. Il 7 giugno Apple presenterà iOS 15, il nuovo sistema operativo per i dispositivi mobile prodotti da Cupertino. La nuova versione di iOS sarà quindi svelata per la prima volta durante la Apple Wordwide developers conference dedicata agli sviluppatori che lavoreranno nei prossimi mesi per aggiornare tutte le componenti, hardware e software, che dovranno interagire con questo nuovo sistema operativo. Non è ancora certa la data di arrivo per gli utenti ma probabilmente sarà attorno a settembre, come già successo per gli scorsi sistemi operativi. Tra fughe di notizie e anticipazioni ufficiali qualcosa del nuovo sistema operativo è già chiaro: non si tratterà di un sistema completamente diverso da iOS 14, distribuito al pubblico il 16 settembre del 2020. Semplicemente andrà a migliorare e a integrare alcune sue funzioni. L’ultimo aggiornamento di iOS 14 in Italia è stato il 26 marzo, con la versione iOS 14.4.2. La strategia consolidata di Apple è quella di pubblicare un sistema operativo ogni anno, il leggendario iPhone OS 1 ha visto la luce infatti nel 2007, quando Steve Jobs ha presentato il primo smartphone prodotto da Cupertino.',
				creationDate: '2021-04-16T17:20:25+0200',
				changed: '2021-04-16T17:22:34+0200',
				duration: '240',
				format: 'text',
				cover:
					'https://d22cxfqtum6m93.cloudfront.net/media/2021-04/apple.jpeg?VersionId=LEW3S2lDQ3s3zdH4r3H8HhJyO6WEmtQE',
				type: 'news',
				needs: [
					{
						id: null,
						name: null,
					},
				],
				cohorts: [
					{
						id: '17',
						name: 'Cohort 1',
					},
				],
			},
			{
				itemId: '65',
				title:
					'Monitoraggio Iss, l’indice Rt nazionale cala a 0,85. Terapie intensive ancora critiche: 16 regioni a rischio moderato',
				body:
					'Buone notizie dal monitoraggio settimanale dell’Istituto superiore di sanità e del ministero della Salute: la pandemia di Coronavirus, in Italia, sta allentando la morsa. L’indice Rt nazionale, valore che descrive il tasso di contagiosità del virus, negli ultimi sette giorni è infatti sceso a 0,85. Una settimana fa si attestava a 0,92, due settimane fa a 0,98 e tre settimane fa a 1,08. In un mese, anche grazie alle restrizioni adottate a marzo e aprile, l’indice si è quindi contratto di 0,23 punti.\r\n\r\n \r\n\r\nLe regioni con un indice Rt maggiore di 1 sono cinque, contro le otto della settimana precedente. Si tratta di Basilicata, Sardegna, Sicilia, Toscana e Valle d’Aosta. Tra queste, la Sardegna ha una trasmissibilità compatibile con uno scenario di tipo 3, caratterizzato cioè da rischi di tenuta del sistema sanitario nel medio periodo. Sicilia e Valle d’Aosta hanno una trasmissibilità compatibile con uno scenario di tipo 2, ovvero gestibile dal sistema sanitario nel breve e nel medio periodo. Mentre le altre regioni hanno una trasmissibilità compatibile con uno scenario di tipo 1, vale a dire sostanzialmente localizzata (Rt inferiore a 1).',
				creationDate: '2021-04-16T17:18:24+0200',
				changed: '2021-04-16T17:19:47+0200',
				duration: '150',
				format: 'text',
				cover:
					'https://d22cxfqtum6m93.cloudfront.net/media/2021-04/iss.jpg?VersionId=l24ipH.5KtlLdZlOv7xr8Y6gKPSlQL48',
				type: 'news',
				needs: [
					{
						id: null,
						name: null,
					},
				],
				cohorts: [
					{
						id: '17',
						name: 'Cohort 1',
					},
				],
			},
			{
				itemId: '64',
				title:
					'Ponte Morandi a rischio crollo dal 2013, il controllore intercettato: «Mi hanno chiesto un’analisi, ma io a Genova non ci sono mai stato»',
				body:
					'Dal 2013 il Ponte Morandi di Genova era classificato nei documenti di Autostrade per l’Italia, come a rischio crollo, per via delle ritardate manutenzioni di cui la stessa società era a conoscenza. In più l’uomo che si è occupato di stilare il report di valutazione sullo stato del Ponte Morandi, Roberto Salvi, non aveva mai visto il viadotto dal vivo e a Genova non c’era mai stato. «Io non ci ero mai andato a Genova a vedere questo ponte. Mi hanno detto: “Fai l’analisi dei rischi catastrofali”. E io: “ok”», si sente dire nelle intercettazioni tra il membro operativo del risk management di Autostrade e suo padre, il 28 marzo 2019.\r\n\r\n \r\n\r\nIl tono di voce era agitato. Salvi – che non risulta indagato – aveva appena ricevuto la visita della Guardia di finanza: le Fiamme gialle volevano comprendere meglio i criteri alla base del Catalogo dei rischi aziendali di Atlantia. Il dirigente di Autostrade, nello sfogo intercettato con il padre, ha spiegato esattamente quello che cercavano di capire gli agenti: «Mi sono posto il problema e sono andato da quello che si occupa dei ponti. Gli ho chiesto: dov’è che potrebbe avvenire una catastrofe? Lui mi ha aperto il computer e mi ha fatto vedere: “Ecco, qui” – riferito al Morandi -. Finito. È così che è nata”». Il catalogo dei rischi è un elemento ritenuto fondamentale dalla procura di Genova per le indagini.',
				creationDate: '2021-04-16T17:16:09+0200',
				changed: '2021-04-16T17:18:04+0200',
				duration: '180',
				format: 'text',
				cover:
					'https://d22cxfqtum6m93.cloudfront.net/media/2021-04/pmorandi.jpg?VersionId=QzCvqo5mPLKDzC4YkBUfHIKwKt2OVaEl',
				type: 'news',
				needs: [
					{
						id: null,
						name: null,
					},
				],
				cohorts: [
					{
						id: '17',
						name: 'Cohort 1',
					},
				],
			},
			{
				itemId: '63',
				title:
					'Ciciliano (Cts): «Riaperture? Frutto di un’esigenza politica. I dati non ci aiutano» – L’intervista',
				body:
					'Dopo il Benin invaso dall’emergenza Aids, dopo l’esplosione del reattore di Fukushima, dopo l’epidemia di colera ad Haiti e il terremoto in Iran, il dirigente medico della Polizia di Stato Fabio Ciciliano, un anno fa, è corso in Italia per dare aiuto in quella che definisce «la situazione più difficile che abbia mai dovuto gestire». Membro della prima ora del Comitato tecnico scientifico per l’emergenza Covid-19 del nostro Paese, fu chiamato dall’ex capo della Polizia Gabrielli, ora sottosegretario alla presidenza del Consiglio scelto da Mario Draghi, per far parte del primo gruppo di esperti incaricato di guidare la nave in tempesta.\r\n\r\n \r\n\r\nEsperto in medicina delle catastrofi, per un anno segretario del Comitato, è rimasto tra i componenti anche del nuovo Cts voluto da Draghi, ora in rappresentanza del Dipartimento della Protezione Civile. Oggi, insieme altri altri 10 membri, deciderà da un punto di vista tecnico e scientifico, se le proposte di riaperture di bar, ristoranti, piscine e stadi, avanzate ieri dalle Regioni italiane, potranno essere approvate.',
				creationDate: '2021-04-16T17:13:43+0200',
				changed: '2021-04-16T17:15:49+0200',
				duration: '120',
				format: 'text',
				cover:
					'https://d22cxfqtum6m93.cloudfront.net/media/2021-04/ciciliano.jpg?VersionId=RL6ldHmNR1RHFTN3Ma0P0ofbupAdi3Y2',
				type: 'news',
				needs: [
					{
						id: null,
						name: null,
					},
				],
				cohorts: [
					{
						id: '17',
						name: 'Cohort 1',
					},
				],
			},
			{
				itemId: '62',
				title:
					'La conferenza stampa di Draghi: «Riapriamo dal 26. Prima scuole e attività all’aperto. È un rischio calcolato»',
				body:
					'«La decisione di oggi anticipa al 26 di questo mese l’introduzione della zona gialla, ma introduce un cambiamento rispetto al passato. Si dà la precedenza alle attività all’aperto e alle scuole», ha dichiarato il presidente del Consiglio Mario Draghi in conferenza stampa. «Con la decisione di oggi – ha aggiunto il premier – il governo ha preso un rischio ragionato e fondato sui dati che sono in miglioramento, ma non in modo drammatico. Questo rischio che incontra le aspettative dei cittadini si fonda su una premessa: quei provvedimenti che governano il comportamento nelle attività riaperte vanno osservati scrupolosamente».',
				creationDate: '2021-04-16T17:07:55+0200',
				changed: '2021-04-16T17:12:31+0200',
				duration: '180',
				format: 'text',
				cover:
					'https://d22cxfqtum6m93.cloudfront.net/media/2021-04/mdraghi.jpg?VersionId=RbIXjK4OWwg6gqf0VWuIdT7emIzwS9ZC',
				type: 'news',
				needs: [
					{
						id: null,
						name: null,
					},
				],
				cohorts: [
					{
						id: '17',
						name: 'Cohort 1',
					},
				],
			},
			{
				itemId: '46',
				title: 'Benvenuto sul nuovo Skills4Capital',
				body:
					'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
				creationDate: '2021-03-19T11:45:51+0100',
				changed: '2021-03-19T11:47:21+0100',
				duration: '180',
				format: 'text',
				cover:
					'https://d22cxfqtum6m93.cloudfront.net/media/2021-03/winter.jpg?VersionId=uVmZ_kpdmd_hIgBRE8pTgpgg8lJazDjd',
				type: 'news',
				needs: [
					{
						id: '20',
						name: 'Accesso al credito',
					},
				],
				cohorts: [
					{
						id: '17',
						name: 'Cohort 1',
					},
				],
			},
		],
		resultCode: 200,
		errorManagement: null,
	});

export const getPlaylistsMock = () =>
	getBaseResponse({
		appName: "S4B",
		errorManagement: null,
		errorResponse: null,
		requestId: "e0b47f3c-747b-450a-9059-122433250329",
		resultCode: 200,
		success: true,
		yourPathProgress: {
			collection: {
				items: [
					{
						body: "Come il lean management può cambiare il tuo business\r\n",
						completed: false,
						cover: "https://medias4b2sit.ispfdevelop.com/media/2022-12/lean%20management.jpg?VersionId=4uXK2CNgn9WaDaQBqDExnY.VEh.9_9Pf",
						description: null,
						itemId: "76",
						numberOfContents: 5,
						numberOfContentsCompleted: 0,
						progress: "1/5",
						sessionTime: "00:00:00",
						title: "Il lean management ",
						totalDuration: "00:33:00",
						totalDurationSec: 1980,
						type: "COLLECTION",
						weight: null
					},
					{
						body: null,
						completed: false,
						cover: "https://medias4b2sit.ispfdevelop.com/media/2022-03/sostenibilita-sostenibile_thumb_720_405_0.jpg?VersionId=xoJqLrnr5ruZ4Ge5zjbS.ZMIfEVTD9jW",
						description: null,
						itemId: "175",
						numberOfContents: 3,
						numberOfContentsCompleted: 0,
						progress: "0/3",
						sessionTime: "00:00:00",
						title: "1A. Politiche ESG",
						totalDuration: "00:15:00",
						totalDurationSec: 900,
						type: "COLLECTION",
						weight: null
					},
					{
						body: null,
						completed: false,
						cover: "https://medias4b2sit.ispfdevelop.com/media/2022-03/sostenibilita-sostenibile_thumb_720_405_0.jpg?VersionId=xoJqLrnr5ruZ4Ge5zjbS.ZMIfEVTD9jW",
						description: null,
						itemId: "176",
						numberOfContents: 5,
						numberOfContentsCompleted: 0,
						progress: "0/5",
						sessionTime: "00:00:00",
						title: "1B - Strategie ESG",
						totalDuration: "00:49:00",
						totalDurationSec: 2940,
						type: "COLLECTION",
						weight: null
					},
					{
						body: null,
						completed: false,
						cover: "https://medias4b2sit.ispfdevelop.com/media/2022-03/sostenibilita-sostenibile_thumb_720_405_0.jpg?VersionId=xoJqLrnr5ruZ4Ge5zjbS.ZMIfEVTD9jW",
						description: null,
						itemId: "177",
						numberOfContents: 2,
						numberOfContentsCompleted: 0,
						progress: "0/2",
						sessionTime: "00:00:00",
						title: "2. Requirements ESG",
						totalDuration: "00:10:00",
						totalDurationSec: 600,
						type: "COLLECTION",
						weight: null
					},
					{
						body: null,
						completed: false,
						cover: "https://medias4b2sit.ispfdevelop.com/media/2022-03/sostenibilita-sostenibile_thumb_720_405_0.jpg?VersionId=xoJqLrnr5ruZ4Ge5zjbS.ZMIfEVTD9jW",
						description: null,
						itemId: "180",
						numberOfContents: 2,
						numberOfContentsCompleted: 0,
						progress: "0/2",
						sessionTime: "00:00:00",
						title: "3. Performance e competitività ESG",
						totalDuration: "00:10:00",
						totalDurationSec: 600,
						type: "COLLECTION",
						weight: null
					},
					{
						body: null,
						completed: false,
						cover: "https://medias4b2sit.ispfdevelop.com/media/2022-03/sostenibilita-sostenibile_thumb_720_405_0.jpg?VersionId=xoJqLrnr5ruZ4Ge5zjbS.ZMIfEVTD9jW",
						description: null,
						itemId: "182",
						numberOfContents: 2,
						numberOfContentsCompleted: 0,
						progress: "0/2",
						sessionTime: "00:00:00",
						title: "4. Rendicontazione e comunicazione ESG",
						totalDuration: "00:10:00",
						totalDurationSec: 600,
						type: "COLLECTION",
						weight: null
					},
					{
						body: null,
						completed: false,
						cover: "https://medias4b2sit.ispfdevelop.com/media/2022-11/documenti%20vari.jpg?VersionId=_aUEhXaV_jIUzUG5KCvIZQj4tMMiyl3P",
						description: null,
						itemId: "205",
						numberOfContents: 1,
						numberOfContentsCompleted: 0,
						progress: "0/1",
						sessionTime: "00:00:00",
						title: "Link utili e approfondimenti",
						totalDuration: "00:05:00",
						totalDurationSec: 300,
						type: "COLLECTION",
						weight: null
					}
				],
				percentage: "0",
				progress: "0/7"
			},
			event: {
				items: [],
				percentage: "0",
				progress: "0/0"
			},
			selection: {
				items: [{
					body: "Come il lean management può cambiare il tuo business\r\n",
					completed: false,
					cover: "https://medias4b2sit.ispfdevelop.com/media/2022-12/lean%20management.jpg?VersionId=4uXK2CNgn9WaDaQBqDExnY.VEh.9_9Pf",
					description: null,
					itemId: "76",
					numberOfContents: 5,
					numberOfContentsCompleted: 0,
					progress: "1/5",
					sessionTime: "00:00:00",
					title: "Il lean managementaaaa a aaaa a a ",
					totalDuration: "00:33:00",
					totalDurationSec: 1980,
					type: "COLLECTION",
					weight: null
				},],
				percentage: "0",
				progress: "0/0"
			}
		}
	});

export const getFiveMinCardsMock = () => ({
	virtualClassrooms: [
		{
			title: 'Il business agricolo',
			startDate: '2021-09-07T08:30',
			endDate: '2021-09-09T17:30',
			image: imgTestLarge,
		},
		{
			title: 'Il business agricolo',
			startDate: '2021-09-07T08:30',
			endDate: '2021-09-09T17:30',
			image: imgTestLarge,
		},
		{
			title: 'Il business agricolo',
			startDate: '2021-09-07T08:30',
			endDate: '2021-09-09T17:30',
			image: imgTestLarge,
		},
		{
			title: 'Il business agricolo',
			startDate: '2021-09-07T08:30',
			endDate: '2021-09-09T17:30',
			image: imgTestLarge,
		},
	],
});

export const getPlaylistMock = () =>
	getBaseResponse({
		response: {
			body: "Come il lean management può cambiare il tuo business\r\n",
			bookmarked: false,
			completedLo: 0,
			coursesCount: 5,
			cover: "https://medias4b2sit.ispfdevelop.com/media/2022-12/lean%20management.jpg?VersionId=4uXK2CNgn9WaDaQBqDExnY.VEh.9_9Pf",
			feedback: null,
			finalTestAvailable: false,
			idSurvey: null,
			itemId: 76,
			listOfLo: [
				{
					body: "Primi suggerimenti pratici per l’introduzione del lean management in azienda\r\n• Visual management\r\n• 5 S\r\n• ….",
					completed: false,
					cover: "https://medias4b2sit.ispfdevelop.com/media/2022-12/lean%20management.jpg?VersionId=4uXK2CNgn9WaDaQBqDExnY.VEh.9_9Pf",
					creationDate: "2021-12-21T16:17:18+0100",
					duration: "300",
					finalTest: false,
					format: null,
					fruitionLocked: false,
					itemId: "71",
					resourceType: null,
					title: "Visual management e 5s: i primi passi nel lean management",
					type: "learning_object",
					videoId: "6085264627001",
					videoUrl: null
				},
				{
					body: "La rappresentazione grafica del flusso lean.\r\nL’importanza di rappresentare graficamente il processo, anche per agevolare l’individuazione delle aree di miglioramento",
					completed: false,
					cover: "https://medias4b2sit.ispfdevelop.com/media/2023-02/mappatura%20del%20flusso%20di%20lean%20%281%29.jpg?VersionId=cnXO9eZpQ.s6heLjuZqEGfuTDUkzVltP",
					creationDate: "2021-12-21T16:17:58+0100",
					duration: "240",
					finalTest: false,
					format: null,
					fruitionLocked: false,
					itemId: "72",
					resourceType: null,
					title: "Mappatura del flusso di valore, rappresentazione grafica del lean",
					type: "learning_object",
					videoId: "6085263605001",
					videoUrl: null
				},
				{
					body: "Come l’organizzazione lean impatta sulla gestione delle persone",
					completed: false,
					cover: "https://medias4b2sit.ispfdevelop.com/media/2022-12/lean%20management.jpg?VersionId=4uXK2CNgn9WaDaQBqDExnY.VEh.9_9Pf",
					creationDate: "2021-12-21T16:19:05+0100",
					duration: "240",
					finalTest: false,
					format: null,
					fruitionLocked: false,
					itemId: "74",
					resourceType: null,
					title: "Lean management e persone",
					type: "learning_object",
					videoId: "6085263603001",
					videoUrl: null
				},
				{
					body: "REQUIREMENTS ESG: ANALISI DELLA PROPRIA AZIENDA",
					completed: false,
					cover: "https://medias4b2sit.ispfdevelop.com/media/2022-03/prova_banner%20%281%29.png?VersionId=MGWccd7V_uElnzl5hpmyLtT1W40SrQ5f",
					creationDate: "2022-11-07T15:22:12+0100",
					duration: "300",
					finalTest: false,
					format: null,
					fruitionLocked: false,
					itemId: "149",
					resourceType: null,
					title: "Self Learning: analisi della propria azienda",
					type: "learning_object",
					videoId: null,
					videoUrl: "https://los4b2sit.ispfdevelop.com/los/libraries/gate.html?d=%2Flos%2F21155%2Findex.html%09%3F%09endpoint%3Dhttps%3A%2F%2Fs4b2api.ispfdevelop.com%2Ftracking%2Fproxy%2F%09%26auth%3D{VALUE}%09%26Accept-Language%3Dit%09%26actor%3D%7B%22mbox%22%3A%22mailto%3Ademo-frutore-internal-001%40yopmail.com%22%2C%22name%22%3A%22Mario+Rossi%22%7D%09%26activity_id%3Dhttps%3A%2F%2Fintesasanpaoloformazione.com%2Fs4b149&t={VALUE}"
				},
				{
					body: null,
					completed: false,
					cover: "https://medias4b2sit.ispfdevelop.com/media/2022-03/prova_banner%20%281%29.png?VersionId=MGWccd7V_uElnzl5hpmyLtT1W40SrQ5f",
					creationDate: "2022-11-11T17:45:24+0100",
					duration: "900",
					finalTest: false,
					format: null,
					fruitionLocked: false,
					itemId: "186",
					resourceType: null,
					title: "Mettiti alla prova!",
					type: "learning_object",
					videoId: null,
					videoUrl: "https://los4b2sit.ispfdevelop.com/los/libraries/gate.html?d=%2Flos%2F21100%2Fassessment%2Findex.html%09%3F%09endpoint%3Dhttps%3A%2F%2Fs4b2api.ispfdevelop.com%2Ftracking%2Fproxy%2F%09%26auth%3D{VALUE}%09%26Accept-Language%3Dit%09%26actor%3D%7B%22mbox%22%3A%22mailto%3Ademo-frutore-internal-001%40yopmail.com%22%2C%22name%22%3A%22Mario+Rossi%22%7D%09%26activity_id%3Dhttps%3A%2F%2Fintesasanpaoloformazione.com%2Fs4b186&t={VALUE}"
				}
			],
			locked: false,
			needId: 20,
			progress: "0/5",
			recommended: false,
			reviewed: false,
			reviews: [],
			survey: null,
			surveyCompleted: false,
			title: "Il lean management ",
			totalLo: 5,
			trailer: null,
			type: "collection"
		},
		resultCode: 200,
		success: true
	});

export const getBookmarksMock = () =>
	getBaseResponse(
		{
			appName: 'S4B',
			requestId: 'c4a42636-bbd5-44d4-8c86-cbf71b87e29c',
			success: true,
			bookmarkList: [
				{
					bookId: 'e550fd55-8a0b-4b17-b31a-3270db4ce4f0',
					itemId: '18',
					userId: '60fd1284-0dd5-4bc7-a2bc-82e2e7c9c03c',
					type: 'collection',
					title: 'Big data',
					imageUrl:
						'https://d22cxfqtum6m93.cloudfront.net/media/2021-05/Collection%203.jpeg?VersionId=GEBsvmvfmRCW.LDse.xWoysUNgOqS5LQ',
					duration: '0',
					coursesCount: 7,
					completed: 'true',
				},
				{
					bookId: "9e223bef-2dd8-48ba-a3ec-c7d28f840223",
					itemId: "76",
					userId: "f228a48e-daa8-40f8-be44-3fa3df735837",
					type: "collection",
					title: "Il lean management ",
					imageUrl: "https://medias4b2sit.ispfdevelop.com/media/2022-12/news%206%202312.png?VersionId=az5U3TKC6vmJYgeEQRRoblCd8fxAV6Yd",
					duration: "1980",
					format: "text"
				},
				{
					bookId: "9e223bef-2dd8-48ba-a3ec-c7d28f840332",
					itemId: "221",
					userId: "f228a48e-daa8-40f8-be44-3fa3df735837",
					type: "news",
					title: "Nuovi rigassificatori e più rinnovabili: la ricetta contro il caro-energia",
					imageUrl: "https://medias4b2sit.ispfdevelop.com/media/2022-12/news%206%202312.png?VersionId=az5U3TKC6vmJYgeEQRRoblCd8fxAV6Yd",
					duration: "300",
					format: "text"
				},
				{
					bookId: "6ef8516e-dabb-454a-a27c-b5fdbac2d65b",
					itemId: "105",
					userId: "f228a48e-daa8-40f8-be44-3fa3df735837",
					type: "learning_object",
					title: "POLITICHE E STRATEGIE ESG: ANALISI DELLA PROPRIA AZIENDA",
					imageUrl: "https://medias4b2sit.ispfdevelop.com/media/2022-12/Practice.jpeg?VersionId=cTmUw_czmir3DRDmh5yqQAuOVjNheL8D",
					duration: "900",
					completed: "true"
				},
				{
					bookId: "e550fd55-8a0b-4b17-b31a-3270db4ce4f0",
					completed: "true",
					coursesCount: 7,
				},
				{
					bookId: '1985e7ce-7f45-49ec-b984-89d807893d26',
					itemId: '83',
					userId: '60fd1284-0dd5-4bc7-a2bc-82e2e7c9c03c',
					type: 'news',
					title:
						'Circular economy, al via quarta edizione contest nazionale di SeedUp',
					imageUrl:
						'https://d22cxfqtum6m93.cloudfront.net/media/2021-04/CircularEconomy.jpg?VersionId=cH8pvnGFVhMI320e1HZIsADdIykaBdOk',
					duration: '120',
					format: 'text',
				},
				{
					bookId: '29e663c9-3d44-44b1-9f0b-141a01fec67c',
					itemId: '518',
					userId: '60fd1284-0dd5-4bc7-a2bc-82e2e7c9c03c',
					type: 'learning_object',
					title:
						'Usa realtà aumentata e virtuale per il tuo business enogastronomico',
					imageUrl:
						'https://d22cxfqtum6m93.cloudfront.net/media/2021-05/32.9.PNG?VersionId=zyocSD9lT3zAyCsRGM1bq0KYsSIDaYf7',
					duration: '180',
					completed: 'false',
					format: 'video',
				},
				{
					bookId: '17286659-98d1-47bb-abe2-7f5bafeb58cb',
					itemId: '219',
					userId: '60fd1284-0dd5-4bc7-a2bc-82e2e7c9c03c',
					type: 'learning_object',
					title: 'Fatturazione elettronica: quali opportunità',
					imageUrl:
						'https://d22cxfqtum6m93.cloudfront.net/media/2021-05/14.4.PNG?VersionId=6SdSXqorflKAkzT0MgehWAhTEBI7VDCJ',
					duration: '120',
					completed: 'false',
					format: 'video',
				},
			],
			resultCode: 200,
		},
		200,
		'ok'
	);

export const addBookmarkMock = () =>
	getBaseResponse(
		{
			appName: 'S4B',
			requestId: 'cf8756c0-817d-4f18-9d9c-daea7a26bf07',
			success: true,
			bookmark: {
				bookId: 'd85325be-ebd1-4fd4-b11d-858b6382aaa5',
				itemId: '157',
				userId: '88b0d09a-0cea-46a3-9e21-a2438dfb632e',
				type: 'news',
				title: 'Come Presentare Un Progetto di Investimento',
				imageUrl: imgTest,
				duration: '0',
				coursesCount: 6,
				completed: false,
			},
			resultCode: 200,
		},
		200,
		'ok'
	);

export const removeBookmarkMock = () =>
	getBaseResponse(
		{
			appName: 'S4B',
			requestId: 'b815fd0e-1b0f-4d13-9cf9-4990fc0e950f',
			success: true,
			resultCode: 200,
		},
		200,
		'ok'
	);

export const removeBookmarkByIdMock = () =>
	getBaseResponse(
		{
			appName: 'S4B',
			requestId: '2b041319-5e1c-4563-8dc9-cfd40d146859',
			success: true,
			resultCode: 200,
		},
		200,
		'ok'
	);

export const getNotesMock = () =>
	getBaseResponse({
		appName: 'S4B',
		requestId: '2e774a13-24e1-400d-83ca-45ffe59a1106',
		success: true,
		errorResponse: null,
		notes: [
			{
				id: '9ec828e8-6d1c-49be-a638-8729ab1e9a71',
				title: 'Il tuo territorio è ok per il turismo enogastronomico?',
				body: 'Marcello Utente ha scritto la nota\nmodificata',
				owner: {
					userId: '663ad702-898d-45f4-b3b3-3e785f0f220e',
					givenName: 'Marcello',
					familyName: 'utente',
					imageUrl: null,
				},
				users: [
					{
						userId: '4c32eebd-2e84-4706-9647-bb895c76bd0a',
						givenName: 'Marcello',
						familyName: 'Scanavino',
						imageUrl: null,
					},
				],
				dateCreate: '2021-10-20T19:23:26.943',
				comments: [
					{
						id: 'e7612d3a-59fd-459d-a98b-d4f51d7e326d',
						idNote: '9ec828e8-6d1c-49be-a638-8729ab1e9a71',
						owner: {
							userId: '4c32eebd-2e84-4706-9647-bb895c76bd0a',
							givenName: 'Marcello',
							familyName: 'Scanavino',
							imageUrl: null,
						},
						body: 'veramente bello',
						pic: null,
						dateCreate: '2021-10-21T11:05:17.833',
					},
					{
						id: '977ff456-60ab-446f-8950-1968b2ac2c06',
						idNote: '9ec828e8-6d1c-49be-a638-8729ab1e9a71',
						owner: {
							userId: '663ad702-898d-45f4-b3b3-3e785f0f220e',
							givenName: 'Marcello',
							familyName: 'utente',
							imageUrl: null,
						},
						body: "Commento dell'utente taggato",
						pic: null,
						dateCreate: '2023-02-18T20:21:26.875',
					},
				],
				lastUpdateDate: '2021-10-21T11:08:26.875',
				imageUrl: null,
			},
			{
				id: '4177ad1c-7273-4d3e-bddf-515d3d5cf893',
				title: 'Nota solo mia',
				body: 'testo',
				owner: {
					userId: '4c32eebd-2e84-4706-9647-bb895c76bd0a',
					givenName: 'Marcello',
					familyName: 'Scanavino',
					imageUrl: null,
				},
				users: [],
				dateCreate: '2021-10-21T12:54:15.238',
				comments: [],
				lastUpdateDate: '2021-10-21T12:54:15.238',
				imageUrl: null,
			},
			{
				id: 'f66d9312-8abf-4810-9dc3-490f7d91c0ba',
				title: 'note con img',
				body: 'condivisa',
				owner: {
					userId: '4c32eebd-2e84-4706-9647-bb895c76bd0a',
					givenName: 'Marcello',
					familyName: 'Scanavino',
					imageUrl: null,
				},
				users: [
					{
						userId: '2e96df55-933c-41c5-9044-9c6643036d6f',
						givenName: 'Mario',
						familyName: 'Rossi',
						imageUrl: null,
					},
				],
				dateCreate: '2021-10-14T17:55:01.160',
				comments: [],
				lastUpdateDate: '2021-10-14T12:53:58.024',
				imageUrl:
					'https://los4b2sit.ispfdevelop.com/images/notes/4c32eebd-2e84-4706-9647-bb895c76bd0a_2021-10-21T10:53:56.547740Z.jpg',
			},
		],
		nextPage: null,
		items: 10,
		nextPagePresent: false,
		resultCode: 200,
		errorManagement: null,
	});

export const addNoteMock = () =>
	getBaseResponse(
		{
			appName: 's4b',
			requestId: '6a766916-4d93-4064-981c-38735998fe79',
			success: true,
			errorResponse: null,
			id: '122d0fd3-6d4f-4bd6-8ecc-42e3f478e11d',
			title: 'Nota da modificare',
			body: '',
			owner: {
				userId: '44a3ce0c-277f-44f1-9a7c-f65a42a2d32c',
				givenName: '',
				familyName: '',
				imageUrl: null,
			},
			imageUrl: 'pic.gif',
			users: [],
			dateCreate: '2021-02-18T09:59:24.396',
			comments: null,
			resultCode: 200,
			errorManagement: null,
			lastUpdateDate: '2021-02-18T09:59:24.396',
		},
		200,
		'ok'
	);

const addWorkoutMock = addNoteMock;
export { addWorkoutMock };

export const editNoteMock = () =>
	getBaseResponse(
		{
			appName: 's4b',
			requestId: '85d2023a-393d-4288-a031-c4c57f1042b7',
			success: true,
			errorResponse: null,
			id: 'cbb0f82d-7569-4a68-b47e-1bd0ad659087',
			title: 'Nota modificata',
			body:
				'[updated] Chi riceve e gestisce il cliente (o chi risponde al telefono), ha una grande responsabilità. Un cliente ben accolto avrà da subito una percezione positiva del luogo in cui si trova (in azienda, al centralino, in uno studio professionale, in ambulatorio, in accettazione, in hotel, albergo, reception, agenzia, negozio o punti vendita, farmacia e altro), con tutto ciò che di positivo ne consegue. La prima impressione infatti condizionerà i suoi comportamenti e le scelte successive.',
			owner: {
				userId: '3e670af7-e7e4-4928-ac59-0c8a2e277e5d',
				givenName: 'Marcello',
				familyName: 'Scanavino',
				imageUrl: null,
			},
			imageUrl: 'myBeautifulNewPic',
			partecipants: [],
			dateCreate: '2021-04-27T10:26:42.136',
			comments: null,
			resultCode: 200,
			errorManagement: null,
			lastUpdateDate: '2021-04-27T10:57:06.765',
		},
		200,
		'ok'
	);

export const addPartecipantsMock = () =>
	getBaseResponse(
		{
			appName: 's4b',
			requestId: '0036cf6a-1b10-4a76-801c-7f0b3babe2b9',
			success: true,
			errorResponse: null,
			id: '178e36a8-dc89-4b7b-9d22-a56f316e1826',
			title: 'Nota modificata',
			body:
				'[updated] Chi riceve e gestisce il cliente (o chi risponde al telefono), ha una grande responsabilità. Un cliente ben accolto avrà da subito una percezione positiva del luogo in cui si trova (in azienda, al centralino, in uno studio professionale, in ambulatorio, in accettazione, in hotel, albergo, reception, agenzia, negozio o punti vendita, farmacia e altro), con tutto ciò che di positivo ne consegue. La prima impressione infatti condizionerà i suoi comportamenti e le scelte successive.',
			owner: {
				userId: 'a170b648-a019-4c7b-92b7-3435cbb1cae9',
				givenName: 'Gabriel',
				familyName: 'Wanduragala',
				imageUrl:
					'https://los4b2sit.ispfdevelop.com/images/profile/a170b648-a019-4c7b-92b7-3435cbb1cae9_2021-05-07T14:55:58.390958Z.png',
			},
			imageUrl: 'myBeautifulNewPic',
			partecipants: [
				{
					userId: 'd87c8e0d-416b-45a2-8a99-7323a5bbd184',
					givenName: 'Simona',
					familyName: 'Di iorio',
					imageUrl: null,
				},
			],
			dateCreate: '2021-05-10T12:04:28.927',
			comments: null,
			resultCode: 200,
			errorManagement: null,
			lastUpdateDate: '2021-05-10T15:37:03.753',
		},
		200,
		'ok'
	);

export const addCommentMock = () =>
	getBaseResponse(
		{
			appName: 's4b',
			requestId: 'ee9fdd08-ff74-4294-ab93-e1fed08036fe',
			success: true,
			errorResponse: null,
			id: '9ec828e8-6d1c-49be-a638-8729ab1e9a71',
			title: 'Il tuo territorio è ok per il turismo enogastronomico?',
			body: 'Marcello Utente ha scritto la nota\nmodificata',
			owner: {
				userId: '663ad702-898d-45f4-b3b3-3e785f0f220e',
				givenName: 'Marcello',
				familyName: 'utente',
				imageUrl: null,
			},
			imageUrl: null,
			partecipants: [
				{
					userId: '4c32eebd-2e84-4706-9647-bb895c76bd0a',
					givenName: 'Marcello',
					familyName: 'Scanavino',
					imageUrl: null,
				},
			],
			dateCreate: '2021-10-20T17:27:26.943',
			comments: [
				{
					id: 'e7612d3a-59fd-459d-a98b-d4f51d7e326d',
					idNote: '9ec828e8-6d1c-49be-a638-8729ab1e9a71',
					owner: {
						userId: '4c32eebd-2e84-4706-9647-bb895c76bd0a',
						givenName: 'Marcello',
						familyName: 'Scanavino',
						imageUrl: null,
					},
					body: 'veramente bello',
					pic: null,
					dateCreate: '2021-10-21T11:05:17.833',
				},
				{
					id: '977ff456-60ab-446f-8950-1968b2ac2c06',
					idNote: '9ec828e8-6d1c-49be-a638-8729ab1e9a71',
					owner: {
						userId: '663ad702-898d-45f4-b3b3-3e785f0f220e',
						givenName: 'Marcello',
						familyName: 'utente',
						imageUrl: null,
					},
					body: "Commento dell'utente taggato",
					pic: null,
					dateCreate: '2021-10-21T11:08:26.875',
				},
				{
					id: 'efd1f26e-3993-4ca3-8094-f33e104b0772',
					idNote: '9ec828e8-6d1c-49be-a638-8729ab1e9a71',
					owner: {
						userId: '663ad702-898d-45f4-b3b3-3e785f0f220e',
						givenName: 'Marcello',
						familyName: 'utente',
						imageUrl: null,
					},
					body: 'Nuovo commento',
					pic: null,
					dateCreate: '2021-10-22T12:48:24.894',
				},
			],
			resultCode: 200,
			errorManagement: null,
			lastUpdateDate: '2021-10-22T12:48:24.894',
		},
		200,
		'ok'
	);

export const getNotesDetailMock = () => ({
	appName: 's4b',
	requestId: '1e90460f-8e3e-47ae-9fa8-ca4e5fdf3f69',
	success: true,
	errorResponse: null,
	id: 'c2f599bc-bcb4-4dce-9db2-7e5f6ef5d6d7',
	title: 'Titolo ',
	body: 'Body',
	owner: {
		userId: 'e2ca88c2-20b3-4c7b-8d7a-161de212f070',
		givenName: '',
		familyName: '',
		imageUrl: null,
	},
	imageUrl: 'https….',
	partecipants: [
		{
			userId: '836e7b89-bb6a-40f4-8156-ee9809921294',
			givenName: 'Persona',
			familyName: 'Uno',
			imageUrl: imgTest,
		},
		{
			userId: '44a3ce0c-277f-44f1-9a7c-f65a42a2d32c',
			givenName: 'Tizio',
			familyName: 'Due',
			imageUrl: null,
		},
	],
	dateCreate: '2021-02-10T12:58:05.705',
	comments: [],
	resultCode: 200,
	errorManagement: null,
	lastUpdateDate: '2021-02-10T12:58:05.705',
});

export const getNewsMock = () =>
getBaseResponse({
	itemId:"216",
	title:"4G e 5G fondamentali per affrontare la crescita della domanda energetica",
	body:"La domanda di energia elettrica globale cresce del 2% all' anno e il mix dei consumi va ricalibrato per allargare il ruolo delle rinnovabili.\r\n\r\nLa connettività ha un ruolo centrale nella gestione del processo di approvvigionamento. La connettività cellulare fondamentale per tenere sotto controllo e abbattere al massimo la domanda di energia elettrica.\r\n\r\nRuolo centrale per diversificare l' uso delle rinnovabili va certamente alla digitalizzazione delle reti elettriche, per mettere i \"prosumers\" nelle condizioni di ottimizzare l' approvvigionamento energetico. E' questo in estrema sintesi il messaggio di un report realizzato da Ericsson in tandem con Arthur D. Little dal titolo Connected Energy Utilities 5G per mitigare la complessità del mix energetico Di pari passo con la crescente domanda energetica e con gli aumenti esponenziali dei prezzi, il report propone una visione del settore in cui la connettività, in particolare 5G, prende piede per mitigare al massimo la crescente complessità di una domanda crescente. L' obiettivo è ottimizzare ed espandere la capacità delle reti, l' affidabilità del grid potenziandone l' affidabilità. Cambia in prospettiva il mix energetico, per includere sempre di più nuove fonti rinnovabili. Sul fronte della sicurezza, invece, cresce la minaccia cyber alle infrastrutture critiche energetiche. Domanda di energia +2% all' anno per i prossimi 20 anni Con la domanda di elettricità in crescita secondo l' , l' Agenzia Internazionale dell' Energia, a un tasso di crescita annuale composto (CAGR) previsto del 2% nei prossimi due decenni, il rapporto rileva che i fornitori di servizi pubblici devono investire in nuove tecnologie per soddisfare queste richieste e servire al meglio i consumatori. La tecnologia Ericsson fornisce servizi di gestione per reti private, infrastrutture pubbliche mission-critical e implementazioni IoT. E proprio l' IoT, l' intelligenza artificiale, l' automazione e la blockchain sono le tecnologie più ricercate per la trasformazione digitale delle reti energetiche. Nei prossimi 10 anni il 4G sarà la tecnologia wireless deputata a gestire il grosso della digitalizzazione delle reti, in prospettiva questo ruolo sarà adottato dal 5G.",
	duration:"300",
	cover:"https://medias4b2sit.ispfdevelop.com/media/2022-12/news%201%2023.12.png?VersionId=xVeUGGtDHEA7SsS85L36ZHwFAtLKar0Y",
	creationDate:"2022-12-23T17:32:44+0100",
	reviewed:false,
	reviews:[

	],
	feedback:{
	  idCourseType:null,
	  views:6,
	  positive:0,
	  negative:0,
	  currentUserVote:-1,
	  title:null
	},
	bookmarked:false,
	format:"text",
	type:"news"
  });

export const getCourseMock = () =>
	getBaseResponse({"completed":false,"title":"Soft Skill Per Il Lavoro Digitale","cover":"https://medias4b2sit.ispfdevelop.com/media/2023-03/Soft_Skills_esterna.jpg?VersionId=KvuSmJ0Sijo8lVBebqPUdFlQGExrDKxk","creationDate":"2023-03-23T10:38:45+0100","type":"training","format":null,"videoId":null,"videoUrl":"https://los4b2sit.ispfdevelop.com/los/libraries/gate.html?d=%2Flos%2Faltaformazione%2FSOFT+SKILL+PER+IL+LAVORO+DIGITALE%2Findex.html%09%3F%09endpoint%3Dhttps%3A%2F%2Fs4b2api.ispfdevelop.com%2Ftracking%2Fproxy%2F%09%26auth%3D{VALUE}%09%26Accept-Language%3Dit%09%26actor%3D%7B%22mbox%22%3A%22mailto%3Af.cavallo%40accenture.com%22%2C%22name%22%3A%22FRANCESCO+CAVALLO%22%7D%09%26activity_id%3Dhttps%3A%2F%2Fintesasanpaoloformazione.com%2Fs4b445&t={VALUE}","resourceType":"web","duration":"900","bookmarked":false,"recommended":false,"reviewed":false,"reviews":[],"feedback":{"idCourseType":null,"views":17,"positive":1,"negative":0,"currentUserVote":-1,"title":null},"canUploadExercise":false,"itemId":"445","body":"Se quindici anni fa si faceva principalmente riferimento alle hard skill, ossia alle competenze tecniche, a mano a mano si è affiancato il concetto di soft skill, competenze trasversali acquisite con l'esperienza. In ottica digital transformation diventano digital soft skill. Esempi? Flexibility, Community, Empowerment, Virtuality."});

export const getRelatedMock = () =>
	getBaseResponse({
		appName: 's4b',
		requestId: '',
		success: true,
		errorResponse: null,
		itemsCompleted: [
			{
				title: 'La garanzia nel credito',
				type: '',
				finalTest: false,
				format: 'video',
				duration: '319',
				cover: imgTest,
				creationDate: '2020-04-17T15:45:51+0200',
				creationDateTS: 1587131151000,
				completed: true,
				itemId: '101',
			},
		],
		itemsUncompleted: [
			{
				title: 'La garanzia nel credito',
				type: 'news',
				finalTest: false,
				format: 'text',
				duration: '216',
				cover: imgTest,
				creationDate: '2020-04-17T16:08:08+0200',
				creationDateTS: 1587132488000,
				completed: false,
				itemId: '106',
			},
			{
				title: 'Banca dei territori: la formazione per il tuo mestiere',
				type: 'news',
				finalTest: false,
				format: 'video',
				duration: '308',
				cover: imgTest,
				creationDate: '2020-04-17T16:08:08+0200',
				creationDateTS: 1587132488000,
				completed: false,
				itemId: '107',
			},
			{
				title: 'Chi investe nel green chiede più trasparenza',
				type: 'news',
				finalTest: false,
				format: 'text',
				duration: '216',
				cover: imgTest,
				creationDate: '2020-04-17T16:08:08+0200',
				creationDateTS: 1587132488000,
				completed: false,
				itemId: '108',
			},
		],
		itemsUntracked: [
			{
				title: 'Semplice presenza o partecipazione attiva?',
				type: '',
				finalTest: false,
				format: 'video',
				duration: '120',
				cover: imgTest,
				creationDate: '2020-04-17T15:58:03+0200',
				creationDateTS: 1587131883000,
				completed: false,
				itemId: '102',
			},
		],
		resultCode: 200,
		errorManagement: null,
	});

export const registerProspectMock = () => getBaseResponse({});

export const getNotConfiguredAssetsMock = () =>
	getBaseResponse({
		appName: 'S4B',
		requestId: '73cd0ff7-9819-499c-8cc0-3186fa6d8b95',
		success: true,
		assets: [
			/*  {
				id: '71245606-800d-4741-96af-7f7879c3faae',
				type: 'collection'
			},
			{
				id: 'd861b54c-5177-495a-881c-370df7cd9b59',
				type: 'collection'
			},
			{
				id: '2f983406-f177-41a-a627-fa750232806b',
				type: 'collection'
			},
			{
				id: '20a94d04-95d5-4e7889fa-4c451fc7e097',
				type: 'collection'
			},
			{
				id: '71245606-8d-4741-96af-7f7879c3faae',
				type: 'collection'
			},
			{
				id: 'd861bc-5177-495a-881c-370df7cd9b59',
				type: 'collection'
			}*/
		],
		assetsCreated: 16,
		resultCode: 200,
	});

export const getOnBoardingMock = () =>
	getBaseResponse({
		appName: 'S4B',
		errorManagement: null,
		errorResponse: null,
		needs: [
			{
				id: 18,
				items: [
					{
						asset: false,
						body: 'Nuovi canali di vendita e customer care',
						completed: false,
						coursesCount: 2,
						cover: 'https://medias4b2sit.ispfdevelop.com/media/2022-12/pagamenti%20digitali.jpg?VersionId=62s9JNcocYNOZDdqMohZALl1dPOo82gQ',
						hideFromOnboarding: false,
						id: 97,
						locked: true,
						title: 'I pagamenti digitali per sviluppare il business',
						trailer: null,
						type: 'collection'
					},
					{
						asset: false,
						body: 'Gli ingredienti della vendita efficace',
						completed: false,
						coursesCount: 3,
						cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/sales%20e%20marketing%20mix.jpg?VersionId=XgJuetVRAIvRbqIyZmUPgj._G9MxbVDr',
						hideFromOnboarding: false,
						id: 60,
						locked: true,
						title: 'Sales e marketing mix',
						trailer: null,
						type: 'collection'
					}
				],
				itemSize: 2,
				order: 9223372036854776000,
				title: 'Posizionamento sul mercato'
			},
			{
				id: 21,
				items: [
					{
						asset: false,
						body: 'Far crescere il fatturato e i collaboratori',
						completed: false,
						coursesCount: 4,
						cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/sviluppo%20persone.jpg?VersionId=azA2CM1ZmhvLC_o988tp4fiTVxlFgXdQ',
						hideFromOnboarding: false,
						id: 82,
						locked: true,
						title: 'Leadership sviluppo persone',
						trailer: null,
						type: 'collection'
					},
					{
						asset: false,
						body: 'Dare il meglio col lavoro flessibile e da remoto',
						completed: false,
						coursesCount: 2,
						cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/smartworking.jpg?VersionId=mZBeWP.1O_.IpOdquGicFNGIS4KshkdB',
						hideFromOnboarding: true,
						id: 91,
						locked: true,
						title: 'Smart working',
						trailer: null,
						type: 'collection'
					}
				],
				itemSize: 2,
				order: 9223372036854776000,
				title: 'Sviluppo risorse umane'
			},
			{
				id: 22,
				items: [
					{
						asset: false,
						body: 'Fondi pubblici e misure straordinarie per le imprese',
						completed: false,
						coursesCount: 3,
						cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/fondi%20pubblici.jpg?VersionId=_1CQKN5ovsStbEHoX_0lWLbTMqAjWipi',
						hideFromOnboarding: false,
						id: 83,
						locked: true,
						title: 'Fondi pubblici a favore delle imprese',
						trailer: null,
						type: 'collection'
					},
					{
						asset: false,
						body: 'I requisiti di accesso e come inoltrare una domanda',
						completed: false,
						coursesCount: 2,
						cover: 'https://medias4b2sit.ispfdevelop.com/media/2022-12/finanziamenti%20europei.jpg?VersionId=O10cbI4zVOd0tH0SIjFcrS4gBUc00958',
						hideFromOnboarding: false,
						id: 100,
						locked: true,
						title: 'Finanziamenti europei',
						trailer: null,
						type: 'collection'
					}
				],
				itemSize: 2,
				order: 9223372036854776000,
				title: 'Strumenti di sostegno alle imprese'
			},
			{
				id: 19,
				items: [
					{
						asset: false,
						body: 'Rating e business idea per l\'erogazione del credito',
						completed: false,
						coursesCount: 3,
						cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/relazione%20banca%20impresa.jpg?VersionId=GqLhu4_8ctzY9SesFXVkXMqVq.2D73S8',
						hideFromOnboarding: false,
						id: 70,
						locked: true,
						title: 'Relazione banca impresa',
						trailer: null,
						type: 'collection'
					},
					{
						asset: false,
						body: 'Valuta i benefici e i rischi del tuo progetto di investimento',
						completed: false,
						coursesCount: 3,
						cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/come%20presentare%20un%20progetto.jpg?VersionId=1_6UB8mQ894IbSnBfTGpDAyM4vVOJcIR',
						hideFromOnboarding: false,
						id: 94,
						locked: true,
						title: 'Come presentare un progetto di investimento',
						trailer: null,
						type: 'collection'
					}
				],
				itemSize: 2,
				order: 9223372036854776000,
				title: 'Accesso al credito'
			},
			{
				id: 20,
				items: [
					{
						asset: true,
						body: 'Come il lean management può cambiare il tuo business',
						completed: false,
						coursesCount: 5,
						cover: 'https://medias4b2sit.ispfdevelop.com/media/2022-12/lean%20management.jpg?VersionId=4uXK2CNgn9WaDaQBqDExnY.VEh.9_9Pf',
						hideFromOnboarding: false,
						id: 76,
						locked: false,
						title: 'Il lean management ',
						trailer: null,
						type: 'collection'
					}
				],
				itemSize: 1,
				order: 9223372036854776000,
				title: 'Gestione dei processi aziendali'
			},
			{
				id: 34,
				items: [
					{
						asset: false,
						body: 'Proteggi la tua azienda dagli attacchi informatici',
						completed: false,
						coursesCount: 7,
						cover: 'https://medias4b2sit.ispfdevelop.com/media/2022-11/consob.jpg?VersionId=BwiAIcfcY3odjJHS8CSn1axVkz_oI4S8',
						hideFromOnboarding: true,
						id: 125,
						locked: true,
						title: 'Cyber security',
						trailer: null,
						type: 'collection'
					}
				],
				itemSize: 1,
				order: 9223372036854776000,
				title: 'Cyber security'
			}
		],
		requestId: 'fbad1e74-3f3a-416e-b7b0-8736c93191fa',
		resultCode: 200,
		success: true
	});

export const putAssetsActiveMock = () =>
	getBaseResponse({
		status: 200,
	});
export const getQuestionsMock = () =>
	getBaseResponse(
		{
			appName: "S4B",
			requestId: "7f2e3a00-0226-42bb-b042-8082d9c58758",
			success: true,
			errorResponse: null,
			resultCode: 200,
			errorManagement: null,
			survey: {
				idItem: 209,
				courseSource: "DRUPAL",
				title: "Prova della survey, sei pronto?",
				description: null,
				questions: [
					{
						idQuestion: "104",
						question: "Quanto ti è stato utile questo corso?",
						questionType: "question_single",
						maxValue: null,
						minLabel: null,
						maxLabel: null,
						hasComment: false,
						answers: [
							{
								answer: "Moltissimo"
							},
							{
								answer: "Tanto"
							},
							{
								answer: "Nè utile nè inutile"
							},
							{
								answer: "Poco"
							},
							{
								answer: "Per niente"
							}
						]
					},
					{
						idQuestion: "208",
						question: "Che cosa miglioreresti di questo corso?",
						questionType: "question_open",
						maxValue: null,
						minLabel: null,
						maxLabel: null,
						hasComment: false,
						answers: null
					},
					{
						idQuestion: "207",
						question: "Ti è stato utile questo corso per la tua formazione professionale?",
						questionType: "question_like_dislike",
						maxValue: null,
						minLabel: null,
						maxLabel: null,
						hasComment: false,
						answers: null
					}
				]
			}
		},
		200,
		'ok'
	);

export const addReviewMock = () =>
	getBaseResponse(
		{
			appName: 's4b',
			requestId: '901b1a49-7fbf-46bc-add4-9ce2c6b2c045',
			success: true,
			errorResponse: null,
			idReview: '6a66f113-d1c7-4311-906d-64f305f8a16a',
			resultCode: 200,
			errorManagement: null,
		},
		200,
		'ok'
	);

export const getQuestionsSurveyMock = () =>
	getBaseResponse(
		{
			appName: "S4B",
			errorManagement: null,
			errorResponse: null,
			requestId: "7f2e3a00-0226-42bb-b042-8082d9c58758",
			resultCode: 200,
			success: true,
			survey: {
				courseSource: "DRUPAL",
				description: null,
				idItem: 209,
				questions: [
					{
						answers: [
							{
								answer: "Moltissimo"
							},
							{
								answer: "Tanto"
							},
							{
								answer: "Nè utile nè inutile"
							},
							{
								answer: "Poco"
							},
							{
								answer: "Per niente"
							}
						],
						hasComment: false,
						idQuestion: "104",
						maxLabel: null,
						maxValue: null,
						minLabel: null,
						question: "Quanto ti è stato utile questo corso?",
						questionType: "question_single"
					},
					{
						answers: null,
						hasComment: false,
						idQuestion: "208",
						maxLabel: null,
						maxValue: null,
						minLabel: null,
						question: "Che cosa miglioreresti di questo corso?",
						questionType: "question_open"
					},
					{
						answers: null,
						hasComment: false,
						idQuestion: "207",
						maxLabel: null,
						maxValue: null,
						minLabel: null,
						question: "Ti è stato utile questo corso per la tua formazione professionale?",
						questionType: "question_like_dislike"
					}
				],
				title: "Prova della survey, sei pronto?"
			}
		},
		200,
		'ok'
	);

export const getUsersMock = nextPage => {
	if (nextPage === null) {
		return getBaseResponse(
			{
				appName: 'S4B',
				requestId: '4bcb5e22-fdb6-4acf-85d8-0ea7c0ea55ac',
				success: true,
				errorResponse: null,
				allUsers: [
					{
						userId: 'b1a76447-7014-42ba-9776-ec4a24aeaa1e',
						givenName: 'MARTA RUTH',
						familyName: 'TORRE',
						imageUrl: null,
					},
					{
						userId: '8f28493c-a911-4ea0-8eea-d3ed0a09994b',
						givenName: 'Alessandro',
						familyName: 'Coseddi',
						imageUrl: null,
					},
					{
						userId: '30f82f66-409a-40fe-8420-2b425bc568fc',
						givenName: 'Alessio',
						familyName: 'Sedino',
						imageUrl: null,
					},
					{
						userId: '4cd50d09-4a79-4d7f-af0b-d30d6460f159',
						givenName: 'Alex',
						familyName: 'Milash',
						imageUrl: null,
					},
					{
						userId: 'oaIBgNth-WwqC-BuEf-eauE-HLQFCqarhjny',
						givenName: 'marta',
						familyName: 'della torre',
						imageUrl: null,
					},
					{
						userId: '379882bd-3066-4bad-9776-36bae359acab',
						givenName: 'Alex26',
						familyName: 'Alex26',
						imageUrl: null,
					},
					{
						userId: 'd9aeac02-2ed1-43fb-854d-553e21d88e40',
						givenName: 'Alex27',
						familyName: 'Alex27',
						imageUrl: null,
					},
					{
						userId: '747ae3ab-fce0-43a2-899e-f88727d48028',
						givenName: 'Alex28',
						familyName: 'Alex28',
						imageUrl: null,
					},
					{
						userId: '3f0264cf-5a4b-47ac-90f0-97444229fc78',
						givenName: 'Alex29',
						familyName: 'Alex29',
						imageUrl: null,
					},
					{
						userId: '41b9b145-c620-47d7-800a-dfb015b7e81d',
						givenName: 'Alex30',
						familyName: 'Alex30',
						imageUrl: null,
					},
				],
				followed: [],
				nextPage: 'fd7599ef-5b8f-4011-a310-617e16380345',
				items: 10,
				nextPagePresent: true,
				resultCode: 200,
				errorManagement: null,
			},
			200,
			'ok'
		);
	}
	if (nextPage === 'fd7599ef-5b8f-4011-a310-617e16380345') {
		return getBaseResponse(
			{
				appName: 'S4B',
				requestId: '4bcb5e22-fdb6-4acf-85d8-0ea7c0ea55ac',
				success: true,
				errorResponse: null,
				allUsers: [
					{
						userId: 'aa1aa3a7-f05d-434d-8eb6-a2520c6c55f8',
						givenName: 'Alex31',
						familyName: 'Alex31',
						imageUrl: null,
					},
					{
						userId: 'fd7599ef-5b8f-4011-a310-617e16380345',
						givenName: 'Alex32',
						familyName: 'Alex32',
						imageUrl: null,
					},
					{
						userId: '8f28493c-a911-4ea0-8eea-d3ed0a09994b',
						givenName: 'Gina',
						familyName: 'Lollobrigida',
						imageUrl: null,
					},
					{
						userId: '30f82f66-409a-40fe-8420-2b425bc568fc',
						givenName: 'Sofia',
						familyName: 'Loren',
						imageUrl: null,
					},
					{
						userId: 'b1a76447-7014-42ba-9776-ec4a2beaa1e',
						givenName: 'Gianna',
						familiyName: 'Giannagianna',
						imageUrl: null,
					},
					{
						userId: 'HIrIEtbz-rHuk-hpVC-xtlO-YhEQSFyyevgy',
						givenName: 'Anna',
						familyName: 'Oxa',
						imageUrl: null,
					},
					{
						userId: '379882bd-3066-4bad-9776-36bae359acab',
						givenName: 'Alex33',
						familyName: 'Alex33',
						imageUrl: null,
					},
					{
						userId: 'd9aeac02-2ed1-43fb-854d-553e21d88e40',
						givenName: 'Alex34',
						familyName: 'Alex34',
						imageUrl: null,
					},
					{
						userId: '747ae3ab-fce0-43a2-899e-f88727d48028',
						givenName: 'Alex35',
						familyName: 'Alex35',
						imageUrl: null,
					},
					{
						userId: '3f0264cf-5a4b-47ac-90f0-97444229fc78',
						givenName: 'Alex36',
						familyName: 'Alex36',
						imageUrl: null,
					},
				],
				followed: [],
				nextPage: 'QUFxJKyO-JagO-CFIk-PPsP-VIiQRTDJLhAn',
				items: 10,
				nextPagePresent: true,
				resultCode: 200,
				errorManagement: null,
			},
			200,
			'ok'
		);
	}
	if (nextPage === 'QUFxJKyO-JagO-CFIk-PPsP-VIiQRTDJLhAn') {
		return getBaseResponse(
			{
				appName: 'S4B',
				requestId: '4bcb5e22-fdb6-4acf-85d8-0ea7c0ea55ac',
				success: true,
				errorResponse: null,
				allUsers: [
					{
						userId: '41b9b145-c620-47d7-800a-dfb015b7e81d',
						givenName: 'Alex37',
						familyName: 'Alex37',
						imageUrl: null,
					},
					{
						userId: 'aa1aa3a7-f05d-434d-8eb6-a2520c6c55f8',
						givenName: 'Alex38',
						familyName: 'Alex38',
						imageUrl: null,
					},
					{
						userId: 'fd7599ef-5b8f-4011-a310-617e16380345',
						givenName: 'Alex39',
						familyName: 'Alex39',
						imageUrl: null,
					},
				],
				followed: [],
				nextPage: null,
				items: 10,
				nextPagePresent: false,
				resultCode: 200,
				errorManagement: null,
			},
			200,
			'ok'
		);
	}
	return getBaseResponse(
		{
			appName: 'S4B',
			requestId: '4bcb5e22-fdb6-4acf-85d8-0ea7c0ea55ac',
			success: true,
			errorResponse: null,
			allUsers: [
				{
					userId: '41b9b145-c6s20-47d7-800a-dfb015b7e81d',
					givenName: 'Alex33',
					familyName: 'Alex33',
					imageUrl: null,
				},
				{
					userId: 'aa1aa3a7-f05d-434d-8eb6-a252d0c6c55f8',
					givenName: 'Alex34',
					familyName: 'Alex34',
					imageUrl: null,
				},
				{
					userId: 'fd7599ef-5b8f-4011-a310-617e16g380345',
					givenName: 'Alex35',
					familyName: 'Alex35',
					imageUrl: null,
				},
			],
			followed: [],
			nextPage: null,
			items: 10,
			nextPagePresent: false,
			resultCode: 200,
			errorManagement: null,
		},
		200,
		'ok'
	);
};

export const uploadFileMock = () =>
	getBaseResponse(
		{
			status: 200,
			errorMessage: '',
			fileDownloadUri:
				'https://los4b2sit.ispfdevelop.com/images/profile/3e670af7-e7e4-4928-ac59-0c8a2e277e5d_2021-04-27T09:15:57.134824Z.png',
			fileType: 'image/png',
			size: 140082,
		},
		200,
		'ok'
	);

export const handleFeedbackMock = () =>
	getBaseResponse(
		{
			appName: 'S4B',
			requestId: 'dc5b7bb9-3936-4125-8a61-1d3aaebdaa2f',
			success: true,
			idCourse: 16,
			views: 1,
			positive: 6,
			negative: 0,
			currentUserVote: 1,
			resultCode: 200,
		},
		200,
		'ok'
	);

export const getProductCatalogMock = () =>
	getBaseResponse(
		{
			count_data_obj: "6",
			data: [
				{
					domain_nid: 212,
					product_id: 1035,
					product_variations: {
						data: [
							{
								calendar_choice: "",
								calendars: "",
								cover_alt: "",
								cover_uri: "",
								documents: null,
								domain: 212,
								is_premium: "False",
								learning_contents: [
									{
										limit: "",
										nid: "97",
										ref_content_type: "",
										title: "I pagamenti digitali per sviluppare il business",
										total_duration: "300",
										type: "collection",
										weight: "1"
									}
								],
								link: [
									{
										link_name: "",
										link_uri: ""
									}
								],
								notForSale: "False",
								price: "0,00",
								price_code: "EUR",
								product_description: "",
								product_id: 1035,
								product_information: "",
								product_publish: "True",
								product_title: "Finger Learning - I pagamenti digitali per sviluppare il business",
								product_type: "learning",
								productrateplanchargesbill: "",
								productrateplanchargesid: "8adcc1d1867e2904018682ffa06601ce",
								productrateplanchargestrig: "ContractEffective",
								productrateplanchargestype: "OneTime",
								productrateplansid: "8adcc1d1867e2904018682ffa04701cc",
								promoted: "False",
								question: "",
								sku: "SKU-00000137",
								survey: "",
								variation_id: 1040,
								variation_publish: "True",
								variation_title: "Finger Learning - I pagamenti digitali per sviluppare il business",
								variation_type: "learning",
								view_3: [
									{
										id: "",
										name: ""
									}
								],
								zuora_productid: "8adcc1d1867e2904018682ffa00601ca"
							}
						]
					},
					title: "Finger Learning - I pagamenti digitali per sviluppare il business"
				},
				{
					domain_nid: 212,
					product_id: 1036,
					product_variations: {
						data: [
							{
								calendar_choice: "",
								calendars: "",
								cover_alt: "",
								cover_uri: "",
								documents: null,
								domain: 212,
								is_premium: "False",
								learning_contents: [
									{
										limit: "",
										nid: "58",
										ref_content_type: "",
										title: "Salute e sicurezza sul lavoro",
										total_duration: "993",
										type: "selection",
										weight: "1"
									}
								],
								link: [
									{
										link_name: "",
										link_uri: ""
									}
								],
								notForSale: "False",
								price: "0,00",
								price_code: "EUR",
								product_description: "",
								product_id: 1036,
								product_information: "",
								product_publish: "True",
								product_title: "Privacy e Salute e Sicurezza sul lavoro",
								product_type: "learning",
								productrateplanchargesbill: "",
								productrateplanchargesid: "8adcfb31867e200e018682f5ce407952",
								productrateplanchargestrig: "ContractEffective",
								productrateplanchargestype: "OneTime",
								productrateplansid: "8adcfb31867e200e018682f5ce207950",
								promoted: "False",
								question: "",
								sku: "SKU-00000133",
								survey: "",
								variation_id: 1041,
								variation_publish: "True",
								variation_title: "Privacy e Salute e Sicurezza sul lavoro",
								variation_type: "learning",
								view_3: [
									{
										id: "",
										name: ""
									}
								],
								zuora_productid: "8adcfb31867e200e018682f5ce06794e"
							}
						]
					},
					title: "Privacy e Salute e Sicurezza sul lavoro"
				},
				{
					domain_nid: 212,
					product_id: 1037,
					product_variations: {
						data: [
							{
								calendar_choice: "",
								calendars: "",
								cover_alt: "",
								cover_uri: "",
								documents: null,
								domain: 212,
								is_premium: "False",
								learning_contents: [
									{
										limit: "",
										nid: "58",
										ref_content_type: "",
										title: "Salute e sicurezza sul lavoro",
										total_duration: "993",
										type: "selection",
										weight: "1"
									},
									{
										limit: "",
										nid: "67",
										ref_content_type: "",
										title: "GDPR - Tutela privacy",
										total_duration: "1484",
										type: "selection",
										weight: "2"
									}
								],
								link: [
									{
										link_name: "",
										link_uri: ""
									}
								],
								notForSale: "False",
								price: "0,00",
								price_code: "EUR",
								product_description: "",
								product_id: 1037,
								product_information: "",
								product_publish: "True",
								product_title: "GDPR - Tutela privacy",
								product_type: "learning",
								productrateplanchargesbill: "",
								productrateplanchargesid: "8adcdaf2867e2017018682e706b623f3",
								productrateplanchargestrig: "ContractEffective",
								productrateplanchargestype: "OneTime",
								productrateplansid: "8adcdaf2867e2017018682e7068923f1",
								promoted: "False",
								question: "",
								sku: "SKU-00000131",
								survey: "",
								variation_id: 1042,
								variation_publish: "True",
								variation_title: "GDPR - Tutela privacy",
								variation_type: "learning",
								view_3: [
									{
										id: "",
										name: ""
									}
								],
								zuora_productid: "8adcdaf2867e2017018682e7063e23ef"
							}
						]
					},
					title: "GDPR - Tutela privacy"
				},
				{
					domain_nid: 212,
					product_id: 1039,
					product_variations: {
						data: [
							{
								calendar_choice: "",
								calendars: "",
								cover_alt: "",
								cover_uri: "",
								documents: null,
								domain: 212,
								is_premium: "False",
								learning_contents: [
									{
										limit: "",
										nid: "82",
										ref_content_type: "",
										title: "Leadership sviluppo persone",
										total_duration: "780",
										type: "collection",
										weight: "3"
									},
									{
										limit: "",
										nid: "83",
										ref_content_type: "",
										title: "Fondi pubblici a favore delle imprese",
										total_duration: "660",
										type: "collection",
										weight: "1"
									},
									{
										limit: "",
										nid: "91",
										ref_content_type: "",
										title: "Smart working",
										total_duration: "420",
										type: "collection",
										weight: "2"
									}
								],
								link: [
									{
										link_name: "",
										link_uri: ""
									}
								],
								notForSale: "False",
								price: "0,00",
								price_code: "EUR",
								product_description: "",
								product_id: 1039,
								product_information: "",
								product_publish: "True",
								product_title: "Pacchetto - Smart working",
								product_type: "learning",
								productrateplanchargesbill: "",
								productrateplanchargesid: "8adcad95867df528018682f9c72728b1",
								productrateplanchargestrig: "ContractEffective",
								productrateplanchargestype: "OneTime",
								productrateplansid: "8adcad95867df528018682f9c70b28af",
								promoted: "False",
								question: "",
								sku: "SKU-00000135",
								survey: "",
								variation_id: 1044,
								variation_publish: "True",
								variation_title: "Pacchetto - Smart working",
								variation_type: "learning",
								view_3: [
									{
										id: "",
										name: ""
									}
								],
								zuora_productid: "8adcad95867df528018682f9c6f228ad"
							}
						]
					},
					title: "Pacchetto - Smart working"
				},
				{
					domain_nid: 212,
					product_id: 1042,
					product_variations: {
						data: [
							{
								calendar_choice: "Preselected",
								calendars: [
									"269",
									"268",
									"266",
									"267",
									"265"
								],
								cover_alt: "",
								cover_uri: "",
								documents: null,
								domain: 212,
								is_premium: "True",
								learning_contents: [
									{
										limit: "",
										nid: "76",
										ref_content_type: "",
										title: "Il lean management ",
										total_duration: "780",
										type: "collection",
										weight: "3"
									},
									{
										limit: "",
										nid: "240",
										ref_content_type: "",
										title: "Ask the Expert",
										total_duration: "7200",
										type: "live_event",
										weight: "4"
									},
									{
										limit: "",
										nid: "241",
										ref_content_type: "",
										title: "Evento finale",
										total_duration: "18000",
										type: "live_event",
										weight: "2"
									},
									{
										limit: "",
										nid: "284",
										ref_content_type: "",
										title: "Kick-off",
										total_duration: "7200",
										type: "live_event",
										weight: "1"
									}
								],
								link: [
									{
										link_name: "",
										link_uri: ""
									}
								],
								notForSale: "False",
								price: "0,00",
								price_code: "EUR",
								product_description: "",
								product_id: 1042,
								product_information: "",
								product_publish: "True",
								product_title: "ESG Premium",
								product_type: "learning",
								productrateplanchargesbill: "",
								productrateplanchargesid: "8adcdaf2867e20170186830ce4354968",
								productrateplanchargestrig: "ContractEffective",
								productrateplanchargestype: "OneTime",
								productrateplansid: "8adcdaf2867e20170186830ce4194966",
								promoted: "False",
								question: "",
								sku: "SKU-00000141",
								survey: "",
								variation_id: 1047,
								variation_publish: "True",
								variation_title: "ESG Premium",
								variation_type: "learning",
								view_3: [
									{
										id: "",
										name: ""
									}
								],
								zuora_productid: "8adcdaf2867e20170186830ce3fb4964"
							}
						]
					},
					title: "ESG Premium"
				},
				{
					domain_nid: 212,
					product_id: 1043,
					product_variations: {
						data: [
							{
								calendar_choice: "",
								calendars: "",
								cover_alt: "",
								cover_uri: "",
								documents: null,
								domain: 212,
								is_premium: "False",
								learning_contents: [
									{
										limit: "",
										nid: "100",
										ref_content_type: "",
										title: "Finanziamenti europei",
										total_duration: "450",
										type: "collection",
										weight: "1"
									}
								],
								link: [
									{
										link_name: "",
										link_uri: ""
									}
								],
								notForSale: "False",
								price: "0,00",
								price_code: "EUR",
								product_description: "",
								product_id: 1043,
								product_information: "",
								product_publish: "True",
								product_title: "Finger Learning - Finanziamenti europei",
								product_type: "learning",
								productrateplanchargesbill: "",
								productrateplanchargesid: "8adcc1d1867e290401868307a15e0994",
								productrateplanchargestrig: "ContractEffective",
								productrateplanchargestype: "OneTime",
								productrateplansid: "8adcc1d1867e290401868307a13e0992",
								promoted: "False",
								question: "",
								sku: "SKU-00000139",
								survey: "",
								variation_id: 1048,
								variation_publish: "True",
								variation_title: "Finger Learning - Finanziamenti europei",
								variation_type: "learning",
								view_3: [
									{
										id: "",
										name: ""
									}
								],
								zuora_productid: "8adcc1d1867e290401868307a10a0990"
							}
						]
					},
					title: "Finger Learning - Finanziamenti europei"
				}
			],
			pager: {
				current_page: 0,
				items_per_page: "100",
				total_items: "6",
				total_pages: 1
			}
		}
	);

export const getFilteredCatalogMock = () =>
	getBaseResponse({
		data: [
			{
				product_id: 25,
				title: 'Pacchetto base',
				domain_nid: 47,
				product_variations: {
					data: [
						{
							variation_id: 30,
							sku: 'variation_base',
							question:
								'Necessiti di una formazione per lo sviluppo delle persone e di trasformazione digitale? ',
							information:
								'<p>Formazione per la gestione e sviluppo delle tue risorse e sui  temi del digitale sempre aggiornata. Hai la possibilità di accedere a 10 collection ad un prezzo competitivo, rinnovate annualmente</p>',
							price_number: '120,00',
							price_code: 'EUR',
							title: 'BASE',
							cover: 0,
							promoted: 'False',
							learning_contents: [
								{
									nid: '15',
									type: 'custom_pack',
									title: '1. Custom pack (16 collections)',
									ref_content_type: 'collection',
									limit: '5',
								},
							],
							field_productid: '8adca41e7c6428eb017c762cd5964ee4',
							field_productrateplanchargesbill: '8adca41e7c6428eb017c762cd5964ee4',
							field_productrateplanchargesid: '8adca41e7c6428eb017c762d8cf14fa7',
							field_productrateplanchargestrig: 'Recurring',
							field_productrateplanchargestype: 'Annual',
							field_productrateplansid: 'ContractEffective',
						},
						{
							variation_id: 31,
							sku: 'formazione_obbligatoria',
							question:
								'Hai bisogno di rinnovare la certificazione di sicurezza L.XXY/2018?',
							information:
								'<p>Vuoi ottenere le certificazioni di legge in modo efficace, veloce ed economico. Attiva la formazione obbligatoria ed otterrai i vantaggi di un corso completamente online con la certificazione finale</p>',
							price_number: '60,00',
							price_code: 'EUR',
							title: 'Formazione obbligatoria',
							cover: 0,
							promoted: 'False',
							learning_contents: [
								{
									nid: '51',
									type: 'custom_pack',
									title: 'Custom pack - Formazione obbligatoria',
									ref_content_type: 'collection',
									limit: '5',
								},
							],
							field_productid: '8adccb057ce8d8a7017cea1485a479fa',
							field_productrateplanchargesbill: '8adccb057ce8d8a7017cea1485a479fa',
							field_productrateplanchargesid: '8adccb057ce8d8a7017cea1485bc79fc',
							field_productrateplanchargestrig: 'OneTime',
							field_productrateplansid: 'ContractEffective',
						},
					],
				},
			},
		],
		pager: {
			current_page: 0,
			total_items: '3',
			total_pages: 1,
			items_per_page: 10,
		},
		count_data_obj: '3',
	});

export const getDomainAuthMock = () =>
	getBaseResponse({
		userName: '919f591a-6884-4039-8d7a-56d074593798',
		email: 'email del manager',
		role: 'Admin',
		organizationId: 'd3be9862-9814-4c17-830c-59c5a6f7e9fe',
		token: 't o k e n',
		expiresIn: 3600,
		accessToken: 'a c c e s s t o k e n ',
		refreshToken: 'r e f r e s h t o k e n',
		domainList: IS_MULTI_DOMAIN ? domainList : domainList.at(0),
		clientEnabled: userType,
		givenName: 'Nome',
		familyName: 'Cognome',
	});

export const cartConfirmMock = () => getBaseResponse({});
export const completeManagerMock = () =>
	getBaseResponse(
		{
			userName: '919f591a-6884-4039-8d7a-56d074593798',
			email: 'a.rouissi@accenture.com',
			role: 'Admin',
			organizationId: 'd3be9862-9814-4c17-830c-59c5a6f7e9fe',
			token: 't o k e n',
			expiresIn: 3600,
			accessToken: 'a c c e s s t o k e n ',
			refreshToken: 'r e f r e s h t o k e n',
			domainList: [
				{
					id: 47,
					title: 'Skills4Capital',
					url: 'https://s4b2sit.ispfdevelop.com',
					fruitionChannel: ['app', 'web'],
					cohortId: 17,
					brand: {
						name: 'Skills4Capital',
						color: '#F2284F',
						logo:
							'https://d22cxfqtum6m93.cloudfront.net/media/2021-04/logo-new-positivo-2.png?VersionId=kUDh6Z2LDMLxKZ.cV1MVGVCvIvc7FsIp',
					},
				},
				{
					id: 56,
					title: 'Dominio 2 ',
					url: '0',
					fruitionChannel: ['app', 'web'],
					cohortId: 18,
					brand: {
						name: 'Brand 2',
						color: '#fd8232',
						logo:
							'https://d22cxfqtum6m93.cloudfront.net/media/2021-04/group-4%403x.png?VersionId=S5MIqdE2Vnv9JopKEHNTdUG7chNjd4jf',
					},
				},
			],
			sendDataTreatment: false,
			givenName: 'Anouer',
			familyName: 'Rouissi',
			cf: 'XXXCVB90A42D969L',
			phoneNumber: 123456789,
		},
		200,
		'ok'
	);

export const getFollowCountMock = () =>
	getBaseResponse(
		{
			followers: 5,
			followed: 4,
		},
		200,
		'ok'
	);

export const signupSuperManagerInfoMock = () =>
	getBaseResponse({
		userName: '919f591a-6884-4039-8d7a-56d074593798',
		token: 't o k e n',
		expiresIn: 3600,
		accessToken: 'a c c e s s t o k e n ',
		refreshToken: 'r e f r e s h t o k e n',
	});

export const getPathMock = () =>
	getBaseResponse(
		{
			appName: 'S4B',
			requestId: '2285e13d-35cc-45de-bfb6-b26d96898435',
			success: true,
			errorResponse: null,
			yourPathProgress: {
				collection: {
					percentage: '0',
					progress: '0/0',
					items: [],
				},
				selection: {
					percentage: '0',
					progress: '0/0',
					items: [],
				},
			},
			resultCode: 200,
			errorManagement: null,
		},
		200,
		'ok'
	);

export const getStatementsMock = () =>
	getBaseResponse(
		{
			statements: [
				{
					actor: {
						name: 'Marcello Scanavino',
						mbox: 'mailto:scanavino.marcello@accenture.com',
						objectType: 'Agent',
					},
					stored: '2021-04-23T14:11:11.281Z',
					authority: {
						name: 'Client di collaudo Intesa',
						mbox: 'mailto:staging@intesa.com',
						objectType: 'Agent',
					},
					verb: {
						id: 'http://adlnet.gov/expapi/verbs/initialized',
						display: {
							'it-IT': 'ha inizializzato',
							'en-US': 'initialized',
						},
					},
					id: 'e7f9035b-4970-48f5-9506-e81d8ab1ac07',
					version: '1.0.0',
					object: {
						definition: {
							name: {
								'it-IT': 'Nome risorsa',
							},
							description: {
								'it-IT': 'Descrizione risorsa',
							},
						},
						objectType: 'Activity',
						id: 'https://intesasanpaoloformazione.com/s4b50',
					},
					timestamp: '2021-04-23T14:11:11.281Z',
				},
			],
		},
		200,
		'ok'
	);
export const postStatementsMock = () => getBaseResponse({}, 200, 'ok');
export const getActivityMock = () => getBaseResponse({ val: '10' }, 200, 'ok');
export const putActivityMock = () => getBaseResponse({}, 200, 'ok');

export const addSurveyMock = () => getBaseResponse({}, 200, 'ok');

export const setRecommendedMock = () => getBaseResponse({}, 200, 'ok');

export const getCategoriesMock = () =>
	getBaseResponse(
		[
			{ id: '20', name: 'Accesso al credito' },
			{ id: '21', name: 'Adeguamento alle normative' },
			{ id: '22', name: 'Competenze di Settore' },
			{ id: '60', name: 'Business Turistico' },
			{ id: '62', name: 'Gestione dei processi aziendali' },
			{ id: '63', name: 'Economia circolare' },
			{ id: '64', name: 'Big Data, A.I. e Industria 4.0' },
			{ id: '65', name: 'Superbonus 110' },
			{ id: '66', name: 'Strumenti di sostegno alle imprese' },
			{ id: '67', name: 'Sviluppo risorse umane' },
			{ id: '69', name: 'Posizionamento sul mercato' },
			{ id: '70', name: 'Internazionalizzazione' },
			{ id: '71', name: 'Agribusiness' },
			{ id: '73', name: 'Pagamenti e fatturazioni' },
			{ id: '74', name: 'Trasformazione digitale' },
			{ id: '75', name: 'Privacy e Salute e Sicurezza sul lavoro' },
			{ id: '76', name: 'ESG e sostenibilit\u00e0' },
			{ id: '78', name: 'Business turistico' },
		],
		200,
		'ok'
	);

export const deleteNoteMock = () => getBaseResponse({}, 200, 'ok');

export const setDiscountMock = () =>
	getBaseResponse({
		name: 'order_item_fixed_amount_off',
		display_name: 'order_item_fixed_amount_off Display Name',
		description: 'description order_item_fixed_amount_off',
		compatibility: 'none',
		offer: {
			offer_type: 'order_item_fixed_amount_off',
			amount: '50',
			currency_code: 'EUR',
		},
	});

export const orderPreviewZuoraMock = () =>
	getBaseResponse({
		appName: 'S4B',
		requestId: '038a39d8-2f22-4caf-a6ff-3e3cbb00097b',
		success: false,
		errorResponse: null,
		promoCode: {
			promoCode: 'Discount50',
			validPromoCode: true,
			errorDescription: null,
			valideRatePlanIds: null,
			validForAll: true,
			type: 'fixedAmount',
		},
		orderData: [
			{
				accountNumber: 'A00000132',
				created: 1642516597640,
				priceWithoutTax: '230.0',
				totalPrice: '280.6',
				taxAmount: '50.6',
				taxPercentage: 22,
				discountAmount: '20',
				orderSubscriptions: [
					{
						productType: 'Recurring',
						productId: '8adcddea7c6430e2017c761d100851a7',
						productRatePlanId: '8adca41e7c6428eb017c762cd5964ee4',
						productRatePlanChargeId: '8adca41e7c6428eb017c762d8cf14fa7',
						productName: 'BASE',
						productChargeName: 'BASE (Annual)',
						billingPeriod: 'Annual',
						periodSize: 1,
						triggerEvents: [
							'ContractEffective',
						],
						quantity: '1',
						priceWithoutDiscount: {
							quantity: 1,
							amountWithoutTaxPerUnit: 120,
							taxPerUnit: 26.4,
							amountWithoutTaxPerSubscription: 120,
							taxPerSubscription: 26.4,
							amountPerUnit: 146.4,
							amountPerSubscription: 146.4,
						},
						discount: {
							quantity: 1,
							amountWithoutTaxPerUnit: 0,
							taxPerUnit: 0,
							amountWithoutTaxPerSubscription: 0,
							taxPerSubscription: 0,
							amountPerUnit: 0,
							amountPerSubscription: 0,
						},
						adjustedPrice: {
							quantity: 1,
							amountWithoutTaxPerUnit: 120,
							taxPerUnit: 26.4,
							amountWithoutTaxPerSubscription: 120,
							taxPerSubscription: 26.4,
							amountPerUnit: 146.4,
							amountPerSubscription: 146.4,
						},
					},
					{
						productType: 'OneTime',
						productId: '8adcddea7ce8d8ab017cea1c73a37bc1',
						productRatePlanId: '8adcddea7ce8d8ab017cea1c73b97bc3',
						productRatePlanChargeId: '8adcddea7ce8d8ab017cea1c73d27bc5',
						productName: 'Finger Learning - Cybersecurity: introduzione alla sicurezza informatica',
						productChargeName: 'Finger Learning',
						billingPeriod: '',
						periodSize: 1,
						triggerEvents: [
							'ContractEffective',
						],
						quantity: '1',
						priceWithoutDiscount: {
							quantity: 1,
							amountWithoutTaxPerUnit: 30,
							taxPerUnit: 6.6,
							amountWithoutTaxPerSubscription: 30,
							taxPerSubscription: 6.6,
							amountPerUnit: 36.6,
							amountPerSubscription: 36.6,
						},
						discount: {
							quantity: 1,
							amountWithoutTaxPerUnit: 0,
							taxPerUnit: 0,
							amountWithoutTaxPerSubscription: 0,
							taxPerSubscription: 0,
							amountPerUnit: 0,
							amountPerSubscription: 0,
						},
						adjustedPrice: {
							quantity: 1,
							amountWithoutTaxPerUnit: 30,
							taxPerUnit: 6.6,
							amountWithoutTaxPerSubscription: 30,
							taxPerSubscription: 6.6,
							amountPerUnit: 36.6,
							amountPerSubscription: 36.6,
						},
					},
					{
						productType: 'OneTime',
						productId: '8adc8ea17e52935d017e581238fa3c85',
						productRatePlanId: '8adc8ea17e52935d017e5812392a3c87',
						productRatePlanChargeId: '8adc8ea17e52935d017e5812393f3c89',
						productName: 'ESG e sostenibilità - avanzata',
						productChargeName: 'ESG e sostenibilità - Introduzione',
						billingPeriod: '',
						periodSize: 1,
						triggerEvents: [
							'ContractEffective',
						],
						quantity: '1',
						priceWithoutDiscount: {
							quantity: 1,
							amountWithoutTaxPerUnit: 100,
							taxPerUnit: 22,
							amountWithoutTaxPerSubscription: 100,
							taxPerSubscription: 22,
							amountPerUnit: 122,
							amountPerSubscription: 122,
						},
						discount: {
							quantity: 1,
							amountWithoutTaxPerUnit: 0,
							taxPerUnit: 0,
							amountWithoutTaxPerSubscription: 0,
							taxPerSubscription: 0,
							amountPerUnit: 0,
							amountPerSubscription: 0,
						},
						adjustedPrice: {
							quantity: 1,
							amountWithoutTaxPerUnit: 100,
							taxPerUnit: 22,
							amountWithoutTaxPerSubscription: 100,
							taxPerSubscription: 22,
							amountPerUnit: 122,
							amountPerSubscription: 122,
						},
					},
				],
			},
		],
		resultCode: 200,
		errorManagement: null,
	});

export const getCalendarsForPremiumProductMock = () => (
	getBaseResponse({
		calendars: [
			{
				availableSeats: 1,
				body: null,
				calendarId: 264,
				endDate: '2023-04-05T12:00:00+0200',
				sessions: [
					{
						endDate: '2023-02-21T13:00:00+0100',
						link: 'https://meet.google.com/',
						liveEventId: 284,
						liveEventMode: 'virtual',
						liveEventTitle: 'Kick-off',
						locations: [
							{
								address: 'Corso Inghilterra, 3',
								city: 'Torino',
								lat: '45.069411',
								lon: '7.663454'
							}
						],
						sessionId: 287,
						sessionTitle: '3 ^ classe virtuale 2',
						startDate: '2023-02-21T09:00:00+0100',
						teachers: [
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/rossi.jpg?VersionId=LO0RomXPkof3T7YTHEKePdaGdajcC6zV',
								email: 'Laureato in ingegneria informatica ',
								info: 'Laureato in ingegneria informatica ',
								lastName: 'Rossi',
								name: 'Marco'
							},
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/sollo.jpg?VersionId=3aQWIm2T.SjkoKNkxQLfKx1OIH2.pVXg',
								email: 'Laureata in Economia',
								info: 'Laureata in Economia',
								lastName: 'Sollo',
								name: 'Sonia'
							},
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/rossi.jpg?VersionId=LO0RomXPkof3T7YTHEKePdaGdajcC6zV',
								email: 'Laureato in ingegneria informatica ',
								info: 'Laureato in ingegneria informatica ',
								lastName: 'Rossi',
								name: 'Marco'
							},
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/sollo.jpg?VersionId=3aQWIm2T.SjkoKNkxQLfKx1OIH2.pVXg',
								email: 'Laureata in Economia',
								info: 'Laureata in Economia',
								lastName: 'Sollo',
								name: 'Sonia'
							}
						],
						totalSeats: 20,
						userId: null
					},
					{
						endDate: '2023-03-14T12:00:00+0100',
						link: 'https://meet.google.com/',
						liveEventId: 240,
						liveEventMode: 'virtual',
						liveEventTitle: 'Ask the Expert',
						locations: [
							{
								address: 'Corso Inghilterra, 3',
								city: 'Torino',
								lat: '45.069411',
								lon: '7.663454'
							}
						],
						sessionId: 248,
						sessionTitle: '3 ^ classe virtuale',
						startDate: '2023-03-14T08:00:00+0100',
						teachers: [
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/rossi.jpg?VersionId=LO0RomXPkof3T7YTHEKePdaGdajcC6zV',
								email: 'Laureato in ingegneria informatica ',
								info: 'Laureato in ingegneria informatica ',
								lastName: 'Rossi',
								name: 'Marco'
							},
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/sollo.jpg?VersionId=3aQWIm2T.SjkoKNkxQLfKx1OIH2.pVXg',
								email: 'Laureata in Economia',
								info: 'Laureata in Economia',
								lastName: 'Sollo',
								name: 'Sonia'
							},
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/rossi.jpg?VersionId=LO0RomXPkof3T7YTHEKePdaGdajcC6zV',
								email: 'Laureato in ingegneria informatica ',
								info: 'Laureato in ingegneria informatica ',
								lastName: 'Rossi',
								name: 'Marco'
							},
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/sollo.jpg?VersionId=3aQWIm2T.SjkoKNkxQLfKx1OIH2.pVXg',
								email: 'Laureata in Economia',
								info: 'Laureata in Economia',
								lastName: 'Sollo',
								name: 'Sonia'
							}
						],
						totalSeats: 20,
						userId: null
					},
					{
						endDate: '2023-04-05T12:00:00+0200',
						link: null,
						liveEventId: 241,
						liveEventMode: 'live',
						liveEventTitle: 'Evento finale',
						locations: [
							{
								address: 'Corso Inghilterra, 3',
								city: 'Torino',
								lat: '45.069411',
								lon: '7.663454'
							}
						],
						sessionId: 256,
						sessionTitle: '3 ^ classe fisica',
						startDate: '2023-04-05T08:00:00+0200',
						teachers: [
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/rossi.jpg?VersionId=LO0RomXPkof3T7YTHEKePdaGdajcC6zV',
								email: 'Laureato in ingegneria informatica ',
								info: 'Laureato in ingegneria informatica ',
								lastName: 'Rossi',
								name: 'Marco'
							},
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/sollo.jpg?VersionId=3aQWIm2T.SjkoKNkxQLfKx1OIH2.pVXg',
								email: 'Laureata in Economia',
								info: 'Laureata in Economia',
								lastName: 'Sollo',
								name: 'Sonia'
							},
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/rossi.jpg?VersionId=LO0RomXPkof3T7YTHEKePdaGdajcC6zV',
								email: 'Laureato in ingegneria informatica ',
								info: 'Laureato in ingegneria informatica ',
								lastName: 'Rossi',
								name: 'Marco'
							},
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/sollo.jpg?VersionId=3aQWIm2T.SjkoKNkxQLfKx1OIH2.pVXg',
								email: 'Laureata in Economia',
								info: 'Laureata in Economia',
								lastName: 'Sollo',
								name: 'Sonia'
							}
						],
						totalSeats: 15,
						userId: null
					}
				],
				startDate: '2023-02-21T09:00:00+0100',
				title: 'Dal 21/02/2023 al 05/04/2023, Torino',
				totalSeats: 15
			},
			{
				availableSeats: 15,
				body: null,
				calendarId: 265,
				endDate: '2023-04-10T13:00:00+0200',
				sessions: [
					{
						endDate: '2023-03-02T16:00:00+0100',
						link: 'https://meet.google.com/',
						liveEventId: 284,
						liveEventMode: 'virtual',
						liveEventTitle: 'Kick-off',
						locations: [
							{
								address: 'Corso Inghilterra, 3',
								city: 'Torino',
								lat: '45.069411',
								lon: '7.663454'
							}
						],
						sessionId: 288,
						sessionTitle: '4 ^ classe virtuale 2',
						startDate: '2023-03-02T09:00:00+0100',
						teachers: [
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/rossi.jpg?VersionId=LO0RomXPkof3T7YTHEKePdaGdajcC6zV',
								email: 'Laureato in ingegneria informatica ',
								info: 'Laureato in ingegneria informatica ',
								lastName: 'Rossi',
								name: 'Marco'
							},
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/rossi.jpg?VersionId=LO0RomXPkof3T7YTHEKePdaGdajcC6zV',
								email: 'Laureato in ingegneria informatica ',
								info: 'Laureato in ingegneria informatica ',
								lastName: 'Rossi',
								name: 'Marco'
							},
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/rossi.jpg?VersionId=LO0RomXPkof3T7YTHEKePdaGdajcC6zV',
								email: 'Laureato in ingegneria informatica ',
								info: 'Laureato in ingegneria informatica ',
								lastName: 'Rossi',
								name: 'Marco'
							},
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/massaro.jpg?VersionId=1E8fC1028EOR_L9e6kCxCvzGrCoEP0bK',
								email: 'Laureato in biologia',
								info: 'Laureato in biologia',
								lastName: 'Massaro',
								name: 'Luigi'
							}
						],
						totalSeats: 20,
						userId: null
					},
					{
						endDate: '2023-03-16T13:00:00+0100',
						link: 'https://meet.google.com/',
						liveEventId: 240,
						liveEventMode: 'virtual',
						liveEventTitle: 'Ask the Expert',
						locations: [
							{
								address: 'Corso Inghilterra, 3',
								city: 'Torino',
								lat: '45.069411',
								lon: '7.663454'
							}
						],
						sessionId: 249,
						sessionTitle: '4 ^ classe virtuale',
						startDate: '2023-03-16T08:00:00+0100',
						teachers: [
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/rossi.jpg?VersionId=LO0RomXPkof3T7YTHEKePdaGdajcC6zV',
								email: 'Laureato in ingegneria informatica ',
								info: 'Laureato in ingegneria informatica ',
								lastName: 'Rossi',
								name: 'Marco'
							},
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/rossi.jpg?VersionId=LO0RomXPkof3T7YTHEKePdaGdajcC6zV',
								email: 'Laureato in ingegneria informatica ',
								info: 'Laureato in ingegneria informatica ',
								lastName: 'Rossi',
								name: 'Marco'
							},
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/rossi.jpg?VersionId=LO0RomXPkof3T7YTHEKePdaGdajcC6zV',
								email: 'Laureato in ingegneria informatica ',
								info: 'Laureato in ingegneria informatica ',
								lastName: 'Rossi',
								name: 'Marco'
							},
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/massaro.jpg?VersionId=1E8fC1028EOR_L9e6kCxCvzGrCoEP0bK',
								email: 'Laureato in biologia',
								info: 'Laureato in biologia',
								lastName: 'Massaro',
								name: 'Luigi'
							}
						],
						totalSeats: 20,
						userId: null
					},
					{
						endDate: '2023-04-10T13:00:00+0200',
						link: null,
						liveEventId: 241,
						liveEventMode: 'live',
						liveEventTitle: 'Evento finale',
						locations: [
							{
								address: 'Corso Inghilterra, 3',
								city: 'Torino',
								lat: '45.069411',
								lon: '7.663454'
							}
						],
						sessionId: 257,
						sessionTitle: '4 ^ classe fisica',
						startDate: '2023-04-10T07:30:00+0200',
						teachers: [
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/rossi.jpg?VersionId=LO0RomXPkof3T7YTHEKePdaGdajcC6zV',
								email: 'Laureato in ingegneria informatica ',
								info: 'Laureato in ingegneria informatica ',
								lastName: 'Rossi',
								name: 'Marco'
							},
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/rossi.jpg?VersionId=LO0RomXPkof3T7YTHEKePdaGdajcC6zV',
								email: 'Laureato in ingegneria informatica ',
								info: 'Laureato in ingegneria informatica ',
								lastName: 'Rossi',
								name: 'Marco'
							},
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/rossi.jpg?VersionId=LO0RomXPkof3T7YTHEKePdaGdajcC6zV',
								email: 'Laureato in ingegneria informatica ',
								info: 'Laureato in ingegneria informatica ',
								lastName: 'Rossi',
								name: 'Marco'
							},
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/massaro.jpg?VersionId=1E8fC1028EOR_L9e6kCxCvzGrCoEP0bK',
								email: 'Laureato in biologia',
								info: 'Laureato in biologia',
								lastName: 'Massaro',
								name: 'Luigi'
							}
						],
						totalSeats: 15,
						userId: null
					}
				],
				startDate: '2023-03-02T09:00:00+0100',
				title: 'Dal 02/03/2023 al 10/04/2023, Torino',
				totalSeats: 15
			},
			{
				availableSeats: 12,
				body: 'prova - descrizione',
				calendarId: 247,
				endDate: '2023-04-02T12:00:00+0200',
				sessions: [
					{
						endDate: '2023-02-17T18:00:00+0100',
						link: 'https://meet.google.com/',
						liveEventId: 284,
						liveEventMode: 'virtual',
						liveEventTitle: 'Kick-off',
						locations: [
							{
								address: 'Corso Inghilterra, 3',
								city: 'Torino',
								lat: '45.069411',
								lon: '7.663454'
							}
						],
						sessionId: 286,
						sessionTitle: '2 ^ classe virtuale 2',
						startDate: '2023-02-17T16:00:00+0100',
						teachers: [
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/rossi.jpg?VersionId=LO0RomXPkof3T7YTHEKePdaGdajcC6zV',
								email: 'Laureato in ingegneria informatica ',
								info: 'Laureato in ingegneria informatica ',
								lastName: 'Rossi',
								name: 'Marco'
							},
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/massaro.jpg?VersionId=1E8fC1028EOR_L9e6kCxCvzGrCoEP0bK',
								email: 'Laureato in biologia',
								info: 'Laureato in biologia',
								lastName: 'Massaro',
								name: 'Luigi'
							},
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/massaro.jpg?VersionId=1E8fC1028EOR_L9e6kCxCvzGrCoEP0bK',
								email: 'Laureato in biologia',
								info: 'Laureato in biologia',
								lastName: 'Massaro',
								name: 'Luigi'
							}
						],
						totalSeats: 20,
						userId: null
					},
					{
						endDate: '2023-03-10T14:00:00+0100',
						link: 'https://meet.google.com/',
						liveEventId: 240,
						liveEventMode: 'virtual',
						liveEventTitle: 'Ask the Expert',
						locations: [
							{
								address: 'Corso Inghilterra, 3',
								city: 'Torino',
								lat: '45.069411',
								lon: '7.663454'
							}
						],
						sessionId: 245,
						sessionTitle: '2 ^ classe virtuale',
						startDate: '2023-03-10T08:00:00+0100',
						teachers: [
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/rossi.jpg?VersionId=LO0RomXPkof3T7YTHEKePdaGdajcC6zV',
								email: 'Laureato in ingegneria informatica ',
								info: 'Laureato in ingegneria informatica ',
								lastName: 'Rossi',
								name: 'Marco'
							},
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/massaro.jpg?VersionId=1E8fC1028EOR_L9e6kCxCvzGrCoEP0bK',
								email: 'Laureato in biologia',
								info: 'Laureato in biologia',
								lastName: 'Massaro',
								name: 'Luigi'
							},
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/massaro.jpg?VersionId=1E8fC1028EOR_L9e6kCxCvzGrCoEP0bK',
								email: 'Laureato in biologia',
								info: 'Laureato in biologia',
								lastName: 'Massaro',
								name: 'Luigi'
							}
						],
						totalSeats: 20,
						userId: null
					},
					{
						endDate: '2023-04-02T12:00:00+0200',
						link: null,
						liveEventId: 241,
						liveEventMode: 'live',
						liveEventTitle: 'Evento finale',
						locations: [
							{
								address: 'Corso Inghilterra, 3',
								city: 'Torino',
								lat: '45.069411',
								lon: '7.663454'
							}
						],
						sessionId: 246,
						sessionTitle: '2 ^ classe fisica',
						startDate: '2023-04-02T08:00:00+0200',
						teachers: [
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/rossi.jpg?VersionId=LO0RomXPkof3T7YTHEKePdaGdajcC6zV',
								email: 'Laureato in ingegneria informatica ',
								info: 'Laureato in ingegneria informatica ',
								lastName: 'Rossi',
								name: 'Marco'
							},
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/massaro.jpg?VersionId=1E8fC1028EOR_L9e6kCxCvzGrCoEP0bK',
								email: 'Laureato in biologia',
								info: 'Laureato in biologia',
								lastName: 'Massaro',
								name: 'Luigi'
							},
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/massaro.jpg?VersionId=1E8fC1028EOR_L9e6kCxCvzGrCoEP0bK',
								email: 'Laureato in biologia',
								info: 'Laureato in biologia',
								lastName: 'Massaro',
								name: 'Luigi'
							}
						],
						totalSeats: 15,
						userId: null
					}
				],
				startDate: '2023-02-17T16:00:00+0100',
				title: 'Dal 17/02/2023 al 02/04/2023, Torino',
				totalSeats: 15
			},
			{
				availableSeats: 0,
				body: 'descrizione prova',
				calendarId: 267,
				endDate: '2023-04-17T12:00:00+0200',
				sessions: [
					{
						endDate: '2023-03-23T13:00:00+0100',
						link: 'https://meet.google.com/',
						liveEventId: 284,
						liveEventMode: 'virtual',
						liveEventTitle: 'Kick-off',
						locations: [
							{
								address: 'Corso Inghilterra, 3',
								city: 'Torino',
								lat: '45.069411',
								lon: '7.663454'
							}
						],
						sessionId: 290,
						sessionTitle: '6 ^ classe virtuale 2',
						startDate: '2023-03-23T08:00:00+0100',
						teachers: [
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/sollo.jpg?VersionId=3aQWIm2T.SjkoKNkxQLfKx1OIH2.pVXg',
								email: 'Laureata in Economia',
								info: 'Laureata in Economia',
								lastName: 'Sollo',
								name: 'Sonia'
							},
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/sollo.jpg?VersionId=3aQWIm2T.SjkoKNkxQLfKx1OIH2.pVXg',
								email: 'Laureata in Economia',
								info: 'Laureata in Economia',
								lastName: 'Sollo',
								name: 'Sonia'
							},
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/massaro.jpg?VersionId=1E8fC1028EOR_L9e6kCxCvzGrCoEP0bK',
								email: 'Laureato in biologia',
								info: 'Laureato in biologia',
								lastName: 'Massaro',
								name: 'Luigi'
							},
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/sollo.jpg?VersionId=3aQWIm2T.SjkoKNkxQLfKx1OIH2.pVXg',
								email: 'Laureata in Economia',
								info: 'Laureata in Economia',
								lastName: 'Sollo',
								name: 'Sonia'
							}
						],
						totalSeats: 20,
						userId: null
					},
					{
						endDate: '2023-03-29T14:00:00+0200',
						link: 'https://meet.google.com/',
						liveEventId: 240,
						liveEventMode: 'virtual',
						liveEventTitle: 'Ask the Expert',
						locations: [
							{
								address: 'Corso Inghilterra, 3',
								city: 'Torino',
								lat: '45.069411',
								lon: '7.663454'
							}
						],
						sessionId: 251,
						sessionTitle: '6 ^ classe virtuale',
						startDate: '2023-03-29T07:30:00+0200',
						teachers: [
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/sollo.jpg?VersionId=3aQWIm2T.SjkoKNkxQLfKx1OIH2.pVXg',
								email: 'Laureata in Economia',
								info: 'Laureata in Economia',
								lastName: 'Sollo',
								name: 'Sonia'
							},
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/sollo.jpg?VersionId=3aQWIm2T.SjkoKNkxQLfKx1OIH2.pVXg',
								email: 'Laureata in Economia',
								info: 'Laureata in Economia',
								lastName: 'Sollo',
								name: 'Sonia'
							},
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/massaro.jpg?VersionId=1E8fC1028EOR_L9e6kCxCvzGrCoEP0bK',
								email: 'Laureato in biologia',
								info: 'Laureato in biologia',
								lastName: 'Massaro',
								name: 'Luigi'
							},
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/sollo.jpg?VersionId=3aQWIm2T.SjkoKNkxQLfKx1OIH2.pVXg',
								email: 'Laureata in Economia',
								info: 'Laureata in Economia',
								lastName: 'Sollo',
								name: 'Sonia'
							}
						],
						totalSeats: 20,
						userId: null
					},
					{
						endDate: '2023-04-17T12:00:00+0200',
						link: null,
						liveEventId: 241,
						liveEventMode: 'live',
						liveEventTitle: 'Evento finale',
						locations: [
							{
								address: 'Corso Inghilterra, 3',
								city: 'Torino',
								lat: '45.069411',
								lon: '7.663454'
							}
						],
						sessionId: 259,
						sessionTitle: '6 ^ classe fisica',
						startDate: '2023-04-17T08:30:00+0200',
						teachers: [
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/sollo.jpg?VersionId=3aQWIm2T.SjkoKNkxQLfKx1OIH2.pVXg',
								email: 'Laureata in Economia',
								info: 'Laureata in Economia',
								lastName: 'Sollo',
								name: 'Sonia'
							},
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/sollo.jpg?VersionId=3aQWIm2T.SjkoKNkxQLfKx1OIH2.pVXg',
								email: 'Laureata in Economia',
								info: 'Laureata in Economia',
								lastName: 'Sollo',
								name: 'Sonia'
							},
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/massaro.jpg?VersionId=1E8fC1028EOR_L9e6kCxCvzGrCoEP0bK',
								email: 'Laureato in biologia',
								info: 'Laureato in biologia',
								lastName: 'Massaro',
								name: 'Luigi'
							},
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/sollo.jpg?VersionId=3aQWIm2T.SjkoKNkxQLfKx1OIH2.pVXg',
								email: 'Laureata in Economia',
								info: 'Laureata in Economia',
								lastName: 'Sollo',
								name: 'Sonia'
							}
						],
						totalSeats: 15,
						userId: null
					}
				],
				startDate: '2023-03-23T08:00:00+0100',
				title: 'Dal 23/03/2023 al 17/04/2023, Torino',
				totalSeats: 15
			},
			{
				availableSeats: 14,
				body: 'prova - descrizione',
				calendarId: 266,
				endDate: '2023-04-12T15:00:00+0200',
				sessions: [
					{
						endDate: '2023-03-16T14:00:00+0100',
						link: 'https://meet.google.com/',
						liveEventId: 284,
						liveEventMode: 'virtual',
						liveEventTitle: 'Kick-off',
						locations: [
							{
								address: 'Corso Inghilterra, 3',
								city: 'Torino',
								lat: '45.069411',
								lon: '7.663454'
							}
						],
						sessionId: 289,
						sessionTitle: '5 ^ classe virtuale 2',
						startDate: '2023-03-16T08:30:00+0100',
						teachers: [
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/rossi.jpg?VersionId=LO0RomXPkof3T7YTHEKePdaGdajcC6zV',
								email: 'Laureato in ingegneria informatica ',
								info: 'Laureato in ingegneria informatica ',
								lastName: 'Rossi',
								name: 'Marco'
							},
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/sollo.jpg?VersionId=3aQWIm2T.SjkoKNkxQLfKx1OIH2.pVXg',
								email: 'Laureata in Economia',
								info: 'Laureata in Economia',
								lastName: 'Sollo',
								name: 'Sonia'
							},
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/rossi.jpg?VersionId=LO0RomXPkof3T7YTHEKePdaGdajcC6zV',
								email: 'Laureato in ingegneria informatica ',
								info: 'Laureato in ingegneria informatica ',
								lastName: 'Rossi',
								name: 'Marco'
							},
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/massaro.jpg?VersionId=1E8fC1028EOR_L9e6kCxCvzGrCoEP0bK',
								email: 'Laureato in biologia',
								info: 'Laureato in biologia',
								lastName: 'Massaro',
								name: 'Luigi'
							}
						],
						totalSeats: 20,
						userId: null
					},
					{
						endDate: '2023-03-22T14:30:00+0100',
						link: 'https://meet.google.com/',
						liveEventId: 240,
						liveEventMode: 'virtual',
						liveEventTitle: 'Ask the Expert',
						locations: [
							{
								address: 'Corso Inghilterra, 3',
								city: 'Torino',
								lat: '45.069411',
								lon: '7.663454'
							}
						],
						sessionId: 250,
						sessionTitle: '5 ^ classe virtuale',
						startDate: '2023-03-22T09:00:00+0100',
						teachers: [
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/rossi.jpg?VersionId=LO0RomXPkof3T7YTHEKePdaGdajcC6zV',
								email: 'Laureato in ingegneria informatica ',
								info: 'Laureato in ingegneria informatica ',
								lastName: 'Rossi',
								name: 'Marco'
							},
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/sollo.jpg?VersionId=3aQWIm2T.SjkoKNkxQLfKx1OIH2.pVXg',
								email: 'Laureata in Economia',
								info: 'Laureata in Economia',
								lastName: 'Sollo',
								name: 'Sonia'
							},
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/rossi.jpg?VersionId=LO0RomXPkof3T7YTHEKePdaGdajcC6zV',
								email: 'Laureato in ingegneria informatica ',
								info: 'Laureato in ingegneria informatica ',
								lastName: 'Rossi',
								name: 'Marco'
							},
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/massaro.jpg?VersionId=1E8fC1028EOR_L9e6kCxCvzGrCoEP0bK',
								email: 'Laureato in biologia',
								info: 'Laureato in biologia',
								lastName: 'Massaro',
								name: 'Luigi'
							}
						],
						totalSeats: 20,
						userId: null
					},
					{
						endDate: '2023-04-12T15:00:00+0200',
						link: null,
						liveEventId: 241,
						liveEventMode: 'live',
						liveEventTitle: 'Evento finale',
						locations: [
							{
								address: 'Corso Inghilterra, 3',
								city: 'Torino',
								lat: '45.069411',
								lon: '7.663454'
							}
						],
						sessionId: 258,
						sessionTitle: '5 ^ classe fisica',
						startDate: '2023-04-12T08:00:00+0200',
						teachers: [
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/rossi.jpg?VersionId=LO0RomXPkof3T7YTHEKePdaGdajcC6zV',
								email: 'Laureato in ingegneria informatica ',
								info: 'Laureato in ingegneria informatica ',
								lastName: 'Rossi',
								name: 'Marco'
							},
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/sollo.jpg?VersionId=3aQWIm2T.SjkoKNkxQLfKx1OIH2.pVXg',
								email: 'Laureata in Economia',
								info: 'Laureata in Economia',
								lastName: 'Sollo',
								name: 'Sonia'
							},
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/rossi.jpg?VersionId=LO0RomXPkof3T7YTHEKePdaGdajcC6zV',
								email: 'Laureato in ingegneria informatica ',
								info: 'Laureato in ingegneria informatica ',
								lastName: 'Rossi',
								name: 'Marco'
							},
							{
								cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/massaro.jpg?VersionId=1E8fC1028EOR_L9e6kCxCvzGrCoEP0bK',
								email: 'Laureato in biologia',
								info: 'Laureato in biologia',
								lastName: 'Massaro',
								name: 'Luigi'
							}
						],
						totalSeats: 15,
						userId: null
					}
				],
				startDate: '2023-03-16T08:30:00+0100',
				title: 'Dal 16/03/2023 al 12/04/2023, Torino',
				totalSeats: 15
			}
		],
		pageInfo: {
			hasNextPage: true,
			itemsPerPage: 5,
			nextPageToken: 'MToxNjc2NTU1NDEw'
		},
		responseResult: {
			errors: null,
			statusCode: 200,
			success: true
		}
	})
)

export const getFollowersMock = () =>
	getBaseResponse(
		{
			appName: 'S4B',
			requestId: '7d8ecc1f-6b65-49ed-ae48-851ea7f709cc',
			success: true,
			errorResponse: null,
			followers: [],
			followed: [],
			nextPage: null,
			items: 10,
			nextPagePresent: false,
			resultCode: 200,
			errorManagement: null,
		},
		200,
		'ok'
	);

export const addFollowMock = () => getBaseResponse({}, 200, 'ok');
export const removeFollowMock = () => getBaseResponse({}, 200, 'ok');

export const getKeepWatchingMock = () =>
	getBaseResponse(
		{
			success: true,
			listOfLoInProgress: [
				{
					status: 'IN_PROGRESS',
					title: 'Il Tuo Territorio È Ok Per Il Turismo Enogastronomico? abcdefghijklmnopqrstuvwxyz',
					cover:
						'https://medias4b2sit.ispfdevelop.com/media/2022-03/prova_banner%20%281%29.png?VersionId=MGWccd7V_uElnzl5hpmyLtT1W40SrQ5f',
					creationDate: '2021-05-07T16:57:43+0200',
					type: 'learning_object',
					format: 'video',
					duration: '180',
					itemId: '509',
					completed: false,
					body:
						'Scopri gli elementi che possono aiutare la tua attività a inserirsi in una destinazione turistica di successo.',
				},
				{
					status: 'IN_PROGRESS',
					title: 'Cyber Crime: Cos’è E Perchè Devi Conoscerlo',
					cover: null,
					creationDate: '2021-05-06T16:46:34+0200',
					type: 'learning_object',
					format: 'video',
					duration: '180',
					itemId: '324',
					completed: false,
					body:
						'Scopri cosa si intende per crimine informatico, quali conseguenze comporta, come avviene e come proteggersi da possibili cyber attack.',
				},
				{
					status: 'IN_PROGRESS',
					title:
						'Sistemi Di Pagamento: Alcuni Servizi Aggiuntivi Per Il Tuo Pos',
					cover:
						'https://d22cxfqtum6m93.cloudfront.net/media/2021-05/31.2.PNG?VersionId=DePmZ3OpQ2S3hhV9ckPjxGOG1xKb1M3t',
					creationDate: '2021-05-06T11:14:28+0200',
					type: 'learning_object',
					format: 'video',
					duration: '120',
					itemId: '269',
					completed: false,
					body:
						"Scopri quali servizi aggiuntivi puoi scegliere da collegare al tuo Pos e chiedili al tuo gestore di filiale, per fornire un'offerta più completa ai tuoi clienti.",
				},
			],
		},
		200,
		'ok'
	);

export const getResourceCommerceOrderMock = (order, state) => {
	if (order) {
		return getBaseResponse({
			start: '0',
			take: '1',
			total_items: 170,
			items_in_page: 1,
			data: [
				{
					id: '1304',
					bundle: 'default',
					euid: '427488dc-e297-4ef3-ac93-83aa26f347cd',
					state: 'draft',
					subtotal_price_number: '240.000000',
					total_price_number: '292.800000',
					tax_amount: '52.8',
					tax_percentage: 22,
					paymentMethodId: '',
					order_items: [
						{
							id: '5400',
							bundle: 'for_life',
							qty: '1.00',
							unit_price: '25.000000',
							total_price: '25.000000',
							adjusted_unit_price: '30.50',
							adjusted_total_price: '30.50',
							variation: {
								id: '20',
								sku: 'FL2',
								title: 'Relazione banca Impresa',
								bundle: 'learning',
								learning_contents: [
									{
										id: '198',
										title: 'Relazione banca impresa',
										type: 'collection',
									},
								],
							},
							product: {
								id: '23',
								title: 'Prodotto 3',
								bundle: 'learning_subscription',
							},
							adjustments: [
								{
									type: 'card_tax',
									sourceId: '81',
									label: 'Italy 22%',
									percentage: '0.22',
									price_number: '5.5',
								},
							],
						},
					],
				},
			],
		});
	}

	if (state.indexOf('draft') > -1) {
		return getBaseResponse({
			start: '0',
			take: '10000000',
			total_items: 1,
			items_in_page: 1,
			data: [
				{
					id: '2355',
					bundle: 'default',
					euid: '4014ea49-8b4b-407e-ab16-0b5be0b6dc75',
					state: 'draft',
					subtotal_price_number: '25.000000',
					total_price_number: '30.500000',
					tax_amount: '5.5',
					tax_percentage: 22,
					paymentMethodId: '432',
					order_items: [
						{
							id: '5400',
							bundle: 'for_life',
							qty: '1.00',
							unit_price: '25.000000',
							total_price: '25.000000',
							adjusted_unit_price: '30.50',
							adjusted_total_price: '30.50',
							variation: {
								id: '33',
								sku: 'FL2',
								title: 'Relazione banca Impresa',
								bundle: 'learning',
								learning_contents: [
									{
										id: '198',
										title: 'Relazione banca impresa',
										type: 'collection',
									},
								],
							},
							product: {
								id: '23',
								title: 'Prodotto 3',
								bundle: 'learning_subscription',
							},
							adjustments: [
								{
									type: 'card_tax',
									sourceId: '81',
									label: 'Italy 22%',
									percentage: '0.22',
									price_number: '5.5',
								},
							],
						},
					],
					adjustments: [],
				},
			],
		});
	}

	return getBaseResponse({
		start: '0',
		take: '1000000',
		total_items: 6,
		items_in_page: 6,
		data: [
			{
				id: '2171',
				bundle: 'default',
				euid: '4014ea49-8b4b-407e-ab16-0b5be0b6dc75',
				created: 1623052320,
				placed: 1623052322,
				state: 'completed',
				subtotal_price_number: '292',
				total_price_number: '356.240000',
				tax_amount: '64.24',
				tax_percentage: 22,
				paymentMethodId: '432',
				order_items: [
					{
						id: '4979',
						bundle: 'subscription',
						qty: '1.00',
						unit_price: '120.000000',
						total_price: '120.000000',
						adjusted_unit_price: '146.40',
						adjusted_total_price: '146.40',
						variation: {
							id: '35',
							sku: 'BASE_S4C',
							title: 'Base',
							bundle: 'learning_subscription',
							learning_contents: [
								{
									id: '303',
									title: 'Pacchetto Base - 10 collection',
									type: 'custom_pack',
									learning_type: 'collection',
									limited: '10',
								},
							],
						},
						product: {
							id: '30',
							title: 'Pacchetto Base - 10 collection',
							bundle: 'learning_subscription',
						},
						adjustments: [
							{
								type: 'exclude_subscriptions',
								sourceId: null,
								label: 'Exclude subscriptions from total',
								percentage: null,
								price_number: '-120',
							},
							{
								type: 'subscription_installment',
								sourceId: '2216',
								label: 'Subscription: pay installment for paragraph ID 2216',
								percentage: null,
								price_number: '120.00',
							},
							{
								type: 'card_tax',
								sourceId: '81',
								label: 'Italy 22%',
								percentage: '0.22',
								price_number: '26.4',
							},
						],
						installments: [
							{
								id: 2216,
								number: 1,
								euid: '4014ea49-8b4b-407e-ab16-0b5be0b6dc75',
								parent: 4979,
								tot_installments: 1,
								is_unique: true,
								first_installment: 2216,
								is_first: 1,
								last_installment: 2216,
								is_last: 1,
								due_date: '2021-06-07',
								period_start: '2021-06-07',
								period_end: '2022-06-07',
								is_period_in: true,
								is_period_expired: false,
								is_payment_due: false,
								total_price_no_tax: 120,
								total_price: 146.4,
								tax_amount: 26.4,
								tax_percentage: 22,
								payment_state: 'completed',
							},
						],
					},
					{
						id: '4980',
						bundle: 'for_life',
						qty: '1.00',
						unit_price: '72.000000',
						total_price: '72.000000',
						adjusted_unit_price: '87.84',
						adjusted_total_price: '87.84',
						variation: {
							id: '36',
							sku: 'Privacy e Salute e Sicurezza sul lavoro _S4C',
							title: 'Privacy e salute e sicurezza sul lavoro ',
							bundle: 'learning',
							learning_contents: [
								{
									id: '302',
									title: 'GDPR - Tutela privacy',
									type: 'selection',
								},
								{
									id: '442',
									title: 'Salute e sicurezza sul lavoro',
									type: 'selection',
								},
							],
						},
						product: {
							id: '31',
							title: 'Formazione obbligatoria',
							bundle: 'learning',
						},
						adjustments: [
							{
								type: 'card_tax',
								sourceId: '81',
								label: 'Italy 22%',
								percentage: '0.22',
								price_number: '15.84',
							},
						],
					},
					{
						id: '4981',
						bundle: 'for_life',
						qty: '1.00',
						unit_price: '100.000000',
						total_price: '100.000000',
						adjusted_unit_price: '122.00',
						adjusted_total_price: '122.00',
						variation: {
							id: '65',
							sku: 'INTERNAZIONALIZZAZIONE_S4C',
							title: 'Internazionalizzazione',
							bundle: 'learning',
							learning_contents: [
								{
									id: '350',
									title: 'Le garanzie internazionali',
									type: 'collection',
								},
								{
									id: '400',
									title: 'Internazionalizzazione e trade estero',
									type: 'collection',
								},
								{
									id: '412',
									title: 'Trade e structured export finance solutions',
									type: 'collection',
								},
							],
						},
						product: {
							id: '60',
							title: 'Prodotto Internazionalizzazione',
							bundle: 'learning',
						},
						adjustments: [
							{
								type: 'card_tax',
								sourceId: '81',
								label: 'Italy 22%',
								percentage: '0.22',
								price_number: '22',
							},
						],
					},
				],
				adjustments: [],
			},
			{
				id: '2179',
				bundle: 'default',
				euid: '4014ea49-8b4b-407e-ab16-0b5be0b6dc75',
				created: 1623053879,
				placed: 1623053888,
				state: 'completed',
				subtotal_price_number: '25.000000',
				total_price_number: '30.500000',
				tax_amount: '5.5',
				tax_percentage: 22,
				paymentMethodId: '432',
				order_items: [
					{
						id: '4999',
						bundle: 'for_life',
						qty: '1.00',
						unit_price: '25.000000',
						total_price: '25.000000',
						adjusted_unit_price: '30.50',
						adjusted_total_price: '30.50',
						variation: {
							id: '33',
							sku: 'FL2',
							title: 'Relazione banca Impresa',
							bundle: 'learning',
							learning_contents: [
								{
									id: '198',
									title: 'Relazione banca impresa',
									type: 'collection',
								},
							],
						},
						product: {
							id: '28',
							title: 'Finger learning - Relazione banca Impresa',
							bundle: 'learning',
						},
						adjustments: [
							{
								type: 'card_tax',
								sourceId: '81',
								label: 'Italy 22%',
								percentage: '0.22',
								price_number: '5.5',
							},
						],
					},
				],
				adjustments: [],
			},
			{
				id: '2352',
				bundle: 'default',
				euid: '4014ea49-8b4b-407e-ab16-0b5be0b6dc75',
				created: 1623677520,
				placed: 1623677532,
				state: 'completed',
				subtotal_price_number: '392',
				total_price_number: '478.240000',
				tax_amount: '86.24',
				tax_percentage: 22,
				paymentMethodId: '432',
				order_items: [
					{
						id: '5394',
						bundle: 'subscription',
						qty: '1.00',
						unit_price: '120.000000',
						total_price: '120.000000',
						adjusted_unit_price: '146.40',
						adjusted_total_price: '146.40',
						variation: {
							id: '35',
							sku: 'BASE_S4C',
							title: 'Base',
							bundle: 'learning_subscription',
							learning_contents: [
								{
									id: '303',
									title: 'Pacchetto Base - 10 collection',
									type: 'custom_pack',
									learning_type: 'collection',
									limited: '10',
								},
							],
						},
						product: {
							id: '30',
							title: 'Pacchetto Base - 10 collection',
							bundle: 'learning_subscription',
						},
						adjustments: [
							{
								type: 'exclude_subscriptions',
								sourceId: null,
								label: 'Exclude subscriptions from total',
								percentage: null,
								price_number: '-120',
							},
							{
								type: 'subscription_installment',
								sourceId: '2327',
								label: 'Subscription: pay installment for paragraph ID 2327',
								percentage: null,
								price_number: '120.00',
							},
							{
								type: 'card_tax',
								sourceId: '81',
								label: 'Italy 22%',
								percentage: '0.22',
								price_number: '26.4',
							},
						],
						installments: [
							{
								id: 2327,
								number: 1,
								euid: '4014ea49-8b4b-407e-ab16-0b5be0b6dc75',
								parent: 5394,
								tot_installments: 1,
								is_unique: true,
								first_installment: 2327,
								is_first: 1,
								last_installment: 2327,
								is_last: 1,
								due_date: '2021-06-14',
								period_start: '2021-06-14',
								period_end: '2022-06-14',
								is_period_in: true,
								is_period_expired: false,
								is_payment_due: false,
								total_price_no_tax: 120,
								total_price: 146.4,
								tax_amount: 26.4,
								tax_percentage: 22,
								payment_state: 'completed',
							},
						],
					},
					{
						id: '5395',
						bundle: 'for_life',
						qty: '1.00',
						unit_price: '72.000000',
						total_price: '72.000000',
						adjusted_unit_price: '87.84',
						adjusted_total_price: '87.84',
						variation: {
							id: '36',
							sku: 'Privacy e Salute e Sicurezza sul lavoro _S4C',
							title: 'Privacy e salute e sicurezza sul lavoro ',
							bundle: 'learning',
							learning_contents: [
								{
									id: '302',
									title: 'GDPR - Tutela privacy',
									type: 'selection',
								},
								{
									id: '442',
									title: 'Salute e sicurezza sul lavoro',
									type: 'selection',
								},
							],
						},
						product: {
							id: '31',
							title: 'Formazione obbligatoria',
							bundle: 'learning',
						},
						adjustments: [
							{
								type: 'card_tax',
								sourceId: '81',
								label: 'Italy 22%',
								percentage: '0.22',
								price_number: '15.84',
							},
						],
					},
					{
						id: '5396',
						bundle: 'for_life',
						qty: '1.00',
						unit_price: '100.000000',
						total_price: '100.000000',
						adjusted_unit_price: '122.00',
						adjusted_total_price: '122.00',
						variation: {
							id: '75',
							sku: 'Big Data, A.I. e Industria 4.0_S4C',
							title: 'Big data, A.I. e industria 4.0',
							bundle: 'learning',
							learning_contents: [
								{
									id: '314',
									title: 'Internet of things e 5g per l’industria 4.0',
									type: 'collection',
								},
								{
									id: '18',
									title: 'Big data',
									type: 'collection',
								},
								{
									id: '147',
									title: 'Realtà virtuale e aumentata',
									type: 'collection',
								},
								{
									id: '313',
									title: 'Additive manufacturing',
									type: 'collection',
								},
							],
						},
						product: {
							id: '70',
							title: 'Pacchetto Big data, A.I. e industria 4.0',
							bundle: 'learning',
						},
						adjustments: [
							{
								type: 'card_tax',
								sourceId: '81',
								label: 'Italy 22%',
								percentage: '0.22',
								price_number: '22',
							},
						],
					},
					{
						id: '5397',
						bundle: 'for_life',
						qty: '1.00',
						unit_price: '100.000000',
						total_price: '100.000000',
						adjusted_unit_price: '122.00',
						adjusted_total_price: '122.00',
						variation: {
							id: '79',
							sku: 'Business turistico_S4C',
							title: 'Business turistico',
							bundle: 'learning',
							learning_contents: [
								{
									id: '462',
									title: 'Turismo ospitalità diffusa',
									type: 'collection',
								},
								{
									id: '517',
									title: 'Digitale per strutture alberghiere',
									type: 'collection',
								},
								{
									id: '520',
									title: 'Turismo enogastronomico',
									type: 'collection',
								},
							],
						},
						product: {
							id: '74',
							title: 'Pacchetto Business turistico',
							bundle: 'learning',
						},
						adjustments: [
							{
								type: 'card_tax',
								sourceId: '81',
								label: 'Italy 22%',
								percentage: '0.22',
								price_number: '22',
							},
						],
					},
				],
				adjustments: [],
			},
			{
				id: '2376',
				bundle: 'default',
				euid: '4014ea49-8b4b-407e-ab16-0b5be0b6dc75',
				created: 1623767551,
				placed: 1623767565,
				state: 'completed',
				subtotal_price_number: '512',
				total_price_number: '624.640000',
				tax_amount: '112.64',
				tax_percentage: 22,
				paymentMethodId: '432',
				order_items: [
					{
						id: '5471',
						bundle: 'subscription',
						qty: '2.00',
						unit_price: '120.000000',
						total_price: '240.000000',
						adjusted_unit_price: '146.40',
						adjusted_total_price: '292.80',
						variation: {
							id: '35',
							sku: 'BASE_S4C',
							title: 'Base',
							bundle: 'learning_subscription',
							learning_contents: [
								{
									id: '303',
									title: 'Pacchetto Base - 10 collection',
									type: 'custom_pack',
									learning_type: 'collection',
									limited: '10',
								},
							],
						},
						product: {
							id: '30',
							title: 'Pacchetto Base - 10 collection',
							bundle: 'learning_subscription',
						},
						adjustments: [
							{
								type: 'exclude_subscriptions',
								sourceId: null,
								label: 'Exclude subscriptions from total',
								percentage: null,
								price_number: '-240',
							},
							{
								type: 'subscription_installment',
								sourceId: '2345',
								label: 'Subscription: pay installment for paragraph ID 2345',
								percentage: null,
								price_number: '240.00',
							},
							{
								type: 'card_tax',
								sourceId: '81',
								label: 'Italy 22%',
								percentage: '0.22',
								price_number: '52.8',
							},
						],
						installments: [
							{
								id: 2345,
								number: 1,
								euid: '4014ea49-8b4b-407e-ab16-0b5be0b6dc75',
								parent: 5471,
								tot_installments: 1,
								is_unique: true,
								first_installment: 2345,
								is_first: 1,
								last_installment: 2345,
								is_last: 1,
								due_date: '2021-06-15',
								period_start: '2021-06-15',
								period_end: '2022-06-15',
								is_period_in: true,
								is_period_expired: false,
								is_payment_due: false,
								total_price_no_tax: 240,
								total_price: 292.8,
								tax_amount: 52.8,
								tax_percentage: 22,
								payment_state: 'completed',
							},
						],
					},
					{
						id: '5472',
						bundle: 'for_life',
						qty: '1.00',
						unit_price: '72.000000',
						total_price: '72.000000',
						adjusted_unit_price: '87.84',
						adjusted_total_price: '87.84',
						variation: {
							id: '36',
							sku: 'Privacy e Salute e Sicurezza sul lavoro _S4C',
							title: 'Privacy e salute e sicurezza sul lavoro ',
							bundle: 'learning',
							learning_contents: [
								{
									id: '302',
									title: 'GDPR - Tutela privacy',
									type: 'selection',
								},
								{
									id: '442',
									title: 'Salute e sicurezza sul lavoro',
									type: 'selection',
								},
							],
						},
						product: {
							id: '31',
							title: 'Formazione obbligatoria',
							bundle: 'learning',
						},
						adjustments: [
							{
								type: 'card_tax',
								sourceId: '81',
								label: 'Italy 22%',
								percentage: '0.22',
								price_number: '15.84',
							},
						],
					},
					{
						id: '5473',
						bundle: 'for_life',
						qty: '1.00',
						unit_price: '100.000000',
						total_price: '100.000000',
						adjusted_unit_price: '122.00',
						adjusted_total_price: '122.00',
						variation: {
							id: '65',
							sku: 'INTERNAZIONALIZZAZIONE_S4C',
							title: 'Internazionalizzazione',
							bundle: 'learning',
							learning_contents: [
								{
									id: '350',
									title: 'Le garanzie internazionali',
									type: 'collection',
								},
								{
									id: '400',
									title: 'Internazionalizzazione e trade estero',
									type: 'collection',
								},
								{
									id: '412',
									title: 'Trade e structured export finance solutions',
									type: 'collection',
								},
							],
						},
						product: {
							id: '60',
							title: 'Prodotto Internazionalizzazione',
							bundle: 'learning',
						},
						adjustments: [
							{
								type: 'card_tax',
								sourceId: '81',
								label: 'Italy 22%',
								percentage: '0.22',
								price_number: '22',
							},
						],
					},
					{
						id: '5474',
						bundle: 'for_life',
						qty: '1.00',
						unit_price: '100.000000',
						total_price: '100.000000',
						adjusted_unit_price: '122.00',
						adjusted_total_price: '122.00',
						variation: {
							id: '70',
							sku: 'ESG e sostenibilità_S4C',
							title: 'ESG e sostenibilità',
							bundle: 'learning',
							learning_contents: [
								{
									id: '344',
									title: 'Come sviluppare un piano di welfare aziendale',
									type: 'collection',
								},
								{
									id: '20',
									title: 'Circular economy? Come svilupparla in azienda',
									type: 'collection',
								},
								{
									id: '323',
									title: 'La circular economy per la mia azienda',
									type: 'collection',
								},
							],
						},
						product: {
							id: '65',
							title: 'Pacchetto ESG e sostenibilità',
							bundle: 'learning',
						},
						adjustments: [
							{
								type: 'card_tax',
								sourceId: '81',
								label: 'Italy 22%',
								percentage: '0.22',
								price_number: '22',
							},
						],
					},
				],
				adjustments: [],
			},
			{
				id: '2377',
				bundle: 'default',
				euid: '4014ea49-8b4b-407e-ab16-0b5be0b6dc75',
				created: 1623775531,
				placed: 1623775539,
				state: 'completed',
				subtotal_price_number: '192',
				total_price_number: '234.240000',
				tax_amount: '42.24',
				tax_percentage: 22,
				paymentMethodId: '432',
				order_items: [
					{
						id: '5475',
						bundle: 'subscription',
						qty: '1.00',
						unit_price: '120.000000',
						total_price: '120.000000',
						adjusted_unit_price: '146.40',
						adjusted_total_price: '146.40',
						variation: {
							id: '35',
							sku: 'BASE_S4C',
							title: 'Base',
							bundle: 'learning_subscription',
							learning_contents: [
								{
									id: '303',
									title: 'Pacchetto Base - 10 collection',
									type: 'custom_pack',
									learning_type: 'collection',
									limited: '10',
								},
							],
						},
						product: {
							id: '30',
							title: 'Pacchetto Base - 10 collection',
							bundle: 'learning_subscription',
						},
						adjustments: [
							{
								type: 'exclude_subscriptions',
								sourceId: null,
								label: 'Exclude subscriptions from total',
								percentage: null,
								price_number: '-120',
							},
							{
								type: 'subscription_installment',
								sourceId: '2346',
								label: 'Subscription: pay installment for paragraph ID 2346',
								percentage: null,
								price_number: '120.00',
							},
							{
								type: 'card_tax',
								sourceId: '81',
								label: 'Italy 22%',
								percentage: '0.22',
								price_number: '26.4',
							},
						],
						installments: [
							{
								id: 2346,
								number: 1,
								euid: '4014ea49-8b4b-407e-ab16-0b5be0b6dc75',
								parent: 5475,
								tot_installments: 1,
								is_unique: true,
								first_installment: 2346,
								is_first: 1,
								last_installment: 2346,
								is_last: 1,
								due_date: '2021-06-15',
								period_start: '2021-06-15',
								period_end: '2022-06-15',
								is_period_in: true,
								is_period_expired: false,
								is_payment_due: false,
								total_price_no_tax: 120,
								total_price: 146.4,
								tax_amount: 26.4,
								tax_percentage: 22,
								payment_state: 'completed',
							},
						],
					},
					{
						id: '5476',
						bundle: 'for_life',
						qty: '1.00',
						unit_price: '72.000000',
						total_price: '72.000000',
						adjusted_unit_price: '87.84',
						adjusted_total_price: '87.84',
						variation: {
							id: '36',
							sku: 'Privacy e Salute e Sicurezza sul lavoro _S4C',
							title: 'Privacy e salute e sicurezza sul lavoro ',
							bundle: 'learning',
							learning_contents: [
								{
									id: '302',
									title: 'GDPR - Tutela privacy',
									type: 'selection',
								},
								{
									id: '442',
									title: 'Salute e sicurezza sul lavoro',
									type: 'selection',
								},
							],
						},
						product: {
							id: '31',
							title: 'Formazione obbligatoria',
							bundle: 'learning',
						},
						adjustments: [
							{
								type: 'card_tax',
								sourceId: '81',
								label: 'Italy 22%',
								percentage: '0.22',
								price_number: '15.84',
							},
						],
					},
				],
				adjustments: [],
			},
			{
				id: '2402',
				bundle: 'default',
				euid: '4014ea49-8b4b-407e-ab16-0b5be0b6dc75',
				created: 1623841370,
				placed: 1623841379,
				state: 'completed',
				subtotal_price_number: '50.000000',
				total_price_number: '61.000000',
				tax_amount: '11',
				tax_percentage: 22,
				paymentMethodId: '432',
				order_items: [
					{
						id: '5561',
						bundle: 'for_life',
						qty: '2.00',
						unit_price: '25.000000',
						total_price: '50.000000',
						adjusted_unit_price: '30.50',
						adjusted_total_price: '61.00',
						variation: {
							id: '37',
							sku: 'FL4',
							title: 'Il lean management ',
							bundle: 'learning',
							learning_contents: [
								{
									id: '19',
									title: 'Il lean management ',
									type: 'collection',
								},
							],
						},
						product: {
							id: '32',
							title: 'Finger Learning - Il Lean Management ',
							bundle: 'learning',
						},
						adjustments: [
							{
								type: 'card_tax',
								sourceId: '81',
								label: 'Italy 22%',
								percentage: '0.22',
								price_number: '11',
							},
						],
					},
				],
				adjustments: [],
			},
		],
	});
};

export const putOrderItemUpdateToRenewMock = () => getBaseResponse({});

export const refreshTokenMock = () =>
	new Promise(resolve =>
		resolve(
			getBaseResponse({
				token: 't o k e n',
				expiresIn: 3600,
				accessToken: 'a c c e s s t o k e n ',
				refreshToken: 'r e f r e s h t o k e n',
				domainList: [
					{
						id: 47,
						title: 'Skills4Capital',
						url: 's4b2sit.ispfdevelop.com',
						fruitionChannel: ['app', 'web'],
						cohortId: 17,
						brand: {
							name: 'Skills4Capital',
							color: '#F2284F',
							logo:
								'https://media.skills4capital.com/media/2021-04/SKILL4CAPITAL_white_0.png?VersionId=hx6KuV6lTwrUdj1nZwTk7IDmryP2vwEP',
						},
					},
				],
			})
		));

export const getAtecoCodesMock = () =>
	getBaseResponse(
		{
			help:
				'https://indicepa.gov.it/ipa-dati/api/3/action/help_show?name=datastore_search',
			success: true,
			result: {
				include_total: true,
				resource_id: '6f0f7122-3312-47ac-a292-7a647986387e',
				fields: [
					{
						type: 'int',
						id: '_id',
					},
					{
						info: {
							type_override: 'text',
							max_length: '8',
							notes: 'Codice Ateco',
						},
						type: 'text',
						id: 'Codice_ateco',
					},
					{
						info: {
							type_override: 'text',
							max_length: '310',
							notes: 'Codice Ateco - Descrizione attività ateco',
						},
						type: 'text',
						id: 'Descrizione_ateco',
					},
				],
				records_format: 'objects',
				q: '',
				records: [
					{
						_id: 1,
						Codice_ateco: '01',
						Descrizione_ateco:
							'01 - COLTIVAZIONI AGRICOLE E PRODUZIONE DI PRODOTTI ANIMALI, CACCIA E SERVIZI CONNESSI',
					},
					{
						_id: 2,
						Codice_ateco: '01.1',
						Descrizione_ateco:
							'01.1 - COLTIVAZIONE DI COLTURE AGRICOLE NON PERMANENTI',
					},
					{
						_id: 3,
						Codice_ateco: '01.11',
						Descrizione_ateco:
							'01.11 - Coltivazione di cereali (escluso il riso), legumi da granella e semi oleosi',
					},
					{
						_id: 4,
						Codice_ateco: '01.11.1',
						Descrizione_ateco:
							'01.11.1 - Coltivazione di cereali (escluso il riso)',
					},
					{
						_id: 5,
						Codice_ateco: '01.11.10',
						Descrizione_ateco:
							'01.11.10 - Coltivazione di cereali (escluso il riso)',
					},
					{
						_id: 6,
						Codice_ateco: '01.11.2',
						Descrizione_ateco: '01.11.2 - Coltivazione di semi oleosi',
					},
					{
						_id: 7,
						Codice_ateco: '01.11.20',
						Descrizione_ateco: '01.11.20 - Coltivazione di semi oleosi',
					},
					{
						_id: 8,
						Codice_ateco: '01.11.3',
						Descrizione_ateco: '01.11.3 - Coltivazione di legumi da granella',
					},
					{
						_id: 9,
						Codice_ateco: '01.11.30',
						Descrizione_ateco: '01.11.30 - Coltivazione di legumi da granella',
					},
					{
						_id: 10,
						Codice_ateco: '01.11.4',
						Descrizione_ateco:
							'01.11.4 - Coltivazioni miste di cereali, legumi da granella e semi oleosi',
					},
				],
				limit: 10,
				_links: {
					start: '/api/3/action/datastore_search',
					next: '/api/3/action/datastore_search?offset=10',
				},
				total: 3115,
			},
		},
		200,
		'ok'
	);
export const getDataPrivacyMock = () =>
	getBaseResponse({
		appName: 'S4B',
		requestId: '0245c1a9-e27c-4fda-a798-407fa3b2f91b',
		success: true,
		errorResponse: null,
		dataPrivacy: {
			id: '41face55-44eb-4714-9cc5-c673b196950d',
			creationDate: '2021-07-08T16:12:23.372',
			lastUpdate: '2021-07-08T16:12:23.372',
			organizationType: 'ditta_individuale', // 'persona_giuridica', // undefined, //
			dataPrivacylist: [
				{
					mandatory: true,
					authorized: true,
					type: 'Consenso_0010',
				},
				{
					mandatory: true,
					authorized: true,
					type: 'Consenso_0017',
				},
				{
					mandatory: false,
					authorized: true,
					type: 'Consenso_0011',
				},
				{
					mandatory: false,
					authorized: false,
					type: 'Consenso_0012',
				},
				// {
				//   mandatory: false,
				//   authorized: true,
				//   type: 'Consenso_0016'
				// }
			],
		},
		resultCode: 200,
		errorManagement: null,
	});

export const postDataPrivacyMock = () => getBaseResponse({}, 204);

export const getFilteredDomainSettingsMock = () =>
	getBaseResponse(
		{
			english_course_platform_image: "https://medias4b2sit.ispfdevelop.com/media/2022-07/favicon_Black_Untitled.png?VersionId=V_B6izOy6kMkc_dgdHUoexxPEaqgYXHQ",
			english_course_platform_title: "Master English: unlock your language potential!",
			english_course_platform_url: "url",
			banner_course_platform_url: "https://eu.knowbe4.com/learner/index.html#/dashboard",
			banner_course_platform_title: "Impara a difenderti dagli attacchi informatici!",
			banner_course_platform_image: "",
			banner_course_platform_logo: "",
			favicon: "https://medias4b2sit.ispfdevelop.com/media/2022-07/favicon_Black_Untitled.png?VersionId=V_B6izOy6kMkc_dgdHUoexxPEaqgYXHQ",
			footer: {
				footer_color: "#323232",
				footer_copyright: "® Copyright Intesa Sanpaolo Formazione - P.IVA 1991500015",
				footer_description: "Intesa Sanpaolo Formazione è una società del gruppo",
				footer_left_logo: "http://s4c.local:8080/sites/default/files/2022-01/998.png",
				footer_left_logo_link: "https://www.intesasanpaoloformazione.it/",
				footer_right_logo: "http://s4c.local:8080/sites/default/files/2022-01/999.png",
				footer_right_logo_link: "https://www.intesasanpaolo.com/"
			},
			hidden_elements: {
				hide_five_minutes: false,
				hide_followers: false,
				hide_footer: false,
				hide_mandatory_progress: false,
				hide_notes: false,
				hide_report: false,
				hide_standard_progress: false
			},
			link_cookies: "https://www.intesasanpaolo.com/cookie-policy/",
			link_privacy: "https://www.intesasanpaolo.com/privacy-policy/",
			meta_title: "Skills4Capital",
			middleware_configs: {
				base_url_cognito: "a",
				client_id: "a",
				identity_pool_name: "a",
				redirect_uri: "a"
			}
		},
		200
	);

export const getFullCatalogMock = () =>
	getBaseResponse(
		{
			data: [
				{
					body:
						'<p><span><span><span><span><span><span>Scopri quali sono i principali rischi informatici e capisci come proteggere la tua azienda dagli attacchi informatici e capisci come proteggere la tua azienda dagli attacchi informatici</span></span></span></span></span></span></p>',
					body_trimmed:
						'<p><span><span><span><span><span><span>Scopri quali sono i principali rischi informatici e capisci come proteggere la tua azienda dagli attacchi informatici',
					contents: [
						{
							id: '324',
							title: 'Cyber crime: cos’è e perchè devi conoscerlo',
							duration: '180',
						},
					],
					cover:
						'https://d22cxfqtum6m93.cloudfront.net/media/2021-08/Collection%2051_0.jpg?VersionId=qAP2HCYNtK5DEoBN6p6MiyKBERdTUVTi',
					id: 1089,
					need_id: 93,
					need_name: 'ESG e sostenibilità - Intermedio',
					title: 'Cybersecurity: introduzione alla sicurezza informatica',
				},
				{
					id: 58,
					title: 'test collection1',
					body: '\u003Cp\u003Ebody\u003C/p\u003E',
					body_trimmed: '\u003Cp\u003Ebody\u003C/p\u003E',
					cover:
						'https://d22cxfqtum6m93.cloudfront.net/media/2021-05/Collection%2017.jpg?VersionId=Ns1N5pD2HYd9sHxM9g5bjk2eyWbPz5pO',
					need_id: 76,
					need_name: 'Esigenza 1',
					contents: [
						{ id: '42', title: 'lo1', duration: '99' },
						{ id: '43', title: 'lo2', duration: '10' },
					],
				},
				{
					id: 50,
					title: 'test coll',
					body:
						'\u003Cp\u003EIl 25 settembre 2015 l’Assemblea Generale delle Nazioni Unite ha formalmente adottato l’Agenda 2030 per lo Sviluppo Sostenibile, corredata da una lista di 17 obiettivi e 169 sotto-obiettivi che riguardano tutte le dimensioni della vita umana e del pianeta. Questo corso spiega cos’è l’Agenda 2030 e analizza in dettaglio i 17 Obiettivi di Sviluppo Sostenibile.\u003C/p\u003E',
					body_trimmed:
						'\u003Cp\u003EIl 25 settembre 2015 l’Assemblea Generale delle Nazioni Unite ha formalmente adottato l’Agenda 2030\u003C/p\u003E',
					cover:
						'http://s4b2.local:8080/sites/default/files/2021-04/lemon_black.jpg',
					need_id: 76,
					need_name: 'Esigenza 1',
					contents: [{ id: '42', title: 'lo1', duration: '99' }],
				},
				{
					id: 38,
					title: 'Selection 1',
					body: 0,
					body_trimmed: 0,
					cover: 0,
					need_id: 76,
					need_name: 'Esigenza 1',
					contents: [
						{ id: '56', title: 'Titolo Training', duration: '' },
						{ id: '47', title: 'Training 2', duration: '120' },
						{ id: '46', title: 'Training 1', duration: '180' },
						{ id: '48', title: 'Training 3', duration: '150' },
						{ id: '49', title: 'Training 4', duration: '190' },
					],
				},
				{
					id: 20,
					title: '3. Collection',
					body: 0,
					body_trimmed: 0,
					cover: 0,
					need_id: 94,
					need_name: 'Esigenza 2',
					contents: null,
				},
				{
					id: 19,
					title: '2. Collection',
					body: 0,
					body_trimmed: 0,
					cover: 0,
					need_id: 76,
					need_name: 'Esigenza 1',
					contents: [
						{ id: '53', title: 'Titolo L.O. test api2', duration: '10' },
						{ id: '44', title: 'lo3', duration: '10' },
						{ id: '54', title: 'Titolo L.O.', duration: '10' },
						{ id: '52', title: 'Titolo L.O. test api', duration: '10' },
						{ id: '43', title: 'lo2', duration: '10' },
						{ id: '55', title: 'Titolo L.O. test 3', duration: '10' },
					],
				},
				{
					id: 18,
					title: '1. Collection',
					body: 0,
					body_trimmed: 0,
					cover: 0,
					need_id: 94,
					need_name: 'Esigenza 2',
					contents: [
						{ id: '42', title: 'lo1', duration: '99' },
						{ id: '44', title: 'lo3', duration: '10' },
						{ id: '45', title: 'lo4', duration: '10' },
						{ id: '43', title: 'lo2', duration: '10' },
					],
				},
			],
			pager: {
				current_page: 0,
				total_items: '6',
				total_pages: 1,
				items_per_page: 10,
			},
			count_data_obj: '6',
		},
		200,
		'ok'
	);

export const getCommerceOrdersZuoraMock = () => getBaseResponse({
	appName: 'S4B',
	requestId: 'b4037e84-d0e0-4cef-b5d2-c46f5a3af999',
	success: true,
	errorResponse: null,
	payments: [
		{
			id: '2d955ac3-8645-4c7e-bbcc-e830cb1a8ffd',
			paymentNumber: 'PD00000043',
			paymentId: '8adcd40e7e33cab2017e435a3bdb6ca1',
			accountNumber: 'A00000017',
			domain: '41',
			paymentDate: '2022-01-10T10:38:16.000+0000',
			paymentStatusDate: null,
			paymentStatus: 'PENDING',
			paymentAmount: 146.4,
			paymentMethod: {
				type: 'CreditCard',
				paymentAccountNumber: '************1111',
				paymentStatus: 'Processed',
				paymentMethodId: '8adc94ed7d9330fe017d958444ab4d71',
				creditCardType: 'Visa',
				bankTransferType: null,
			},
			invoiceItemsList: [
				{
					orderNumber: 'O-00000251',
					invoiceItemId: '8adcd40e7e33cab2017e435a3b3e6c98',
					invoiceId: '2244SD00000123',
					subscriptionNumber: 'A-S00000312',
					subscriptionId: '8adcd40e7e33cab2017e435a3a0b6c84',
					activationDate: '2022-01-10T00:00:00.000+0000',
					expirationDate: '2023-01-09T00:00:00.000+0000',
					productName: 'BASE',
					chargeType: 'Recurring',
					quantity: 1,
				},
			],
			invoicesList: [
				{
					invoiceId: '8adcd40e7e33cab2017e435a3b276c97',
					invoiceNumber: '2244SD00000123',
					invoiceDate: '2022-01-10T00:00:00.000+0000',
					dueDate: '2022-01-10T00:00:00.000+0000',
					amount: 146.4,
					amountWithoutTax: 120.0,
					taxAmount: 26.4,
					invoiceStatus: 'Posted',
					invoiceReady: false,
				},
			],
			renewal: false,
		},
	],
	nextPage: null,
	items: 3,
	nextPagePresent: false,
	resultCode: 200,
	errorManagement: null,
}, 200);

export const getSubcriptionDraftMock = () => getBaseResponse(
	{
		appName: 'S4B',
		errorManagement: null,
		errorResponse: null,
		items: null,
		nextPage: null,
		nextPagePresent: false,
		requestId: '64fd8787-2c4d-4189-bd39-e91c7d88edcb',
		resultCode: 200,
		subscriptions: [
			{
				accountNumber: 'A00000787',
				calendarChoice: 'preselected',
				creationDate: '2023-02-16T12:05:53.383',
				domain: '41',
				endDate: null,
				lastUpdate: '2023-02-16T12:05:53.383',
				managerId: '9939ef2e-f1eb-4916-8f0c-2d82bbf181a0',
				originalQuantity: 4,
				packageType: 'premium',
				productId: '8adc96cf86254efe018626b0cd2114c1',
				productName: 'ESG Premium',
				productPackage: {
					countCol: 1,
					countLiveEvent: 3,
					countSel: 0,
					listCol: [
						'76'
					],
					listLiveEvent: [
						{
							liveEventId: '240',
							sessionId: null
						},
						{
							liveEventId: '241',
							sessionId: null
						},
						{
							liveEventId: '284',
							sessionId: null
						}
					],
					listSel: []
				},
				quantity: 2,
				sourceType: 'BANK',
				startDate: null,
				status: 'UNASSIGNED',
				subscriptionId: '16FEB000004',
				subscriptionNumber: '16FEB000004',
				total: '240.0',
				type: 'OneTime',
				variationId: '1038'
			}
		],
		success: true
	}
);

export const getActiveSubscriptionsMock = () =>
	getBaseResponse(
		{
			appName: "S4B",
			errorManagement: null,
			errorResponse: null,
			requestId: "7b3c0b01-da56-4bd7-8606-454faa327421",
			response: {
				"518e70cd-3d89-4e71-8b86-9250d30ce194": [
					{
						email: "gianni.pinotto@yopmail.com",
						offerts: [
							{
								body: "Fino al 31/03/2023 è possibile sottoscrivere questo pacchetto gratuitamente",
								calendarId: null,
								chargeType: "OneTime",
								managerId: "518e70cd-3d89-4e71-8b86-9250d30ce194",
								packageType: "base",
								productId: "8adcddea7cb5ba54017cb6d9dd205be6",
								prospectId: "15045252-5859-4e86-bdc5-cb10dab717ae",
								renewal: true,
								sourceType: "PORTAL",
								status: "payment_pending",
								subscriptionId: "8adc861c84426f460184525a8bfe721f",
								title: "Cyber security",
								variationId: "1011"
							},
						]
					},
					{
						email: "alt.tq-4s45gyo@yopmail.com",
						offerts: [
							{
								body: "8 collection di contenuti formativi personalizzabili per tema e settore, in continuo aggiornamento.",
								calendarId: null,
								chargeType: "Recurring",
								managerId: "518e70cd-3d89-4e71-8b86-9250d30ce194",
								packageType: "base",
								productId: "8adcddea7c6430e2017c761d100851a7",
								prospectId: "6832e1a0-2866-477f-98fa-d0c10e01332c",
								renewal: true,
								sourceType: "PORTAL",
								status: "active",
								subscriptionId: "8adcd6298409a81301840a57e49663ce",
								title: "BASE",
								variationId: "968"
							}
						]
					},
					{
						email: "scormatorealta2@yopmail.com",
						offerts: [
							{
								body: "Fino al 31/03/2023 è possibile sottoscrivere questo pacchetto gratuitamente",
								calendarId: null,
								chargeType: "OneTime",
								managerId: "518e70cd-3d89-4e71-8b86-9250d30ce194",
								packageType: "base",
								productId: "8adcddea7cb5ba54017cb6d9dd205be6",
								prospectId: "45ad88c4-2f8e-41f4-a112-8f2cb5ea5d58",
								renewal: false,
								sourceType: "PORTAL",
								status: "INACTIVE",
								subscriptionId: "8adc861c83f9b6e80183fb5faea83945",
								title: "Cyber security",
								variationId: "1011"
							},
							{
								body: "Fino al 31/03/2023 è possibile sottoscrivere questo pacchetto gratuitamente",
								calendarId: null,
								chargeType: "OneTime",
								managerId: "518e70cd-3d89-4e71-8b86-9250d30ce194",
								packageType: "base",
								productId: "8adcddea7cb5ba54017cb6d9dd205be6",
								prospectId: "15045252-5859-4e86-bdc5-cb10dab717ae",
								renewal: true,
								sourceType: "PORTAL",
								status: "active",
								subscriptionId: "8adc861c84426f460184525a8bfe721f",
								title: "Cyber security",
								variationId: "1011"
							},
							{
								body: null,
								calendarId: null,
								chargeType: "OneTime",
								managerId: "518e70cd-3d89-4e71-8b86-9250d30ce194",
								packageType: "base",
								productId: "8adcd9928455c8ef01845c2aa6b0573d",
								prospectId: "e20e09c5-9b84-421c-8310-2bc44a393eee",
								renewal: false,
								sourceType: "PORTAL",
								status: "INACTIVE",
								subscriptionId: "8adcf4a68455c8eb01845ce9913d5f05",
								title: "Learning Journey - ESG Premium",
								variationId: "1034"
							},
							{
								body: "void",
								calendarId: null,
								chargeType: "void",
								managerId: "518e70cd-3d89-4e71-8b86-9250d30ce194",
								packageType: "base",
								productId: "8adc83238455b91601845cc5e50f4d91",
								prospectId: "39b96cd0-4f07-43b1-ae0b-8b8efad1903c",
								renewal: false,
								sourceType: "PORTAL",
								status: "INACTIVE",
								subscriptionId: "8adcf4a68455c8eb01845ce992685f14",
								title: "void",
								variationId: "1035"
							},
							{
								body: null,
								calendarId: null,
								chargeType: "OneTime",
								managerId: "518e70cd-3d89-4e71-8b86-9250d30ce194",
								packageType: "base",
								productId: "8adc99998455b91f01845cc6402d1d2c",
								prospectId: "52a3ec49-90ed-41ab-a0cd-44692208a6d2",
								renewal: false,
								sourceType: "PORTAL",
								status: "INACTIVE",
								subscriptionId: "8adcf4a68455c8eb01845ce9900d5eef",
								title: "ESG Basic",
								variationId: "1037"
							},
							{
								body: "void",
								calendarId: null,
								chargeType: "void",
								managerId: "518e70cd-3d89-4e71-8b86-9250d30ce194",
								packageType: "base",
								productId: "8adc84828455b97201845cc612d85f14",
								prospectId: "cc5e71b3-4ba2-43e8-808b-ad53a8fb2c2f",
								renewal: false,
								sourceType: "PORTAL",
								status: "INACTIVE",
								subscriptionId: "8adcf4a68455c8eb01845ce993f35f30",
								title: "void",
								variationId: "1036"
							},
							{
								body: null,
								calendarId: null,
								chargeType: "OneTime",
								managerId: "518e70cd-3d89-4e71-8b86-9250d30ce194",
								packageType: "base",
								productId: "8adc99998455b91f01845cc6402d1d2c",
								prospectId: "febd367f-b179-433f-9d68-f5bd91806c60",
								renewal: true,
								sourceType: "BANK",
								status: "active",
								subscriptionId: "ITEM1401",
								title: "ESG Basic",
								variationId: "1037"
							},
							{
								body: null,
								calendarId: "264",
								chargeType: "OneTime",
								managerId: "518e70cd-3d89-4e71-8b86-9250d30ce194",
								packageType: "premium",
								productId: "8adc96cf86254efe018626b0cd2114c1",
								prospectId: "be08f450-dbbd-49d7-92a2-428a0f1816fd",
								renewal: true,
								sourceType: "BANK",
								status: "active",
								subscriptionId: "ITEM1402",
								title: "ESG Premium",
								variationId: "1038"
							}
						]
					},
					{
						email: "erinda_01@yopmail.com",
						offerts: [
							{
								body: null,
								calendarId: "264",
								chargeType: "OneTime",
								managerId: "f228a48e-daa8-40f8-be44-3fa3df735837",
								packageType: "premium",
								productId: "8adc96cf86254efe018626b0cd2114c1",
								prospectId: "8663b376-c055-4e99-8054-38ee909113b4",
								renewal: true,
								sourceType: "BANK",
								status: "active",
								subscriptionId: "ITEM1402",
								title: "ESG Premium",
								variationId: "1038"
							}
						]
					}
				]
			},
			resultCode: 200,
			success: true
		}
	);


export const getTotalAmountAndCountSubscriptions = () => getBaseResponse({
	appName: 'S4B',
	requestId: 'c2f114b9-52e4-4ef5-82c2-930029d318a4',
	success: true,
	errorResponse: null,
	items: 99,
	totalAmount: 200.45,
	resultCode: 200,
	errorManagement: null,
},
	200);

export const getSubscriptionProductNamesMock = () => getBaseResponse({
	appName: 'S4B',
	requestId: 'c2f114b9-52e4-4ef5-82c2-930029d318a4',
	success: true,
	subscriptions: [],
	errorResponse: null,
	resultCode: 200,
	errorManagement: null,
},
	404);

export const getPackagesMock = () => (
	getBaseResponse({
		appName: "S4B",
		requestId: "0b6cf371-cfad-43b1-9fc0-9c87d5488f00",
		success: true,
		errorResponse: null,
		packageCount: 2,
		packageList: [
			{
				packageId: "345c2774-15ac-40a3-8de2-aeb1637991fe",
				productId: "8adc96cf86254efe018626b0cd2114c1",
				userId: "ad9b668d-f5dc-464d-a8f8-44ad7fe5610d",
				numberOfAsset: 4,
				numberOfAssetCompleted: 0,
				totalDuration: "1320",
				packageType: "premium",
				domainId: "41",
				cover: "https://medias4b2sit.ispfdevelop.com/media/2022-12/PERFORMANCE%20E%20COMPETITIVIT%C3%80%20ESG%20-%20PREMIUM.jpeg?VersionId=pHtreI1P7phdu1ayREFvvBAUS7a_BDN2",
				title: "ESG Premium",
				body: null,
				tag: [],
				packageStatus: "Active",
				calendarId: "267",
				numberOfAssetContents: 5,
				numberOfAssetContentsCompleted: 0
			},
			{
				packageId: "2b004005-5029-4eff-87f8-73830c0b7be6",
				productId: "8adc99998455b91f01845cc6402d1d2c",
				userId: "ad9b668d-f5dc-464d-a8f8-44ad7fe5610d",
				numberOfAsset: 6,
				numberOfAssetCompleted: 3,
				totalDuration: "5940",
				packageType: "base",
				domainId: "41",
				cover: "https://medias4b2sit.ispfdevelop.com/media/2023-02/ESG%20Cover.png?VersionId=kOJiPXm7nRiqk_4yVKL9To0SCTxS_U7U",
				title: "ESG Basic",
				body: null,
				tag: [],
				packageStatus: "Active",
				calendarId: null,
				numberOfAssetContents: 15,
				numberOfAssetContentsCompleted: 4
			}
		],
		resultCode: 200,
		errorManagement: null
	})
);

export const getPackageMock = () => (
	getBaseResponse({
		appName: "S4B",
		assetDetail: {
			collection: {
				items: [
					{
						body: "Come il lean management può cambiare il tuo business\r\n",
						completed: false,
						cover: "https://medias4b2sit.ispfdevelop.com/media/2022-12/lean%20management.jpg?VersionId=4uXK2CNgn9WaDaQBqDExnY.VEh.9_9Pf",
						description: null,
						itemId: "76",
						numberOfContents: 5,
						numberOfContentsCompleted: 0,
						progress: "0/5",
						sessionTime: "00:00:00",
						title: "Il lean management ",
						totalDuration: "00:33:00",
						totalDurationSec: 1980,
						type: "COLLECTION",
						weight: 2
					}
				],
				percentage: "0",
				progress: "0/1"
			},
			event: {
				items: [
					{
						body: "Esplora il ruolo che la tua azienda può giocare nella transizione verso la sostenibilità.\r\n",
						completed: false,
						cover: "https://medias4b2sit.ispfdevelop.com/media/2022-11/live%20class.jpg?VersionId=LJ00g8HmL7PIzOIpZ528SfvWQrgUMwA7",
						description: null,
						eventType: "live",
						itemId: "241",
						numberOfContents: 1,
						numberOfContentsCompleted: 0,
						progress: "0/1",
						session: {
							calendarId: "267",
							domainId: "41",
							endDate: "2023-03-27T12:00:00Z",
							link: null,
							liveEventId: 241,
							locations: [
								{
									address: "Corso Inghilterra, 3",
									city: "Torino",
									lat: "45.069411",
									lon: "7.663454"
								}
							],
							sessionId: 259,
							sessionType: "LIVE",
							startDate: "2023-03-27T08:30:00Z",
							status: "ACTIVE",
							teachers: [
								{
									cover: "https://medias4b2sit.ispfdevelop.com/media/2023-02/sollo.jpg?VersionId=3aQWIm2T.SjkoKNkxQLfKx1OIH2.pVXg",
									email: "sonia.sollo@gmail.com",
									info: "Laureata in Economia",
									lastName: "Sollo",
									name: "Sonia"
								}
							],
							zuoraProductId: null
						},
						sessionId: "259",
						sessionTime: "00:00:00",
						title: "Evento finale",
						totalDuration: "00:00:00",
						totalDurationSec: 0,
						type: "LIVE_EVENT",
						weight: 4
					},
					{
						body: "Condividi i dubbi e le riflessioni sul percorso di sostenibilità che hai progettato per la tua azienda.\r\n",
						completed: false,
						cover: "https://medias4b2sit.ispfdevelop.com/media/2022-11/welcome.jpg?VersionId=_gvTOQZRpQh8GAeaBxew5usC7DI7zE7e",
						description: null,
						eventType: "virtual",
						itemId: "240",
						numberOfContents: 1,
						numberOfContentsCompleted: 0,
						progress: "0/1",
						session: {
							calendarId: "267",
							domainId: "41",
							endDate: "2023-03-21T15:00:00Z",
							link: "https://meet.google.com/",
							liveEventId: 240,
							locations: [],
							sessionId: 251,
							sessionType: "VIRTUAL",
							startDate: "2023-03-21T08:30:00Z",
							status: "ACTIVE",
							teachers: [
								{
									cover: "https://medias4b2sit.ispfdevelop.com/media/2023-02/massaro.jpg?VersionId=1E8fC1028EOR_L9e6kCxCvzGrCoEP0bK",
									email: "massaro.luigi@gmail.com",
									info: "Laureato in biologia",
									lastName: "Massaro",
									name: "Luigi"
								},
								{
									cover: "https://medias4b2sit.ispfdevelop.com/media/2023-02/sollo.jpg?VersionId=3aQWIm2T.SjkoKNkxQLfKx1OIH2.pVXg",
									email: "sonia.sollo@gmail.com",
									info: "Laureata in Economia",
									lastName: "Sollo",
									name: "Sonia"
								}
							],
							zuoraProductId: null
						},
						sessionId: "251",
						sessionTime: "00:00:00",
						title: "Ask the Expert",
						totalDuration: "00:00:00",
						totalDurationSec: 0,
						type: "LIVE_EVENT",
						weight: 3
					},
					{
						body: "Scopri l’importanza dell’inclusione dei fattori ESG nella gestione della tua azienda.\r\n",
						completed: false,
						cover: "https://medias4b2sit.ispfdevelop.com/media/2022-11/welcome.jpg?VersionId=_gvTOQZRpQh8GAeaBxew5usC7DI7zE7e",
						description: null,
						eventType: "virtual",
						itemId: "284",
						numberOfContents: 1,
						numberOfContentsCompleted: 0,
						progress: "0/1",
						session: {
							calendarId: "267",
							domainId: "41",
							endDate: "2023-03-22T13:00:00Z",
							link: "https://meet.google.com/",
							liveEventId: 284,
							locations: [],
							sessionId: 290,
							sessionType: "VIRTUAL",
							startDate: "2023-03-22T08:00:00Z",
							status: "ACTIVE",
							teachers: [
								{
									cover: "https://medias4b2sit.ispfdevelop.com/media/2023-02/sollo.jpg?VersionId=3aQWIm2T.SjkoKNkxQLfKx1OIH2.pVXg",
									email: "sonia.sollo@gmail.com",
									info: "Laureata in Economia",
									lastName: "Sollo",
									name: "Sonia"
								}
							],
							zuoraProductId: null
						},
						sessionId: "290",
						sessionTime: "00:00:00",
						title: "Kick-off",
						totalDuration: "00:00:00",
						totalDurationSec: 0,
						type: "LIVE_EVENT",
						weight: 1
					}
				],
				percentage: "0",
				progress: "0/3"
			},
			selection: null
		},
		errorManagement: null,
		errorResponse: null,
		packageInfo: {
			body: null,
			completed: false,
			cover: "https://medias4b2sit.ispfdevelop.com/media/2022-12/PERFORMANCE%20E%20COMPETITIVIT%C3%80%20ESG%20-%20PREMIUM.jpeg?VersionId=pHtreI1P7phdu1ayREFvvBAUS7a_BDN2",
			documents: [
				{
					contentType: null,
					fileExtension: "pdf",
					fileName: "ESG Premium_ L&#039;abc del piano formativo.pdf",
					fileUri: "https://medias4b2sit.ispfdevelop.com/media/s3fs-public/2023-02/ESG%20Premium_%20L%27abc%20del%20piano%20formativo.pdf?VersionId=ywYYfV3yFWqCUn1UtlfGWytQAEZplFoH"
				},
				{
					contentType: null,
					fileExtension: "pdf",
					fileName: "ESG_Gli approfondimenti scelti per te.pdf",
					fileUri: "https://medias4b2sit.ispfdevelop.com/media/s3fs-public/2023-02/ESG_Gli%20approfondimenti%20scelti%20per%20te.pdf?VersionId=H0DEcLR226rK2JWYmd1SaY2.ZstAaTxU"
				}
			],
			itemId: 1033,
			links: [
				{
					linkName: "Google",
					linkUri: "https://google.it"
				},
				{
					linkName: "youtube",
					linkUri: "https://youtube.com"
				}
			],
			numberOfAsset: 4,
			numberOfAssetCompleted: 0,
			numberOfAssetContents: 8,
			numberOfAssetContentsCompleted: 0,
			packageType: "premium",
			survey: null,
			surveyCompleted: false,
			surveyEnabled: false,
			surveyId: 300,
			title: "ESG Premium",
			totalDuration: "1320",
			userId: "ad9b668d-f5dc-464d-a8f8-44ad7fe5610d"
		},
		requestId: "70cf8edb-e81b-4d50-b6ac-8f1c6aecc0cc",
		resultCode: 200,
		success: true
	})
);

export const getEventsMock = () => {
	const plannedEvents = [
		{
			body: null,
			cover: "https://medias4b2sit.ispfdevelop.com/media/2022-11/welcome.jpg?VersionId=_gvTOQZRpQh8GAeaBxew5usC7DI7zE7e",
			feedback: null,
			itemId: 473,
			session: {
				calendarId: "475",
				domainId: "301",
				endDate: "2023-04-10T09:00:00Z",
				link: null,
				liveEventId: 473,
				locations: [
					{
						address: "Via Farini, 41",
						city: "Milano",
						lat: "45.4882338",
						lon: "9.1823595"
					}
				],
				sessionId: 469,
				sessionType: "LIVE",
				startDate: "2023-04-10T07:00:00Z",
				status: "PENDING",
				teachers: [
					{
						cover: "https://medias4b2sit.ispfdevelop.com/media/2023-02/massaro.jpg?VersionId=1E8fC1028EOR_L9e6kCxCvzGrCoEP0bK",
						email: "massaro.luigi@gmail.com",
						info: "Laureato in biologia",
						lastName: "Massaro",
						name: "Luigi"
					}
				],
				zuoraProductId: "prelios9ff407a505254cad9f839c4e4304288b"
			},
			title: "Prelios - Kick-Off",
			type: "LIVE_EVENT"
		},
		{
			body: null,
			cover: "https://medias4b2sit.ispfdevelop.com/media/2022-11/live.jpg?VersionId=c0sRnot.WcTuGkQgqCbqabJSPpUFmfC7",
			feedback: null,
			itemId: 474,
			session: {
				calendarId: "475",
				domainId: "301",
				endDate: "2023-04-17T17:00:00Z",
				link: null,
				liveEventId: 474,
				locations: [
					{
						address: "Via Farini, 41",
						city: "Milano",
						lat: "45.4882338",
						lon: "9.1823595"
					}
				],
				sessionId: 471,
				sessionType: "VIRTUAL",
				startDate: "2023-01-17T10:00:00Z",
				status: "PENDING",
				teachers: [
					{
						cover: "https://medias4b2sit.ispfdevelop.com/media/2023-02/sollo.jpg?VersionId=3aQWIm2T.SjkoKNkxQLfKx1OIH2.pVXg",
						email: "sonia.sollo@gmail.com",
						info: "Laureata in Economia",
						lastName: "Sollo",
						name: "Sonia"
					}
				],
				zuoraProductId: "prelios9ff407a505254cad9f839c4e4304288b"
			},
			title: "Prelios - Evento Finale",
			type: "LIVE_EVENT"
		}
	];

	const lockedEvents = [
		{
			body: null,
			cover: "https://medias4b2sit.ispfdevelop.com/media/2022-11/welcome.jpg?VersionId=_gvTOQZRpQh8GAeaBxew5usC7DI7zE7e",
			feedback: null,
			itemId: 473,
			productId: 111,
			session: {
				calendarId: "475",
				domainId: "301",
				endDate: "2023-04-10T09:00:00Z",
				link: null,
				liveEventId: 473,
				locations: [
					{
						address: "Via Farini, 41",
						city: "Milano",
						lat: "45.4882338",
						lon: "9.1823595"
					}
				],
				sessionId: 469,
				sessionType: "LIVE",
				startDate: "2023-04-10T07:00:00Z",
				status: "PENDING",
				teachers: [
					{
						cover: "https://medias4b2sit.ispfdevelop.com/media/2023-02/massaro.jpg?VersionId=1E8fC1028EOR_L9e6kCxCvzGrCoEP0bK",
						email: "massaro.luigi@gmail.com",
						info: "Laureato in biologia",
						lastName: "Massaro",
						name: "Luigi"
					}
				],
				zuoraProductId: "prelios9ff407a505254cad9f839c4e4304288b"
			},
			title: "Prelios - Kick-Off",
			type: "LIVE_EVENT",
			locked: true
		},
	];

	return getBaseResponse({"appName":"s4b","requestId":"991679bd-67bf-48d7-93fc-89ffcb50f5d5","success":true,"errorResponse":null,"catalog":[{"itemId":"473","productId":"1141","title":"Prelios - Kick-Off","cover":"https://medias4b2sit.ispfdevelop.com/media/2022-11/welcome.jpg?VersionId=_gvTOQZRpQh8GAeaBxew5usC7DI7zE7e","body":null,"type":"LIVE_EVENT","description":null,"countContent":1,"eventType":"live_event","calendarChoice":"free","packageType":"premium","needId":"finger","locked":true}],"count":1,"nextPage":null,"resultCode":200,"errorManagement":null,"errorCode":null})
};
export const getAllPlannedEventsMock = () => {
	const allEvents = [
		{
			body: null,
			cover: "https://medias4b2sit.ispfdevelop.com/media/2022-11/welcome.jpg?VersionId=_gvTOQZRpQh8GAeaBxew5usC7DI7zE7e",
			feedback: null,
			itemId: 473,
			session: {
				calendarId: "475",
				domainId: "301",
				endDate: "2023-04-10T09:00:00Z",
				link: null,
				liveEventId: 473,
				locations: [
					{
						address: "Via Farini, 41",
						city: "Milano",
						lat: "45.4882338",
						lon: "9.1823595"
					}
				],
				sessionId: 469,
				sessionType: "LIVE",
				startDate: "2023-04-10T07:00:00Z",
				status: "PENDING",
				teachers: [
					{
						cover: "https://medias4b2sit.ispfdevelop.com/media/2023-02/massaro.jpg?VersionId=1E8fC1028EOR_L9e6kCxCvzGrCoEP0bK",
						email: "massaro.luigi@gmail.com",
						info: "Laureato in biologia",
						lastName: "Massaro",
						name: "Luigi"
					}
				],
				zuoraProductId: "prelios9ff407a505254cad9f839c4e4304288b"
			},
			title: "ALL Prelios - Kick-Off",
			type: "LIVE_EVENT"
		},
		{
			body: null,
			cover: "https://medias4b2sit.ispfdevelop.com/media/2022-11/live.jpg?VersionId=c0sRnot.WcTuGkQgqCbqabJSPpUFmfC7",
			feedback: null,
			itemId: 474,
			session: {
				calendarId: "475",
				domainId: "301",
				endDate: "2023-04-17T17:00:00Z",
				link: null,
				liveEventId: 474,
				locations: [
					{
						address: "Via Farini, 41",
						city: "Milano",
						lat: "45.4882338",
						lon: "9.1823595"
					}
				],
				sessionId: 471,
				sessionType: "VIRTUAL",
				startDate: "2023-01-17T10:00:00Z",
				status: "PENDING",
				teachers: [
					{
						cover: "https://medias4b2sit.ispfdevelop.com/media/2023-02/sollo.jpg?VersionId=3aQWIm2T.SjkoKNkxQLfKx1OIH2.pVXg",
						email: "sonia.sollo@gmail.com",
						info: "Laureata in Economia",
						lastName: "Sollo",
						name: "Sonia"
					}
				],
				zuoraProductId: "prelios9ff407a505254cad9f839c4e4304288b"
			},
			title: "ALL Prelios - Evento Finale",
			type: "LIVE_EVENT"
		}
	];


	return getBaseResponse({"appName":"s4b","requestId":"4ccf6f3d-2483-4adb-8beb-b962ff13fe64","success":true,"errorResponse":null,"resultCode":200,"errorManagement":null,"errorCode":null,"plannedEvents":[{"itemId":473,"title":"Prelios - Kick-Off","cover":"https://medias4b2sit.ispfdevelop.com/media/2022-11/welcome.jpg?VersionId=_gvTOQZRpQh8GAeaBxew5usC7DI7zE7e","body":"Partecipa all'evento di kick-off del tuo percorso formativo! \r\n\r\nL'evento si terrà in presenza, salva il tuo placeholder in agenda!\r\n","type":"LIVE_EVENT","session":{"domainId":"301","sessionId":592,"liveEventId":473,"calendarId":null,"zuoraProductId":"prelios376f3f643744498ba11a534df42c6882","status":"ACTIVE","sessionType":"LIVE","startDate":"2023-05-28T09:00:00Z","endDate":"2023-05-28T11:00:00Z","link":null,"locations":[{"city":"Milano","address":"Via Farini, 41","lat":"45.4882338","lon":"9.1823595"}],"teachers":[{"lastName":"Massaro","name":"Luigi","info":"Laureato in biologia","email":"massaro.luigi@gmail.com","cover":"https://medias4b2sit.ispfdevelop.com/media/2023-02/massaro.jpg?VersionId=1E8fC1028EOR_L9e6kCxCvzGrCoEP0bK"}]},"feedback":null},{"itemId":605,"title":"Prelios - primo training","cover":"https://medias4b2sit.ispfdevelop.com/media/2022-11/live%20class.jpg?VersionId=LJ00g8HmL7PIzOIpZ528SfvWQrgUMwA7","body":null,"type":"LIVE_EVENT","session":{"domainId":"301","sessionId":604,"liveEventId":605,"calendarId":null,"zuoraProductId":"prelios29b213eabc2649bb8e141ae73499215a","status":"ACTIVE","sessionType":"LIVE","startDate":"2023-06-12T10:00:00Z","endDate":"2023-06-12T11:00:00Z","link":null,"locations":[{"city":"Milano","address":"Via Roma, 3","lat":"45.487016","lon":"9.2029041"}],"teachers":[{"lastName":"Rossi","name":"Marco","info":"Laureato in ingegneria informatica ","email":"rossi.marco@gmail.com","cover":"https://medias4b2sit.ispfdevelop.com/media/2023-02/rossi.jpg?VersionId=LO0RomXPkof3T7YTHEKePdaGdajcC6zV"},{"lastName":"Massaro","name":"Luigi","info":"Laureato in biologia","email":"massaro.luigi@gmail.com","cover":"https://medias4b2sit.ispfdevelop.com/media/2023-02/massaro.jpg?VersionId=1E8fC1028EOR_L9e6kCxCvzGrCoEP0bK"}]},"feedback":null}]})
};

export const getAvailableEventsMock = () => {
	const availalbeEvents = [
		{
			body: null,
			cover: "https://medias4b2sit.ispfdevelop.com/media/2022-11/welcome.jpg?VersionId=_gvTOQZRpQh8GAeaBxew5usC7DI7zE7e",
			feedback: null,
			itemId: 473,
			session: {
				calendarId: "475",
				domainId: "301",
				endDate: "2023-04-10T09:00:00Z",
				link: null,
				liveEventId: 473,
				locations: [
					{
						address: "Via Farini, 41",
						city: "Milano",
						lat: "45.4882338",
						lon: "9.1823595"
					}
				],
				sessionId: 469,
				sessionType: "LIVE",
				startDate: "2023-04-10T07:00:00Z",
				status: "PENDING",
				teachers: [
					{
						cover: "https://medias4b2sit.ispfdevelop.com/media/2023-02/massaro.jpg?VersionId=1E8fC1028EOR_L9e6kCxCvzGrCoEP0bK",
						email: "massaro.luigi@gmail.com",
						info: "Laureato in biologia",
						lastName: "Massaro",
						name: "Luigi"
					}
				],
				zuoraProductId: "prelios9ff407a505254cad9f839c4e4304288b"
			},
			title: "AvailPrelios - Kick-Off",
			type: "LIVE_EVENT"
		},
		{
			body: null,
			cover: "https://medias4b2sit.ispfdevelop.com/media/2022-11/live.jpg?VersionId=c0sRnot.WcTuGkQgqCbqabJSPpUFmfC7",
			feedback: null,
			itemId: 474,
			session: {
				calendarId: "475",
				domainId: "301",
				endDate: "2023-04-17T17:00:00Z",
				link: null,
				liveEventId: 474,
				locations: [
					{
						address: "Via Farini, 41",
						city: "Milano",
						lat: "45.4882338",
						lon: "9.1823595"
					}
				],
				sessionId: 471,
				sessionType: "VIRTUAL",
				startDate: "2023-01-17T10:00:00Z",
				status: "PENDING",
				teachers: [
					{
						cover: "https://medias4b2sit.ispfdevelop.com/media/2023-02/sollo.jpg?VersionId=3aQWIm2T.SjkoKNkxQLfKx1OIH2.pVXg",
						email: "sonia.sollo@gmail.com",
						info: "Laureata in Economia",
						lastName: "Sollo",
						name: "Sonia"
					}
				],
				zuoraProductId: "prelios9ff407a505254cad9f839c4e4304288b"
			},
			title: "Avail Prelios - Evento Finale",
			type: "LIVE_EVENT"
		}
	];

	return getBaseResponse(
	{"appName":"s4b","requestId":"991679bd-67bf-48d7-93fc-89ffcb50f5d5","success":true,"errorResponse":null,"catalog":[{"itemId":"473","productId":"1141","title":"Prelios - Kick-Off","cover":"https://medias4b2sit.ispfdevelop.com/media/2022-11/welcome.jpg?VersionId=_gvTOQZRpQh8GAeaBxew5usC7DI7zE7e","body":null,"type":"LIVE_EVENT","description":null,"countContent":1,"eventType":"live_event","calendarChoice":"free","packageType":"premium","needId":"finger","locked":true}],"count":1,"nextPage":null,"resultCode":200,"errorManagement":null,"errorCode":null})
};

export const getEventMock = () => (
	getBaseResponse({
		appName: 's4b',
		errorManagement: null,
		errorResponse: null,
		eventDetail: {
			askTheExpert: true,
			askTheExpertLinks: [
				{
					uri: 'https://medias4b2sit.ispfdevelop.com/media/s3fs-public/2023-02/Paper_decarbonizzazione_ITA_web.pdf?VersionId=ZEYKYyxX_0NHFBVMR2pwKVauM3rzSEjS'
				}
			],
			body: 'Condividi i dubbi e le riflessioni sul percorso di sostenibilità che hai progettato per la tua azienda.',
			bookmarked: false,
			completed: false,
			cover: 'https://medias4b2sit.ispfdevelop.com/media/2022-11/welcome.jpg?VersionId=_gvTOQZRpQh8GAeaBxew5usC7DI7zE7e',
			creationDate: '2023-02-03T18:30:02+0100',
			feedback: {
				currentUserVote: -1,
				idCourseType: null,
				negative: 0,
				positive: 0,
				title: null,
				views: 6
			},
			itemId: 240,
			recommended: false,
			reviewed: false,
			reviews: [],
			session: {
				calendarId: '267',
				domainId: '41',
				endDate: '2023-03-21T15:00:00Z',
				link: 'https://meet.google.com/',
				liveEventId: 240,
				locations: [
					{
						city: 'Roma',
						address: 'Largo Arenula 2',
						lat: '41.8947',
						lon: '12.4763'
					}
				],
				sessionId: 251,
				sessionType: 'VIRTUAL',
				startDate: '2023-03-21T08:30:00Z',
				status: 'ACTIVE',
				teachers: [
					{
						cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/massaro.jpg?VersionId=1E8fC1028EOR_L9e6kCxCvzGrCoEP0bK',
						email: 'massaro.luigi@gmail.com',
						info: 'Laureato in biologia',
						lastName: 'Massaro',
						name: 'Luigi'
					},
					{
						cover: 'https://medias4b2sit.ispfdevelop.com/media/2023-02/sollo.jpg?VersionId=3aQWIm2T.SjkoKNkxQLfKx1OIH2.pVXg',
						email: 'sonia.sollo@gmail.com',
						info: 'Laureata in Economia',
						lastName: 'Sollo',
						name: 'Sonia'
					}
				],
				zuoraProductId: null
			},
			teachingMaterial: {
				documents: null,
				links: null
			},
			title: 'Ask the Expert',
			type: 'LIVE_EVENT'
		},
		requestId: 'faea54a5-2862-4096-8594-892fc083afeb',
		resultCode: 200,
		success: true
	})
);

export const getEventLockedMock = () => (
	getBaseResponse({
		appName: "s4b",
		requestId: "156b14f7-e688-4287-9e9d-62a81341bc72",
		success: true,
		errorResponse: null,
		asset: {
			itemId: "240",
			productId: "8adcd9928455c8ef01845c2aa6b0573d",
			title: "Ask the Expert",
			cover: "https://medias4b2sit.ispfdevelop.com/media/2022-11/welcome.jpg?VersionId=_gvTOQZRpQh8GAeaBxew5usC7DI7zE7e",
			body: "Condividi i dubbi e le riflessioni sul percorso di sostenibilità che hai progettato per la tua azienda.\r\n",
			type: "LIVE_EVENT", "eventType": "VIRTUAL" },
		resultCode: 200,
		errorManagement: null,
		errorCode: null
	})
)

export const getEventSessionsMock = () => (
	getBaseResponse({
		sessions:
		[
			{
				userId: null,
				sessionId: 231,
				liveEventId: 233,
				liveEventTitle: "Evento live 001",
				sessionTitle: "Sessione Febbraio 2023",
				liveEventMode: null, "totalSeats": 10,
				startDate: "2023-02-12T11:00:00+0100",
				endDate: "2023-02-16T19:00:00+0100",
				link: "http://example.com",
				locations: [
					{
					city: "Napoli",
					address: "Via Roma",
					lat: "45.4654219",
					lon: "9.1859243"
					}
				],
				teachers: [
					{
						lastName: null,
						name: "Marco",
						info: "Laureato in ingegneria informatica ",
						email: "rossi.marco@gmail.com", "cover": null },
					{
						lastName: null,
						name: "Sonia",
						info: "Laureata in Economia",
						email: "sonia.sollo@gmail.com",
						cover: null },
					{
						lastName: null,
						name: "Luigi",
						info: "Laureato in biologia",
						email: "massaro.luigi@gmail.com",
						cover: null
					}
				]
			},
			{
				userId: null,
				sessionId: 237,
				liveEventId: null,
				liveEventTitle: null,
				sessionTitle: "Sessione Aprile 2023",
				liveEventMode: null,
				totalSeats: 15,
				startDate: "2023-04-02T18:00:00+0200",
				endDate: "2023-04-06T22:00:00+0200",
				link: "http://example.com",
				locations: [
					{
						city: "Milano",
						addres: "Via Verdi",
						la: "45.4654219",
						lo: "9.1859243"
					}
				],
				teachers: [
					{
						lastName: null,
						name: "Sonia",
						info: "Laureata in Economia",
						email: "sonia.sollo@gmail.com",
						cover: null
					},
					{
						lastName: null,
						name: "Luigi",
						info: "Laureato in biologia",
						email: "massaro.luigi@gmail.com",
						cover: null
					}
				]
			}
		],
		pageInfo:
		{
			hasNextPage: false,
			nextPageToken: null,
			itemsPerPage: 2
		},
		responseResult: {
			statusCode: 200,
			success: true,
			errors: null
		}
	})
);

export const getSelectionsMock = () => (
	getBaseResponse({
		appName: "s4b",
		asset: {
			items: [
				{
					body: "Formazione obbligatoria",
					completed: false,
					cover: "https://medias4b2sit.ispfdevelop.com/media/2023-03/cover%20corsi%20legal%20%281%29.jpg?VersionId=fUnexZRn_hB1xe_Ww6o7MS8YlxKYeOFK",
					description: null,
					itemId: "341",
					numberOfContents: 10,
					numberOfContentsCompleted: 0,
					progress: "0/10",
					sessionTime: "00:00:00",
					title: "Formazione obbligatoria",
					totalDuration: "00:30:00",
					totalDurationSec: 1800,
					toBeCompletedByDate: '2020-10-19T00:00:00.000+0000',
					type: "SELECTION",
					weight: null
				},
			],
			percentage: "0",
			progress: "0/1"
		},
		errorCode: null,
		errorManagement: null,
		errorResponse: null,
		requestId: "cb8b3944-3bf8-4bd2-a153-6ff07c533338",
		resultCode: 200,
		success: true
	})
);

export const getCollectionsMock = (crossContent) => (
	crossContent ? (
		getBaseResponse({
			appName: "s4b",
			asset: {
				items: [
					{
						body: "Smart working",
						completed: false,
						cover: "https://medias4b2sit.ispfdevelop.com/media/2023-02/smartworking.jpg?VersionId=mZBeWP.1O_.IpOdquGicFNGIS4KshkdB",
						description: null,
						itemId: "91",
						numberOfContents: 2,
						numberOfContentsCompleted: 0,
						progress: "0/2",
						sessionTime: "00:00:00",
						title: "Smart working",
						totalDuration: "00:07:00",
						totalDurationSec: 420,
						type: "COLLECTION",
						weight: null
					},
					{
						body: "Fondi pubblici a favore delle imprese",
						completed: false,
						cover: "https://medias4b2sit.ispfdevelop.com/media/2023-02/fondi%20pubblici.jpg?VersionId=_1CQKN5ovsStbEHoX_0lWLbTMqAjWipi",
						description: null,
						itemId: "83",
						numberOfContents: 3,
						numberOfContentsCompleted: 0,
						progress: "0/3",
						sessionTime: "00:00:00",
						title: "Fondi pubblici a favore delle imprese",
						totalDuration: "00:11:00",
						totalDurationSec: 660,
						type: "COLLECTION",
						weight: null
					},
					{
						body: "Leadership sviluppo persone",
						completed: false,
						cover: "https://medias4b2sit.ispfdevelop.com/media/2023-02/sviluppo%20persone.jpg?VersionId=azA2CM1ZmhvLC_o988tp4fiTVxlFgXdQ",
						description: null,
						itemId: "82",
						numberOfContents: 4,
						numberOfContentsCompleted: 0,
						progress: "0/4",
						sessionTime: "00:00:00",
						title: "Leadership sviluppo persone",
						totalDuration: "00:13:00",
						totalDurationSec: 780,
						type: "COLLECTION",
						weight: null
					},
					{
						body: "I pagamenti digitali per sviluppare il business",
						completed: false,
						cover: "https://medias4b2sit.ispfdevelop.com/media/2022-12/pagamenti%20digitali.jpg?VersionId=62s9JNcocYNOZDdqMohZALl1dPOo82gQ",
						description: null,
						itemId: "97",
						numberOfContents: 2,
						numberOfContentsCompleted: 0,
						progress: "0/2",
						sessionTime: "00:00:00",
						title: "I pagamenti digitali per sviluppare il business",
						totalDuration: "00:05:00",
						totalDurationSec: 300,
						type: "COLLECTION",
						weight: null
					},
				],
				percentage: "0",
				progress: "0/4"
			},
			errorCode: null,
			errorManagement: null,
			errorResponse: null,
			requestId: "6b1284fd-50af-45b1-a0d8-9e667248ef69",
			resultCode: 200,
			success: true
		})
	) : (
		getBaseResponse({
			appName: "s4b",
			asset: {
				items: [
					{
						body: "Innovation II",
						completed: false,
						cover: "https://medias4b2sit.ispfdevelop.com/media/2023-03/Digital_workplace_esterna.jpg?VersionId=eMepo60DFdNiAFwEtHRymMu9kGopORRB",
						description: null,
						itemId: "414",
						numberOfContents: 5,
						numberOfContentsCompleted: 0,
						progress: "0/5",
						sessionTime: "00:00:00",
						title: "Innovation II",
						totalDuration: "00:20:00",
						totalDurationSec: 1200,
						type: "COLLECTION",
						weight: null
					},
					{
						body: "Leadership & Personal Skill",
						completed: false,
						cover: "https://medias4b2sit.ispfdevelop.com/media/2023-03/dare_feedback.jpg?VersionId=96rdGh1iAkElgQTZ7SldZ8VHSXmofyWi",
						description: null,
						itemId: "408",
						numberOfContents: 24,
						numberOfContentsCompleted: 0,
						progress: "0/24",
						sessionTime: "00:00:00",
						title: "Leadership & Personal Skill",
						totalDuration: "09:01:00",
						totalDurationSec: 32460,
						type: "COLLECTION",
						weight: null
					},
					{
						body: "Digital Transformation",
						completed: false,
						cover: "https://medias4b2sit.ispfdevelop.com/media/2022-12/video_sit.jpeg?VersionId=N9WLD.vEqzeOytXR8gTRq6nX8C3DCYWJ",
						description: null,
						itemId: "393",
						numberOfContents: 4,
						numberOfContentsCompleted: 0,
						progress: "0/4",
						sessionTime: "00:00:00",
						title: "Digital Transformation",
						totalDuration: "00:09:00",
						totalDurationSec: 540,
						type: "COLLECTION",
						weight: null
					},
					{
						body: "Diversity & Inclusion",
						completed: false,
						cover: "https://medias4b2sit.ispfdevelop.com/media/2023-03/01_stereotipi.jpg?VersionId=fEb_N7Hi4VLbbslJltALvWwAt6QqPUHO",
						description: null,
						itemId: "378",
						numberOfContents: 11,
						numberOfContentsCompleted: 0,
						progress: "0/11",
						sessionTime: "00:00:00",
						title: "Diversity & Inclusion",
						totalDuration: "02:24:00",
						totalDurationSec: 8640,
						type: "COLLECTION",
						weight: null
					},
				],
				percentage: "0",
				progress: "0/4"
			},
			errorCode: null,
			errorManagement: null,
			errorResponse: null,
			requestId: "6b1284fd-50af-45b1-a0d8-9e667248ef69",
			resultCode: 200,
			success: true
		})
	)
);

export const getSearchMock = () => (
	getBaseResponse({
		appName: 's4b',
		errorManagement: null,
		errorResponse: null,
		catalog: [
		   {
            image: "https://medias4b2sit.ispfdevelop.com/media/2022-12/lean%20management.jpg?VersionId=4uXK2CNgn9WaDaQBqDExnY.VEh.9_9Pf",
            itemId: 716,
            productId: 276,
            productItemId: 376,
            needId: 20,
            productSku: 'SKU',
            title: "Il lean management ",
            fingerLearning: true,
            liveEventType: 'liveEventType',
            itemType: "COLLECTION",
            domainId: 301,
            locked: false,}
        ],
		pageInfo: {
			hasNextPage: true,
			itemsPerPage: 5,
			nextPageToken: 'MToxNjc2NTU1NDEw'
		},
		requestId: 'faea54a5-2862-4096-8594-892fc083afeb',
		resultCode: 200,
		success: true
	})
);

export const getAllNewsFeedMock = () => (
	getBaseResponse({
		appName: "s4b",
		requestId: "3ceed997-90dc-4944-99a9-5c59c86336c2",
		success: true,
		errorResponse: null,
		newsfeeds: [
			{
				"newsfeedId": "7b225823-213f-484c-9168-e5d235cb267c",
				"itemId": "450",
				"objectType": "learning_object",
				"objectDomainId": "301",
				"domainId": "301",
				"title": "Digital Workplace - Professional",
				"description": null,
				"imageUrl": "https://medias4b2sit.ispfdevelop.com/media/2023-03/Soft_Skills_esterna.jpg?VersionId=KvuSmJ0Sijo8lVBebqPUdFlQGExrDKxk",
				"commentsCounter": 3,
				"sharedCounter": 1,
				"feedback": {
					"positive": 1,
					"negative": 0,
					"currentUserVote": -1
				},
				"sharedInfo": {
					"firstName": "ANTONIO",
					"lastName": "QUINZIO",
					"sharedDateTS": 1684246260026,
					"sharedDate": "2023-05-16T16:11:00.026",
					"sharedMessage": "corso bellissimissimo"
				},
				"recentComments": [
					{
						"commentId": "8d911ff1-2a16-43ce-af59-b4726b9297ca",
						"firstName": "MARIA",
						"lastName": "ROSSI",
						"body": "Prova 2",
						"newsfeedId": "7b225823-213f-484c-9168-e5d235cb267c",
						"creationDate": "2023-05-29T12:18:22.042",
						"creationDateTS": 1685355502042,
						"lastUpdateDate": "2023-05-29T12:18:43.043",
						"lastUpdateDateTS": 1685355523043,
						"deleteDate": null,
						"deleteDateTS": null,
						"logicDelete": false,
						"myComment": false,
						"title": "MARIA ROSSI",
						"domainId": "301",
						"userIdDomainId": "2aaa1fee-b915-4ec2-846e-cf80e66cdd3b:301"
					},
					{
						"commentId": "160ae566-2219-443b-89c7-3e0d65a4c4e8",
						"firstName": "M",
						"lastName": "Boetto",
						"body": "Test",
						"newsfeedId": "7b225823-213f-484c-9168-e5d235cb267c",
						"creationDate": "2023-05-26T10:57:39.061",
						"creationDateTS": 1685091459061,
						"lastUpdateDate": null,
						"lastUpdateDateTS": null,
						"deleteDate": null,
						"deleteDateTS": null,
						"logicDelete": false,
						"myComment": false,
						"title": "M Boetto",
						"domainId": "301",
						"userIdDomainId": "27a763d3-b8e5-4bfd-b9d4-d50b570d1c97:301"
					}
				],
				"locked": true,
				"notForSale": false
			},
			{
				"newsfeedId": "6bf6064c-1010-4659-986d-10c4341c6e93",
				"itemId": "23e1560a-e309-4524-b604-d00316ea46e2",
				"objectType": "no_content",
				"objectDomainId": "301",
				"domainId": "301",
				"title": "a",
				"description": null,
				"imageUrl": "https://los4b2sit.ispfdevelop.com/newsfeed/6bf6064c-1010-4659-986d-10c4341c6e93/f2aee260-2d03-4397-80e8-d7471b72cb4c_2023-05-31T130233.485648Z.jpg",
				"commentsCounter": 0,
				"sharedCounter": 1,
				"feedback": {
					"positive": 0,
					"negative": 0,
					"currentUserVote": -1
				},
				"sharedInfo": {
					"firstName": "FRANCESCO",
					"lastName": "CAVALLO",
					"sharedDateTS": 1685537480053,
					"sharedDate": "2023-05-31T14:51:20.053",
					"sharedMessage": null
				},
				"recentComments": [],
				"locked": false,
				"notForSale": false
			},
			{
				"newsfeedId": "d71e018b-0d60-42f5-b141-1eddce9e6722",
				"itemId": "37da0a0f-06bd-4462-a552-d12174343ab5",
				"objectType": "no_content",
				"objectDomainId": "301",
				"domainId": "301",
				"title": "test",
				"description": "<p>asd</p>\n",
				"imageUrl": null,
				"commentsCounter": 0,
				"sharedCounter": 1,
				"feedback": {
					"positive": 0,
					"negative": 0,
					"currentUserVote": -1
				},
				"sharedInfo": {
					"firstName": "FRANCESCO",
					"lastName": "CAVALLO",
					"sharedDateTS": 1685536914057,
					"sharedDate": "2023-05-31T14:41:54.057",
					"sharedMessage": null
				},
				"recentComments": [],
				"locked": false,
				"notForSale": false
			},
			{
				"newsfeedId": "78267de3-21f2-45eb-9ef3-7ec7d4d53548",
				"itemId": "82dcc27e-3068-4adc-b449-b53cafc10309",
				"objectType": "no_content",
				"objectDomainId": "301",
				"domainId": "301",
				"title": "asd",
				"description": "<p>sad</p>\n",
				"imageUrl": null,
				"commentsCounter": 0,
				"sharedCounter": 1,
				"feedback": {
					"positive": 0,
					"negative": 0,
					"currentUserVote": -1
				},
				"sharedInfo": {
					"firstName": "FRANCESCO",
					"lastName": "CAVALLO",
					"sharedDateTS": 1685535887260,
					"sharedDate": "2023-05-31T14:24:47.260",
					"sharedMessage": null
				},
				"recentComments": [],
				"locked": false,
				"notForSale": false
			},
			{
				"newsfeedId": "29610ad6-758c-4ab5-885e-ee2d625bd51f",
				"itemId": "14ee3829-f629-4474-a125-ec44f2a45825",
				"objectType": "no_content",
				"objectDomainId": "301",
				"domainId": "301",
				"title": "asd",
				"description": "<p></p>\n",
				"imageUrl": null,
				"commentsCounter": 0,
				"sharedCounter": 1,
				"feedback": {
					"positive": 0,
					"negative": 0,
					"currentUserVote": -1
				},
				"sharedInfo": {
					"firstName": "FRANCESCO",
					"lastName": "CAVALLO",
					"sharedDateTS": 1685535841038,
					"sharedDate": "2023-05-31T14:24:01.038",
					"sharedMessage": null
				},
				"recentComments": [],
				"locked": false,
				"notForSale": false
			},
			{
				"newsfeedId": "23e8e34c-17fc-4026-9fd5-09c1287e81d0",
				"itemId": "b26f6e94-3d0f-470c-ad39-22b7750400cb",
				"objectType": "no_content",
				"objectDomainId": "301",
				"domainId": "301",
				"title": "asd",
				"description": null,
				"imageUrl": null,
				"commentsCounter": 0,
				"sharedCounter": 1,
				"feedback": {
					"positive": 0,
					"negative": 0,
					"currentUserVote": -1
				},
				"sharedInfo": {
					"firstName": "FRANCESCO",
					"lastName": "CAVALLO",
					"sharedDateTS": 1685535766993,
					"sharedDate": "2023-05-31T14:22:46.993",
					"sharedMessage": null
				},
				"recentComments": [],
				"locked": false,
				"notForSale": false
			},
			{
				"newsfeedId": "15133a78-2d48-4df3-be1c-ee325189f206",
				"itemId": "f44af7f8-1e04-4766-aeea-b0f910cfe2e6",
				"objectType": "no_content",
				"objectDomainId": "301",
				"domainId": "301",
				"title": "asd",
				"description": "<p>asd</p>\n",
				"imageUrl": null,
				"commentsCounter": 0,
				"sharedCounter": 1,
				"feedback": {
					"positive": 0,
					"negative": 0,
					"currentUserVote": -1
				},
				"sharedInfo": {
					"firstName": "FRANCESCO",
					"lastName": "CAVALLO",
					"sharedDateTS": 1685535725066,
					"sharedDate": "2023-05-31T14:22:05.066",
					"sharedMessage": null
				},
				"recentComments": [],
				"locked": false,
				"notForSale": false
			},
			{
				"newsfeedId": "7b9bdc82-8f94-48f0-ad63-bbe0d0f9b3f7",
				"itemId": "0e3c0681-2eed-4f01-8841-a488977ffa8f",
				"objectType": "no_content",
				"objectDomainId": "301",
				"domainId": "301",
				"title": "a",
				"description": "<p>sd</p>\n",
				"imageUrl": null,
				"commentsCounter": 0,
				"sharedCounter": 1,
				"feedback": {
					"positive": 0,
					"negative": 0,
					"currentUserVote": -1
				},
				"sharedInfo": {
					"firstName": "FRANCESCO",
					"lastName": "CAVALLO",
					"sharedDateTS": 1685525255041,
					"sharedDate": "2023-05-31T11:27:35.041",
					"sharedMessage": null
				},
				"recentComments": [],
				"locked": false,
				"notForSale": false
			},
			{
				"newsfeedId": "c4c6e761-a505-4f05-976f-f90ba17ab35e",
				"itemId": "e891a6e5-66aa-4bdb-a620-7b7346e24ed1",
				"objectType": "no_content",
				"objectDomainId": "301",
				"domainId": "301",
				"title": "a",
				"description": "<p>a</p>\n",
				"imageUrl": null,
				"commentsCounter": 0,
				"sharedCounter": 1,
				"feedback": {
					"positive": 0,
					"negative": 0,
					"currentUserVote": -1
				},
				"sharedInfo": {
					"firstName": "FRANCESCO",
					"lastName": "CAVALLO",
					"sharedDateTS": 1685520432120,
					"sharedDate": "2023-05-31T10:07:12.120",
					"sharedMessage": null
				},
				"recentComments": [],
				"locked": false,
				"notForSale": false
			},
			{
				"newsfeedId": "d646d790-6677-4599-8307-2548295e8164",
				"itemId": "c94d8cb6-381f-4c8d-a688-ab540861a8a4",
				"objectType": "no_content",
				"objectDomainId": "301",
				"domainId": "301",
				"title": "asd",
				"description": "<p>test</p>\n",
				"imageUrl": null,
				"commentsCounter": 0,
				"sharedCounter": 1,
				"feedback": {
					"positive": 0,
					"negative": 0,
					"currentUserVote": -1
				},
				"sharedInfo": {
					"firstName": "FRANCESCO",
					"lastName": "CAVALLO",
					"sharedDateTS": 1685460687276,
					"sharedDate": "2023-05-30T17:31:27.276",
					"sharedMessage": null
				},
				"recentComments": [],
				"locked": false,
				"notForSale": false
			},
			{
				"newsfeedId": "b3e22956-4bb1-4ea9-9a8f-4d00c69c8d53",
				"itemId": "9053f6c5-78bd-4674-9905-d2a0c668cc6c",
				"objectType": "no_content",
				"objectDomainId": "301",
				"domainId": "301",
				"title": "esempio",
				"description": "<p>desc</p>\n",
				"imageUrl": null,
				"commentsCounter": 0,
				"sharedCounter": 1,
				"feedback": {
					"positive": 0,
					"negative": 0,
					"currentUserVote": -1
				},
				"sharedInfo": {
					"firstName": "FRANCESCO",
					"lastName": "CAVALLO",
					"sharedDateTS": 1685450031090,
					"sharedDate": "2023-05-30T14:33:51.090",
					"sharedMessage": null
				},
				"recentComments": [],
				"locked": false,
				"notForSale": false
			},
			{
				"newsfeedId": "4fdfe510-79d8-4755-b7d2-15949a34fa19",
				"itemId": "385",
				"objectType": "learning_object",
				"objectDomainId": "301",
				"domainId": "301",
				"title": "Human skills",
				"description": null,
				"imageUrl": "https://medias4b2sit.ispfdevelop.com/media/2023-03/TESTA_02.jpg?VersionId=6Kuywe4U_9G0a2XC_WCFMY0_XUC9oPm.",
				"commentsCounter": 1,
				"sharedCounter": 2,
				"feedback": {
					"positive": 1,
					"negative": 0,
					"currentUserVote": -1
				},
				"sharedInfo": {
					"firstName": "EUGENIO",
					"lastName": "CIANCIMINO",
					"sharedDateTS": 1685116498584,
					"sharedDate": "2023-05-26T17:54:58.584",
					"sharedMessage": "Video molto interessante"
				},
				"recentComments": [
					{
						"commentId": "d14c9691-a0d3-490b-8acd-dcd6501bd2c3",
						"firstName": "ALESSANDRO",
						"lastName": "BATTAGLIA",
						"body": "Bello davvero!",
						"newsfeedId": "4fdfe510-79d8-4755-b7d2-15949a34fa19",
						"creationDate": "2023-05-12T17:27:26.136",
						"creationDateTS": 1683905246136,
						"lastUpdateDate": null,
						"lastUpdateDateTS": null,
						"deleteDate": null,
						"deleteDateTS": null,
						"logicDelete": false,
						"myComment": false,
						"title": "ALESSANDRO BATTAGLIA",
						"domainId": "301",
						"userIdDomainId": "a84f4a1b-28ba-4a5a-98c1-b527096821fc:301"
					}
				],
				"locked": false,
				"notForSale": false
			},

			{
				"newsfeedId": "ef7f45fc-7ea7-4184-8040-64930e4a84de",
				"itemId": "1c712fdd-cfac-420c-89d4-820191433bba",
				"objectType": "no_content",
				"objectDomainId": "301",
				"domainId": "301",
				"title": "Ciao",
				"description": "<p>Descrizone prova</p>\n",
				"imageUrl": null,
				"commentsCounter": 0,
				"sharedCounter": 1,
				"feedback": {
					"positive": 0,
					"negative": 0,
					"currentUserVote": -1
				},
				"sharedInfo": {
					"firstName": "IVAN",
					"lastName": "TEODORO",
					"sharedDateTS": 1684159994038,
					"sharedDate": "2023-05-15T16:13:14.038",
					"sharedMessage": null
				},
				"recentComments": [],
				"locked": false,
				"notForSale": false
			},
			{
				"newsfeedId": "ed70ba04-af2f-4774-86a7-04c60bec3899",
				"itemId": "76",
				"objectType": "learning_object",
				"objectDomainId": "301",
				"domainId": "301",
				"title": "Il lean management ",
				"description": "Come il lean management può cambiare il tuo business\r\n",
				"imageUrl": "https://medias4b2sit.ispfdevelop.com/media/2022-12/lean%20management.jpg?VersionId=4uXK2CNgn9WaDaQBqDExnY.VEh.9_9Pf",
				"commentsCounter": 1,
				"sharedCounter": 1,
				"feedback": {
					"positive": 2,
					"negative": 0,
					"currentUserVote": -1
				},
				"sharedInfo": {
					"firstName": "CHIARA",
					"lastName": "BAGGI",
					"sharedDateTS": 1683879627681,
					"sharedDate": "2023-05-12T10:20:27.681",
					"sharedMessage": "Teste condivisione collection"
				},
				"recentComments": [
					{
						"commentId": "30f901a4-c9d0-470f-97b5-bb1917620532",
						"firstName": "FRANCESCO",
						"lastName": "CAVALLO",
						"body": "prova comm",
						"newsfeedId": "ed70ba04-af2f-4774-86a7-04c60bec3899",
						"creationDate": "2023-05-30T10:49:40.513",
						"creationDateTS": 1685436580513,
						"lastUpdateDate": null,
						"lastUpdateDateTS": null,
						"deleteDate": null,
						"deleteDateTS": null,
						"logicDelete": false,
						"myComment": true,
						"title": "FRANCESCO CAVALLO",
						"domainId": "301",
						"userIdDomainId": "f2aee260-2d03-4397-80e8-d7471b72cb4c:301"
					}
				],
				"locked": true,
				"notForSale": false
			},
			{
				"newsfeedId": "1b247d35-a7c3-4e76-a971-916f1daabdfb",
				"itemId": "428",
				"objectType": "learning_object",
				"objectDomainId": "301",
				"domainId": "301",
				"title": "Diversity & Inclusion - Manager",
				"description": null,
				"imageUrl": "https://medias4b2sit.ispfdevelop.com/media/2023-03/01_stereotipi.jpg?VersionId=fEb_N7Hi4VLbbslJltALvWwAt6QqPUHO",
				"commentsCounter": 0,
				"sharedCounter": 1,
				"feedback": {
					"positive": 0,
					"negative": 0,
					"currentUserVote": -1
				},
				"sharedInfo": {
					"firstName": "FRANCESCO",
					"lastName": "CAVALLO",
					"sharedDateTS": 1683879550688,
					"sharedDate": "2023-05-12T10:19:10.688",
					"sharedMessage": "test share"
				},
				"recentComments": [],
				"locked": false,
				"notForSale": false
			},
			{
				"newsfeedId": "23540926-2889-498a-baea-31bac978d415",
				"itemId": "444",
				"objectType": "learning_object",
				"objectDomainId": "301",
				"domainId": "301",
				"title": "Leadership & Personal skill - Manager",
				"description": null,
				"imageUrl": "https://medias4b2sit.ispfdevelop.com/media/2023-03/06_timemangement.jpg?VersionId=6jGZ_yP_mxVHDIGZoMnv.QxAvCBsT3IW",
				"commentsCounter": 0,
				"sharedCounter": 1,
				"feedback": {
					"positive": 0,
					"negative": 0,
					"currentUserVote": -1
				},
				"sharedInfo": {
					"firstName": "CHIARA",
					"lastName": "BAGGI",
					"sharedDateTS": 1683809428085,
					"sharedDate": "2023-05-11T14:50:28.085",
					"sharedMessage": "Corso interessante"
				},
				"recentComments": [],
				"locked": false,
				"notForSale": false
			},
			{
				"newsfeedId": "92d8ae4b-89ff-4e38-9204-e33c3a480336",
				"itemId": "451",
				"objectType": "learning_object",
				"objectDomainId": "301",
				"domainId": "301",
				"title": "Digital Workplace - Manager",
				"description": null,
				"imageUrl": "https://medias4b2sit.ispfdevelop.com/media/2023-03/Soft_Skills_esterna.jpg?VersionId=KvuSmJ0Sijo8lVBebqPUdFlQGExrDKxk",
				"commentsCounter": 0,
				"sharedCounter": 1,
				"feedback": {
					"positive": 0,
					"negative": 0,
					"currentUserVote": -1
				},
				"sharedInfo": {
					"firstName": "FRANCESCO",
					"lastName": "CAVALLO",
					"sharedDateTS": 1683806914056,
					"sharedDate": "2023-05-11T14:08:34.056",
					"sharedMessage": "test"
				},
				"recentComments": [],
				"locked": false,
				"notForSale": false
			},
			{
				"newsfeedId": "487fde06-25e9-4f93-b3bb-2aedc7cd85b4",
				"itemId": "337",
				"objectType": "learning_object",
				"objectDomainId": "301",
				"domainId": "301",
				"title": "Dallo smart working al working smart",
				"description": "Lo Smart Working è un’occasione da non perdere per lavorare sull’evoluzione dei modelli culturali e organizzativi verso il paradigma del Working Smart. Ripensare la relazione organizzazione - persona” può essere un buon modo per accelerare questo cambiamento che deve essere basato su principi di flessibilità e autonomia, sulla  sperimentazione di una nuova filosofia manageriale, che mette in discussione e cambia i comportamenti organizzativi di Manager e collaboratori, le loro modalità di coordinamento e la misura delle prestazioni lavorative coniugandole con un maggiore orientamento ai risultati e alla responsabilizzazione delle persone. - Alessandro Donadio",
				"imageUrl": "https://medias4b2sit.ispfdevelop.com/media/2023-03/DONADIO_03.jpg?VersionId=yhmOXYqgCWwTD8I176pPRBmfilJ8vaOn",
				"commentsCounter": 0,
				"sharedCounter": 1,
				"feedback": {
					"positive": 0,
					"negative": 0,
					"currentUserVote": -1
				},
				"sharedInfo": {
					"firstName": "CHIARA",
					"lastName": "BAGGI",
					"sharedDateTS": 1683796435466,
					"sharedDate": "2023-05-11T11:13:55.466",
					"sharedMessage": "VIdeo molto interessante"
				},
				"recentComments": [],
				"locked": false,
				"notForSale": false
			},
			{
				"newsfeedId": "b2385cb6-36cd-46cd-9d9c-fe0ecaeb3966",
				"itemId": "328",
				"objectType": "learning_object",
				"objectDomainId": "301",
				"domainId": "301",
				"title": "Empatia: una chiave per le interazioni umane",
				"description": "Neuroni specchio ed empatia rappresentano uno dei meccanismi più affascinanti mai studiati dalla neuroscienza. Si tratta del processo per cui le azioni ed emozioni altrui non ci sono indifferenti, anzi suscitano in noi una risposta empatica. Questi meccanismi hanno una forte componente sociale e il loro corretto funzionamento si ripercuote in larga misura sulle nostre relazioni sociali.  - Paolo Cervari",
				"imageUrl": "https://medias4b2sit.ispfdevelop.com/media/2023-03/CERVARI_01.jpg?VersionId=tTx15mYi8sqK7oDxuz6V9lGYXLd9gQ_Z",
				"commentsCounter": 1,
				"sharedCounter": 2,
				"feedback": {
					"positive": 2,
					"negative": 0,
					"currentUserVote": -1
				},
				"sharedInfo": {
					"firstName": "IVAN",
					"lastName": "TEODORO",
					"sharedDateTS": 1683647157022,
					"sharedDate": "2023-05-09T17:45:57.022",
					"sharedMessage": "Contenuto consigliato!"
				},
				"recentComments": [
					{
						"commentId": "2a5a564e-4834-4e04-99ff-7a1c370ad400",
						"firstName": "ALESSANDRO",
						"lastName": "BATTAGLIA",
						"body": "Grande provo a vederlo anch'io",
						"newsfeedId": "b2385cb6-36cd-46cd-9d9c-fe0ecaeb3966",
						"creationDate": "2023-05-05T16:16:07.018",
						"creationDateTS": 1683296167018,
						"lastUpdateDate": null,
						"lastUpdateDateTS": null,
						"deleteDate": null,
						"deleteDateTS": null,
						"logicDelete": false,
						"myComment": false,
						"title": "ALESSANDRO BATTAGLIA",
						"domainId": "301",
						"userIdDomainId": "a84f4a1b-28ba-4a5a-98c1-b527096821fc:301"
					}
				],
				"locked": false,
				"notForSale": false
			},
			{
				"newsfeedId": "a9bc1b85-1af9-4586-a284-7332a01b3d65",
				"itemId": "129",
				"objectType": "news",
				"objectDomainId": "301",
				"domainId": "301",
				"title": "Il pacchetto di misure europee per rendere i prodotti sostenibili e rafforzare l'indipendenza Ue per le risorse.",
				"description": "La Commissione europea ha presentato un pacchetto di proposte sull' European Green Deal «Volte a rendere i prodotti sostenibili la norma nell' Ue, promuovere modelli imprenditoriali circolari e responsabilizzare i consumatori nella transizione verde». Come annunciato nel piano d' azione per l' economia circolare , la Commissione Ue propone «Nuove norme per rendere quasi tutti i beni fisici presenti sul mercato dell' Ue più rispettosi dell' ambiente, circolari ed efficienti sotto il profilo energetico lungo l' intero ciclo di vita dalla fase di progettazione fino all' uso quotidiano, al cambio di destinazione e alla gestione del fine vita». Presentando il pacchetto di proposte Frans Timmermans, vicepresidente esecutivo per l' European Green Deal, ha sottolineato che «E' giunto il momento di porre fine al modello \"prendi, produci, rompi e getta\", così dannoso per il nostro pianeta, la nostra salute e la nostra economia. Le proposte odierne garantiranno che solo i prodotti più sostenibili siano venduti in Europa e consentiranno ai consumatori di risparmiare energia, riparare e non sostituire i prodotti rotti e compiere scelte ambientali intelligenti quando ne acquistano di nuovi. Solo in questo modo ripristineremo l' equilibrio nelle nostre relazioni con la natura e ridurremo la nostra vulnerabilità alle perturbazioni delle catene di approvvigionamento globali». Ecco le tre misure così come sono state proposte dalla Commissione Ue: Rendere i prodotti sostenibili la norma. La proposta di regolamento sulla progettazione ecocompatibile dei prodotti sostenibili riguarda la progettazione dei prodotti, che genera fino all' 80 % dell' impatto ambientale del prodotto durante il ciclo di vita. Tale proposta stabilisce nuovi requisiti per rendere i prodotti più durevoli, affidabili, riutilizzabili, aggiornabili, riparabili, più facili da mantenere, rinnovare e riciclare , ed efficienti sotto il profilo energetico e delle risorse. Inoltre i requisiti di informazione specifici per prodotto daranno ai consumatori la possibilità di conoscere l' impatto ambientale dei propri acquisti. Tutti i prodotti regolamentati saranno corredati dai cosiddetti passaporti digitali dei prodotti, che ne faciliteranno la riparazione o il riciclaggio e agevoleranno la tracciabilità delle sostanze lungo la catena di approvvigionamento. Potrà essere introdotta anche l' etichettatura. La proposta prevede anche misure volte ad arrestare la distruzione dei beni di consumo invenduti, accrescere il potenziale degli appalti pubblici verdi e incentivare i prodotti sostenibili. La proposta odierna amplia il quadro di progettazione ecocompatibile esistente in due modi: da un lato includendo la gamma più ampia possibile di prodotti e dall' altro ampliando la portata dei requisiti ai quali i prodotti devono conformarsi. La definizione di criteri non solo per l' efficienza energetica ma anche per la circolarità, unitamente a una riduzione complessiva dell' impronta ambientale e climatica dei prodotti, comporterà una maggiore indipendenza energetica e delle risorse e una riduzione dell' inquinamento. Rafforzerà il mercato unico evitando divergenze normative in ciascuno Stato membro e genererà opportunità economiche per l' innovazione e la creazione di posti di lavoro, in particolare in termini di rifabbricazione, manutenzione, riciclaggio e riparazione. La proposta definirà un quadro e un processo attraverso i quali la Commissione, in stretta collaborazione con tutte la parti interessate, definirà progressivamente i requisiti per ciascun prodotto o gruppo di prodotti. Contestualmente alla presente proposta la Commissione ha adottato un piano di lavoro sulla progettazione ecocompatibile e sull' etichettatura energetica per il periodo 2022-2024 come misura transitoria fino all' entrata in vigore del nuovo regolamento, volto a coprire nuovi prodotti connessi all' energia e aggiornare, rendendole più ambiziose, le norme per quelli già regolamentati. Il piano di lavoro riguarda in particolare l' elettronica di consumo (smartphone, tablet, pannelli solari), il flusso di rifiuti in più rapida crescita. Prodotti tessili sostenibili e circolari. Il consumo di prodotti tessili in Europa si trova al quarto posto per maggiore impatto sull' ambiente e sui cambiamenti climatici dopo l' alimentazione, gli alloggi e la mobilità; si tratta inoltre del terzo settore in ordine di consumi per quanto riguarda l' uso di acqua e suolo e del quinto per l' uso di materie prime primarie. La strategia dell' UE per i prodotti tessili sostenibili e circolari definisce una visione ed azioni concrete tese a garantire che entro il 2030 i prodotti tessili immessi sul mercato dell' Ue siano riciclabili e di lunga durata, realizzati il più possibile con fibre riciclate, privi di sostanze pericolose e prodotti nel rispetto dei diritti sociali e dell' ambiente. I consumatori beneficeranno più a lungo di tessili di alta qualità, la moda rapida andrà fuori moda e lascerà spazio a servizi di riutilizzo e riparazione economicamente vantaggiosi e altamente fruibili. In un settore tessile competitivo, resiliente e innovativo, i produttori devono assumersi la responsabilità dei propri prodotti lungo la catena del valore, anche una volta divenuti rifiuti. In tal modo l' ecosistema tessile circolare sarà florido e guidato da capacità sufficienti per garantire un riciclaggio innovativo delle fibre fibre-to-fibre , mentre l' incenerimento e il collocamento in discarica dei tessili dovranno essere ridotti al minimo. Le misure specifiche comprenderanno requisiti di progettazione ecocompatibile dei tessili, informazioni più chiare, un passaporto digitale dei prodotti e un regime di responsabilità estesa del produttore dell' Ue. Sono inoltre previste misure per contrastare il rilascio involontario di microplastiche dai tessili, garantire l' accuratezza delle dichiarazioni ecologiche e promuovere modelli di business circolari, compresi i servizi di riutilizzo e riparazione. Per affrontare la questione della moda rapida, la strategia invita inoltre le imprese a ridurre il numero di collezioni per anno, ad assumersi le proprie responsabilità e ad agire per ridurre al minimo l' impronta ambientale e di carbonio, ed esorta gli Stati membri ad adottare misure fiscali favorevoli per il settore del riutilizzo e della riparazione. La Commissione promuoverà tale transizione anche con l' ausilio di attività di sensibilizzazione. La strategia mira inoltre a sostenere l' ecosistema tessile e a guidarlo attraverso il suo percorso trasformativo. Pertanto la Commissione avvia oggi la creazione condivisa di un percorso di transizione per l' ecosistema tessile. Si tratta di uno strumento collaborativo essenziale concepito per agevolare la ripresa dell' ecosistema dagli effetti negativi della pandemia da COVID-19, che negli ultimi due anni hanno colpito le operazioni quotidiane delle imprese. Lo strumento contribuirà alla sopravvivenza a lungo termine delle imprese rafforzando la loro capacità di resistere all' agguerrita concorrenza globale e agli shock futuri. Tutti gli attori sono incoraggiati a partecipare attivamente al processo di creazione condivisa attraverso il loro impegno in materia di circolarità e modelli imprenditoriali circolari, azioni volte a rafforzare la competitività sostenibile, la digitalizzazione e la resilienza così come l' individuazione degli investimenti specifici necessari per la duplice transizione. I prodotti da costruzione di domani. L' ecosistema edilizio rappresenta quasi il 10 % del valore aggiunto dell' UE e impiega circa 25 milioni di persone in oltre 5 milioni di imprese. Il settore dei prodotti da costruzione annovera 430 000 imprese nell' UE con un fatturato di 800 miliardi di . Principalmente di piccole e medie dimensioni, tali imprese costituiscono una risorsa economica e sociale fondamentale per le comunità locali nelle regioni e nelle città europee. Gli edifici sono responsabili di circa il 50% dell' estrazione e del consumo delle risorse e di oltre il 30 % dei rifiuti totali prodotti ogni anno dall' UE. Inoltre gli edifici sono responsabili del 40 % del consumo energetico dell' Ue e del 36 % delle emissioni di gas a effetto serra legate all' energia. La revisione del regolamento sui prodotti da costruzione rafforzerà e modernizzerà le norme in vigore dal 2011 e creerà un quadro armonizzato per valutare e divulgare le prestazioni ambientali e climatiche dei prodotti da costruzione. I nuovi requisiti garantiranno che i prodotti da costruzione siano progettati e fabbricati in base allo stato dell' arte per essere più durevoli, riparabili, riciclabili e più facili da rifabbricare. La revisione semplificherà inoltre l' elaborazione di norme comuni europee da parte degli organismi di normazione, contribuendo a rimuovere gli ostacoli alla libera circolazione del mercato interno congiuntamente alla maggiore capacità di vigilanza del mercato e a norme più chiare per gli operatori economici lungo la catena di approvvigionamento. Infine la revisione del regolamento offrirà soluzioni digitali per ridurre gli oneri amministrativi, in particolare per le PMI, tra cui la banca dati dei prodotti da costruzione e il passaporto digitale dei prodotti. Thierry Breton, commissario europeo per il mercato interno, ha commentato: «I c onsumatori europei si aspettano giustamente prodotti più rispettosi dell' ambiente e più duraturi. Una sostenibilità e un' efficienza delle risorse migliori comportano anche una maggiore resilienza quando una crisi sconvolge le nostre catene di approvvigionamento industriali. Sfruttando il potenziale del mercato unico, valorizzando al meglio gli strumenti digitali e migliorando la vigilanza del mercato massimizzeremo le opportunità tanto per le imprese quanto per i consumatori. Una maggiore efficienza energetica e delle risorse, in particolare nei settori edile e tessile, creerà posti di lavoro altamente qualificati in tutta Europa». Virginijus Sinkeviius, commissario Ue per l' ambiente, gli oceani e la pesca, ha concluso: «Le nostre proposte in materia di economia circolare segnano l' inizio di un' epoca in cui i prodotti saranno progettati in modo vantaggioso per tutti, entro i limiti del nostro pianeta e tutelando l' ambiente. Prolungando la durata di vita dei prodotti che usiamo ogni giorno, fra cui telefoni e indumenti, consentiremo ai consumatori europei di risparmiare denaro. Alla fine del loro ciclo di vita i prodotti non saranno più fonte di inquinamento ma di nuovi materiali per l' economia, riducendo la dipendenza delle imprese europee dalle importazioni.",
				"imageUrl": "https://medias4b2sit.ispfdevelop.com/media/2022-12/finanziamenti%20europei.jpg?VersionId=O10cbI4zVOd0tH0SIjFcrS4gBUc00958",
				"commentsCounter": 0,
				"sharedCounter": 1,
				"feedback": {
					"positive": 0,
					"negative": 0,
					"currentUserVote": -1
				},
				"sharedInfo": {
					"firstName": "IVAN",
					"lastName": "TEODORO",
					"sharedDateTS": 1683645686929,
					"sharedDate": "2023-05-09T17:21:26.929",
					"sharedMessage": "News bacheca"
				},
				"recentComments": [],
				"locked": true,
				"notForSale": false
			},
			{
				"newsfeedId": "0e95e544-891b-4766-ba24-f685b3d1c449",
				"itemId": "311",
				"objectType": "learning_object",
				"objectDomainId": "301",
				"domainId": "301",
				"title": "Le 5 \"C\" dell'obiettivo",
				"description": "Chiarezza, congruità, costruzione, comunicazione, condivisione, sono le 5 \"C\" che definiscono l'obiettivo finalizzato a raggiungere una performance eccellente - Mike Maric",
				"imageUrl": "https://medias4b2sit.ispfdevelop.com/media/2023-03/MARIC_01.jpg?VersionId=oP5vG6IAlGEabgMChRnIefohs6GMLxvn",
				"commentsCounter": 1,
				"sharedCounter": 1,
				"feedback": {
					"positive": 2,
					"negative": 0,
					"currentUserVote": -1
				},
				"sharedInfo": {
					"firstName": "ALESSANDRO",
					"lastName": "BATTAGLIA",
					"sharedDateTS": 1683550923045,
					"sharedDate": "2023-05-08T15:02:03.045",
					"sharedMessage": "BELLOOOOOOOOOO"
				},
				"recentComments": [
					{
						"commentId": "ff7bd4bd-0b6d-48ce-9e2f-fa30de70defa",
						"firstName": "MAI",
						"lastName": "LE PHAN",
						"body": "Bene!",
						"newsfeedId": "0e95e544-891b-4766-ba24-f685b3d1c449",
						"creationDate": "2023-05-09T13:21:51.023",
						"creationDateTS": 1683631311023,
						"lastUpdateDate": null,
						"lastUpdateDateTS": null,
						"deleteDate": null,
						"deleteDateTS": null,
						"logicDelete": false,
						"myComment": false,
						"title": "MAI LE PHAN",
						"domainId": "301",
						"userIdDomainId": "23b0946b-c76e-4910-b288-78d699889bfa:301"
					}
				],
				"locked": false,
				"notForSale": false
			},
			{
				"newsfeedId": "9a218ade-1368-43eb-a377-5758146e35aa",
				"itemId": "628",
				"objectType": "learning_object",
				"objectDomainId": "301",
				"domainId": "301",
				"title": "ESG modulo 1",
				"description": "Clicca sul contenuto e fruisci del modulo 1 del corso ESG!",
				"imageUrl": "https://medias4b2sit.ispfdevelop.com/media/2023-02/ESG%20Cover.png?VersionId=kOJiPXm7nRiqk_4yVKL9To0SCTxS_U7U",
				"commentsCounter": 4,
				"sharedCounter": 1,
				"feedback": {
					"positive": 2,
					"negative": 0,
					"currentUserVote": -1
				},
				"sharedInfo": {
					"firstName": "IVAN",
					"lastName": "TEODORO",
					"sharedDateTS": 1683546398028,
					"sharedDate": "2023-05-08T13:46:38.028",
					"sharedMessage": "ESG ottimo!"
				},
				"recentComments": [
					{
						"commentId": "d62c14fa-1765-42ee-bb4a-182402c5f3b3",
						"firstName": "LUCIA CHIARA",
						"lastName": "D'AGOSTINO",
						"body": "Davvero interessante",
						"newsfeedId": "9a218ade-1368-43eb-a377-5758146e35aa",
						"creationDate": "2023-05-29T12:46:24.028",
						"creationDateTS": 1685357184028,
						"lastUpdateDate": null,
						"lastUpdateDateTS": null,
						"deleteDate": null,
						"deleteDateTS": null,
						"logicDelete": false,
						"myComment": false,
						"title": "LUCIA CHIARA D'AGOSTINO",
						"domainId": "301",
						"userIdDomainId": "f97d8d94-bd15-4955-b474-5eb578752137:301"
					},
					{
						"commentId": "5e876dfe-2842-48e5-ab68-9ee394a0510f",
						"firstName": "IVAN",
						"lastName": "TEODORO",
						"body": "Confermo!",
						"newsfeedId": "9a218ade-1368-43eb-a377-5758146e35aa",
						"creationDate": "2023-05-09T17:04:40.027",
						"creationDateTS": 1683644680027,
						"lastUpdateDate": null,
						"lastUpdateDateTS": null,
						"deleteDate": null,
						"deleteDateTS": null,
						"logicDelete": false,
						"myComment": false,
						"title": "IVAN TEODORO",
						"domainId": "301",
						"userIdDomainId": "6eea6f26-9335-4bf7-b1b1-68a82c8255d4:301"
					}
				],
				"locked": true,
				"notForSale": false
			},
			{
				"newsfeedId": "4f619441-f661-426c-99e9-31e75d9ed0fc",
				"itemId": "629",
				"objectType": "learning_object",
				"objectDomainId": "301",
				"domainId": "301",
				"title": "Assessment modulo 1",
				"description": "Clicca per svolgere e superare l'assessment del modulo 1.",
				"imageUrl": "https://medias4b2sit.ispfdevelop.com/media/2023-02/ESG%20Cover.png?VersionId=kOJiPXm7nRiqk_4yVKL9To0SCTxS_U7U",
				"commentsCounter": 0,
				"sharedCounter": 1,
				"feedback": {
					"positive": 0,
					"negative": 0,
					"currentUserVote": -1
				},
				"sharedInfo": {
					"firstName": "ALESSANDRO",
					"lastName": "BATTAGLIA",
					"sharedDateTS": 1683296604034,
					"sharedDate": "2023-05-05T16:23:24.034",
					"sharedMessage": "Bello!"
				},
				"recentComments": [],
				"locked": true,
				"notForSale": false
			},
			{
				"newsfeedId": "bcd67808-839b-40ae-8e08-5301111473c8",
				"itemId": "b59ac85e-a97a-47b4-b034-a972c2391528",
				"objectType": "no_content",
				"objectDomainId": "301",
				"domainId": "301",
				"title": "PROVA",
				"description": "<p>Test <strong>ottimo  </strong><strong><em>italic</em></strong></p>\n",
				"imageUrl": null,
				"commentsCounter": 0,
				"sharedCounter": 1,
				"feedback": {
					"positive": 0,
					"negative": 0,
					"currentUserVote": -1
				},
				"sharedInfo": {
					"firstName": "ALESSANDRO",
					"lastName": "BATTAGLIA",
					"sharedDateTS": 1683296310064,
					"sharedDate": "2023-05-05T16:18:30.064",
					"sharedMessage": null
				},
				"recentComments": [],
				"locked": false,
				"notForSale": false
			},
			{
				"newsfeedId": "1d8478f7-2bcb-44fe-9b02-9837cdbb7ee1",
				"itemId": "218",
				"objectType": "news",
				"objectDomainId": "301",
				"domainId": "301",
				"title": "Attenzione al Darkverse, il lato oscuro del metaverso",
				"description": "Il metaverso potrebbe dare un nuovo impulso al cybercrime. L' allarme è di Trend Micro, leader globale di cybersecurity, che ha pubblicato un nuovo studio, dal titolo \" Metaverse or MetaWorse? Cyber Security Threats Against the Internet of Experiences \". Queste le prime cinque minacce del metaverso evidenziate: I NFT saranno colpiti da phishing, richieste di riscatto, frodi o altri attacchi e saranno sempre più presi di mira man mano che diventeranno un importante asset del metaverso per la regolamentazione della proprietà Il Darkverse diventerà il luogo di riferimento per lo svolgimento di attività illegali/criminali perché sarà difficile per le Forze dell' Ordine rintracciare, monitorare o infiltrarsi al suo interno Il riciclaggio di denaro tramite l' utilizzo nel metaverso di immobili e NFT sovrastimati fornirà un nuovo canale ai criminali L' ingegneria sociale, la propaganda e le fake news avranno un impatto profondo in un mondo cyber-fisico. Fatti di cronaca o narrazioni influenti saranno impiegati da criminali o altre entità per prendere di mira i gruppi sensibili a determinati argomenti La privacy verrà ridefinita, poiché gli operatori di spazi simili al metaverso avranno una visibilità senza precedenti sulle azioni degli utenti. Non esisterà più una privacy come la conosciamo \"Il metaverso è una visione hi-tech multimiliardaria che definirà la prossima era di Internet. Sebbene non sappiamo esattamente come si svilupperà, dobbiamo iniziare a pensare ora a come verrà sfruttato dai cybercriminali\". Ha affermato Gastone Nencini, Country Manager di Trend Micro Italia. \"Dati i costi elevati e le sfide giurisdizionali, le Forze dell' Ordine faranno in generale fatica a sorvegliare il metaverso nei primi anni. Dobbiamo intervenire ora, altrimenti si rischia che un nuovo selvaggio West si sviluppi nel nostro mondo digitale.",
				"imageUrl": "https://medias4b2sit.ispfdevelop.com/media/2022-12/news%203%2023.12.png?VersionId=ApgFumhBDOxiTiAPUIXhWc1mZsBkR9lU",
				"commentsCounter": 0,
				"sharedCounter": 1,
				"feedback": {
					"positive": 0,
					"negative": 0,
					"currentUserVote": -1
				},
				"sharedInfo": {
					"firstName": "ALESSANDRO",
					"lastName": "BATTAGLIA",
					"sharedDateTS": 1683296191438,
					"sharedDate": "2023-05-05T16:16:31.438",
					"sharedMessage": "WOWWW"
				},
				"recentComments": [],
				"locked": true,
				"notForSale": false
			}
		],
		currentPageCount: 2,
		nextPage: "bf9d04b8-89b7-4660-899e-aad645056f05",
		resultCode: 200,
		errorManagement: null,
		errorCode: null
	})
);

export const getCommentsByNewsFeedMock = (newsfeedId) => (
	getBaseResponse({
		appName: "s4b",
		requestId: "f9952cab-1a5c-4c23-b90f-19d4ad7ee952",
		success: true,
		errorResponse: null,
		comments: [
			{
				commentId: "e0f23839-102d-4391-bf74-722e235bc2b5",
				firstName: "Gina",
				lastName: "Pina",
				body: "CommentTitle",
				newsfeedId: "463c131f-3279-4ed5-9328-9630f9ffc0cb",
				creationDate: "2023-04-06T11:35:19.171",
				creationDateTS: 1680773719171,
				lastUpdateDate: null,
				lastUpdateDateTS: null,
				deleteDate: null,
				deleteDateTS: null,
				logicDelete: false,
				myComment: true,
				title: "commento di pina",
				domainId: "41"
			},
			{
				commentId: "e0f23839-102d-4391-bf74-722e235bc2b6",
				firstName: "Pinco",
				lastName: "Pallino",
				body: "CommentTitle",
				newsfeedId: "463c131f-3279-4ed5-9328-9630f9ffc0cb",
				creationDate: "2023-04-06T11:35:19.171",
				creationDateTS: 1680773719171,
				lastUpdateDate: null,
				lastUpdateDateTS: null,
				deleteDate: null,
				deleteDateTS: null,
				logicDelete: false,
				myComment: false,
				title: "commento di Pinco",
				domainId: "41"
			},
			{
				commentId: "e0f23839-102d-4391-bf74-722e235bc28ddd81",
				firstName: "Salvatore",
				lastName: "Esposito",
				body: "CommentTitle",
				newsfeedId: "bf9d04b8-89b7-4660-899e-aad645056f05",
				creationDate: "2023-04-06T11:35:19.171",
				creationDateTS: 1680773719171,
				lastUpdateDate: null,
				lastUpdateDateTS: null,
				deleteDate: null,
				deleteDateTS: null,
				logicDelete: false,
				myComment: true,
				title: "commento di Salvatore",
				domainId: "45"
			},
			{
				commentId: "e0f23839-102d-4391-bf74-722e235bc2888",
				firstName: "Maria",
				lastName: "Giovanna",
				body: "CommentTitle",
				newsfeedId: "463c131f-3279-4ed5-9328-9630f9ffc0cb",
				creationDate: "2023-04-06T11:35:19.171",
				creationDateTS: 1680773719171,
				lastUpdateDate: null,
				lastUpdateDateTS: null,
				deleteDate: null,
				deleteDateTS: null,
				logicDelete: false,
				myComment: true,
				title: "commento di Maria",
				domainId: "40"
			},
			{
				commentId: "e0f23839-102d-4391-bf74-722e235bc2b666",
				firstName: "Luca",
				lastName: "Simoni",
				body: "CommentTitle",
				newsfeedId: "463c131f-3279-4ed5-9328-9630f9ffc0cb",
				creationDate: "2023-04-06T11:35:19.171",
				creationDateTS: 1680773719171,
				lastUpdateDate: null,
				lastUpdateDateTS: null,
				deleteDate: null,
				deleteDateTS: null,
				logicDelete: false,
				myComment: false,
				title: "commento di Luca",
				domainId: "42"
			}
		].filter(comment => comment.newsfeedId === newsfeedId),
		currentPageCount: 1,
		nextPage: null,
		resultCode: 200,
		errorManagement: null,
		errorCode: null
	})
);

export const getNewsfeedUserlikeMock = () => (
	getBaseResponse({
		appName: "s4b",
		requestId: "9d0a0479-e09b-4c52-862f-899916ab4a0e",
		success: true,
		errorResponse: null,
		users: [
			{
				firstName: "Fruitore",
				lastName: "Assets",
				userVote: 1
			}
		],
		currentPageCount: 1,
		nextPage: null,
		resultCode: 200,
		errorManagement: null,
		errorCode: null
	})
);

export const getNewsfeedUserdislikeMock = () => (
	getBaseResponse({
		appName: "s4b",
		requestId: "9d0a0479-e09b-4c52-862f-899916ab4a0e",
		success: true,
		errorResponse: null,
		users: [
			{
				firstName: "Fruitore",
				lastName: "Assets",
				userVote: 0
			}
		],
		currentPageCount: 1,
		nextPage: null,
		resultCode: 200,
		errorManagement: null,
		errorCode: null
	})
);

export const addCommentsToNewsFeedMock = () => (
	getBaseResponse({
		appName: "s4b",
		requestId: "aa5af856-7983-4f9b-8f3e-57500af148f6",
		success: true,
		errorResponse: "",
		comment: {
			commentId: "e0f23839-102d-4391-bf74-722e235bc2b0",
			firstName: "Anouer",
			lastName: "Rouissi",
			body: "CommentTitle",
			newsfeedId: "463c131f-3279-4ed5-9328-9630f9ffc0cb",
			creationDate: "2023-04-06T11:35:19.171",
			creationDateTS: 1680773719171,
			lastUpdateDate: null,
			lastUpdateDateTS: null,
			deleteDate: null,
			deleteDateTS: null,
			logicDelete: false,
			myComment: true,
			title: "Mio commento",
			domainId: "41"
		},
		resultCode: 200,
		errorManagement: null,
		errorCode: null
	})
);

export const updateNewsFeedCommentMock = () => (
	getBaseResponse({
		appName: "s4b",
		requestId: "9145a36-945a-4505-a710-ba78dbff17e7",
		success: true,
		errorResponse: "",
		comment: {
			commentId: "e0f23839-102d-4391-bf74-722e235bc2b5",
			firstName: "Fruitore",
			lastName: "Assets",
			body: "updatedCommentBody",
			newsfeedId: "463c131f-3279-4ed5-9328-9630f9ffc0cb",
			creationDate: "2023-04-06T11:35:19.171",
			creationDateTS: 1680773719171,
			lastUpdateDate: "2023-04-06T11:40:36.946",
			lastUpdateDateTS: 1680774036946,
			deleteDate: null,
			deleteDateTS: null,
			logicDelete: false,
			myComment: true,
			title: "updatedCommentTitle",
			domainId: "41"
		},
		resultCode: 200,
		errorManagement: null,
		errorCode: null
	})
);

export const deleteNewsFeedMock = () => (
	getBaseResponse(
	{
		errorMessage: null,
		statusCode: 200,
		success: true
	})
);

export const deleteNewsFeedCommentMock = () => (
	getBaseResponse(
	{
		errorMessage: null,
		statusCode: 200,
		success: true
	})
);

export const shareCommentMock = () => (
	getBaseResponse(
		{
			appName: "s4b",
			requestId: "21347a7d-aeba-4d52-8d2c-13256fe8f644",
			success: true,
			errorResponse: null,
			newsfeeds: [
				{
					newsfeedId: "f895e986-b05d-429e-8344-c510399ec262",
					itemId: "100",
					objectType: "live_event",
					objectDomainId: "41",
					domainId: "41",
					title: "100_Title",
					description: "100_Description",
					imageUrl: "100_ImageUrl",
					commentsCounter: 0,
					sharedCounter: 1,
					feedback: {
						positive: 0,
						negative: 0,
						currentUserVote: -1
					},
					sharedInfo: {
						firstName: "Fruitore",
						lastName: "Assets",
						sharedDateTS: 1680772195173,
						sharedDate: "2023-04-06T11:09:55.173",
						sharedMessage: "100_SharedMessage"
					}
				}
			],
			currentPageCount: null,
			nextPage: null,
			resultCode: 200,
			errorManagement: null,
			errorCode: null
		}
	)
);

export const categoriesMock = () => {
	return getBaseResponse(
		{
			appName:"s4b",
			requestId:"991679bd-67bf-48d7-93fc-89ffcb50f5d5",
			success:true,
			errorResponse:null,
			catalog:[
				{
					itemId:"473",
					productId:"1141",
					title:"Prelios - Kick-Off",
					cover:"https://medias4b2sit.ispfdevelop.com/media/2022-11/welcome.jpg?VersionId=_gvTOQZRpQh8GAeaBxew5usC7DI7zE7e",
					body:null,
					type:"LIVE_EVENT",
					description:null,
					countContent:1,
					eventType:"live_event",
					calendarChoice:"free",
					packageType:"premium",
					needId:"finger",
					locked:false
				},
				{"itemId":"394","productId":"1167","title":"Digital Transformation","cover":"https://medias4b2sit.ispfdevelop.com/media/2023-03/Competenze_Digitali_esterna.jpg?VersionId=LCdRgLzLVfcpuAkIdSoDlM6E3XYLYv1o","body":null,"type":"COLLECTION","description":null,"countContent":4,"calendarChoice":null,"packageType":"base","needId":"160","locked":true}
			],
			count:1,
			nextPage:null,
			resultCode:200,
			errorManagement:null,
			errorCode:null
		}
	)
}

export const categoriesPillsMock = () => {
	return getBaseResponse(
		{ "appName": "s4b", "requestId": "d0fd8d38-25fe-4633-8d08-abeb8711c9a2", "success": true, "errorResponse": null, "resultCode": 200, "errorManagement": null, "errorCode": null, "needs": [ { "needId": "22", "title": "Strumenti di sostegno alle imprese", "itemSize": 1 }, { "needId": "18", "title": "Posizionamento sul mercato", "itemSize": 1 }, { "needId": "160", "title": "Inspiring Talks WeTell", "itemSize": 1 }, { "needId": "21", "title": "Sviluppo risorse umane", "itemSize": 1 } ] }
	)
}

export const categoryPlaylistMock = () => {
	return getBaseResponse(
		{ "appName": "s4b", "requestId": "7456d160-be0c-4ea0-86de-6418543eddde", "success": true, "errorResponse": null, "catalog": [ { "itemId": "100", "productId": "1045", "title": "Finanziamenti europei", "cover": "https://medias4b2sit.ispfdevelop.com/media/2022-12/finanziamenti%20europei.jpg?VersionId=O10cbI4zVOd0tH0SIjFcrS4gBUc00958", "body": null, "type": "COLLECTION", "description": "I requisiti di accesso e come inoltrare una domanda\r\n", "countContent": 2, "calendarChoice": null, "packageType": "base", "needId": "22", "locked": true } ], "count": 1, "nextPage": '123', "resultCode": 200, "errorManagement": null, "errorCode": null}
	)
}
